//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';
import 'moment-duration-format';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class ReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getReportInformeIngresosExport(query: ReportInformeIngresosExportQuery): Observable<DownloadFileResponseCommon> {
        let url_ = this.baseUrl + "/api/report/getreportinformeingresosexport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportInformeIngresosExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportInformeIngresosExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResponseCommon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResponseCommon>;
        }));
    }

    protected processGetReportInformeIngresosExport(response: HttpResponseBase): Observable<DownloadFileResponseCommon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponseCommon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportInformeEgresosExport(query: ReportInformeEgresosExportQuery): Observable<DownloadFileResponseCommon> {
        let url_ = this.baseUrl + "/api/report/getreportinformeegresosexport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportInformeEgresosExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportInformeEgresosExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResponseCommon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResponseCommon>;
        }));
    }

    protected processGetReportInformeEgresosExport(response: HttpResponseBase): Observable<DownloadFileResponseCommon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponseCommon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportInformeSesionesProgramadasForEdit(): Observable<ReportInformeSesionesProgramadasForEditResponse> {
        let url_ = this.baseUrl + "/api/report/getreportinformesesionesprogramadasforedit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportInformeSesionesProgramadasForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportInformeSesionesProgramadasForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportInformeSesionesProgramadasForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportInformeSesionesProgramadasForEditResponse>;
        }));
    }

    protected processGetReportInformeSesionesProgramadasForEdit(response: HttpResponseBase): Observable<ReportInformeSesionesProgramadasForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportInformeSesionesProgramadasForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportInformeSesionesProgramadasExport(query: ReportInformeSesionesProgramadasExportQuery): Observable<DownloadFileResponseCommon> {
        let url_ = this.baseUrl + "/api/report/getreportinformesesionesprogramadasexport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportInformeSesionesProgramadasExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportInformeSesionesProgramadasExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResponseCommon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResponseCommon>;
        }));
    }

    protected processGetReportInformeSesionesProgramadasExport(response: HttpResponseBase): Observable<DownloadFileResponseCommon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponseCommon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportRelacionPacientesServicioHDForEdit(): Observable<ReportRelacionPacientesServicioHDForEditResponse> {
        let url_ = this.baseUrl + "/api/report/getreportrelacionpacientesserviciohdforedit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportRelacionPacientesServicioHDForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportRelacionPacientesServicioHDForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportRelacionPacientesServicioHDForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportRelacionPacientesServicioHDForEditResponse>;
        }));
    }

    protected processGetReportRelacionPacientesServicioHDForEdit(response: HttpResponseBase): Observable<ReportRelacionPacientesServicioHDForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportRelacionPacientesServicioHDForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportRelacionPacientesServicioHDExport(query: ReportRelacionPacientesServicioHDExportQuery): Observable<DownloadFileResponseCommon> {
        let url_ = this.baseUrl + "/api/report/getreportrelacionpacientesserviciohdexport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportRelacionPacientesServicioHDExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportRelacionPacientesServicioHDExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResponseCommon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResponseCommon>;
        }));
    }

    protected processGetReportRelacionPacientesServicioHDExport(response: HttpResponseBase): Observable<DownloadFileResponseCommon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponseCommon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportInformeSesionesEfectOtorgPacienteExport(query: ReportInformeSesionesEfectOtorgPacienteExportQuery): Observable<DownloadFileResponseCommon> {
        let url_ = this.baseUrl + "/api/report/getreportinformesesionesefectotorgpacienteexport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportInformeSesionesEfectOtorgPacienteExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportInformeSesionesEfectOtorgPacienteExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResponseCommon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResponseCommon>;
        }));
    }

    protected processGetReportInformeSesionesEfectOtorgPacienteExport(response: HttpResponseBase): Observable<DownloadFileResponseCommon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponseCommon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportEstadisticosUnidadHDExport(query: ReportEstadisticosUnidadHDExportQuery): Observable<DownloadFileResponseCommon> {
        let url_ = this.baseUrl + "/api/report/getreportestadisticosunidadhdexport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportEstadisticosUnidadHDExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportEstadisticosUnidadHDExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResponseCommon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResponseCommon>;
        }));
    }

    protected processGetReportEstadisticosUnidadHDExport(response: HttpResponseBase): Observable<DownloadFileResponseCommon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponseCommon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportResumenClinicoExport(query: ReportResumenClinicoExportQuery): Observable<DownloadFileResponseCommon> {
        let url_ = this.baseUrl + "/api/report/getreportresumenclinicoexport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportResumenClinicoExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportResumenClinicoExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResponseCommon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResponseCommon>;
        }));
    }

    protected processGetReportResumenClinicoExport(response: HttpResponseBase): Observable<DownloadFileResponseCommon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponseCommon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportResumenClinicoEnviar(query: ReportResumenClinicoEnviarQuery): Observable<number> {
        let url_ = this.baseUrl + "/api/report/getreportresumenclinicoenviar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportResumenClinicoEnviar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportResumenClinicoEnviar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetReportResumenClinicoEnviar(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportNotaInicialExport(query: ReportNotaInicialExportQuery): Observable<DownloadFileResponseCommon> {
        let url_ = this.baseUrl + "/api/report/getreportnotainicialexport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportNotaInicialExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportNotaInicialExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResponseCommon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResponseCommon>;
        }));
    }

    protected processGetReportNotaInicialExport(response: HttpResponseBase): Observable<DownloadFileResponseCommon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponseCommon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportHistoriaClinicaExport(query: ReportHistoriaClinicaExportQuery): Observable<DownloadFileResponseCommon> {
        let url_ = this.baseUrl + "/api/report/getreporthistoriaclinicaexport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportHistoriaClinicaExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportHistoriaClinicaExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResponseCommon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResponseCommon>;
        }));
    }

    protected processGetReportHistoriaClinicaExport(response: HttpResponseBase): Observable<DownloadFileResponseCommon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponseCommon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportEvolucionMedicaExport(query: ReportEvolucionMedicaExportQuery): Observable<DownloadFileResponseCommon> {
        let url_ = this.baseUrl + "/api/report/getreportevolucionmedicaexport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportEvolucionMedicaExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportEvolucionMedicaExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResponseCommon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResponseCommon>;
        }));
    }

    protected processGetReportEvolucionMedicaExport(response: HttpResponseBase): Observable<DownloadFileResponseCommon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponseCommon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReporteSesionesOtorgadasExport(request: ReportInternoSesionesOtorgadasExportQuery): Observable<DownloadFileResponseCommon> {
        let url_ = this.baseUrl + "/api/report/getreportesesionesotorgadasexport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReporteSesionesOtorgadasExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReporteSesionesOtorgadasExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResponseCommon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResponseCommon>;
        }));
    }

    protected processGetReporteSesionesOtorgadasExport(response: HttpResponseBase): Observable<DownloadFileResponseCommon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponseCommon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReporteSesionesAbiertasExport(request: ReportInternoSesionesAbiertasExportQuery): Observable<DownloadFileResponseCommon> {
        let url_ = this.baseUrl + "/api/report/getreportesesionesabiertasexport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReporteSesionesAbiertasExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReporteSesionesAbiertasExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResponseCommon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResponseCommon>;
        }));
    }

    protected processGetReporteSesionesAbiertasExport(response: HttpResponseBase): Observable<DownloadFileResponseCommon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponseCommon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReporteSesionesEliminadasExport(request: ReportInternoSesionesEliminadasExportQuery): Observable<DownloadFileResponseCommon> {
        let url_ = this.baseUrl + "/api/report/getreportesesioneseliminadasexport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReporteSesionesEliminadasExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReporteSesionesEliminadasExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResponseCommon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResponseCommon>;
        }));
    }

    protected processGetReporteSesionesEliminadasExport(response: HttpResponseBase): Observable<DownloadFileResponseCommon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponseCommon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReporteSesionesSuspendidasExport(request: ReportInternoSesionesSuspendidasExportQuery): Observable<DownloadFileResponseCommon> {
        let url_ = this.baseUrl + "/api/report/getreportesesionessuspendidasexport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReporteSesionesSuspendidasExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReporteSesionesSuspendidasExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResponseCommon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResponseCommon>;
        }));
    }

    protected processGetReporteSesionesSuspendidasExport(response: HttpResponseBase): Observable<DownloadFileResponseCommon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponseCommon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReporteDetalleSesionesExport(request: ReportInternoDetalleSesionesExportQuery): Observable<DownloadFileResponseCommon> {
        let url_ = this.baseUrl + "/api/report/getreportedetallesesionesexport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReporteDetalleSesionesExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReporteDetalleSesionesExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResponseCommon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResponseCommon>;
        }));
    }

    protected processGetReporteDetalleSesionesExport(response: HttpResponseBase): Observable<DownloadFileResponseCommon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponseCommon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReporteSesionesMensajesHL7Export(request: ReportInternoSesionesMensajesHL7ExportQuery): Observable<DownloadFileResponseCommon> {
        let url_ = this.baseUrl + "/api/report/getreportesesionesmensajeshl7export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReporteSesionesMensajesHL7Export(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReporteSesionesMensajesHL7Export(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResponseCommon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResponseCommon>;
        }));
    }

    protected processGetReporteSesionesMensajesHL7Export(response: HttpResponseBase): Observable<DownloadFileResponseCommon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponseCommon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MedicoUnidadServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getMedicosUnidadesList(request: MedicoUnidadGetForListQuery): Observable<PagedResultDtoOfMedicoUnidadResponse> {
        let url_ = this.baseUrl + "/api/medicounidad/getmedicosunidadeslist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicosUnidadesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicosUnidadesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMedicoUnidadResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMedicoUnidadResponse>;
        }));
    }

    protected processGetMedicosUnidadesList(response: HttpResponseBase): Observable<PagedResultDtoOfMedicoUnidadResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMedicoUnidadResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMedicosUnidadesAutocompleteList(request: MedicoUnidadGetAutocompleteListQuery): Observable<MedicoUnidadResponse[]> {
        let url_ = this.baseUrl + "/api/medicounidad/getmedicosunidadesautocompletelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicosUnidadesAutocompleteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicosUnidadesAutocompleteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicoUnidadResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicoUnidadResponse[]>;
        }));
    }

    protected processGetMedicosUnidadesAutocompleteList(response: HttpResponseBase): Observable<MedicoUnidadResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MedicoUnidadResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMedicosForCombobox(request: MedicoUnidadGetForComboboxQuery): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/medicounidad/getmedicosforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicosForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicosForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetMedicosForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMedicoUnidadById(request: MedicoUnidadGetByIdQuery): Observable<MedicoUnidadResponse> {
        let url_ = this.baseUrl + "/api/medicounidad/getmedicounidadbyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicoUnidadById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicoUnidadById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicoUnidadResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicoUnidadResponse>;
        }));
    }

    protected processGetMedicoUnidadById(response: HttpResponseBase): Observable<MedicoUnidadResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicoUnidadResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createMedicoUnidad(dto: MedicoUnidadCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/medicounidad/createmedicounidad";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMedicoUnidad(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMedicoUnidad(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateMedicoUnidad(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateMedicoUnidad(dto: MedicoUnidadUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/medicounidad/updatemedicounidad";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMedicoUnidad(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMedicoUnidad(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateMedicoUnidad(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteMedicoUnidad(dto: MedicoUnidadDeleteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/medicounidad/deletemedicounidad";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMedicoUnidad(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMedicoUnidad(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteMedicoUnidad(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MonitorMaquinasBellcoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getMonitorMaquinasBellcoList(): Observable<MonitorMaquinaBellcoResponse[]> {
        let url_ = this.baseUrl + "/api/monitormaquinasbellco/getmonitormaquinasbellcolist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonitorMaquinasBellcoList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonitorMaquinasBellcoList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonitorMaquinaBellcoResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonitorMaquinaBellcoResponse[]>;
        }));
    }

    protected processGetMonitorMaquinasBellcoList(response: HttpResponseBase): Observable<MonitorMaquinaBellcoResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MonitorMaquinaBellcoResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMonitorMaquinasBellcoErroresList(): Observable<MonitorMaquinaBellcoErrorResponse[]> {
        let url_ = this.baseUrl + "/api/monitormaquinasbellco/getmonitormaquinasbellcoerroreslist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonitorMaquinasBellcoErroresList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonitorMaquinasBellcoErroresList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonitorMaquinaBellcoErrorResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonitorMaquinaBellcoErrorResponse[]>;
        }));
    }

    protected processGetMonitorMaquinasBellcoErroresList(response: HttpResponseBase): Observable<MonitorMaquinaBellcoErrorResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MonitorMaquinaBellcoErrorResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PrescripcionHDServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getPrescripcionesHDList(request: PrescripcionHDGetListQuery): Observable<PrescripcionHDForListResponse[]> {
        let url_ = this.baseUrl + "/api/prescripcionhd/getprescripcioneshdlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrescripcionesHDList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrescripcionesHDList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrescripcionHDForListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrescripcionHDForListResponse[]>;
        }));
    }

    protected processGetPrescripcionesHDList(response: HttpResponseBase): Observable<PrescripcionHDForListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PrescripcionHDForListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPrescripcionHDForEdit(request: PrescripcionHDGetForEditQuery): Observable<PrescripcionHDResponse> {
        let url_ = this.baseUrl + "/api/prescripcionhd/getprescripcionhdforedit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrescripcionHDForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrescripcionHDForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrescripcionHDResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrescripcionHDResponse>;
        }));
    }

    protected processGetPrescripcionHDForEdit(response: HttpResponseBase): Observable<PrescripcionHDResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescripcionHDResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPrescripcionHDActivaDePaciente(request: PrescripcionHDGetActivaDePacienteQuery): Observable<PrescripcionHDResponse> {
        let url_ = this.baseUrl + "/api/prescripcionhd/getprescripcionhdactivadepaciente";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrescripcionHDActivaDePaciente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrescripcionHDActivaDePaciente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrescripcionHDResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrescripcionHDResponse>;
        }));
    }

    protected processGetPrescripcionHDActivaDePaciente(response: HttpResponseBase): Observable<PrescripcionHDResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescripcionHDResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPrescripcionHD(dto: PrescripcionHDCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/prescripcionhd/createprescripcionhd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePrescripcionHD(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePrescripcionHD(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePrescripcionHD(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePrescripcionHD(dto: PrescripcionHDUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/prescripcionhd/updateprescripcionhd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePrescripcionHD(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePrescripcionHD(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdatePrescripcionHD(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPrescripcionesHDMotivosCambiosList(request: PrescripcionHDGetMotivosCambiosListQuery): Observable<PrescripcionHDMotivosCambiosCitasResponse[]> {
        let url_ = this.baseUrl + "/api/prescripcionhd/getprescripcioneshdmotivoscambioslist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrescripcionesHDMotivosCambiosList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrescripcionesHDMotivosCambiosList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrescripcionHDMotivosCambiosCitasResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrescripcionHDMotivosCambiosCitasResponse[]>;
        }));
    }

    protected processGetPrescripcionesHDMotivosCambiosList(response: HttpResponseBase): Observable<PrescripcionHDMotivosCambiosCitasResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PrescripcionHDMotivosCambiosCitasResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPrescripcionesHDNotasMedicasList(request: PrescripcionHDGetNotasMedicasListQuery): Observable<PrescripcionHDNotasMedicasResponse[]> {
        let url_ = this.baseUrl + "/api/prescripcionhd/getprescripcioneshdnotasmedicaslist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrescripcionesHDNotasMedicasList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrescripcionesHDNotasMedicasList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrescripcionHDNotasMedicasResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrescripcionHDNotasMedicasResponse[]>;
        }));
    }

    protected processGetPrescripcionesHDNotasMedicasList(response: HttpResponseBase): Observable<PrescripcionHDNotasMedicasResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PrescripcionHDNotasMedicasResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPrescripcionHDNotaMedica(dto: PrescripcionHDNotaMedicaCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/prescripcionhd/createprescripcionhdnotamedica";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePrescripcionHDNotaMedica(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePrescripcionHDNotaMedica(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePrescripcionHDNotaMedica(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SesionHDServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getSesionesHDList(request: SesionHDGetListQuery): Observable<PagedResultDtoOfSesionHDForListResponse> {
        let url_ = this.baseUrl + "/api/sesionhd/getsesioneshdlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSesionesHDList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSesionesHDList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSesionHDForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSesionHDForListResponse>;
        }));
    }

    protected processGetSesionesHDList(response: HttpResponseBase): Observable<PagedResultDtoOfSesionHDForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSesionHDForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSesionHDForEdit(request: SesionHDGetForEditQuery): Observable<SesionHDResponse> {
        let url_ = this.baseUrl + "/api/sesionhd/getsesionhdforedit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSesionHDForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSesionHDForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SesionHDResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SesionHDResponse>;
        }));
    }

    protected processGetSesionHDForEdit(response: HttpResponseBase): Observable<SesionHDResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SesionHDResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    haySesionActivaPaciente(pacienteId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/sesionhd/haysesionactivapaciente?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHaySesionActivaPaciente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHaySesionActivaPaciente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHaySesionActivaPaciente(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    haySesionCerradasDePacienteEnFecha(request: SesionHDGetSesionCerradaPacientePorFechaQuery): Observable<boolean> {
        let url_ = this.baseUrl + "/api/sesionhd/haysesioncerradasdepacienteenfecha";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHaySesionCerradasDePacienteEnFecha(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHaySesionCerradasDePacienteEnFecha(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHaySesionCerradasDePacienteEnFecha(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createSesionHD(dto: SesionHDCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/sesionhd/createsesionhd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSesionHD(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSesionHD(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateSesionHD(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSesionHD(dto: SesionHDUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/sesionhd/updatesesionhd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSesionHD(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSesionHD(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateSesionHD(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSesionHD(dto: SesionHDDeleteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/sesionhd/deletesesionhd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSesionHD(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSesionHD(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteSesionHD(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validarInicioSesionHD(dto: SesionHDValidarInicioSesionQuery): Observable<void> {
        let url_ = this.baseUrl + "/api/sesionhd/validariniciosesionhd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidarInicioSesionHD(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidarInicioSesionHD(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidarInicioSesionHD(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSesionHDAlimentosList(request: SesionHDGetAlimentosListQuery): Observable<SesionHDAlimentoResponse[]> {
        let url_ = this.baseUrl + "/api/sesionhd/getsesionhdalimentoslist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSesionHDAlimentosList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSesionHDAlimentosList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SesionHDAlimentoResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SesionHDAlimentoResponse[]>;
        }));
    }

    protected processGetSesionHDAlimentosList(response: HttpResponseBase): Observable<SesionHDAlimentoResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SesionHDAlimentoResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createSesionHDAlimento(request: SesionHDAlimentoCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/sesionhd/createsesionhdalimento";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSesionHDAlimento(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSesionHDAlimento(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateSesionHDAlimento(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSesionHDMedicamentoesList(request: SesionHDGetMedicamentosListQuery): Observable<SesionHDMedicamentoResponse[]> {
        let url_ = this.baseUrl + "/api/sesionhd/getsesionhdmedicamentoeslist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSesionHDMedicamentoesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSesionHDMedicamentoesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SesionHDMedicamentoResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SesionHDMedicamentoResponse[]>;
        }));
    }

    protected processGetSesionHDMedicamentoesList(response: HttpResponseBase): Observable<SesionHDMedicamentoResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SesionHDMedicamentoResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createSesionHDMedicamento(request: SesionHDMedicamentoCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/sesionhd/createsesionhdmedicamento";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSesionHDMedicamento(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSesionHDMedicamento(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateSesionHDMedicamento(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSesionHDMedicamento(request: SesionHDMedicamentoDeleteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/sesionhd/deletesesionhdmedicamento";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSesionHDMedicamento(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSesionHDMedicamento(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteSesionHDMedicamento(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSesionHDMaterialesList(request: SesionHDGetMaterialesListQuery): Observable<SesionHDMaterialResponse[]> {
        let url_ = this.baseUrl + "/api/sesionhd/getsesionhdmaterialeslist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSesionHDMaterialesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSesionHDMaterialesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SesionHDMaterialResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SesionHDMaterialResponse[]>;
        }));
    }

    protected processGetSesionHDMaterialesList(response: HttpResponseBase): Observable<SesionHDMaterialResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SesionHDMaterialResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createSesionHDMaterial(request: SesionHDMaterialCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/sesionhd/createsesionhdmaterial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSesionHDMaterial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSesionHDMaterial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateSesionHDMaterial(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSesionHDMaterial(request: SesionHDMaterialDeleteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/sesionhd/deletesesionhdmaterial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSesionHDMaterial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSesionHDMaterial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteSesionHDMaterial(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSesionHDDiagnosticosProcList(request: SesionHDGetDiagnosticosListQuery): Observable<SesionHDDiagnosticoProcResponse[]> {
        let url_ = this.baseUrl + "/api/sesionhd/getsesionhddiagnosticosproclist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSesionHDDiagnosticosProcList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSesionHDDiagnosticosProcList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SesionHDDiagnosticoProcResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SesionHDDiagnosticoProcResponse[]>;
        }));
    }

    protected processGetSesionHDDiagnosticosProcList(response: HttpResponseBase): Observable<SesionHDDiagnosticoProcResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SesionHDDiagnosticoProcResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createSesionHDDiagnosticosProc(request: SesionHDDiagnosticoProcCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/sesionhd/createsesionhddiagnosticosproc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSesionHDDiagnosticosProc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSesionHDDiagnosticosProc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateSesionHDDiagnosticosProc(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSesionHDDiagnosticosProc(request: SesionHDDiagnosticoProcDeleteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/sesionhd/deletesesionhddiagnosticosproc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSesionHDDiagnosticosProc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSesionHDDiagnosticosProc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteSesionHDDiagnosticosProc(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSesionHDSignosSintomasList(request: SesionHDGetSignosSintomasListQuery): Observable<SesionHDSignosYSintomasResponse[]> {
        let url_ = this.baseUrl + "/api/sesionhd/getsesionhdsignossintomaslist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSesionHDSignosSintomasList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSesionHDSignosSintomasList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SesionHDSignosYSintomasResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SesionHDSignosYSintomasResponse[]>;
        }));
    }

    protected processGetSesionHDSignosSintomasList(response: HttpResponseBase): Observable<SesionHDSignosYSintomasResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SesionHDSignosYSintomasResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createSesionHDSignoSintoma(request: SesionHDSignoSintomaCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/sesionhd/createsesionhdsignosintoma";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSesionHDSignoSintoma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSesionHDSignoSintoma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateSesionHDSignoSintoma(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSesionHDSignoSintoma(request: SesionHDSignoSintomaDeleteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/sesionhd/deletesesionhdsignosintoma";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSesionHDSignoSintoma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSesionHDSignoSintoma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteSesionHDSignoSintoma(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSesionHDTransfusionesList(request: SesionHDGetTransfusionesListQuery): Observable<SesionHDTransfusionResponse[]> {
        let url_ = this.baseUrl + "/api/sesionhd/getsesionhdtransfusioneslist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSesionHDTransfusionesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSesionHDTransfusionesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SesionHDTransfusionResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SesionHDTransfusionResponse[]>;
        }));
    }

    protected processGetSesionHDTransfusionesList(response: HttpResponseBase): Observable<SesionHDTransfusionResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SesionHDTransfusionResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createSesionHDTransfusion(request: SesionHDTransfusionCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/sesionhd/createsesionhdtransfusion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSesionHDTransfusion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSesionHDTransfusion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateSesionHDTransfusion(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSesionHDTransfusion(request: SesionHDTransfusionDeleteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/sesionhd/deletesesionhdtransfusion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSesionHDTransfusion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSesionHDTransfusion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteSesionHDTransfusion(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSesionHDObservacionesEnfermeriaPaciente(request: SesionHDGetPacienteSesionObservacionesQuery): Observable<SesionHDObservacionesEnfermeriaResponse> {
        let url_ = this.baseUrl + "/api/sesionhd/getsesionhdobservacionesenfermeriapaciente";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSesionHDObservacionesEnfermeriaPaciente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSesionHDObservacionesEnfermeriaPaciente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SesionHDObservacionesEnfermeriaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SesionHDObservacionesEnfermeriaResponse>;
        }));
    }

    protected processGetSesionHDObservacionesEnfermeriaPaciente(response: HttpResponseBase): Observable<SesionHDObservacionesEnfermeriaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SesionHDObservacionesEnfermeriaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMatchMaquinaHD(request: SesionHDGetMatchQuery): Observable<SesionHDMatchResponse> {
        let url_ = this.baseUrl + "/api/sesionhd/getmatchmaquinahd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMatchMaquinaHD(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMatchMaquinaHD(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SesionHDMatchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SesionHDMatchResponse>;
        }));
    }

    protected processGetMatchMaquinaHD(response: HttpResponseBase): Observable<SesionHDMatchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SesionHDMatchResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMedicionesMatchMaquinaHD(request: SesionHDGetMedicionesMatchQuery): Observable<SesionHDMedicionResponse[]> {
        let url_ = this.baseUrl + "/api/sesionhd/getmedicionesmatchmaquinahd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicionesMatchMaquinaHD(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicionesMatchMaquinaHD(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SesionHDMedicionResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SesionHDMedicionResponse[]>;
        }));
    }

    protected processGetMedicionesMatchMaquinaHD(response: HttpResponseBase): Observable<SesionHDMedicionResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SesionHDMedicionResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSesionHDPdf(request: SesionHDExportPDFQuery): Observable<DownloadFileResponseCommon> {
        let url_ = this.baseUrl + "/api/sesionhd/getsesionhdpdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSesionHDPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSesionHDPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResponseCommon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResponseCommon>;
        }));
    }

    protected processGetSesionHDPdf(response: HttpResponseBase): Observable<DownloadFileResponseCommon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponseCommon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TurnoHospitalServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getTurnosHospitalesList(request: TurnoHospitalGetListQuery): Observable<PagedResultDtoOfTurnoHospitalForListResponse> {
        let url_ = this.baseUrl + "/api/turnohospital/getturnoshospitaleslist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTurnosHospitalesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTurnosHospitalesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTurnoHospitalForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTurnoHospitalForListResponse>;
        }));
    }

    protected processGetTurnosHospitalesList(response: HttpResponseBase): Observable<PagedResultDtoOfTurnoHospitalForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTurnoHospitalForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTurnoHospitalForEdit(request: TurnoHospitalGetForEditQuery): Observable<TurnoHospitalForEditResponse> {
        let url_ = this.baseUrl + "/api/turnohospital/getturnohospitalforedit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTurnoHospitalForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTurnoHospitalForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TurnoHospitalForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TurnoHospitalForEditResponse>;
        }));
    }

    protected processGetTurnoHospitalForEdit(response: HttpResponseBase): Observable<TurnoHospitalForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TurnoHospitalForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTurnoHospitalForCombobox(request: TurnoHospitalGetForComboboxQuery): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/turnohospital/getturnohospitalforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTurnoHospitalForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTurnoHospitalForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetTurnoHospitalForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createTurnoHospital(dto: TurnoHospitalCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/turnohospital/createturnohospital";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTurnoHospital(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTurnoHospital(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateTurnoHospital(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateTurnoHospital(dto: TurnoHospitalUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/turnohospital/updateturnohospital";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTurnoHospital(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTurnoHospital(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateTurnoHospital(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTurnosHospitalesResponsablesList(request: TurnoHospitalResponsableGetListQuery): Observable<TurnoHospitalResponsableResponse[]> {
        let url_ = this.baseUrl + "/api/turnohospital/getturnoshospitalesresponsableslist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTurnosHospitalesResponsablesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTurnosHospitalesResponsablesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TurnoHospitalResponsableResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TurnoHospitalResponsableResponse[]>;
        }));
    }

    protected processGetTurnosHospitalesResponsablesList(response: HttpResponseBase): Observable<TurnoHospitalResponsableResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TurnoHospitalResponsableResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTurnoHospitalResponsableForEdit(request: TurnoHospitalResponsableGetForEditQuery): Observable<TurnoHospitalResponsableResponse> {
        let url_ = this.baseUrl + "/api/turnohospital/getturnohospitalresponsableforedit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTurnoHospitalResponsableForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTurnoHospitalResponsableForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TurnoHospitalResponsableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TurnoHospitalResponsableResponse>;
        }));
    }

    protected processGetTurnoHospitalResponsableForEdit(response: HttpResponseBase): Observable<TurnoHospitalResponsableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TurnoHospitalResponsableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createTurnoHospitalResponsable(dto: TurnoHospitalResponsableCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/turnohospital/createturnohospitalresponsable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTurnoHospitalResponsable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTurnoHospitalResponsable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateTurnoHospitalResponsable(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateTurnoHospitalResponsable(dto: TurnoHospitalResponsableUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/turnohospital/updateturnohospitalresponsable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTurnoHospitalResponsable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTurnoHospitalResponsable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateTurnoHospitalResponsable(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteTurnoHospitalResponsable(request: TurnoHospitalResponsableDeleteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/turnohospital/deleteturnohospitalresponsable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTurnoHospitalResponsable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTurnoHospitalResponsable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteTurnoHospitalResponsable(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTurnosMaquinasDisponibilidadList(request: TurnoHospitalMaquinaDisponibilidadGetListQuery): Observable<TurnoHospitalMaquinaDisponibilidadResponse[]> {
        let url_ = this.baseUrl + "/api/turnohospital/getturnosmaquinasdisponibilidadlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTurnosMaquinasDisponibilidadList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTurnosMaquinasDisponibilidadList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TurnoHospitalMaquinaDisponibilidadResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TurnoHospitalMaquinaDisponibilidadResponse[]>;
        }));
    }

    protected processGetTurnosMaquinasDisponibilidadList(response: HttpResponseBase): Observable<TurnoHospitalMaquinaDisponibilidadResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TurnoHospitalMaquinaDisponibilidadResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AccesoVascularPacienteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getAccesosVascularesPacienteList(request: AccesosVascularesPacienteGetListQuery): Observable<PagedResultDtoOfAccesoVascularPacienteForListResponse> {
        let url_ = this.baseUrl + "/api/accesovascularpaciente/getaccesosvascularespacientelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccesosVascularesPacienteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccesosVascularesPacienteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAccesoVascularPacienteForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAccesoVascularPacienteForListResponse>;
        }));
    }

    protected processGetAccesosVascularesPacienteList(response: HttpResponseBase): Observable<PagedResultDtoOfAccesoVascularPacienteForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAccesoVascularPacienteForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAccesoVascularPacienteById(request: AccesosVascularesPacienteGetByIdQuery): Observable<AccesoVascularPacienteResponse> {
        let url_ = this.baseUrl + "/api/accesovascularpaciente/getaccesovascularpacientebyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccesoVascularPacienteById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccesoVascularPacienteById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccesoVascularPacienteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccesoVascularPacienteResponse>;
        }));
    }

    protected processGetAccesoVascularPacienteById(response: HttpResponseBase): Observable<AccesoVascularPacienteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccesoVascularPacienteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAccesoVascularActivoPorPaciente(request: AccesosVascularesPacienteGetActivoPorPacienteQuery): Observable<AccesoVascularPacienteResponse> {
        let url_ = this.baseUrl + "/api/accesovascularpaciente/getaccesovascularactivoporpaciente";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccesoVascularActivoPorPaciente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccesoVascularActivoPorPaciente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccesoVascularPacienteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccesoVascularPacienteResponse>;
        }));
    }

    protected processGetAccesoVascularActivoPorPaciente(response: HttpResponseBase): Observable<AccesoVascularPacienteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccesoVascularPacienteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAccesosVascularesPacienteForCombobox(request: AccesosVascularesPacienteGetForComboboxQuery): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/accesovascularpaciente/getaccesosvascularespacienteforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccesosVascularesPacienteForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccesosVascularesPacienteForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetAccesosVascularesPacienteForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createAccesoVascular(request: AccesoVascularCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/accesovascularpaciente/createaccesovascular";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAccesoVascular(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAccesoVascular(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateAccesoVascular(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAccesoVascular(request: AccesoVascularUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/accesovascularpaciente/updateaccesovascular";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAccesoVascular(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAccesoVascular(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateAccesoVascular(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CitasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getCitasList(request: CitaGetListQuery): Observable<PagedResultDtoOfCitaForListResponse> {
        let url_ = this.baseUrl + "/api/citas/getcitaslist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCitasList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCitasList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCitaForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCitaForListResponse>;
        }));
    }

    protected processGetCitasList(response: HttpResponseBase): Observable<PagedResultDtoOfCitaForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCitaForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCitasProgramadasNoOtorgadasList(request: CitaProgramadaNoOtorgadaGetListQuery): Observable<PagedResultDtoOfCitaForListResponse> {
        let url_ = this.baseUrl + "/api/citas/getcitasprogramadasnootorgadaslist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCitasProgramadasNoOtorgadasList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCitasProgramadasNoOtorgadasList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCitaForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCitaForListResponse>;
        }));
    }

    protected processGetCitasProgramadasNoOtorgadasList(response: HttpResponseBase): Observable<PagedResultDtoOfCitaForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCitaForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCita(request: CitaGetByIdQuery): Observable<CitaResponse> {
        let url_ = this.baseUrl + "/api/citas/getcita";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCita(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCita(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CitaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CitaResponse>;
        }));
    }

    protected processGetCita(response: HttpResponseBase): Observable<CitaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CitaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createCita(request: CitaCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/citas/createcita";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCita(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCita(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateCita(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelarCita(request: CitaCancelarCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/citas/cancelarcita";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelarCita(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelarCita(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCancelarCita(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    confirmarCita(request: CitaConfirmarCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/citas/confirmarcita";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmarCita(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmarCita(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processConfirmarCita(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    imprimirIMSS(request: CitasExportIMSSQuery): Observable<DownloadFileResponseCommon> {
        let url_ = this.baseUrl + "/api/citas/imprimirimss";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImprimirIMSS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImprimirIMSS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResponseCommon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResponseCommon>;
        }));
    }

    protected processImprimirIMSS(response: HttpResponseBase): Observable<DownloadFileResponseCommon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponseCommon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConfigurarHospitalServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getConfiguracionHospital(): Observable<ConfiguracionUnidadResponse> {
        let url_ = this.baseUrl + "/api/configurarhospital/getconfiguracionhospital";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfiguracionHospital(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfiguracionHospital(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfiguracionUnidadResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfiguracionUnidadResponse>;
        }));
    }

    protected processGetConfiguracionHospital(response: HttpResponseBase): Observable<ConfiguracionUnidadResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfiguracionUnidadResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveConfiguracionHospital(dto: ConfiguracionUnidadCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/configurarhospital/saveconfiguracionhospital";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveConfiguracionHospital(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveConfiguracionHospital(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSaveConfiguracionHospital(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHospitalesConfiguradosForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/configurarhospital/gethospitalesconfiguradosforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHospitalesConfiguradosForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHospitalesConfiguradosForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetHospitalesConfiguradosForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getConfiguracionUnidadHospitalesList(): Observable<ConfiguracionUnidadHospitalResponse[]> {
        let url_ = this.baseUrl + "/api/configurarhospital/getconfiguracionunidadhospitaleslist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfiguracionUnidadHospitalesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfiguracionUnidadHospitalesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfiguracionUnidadHospitalResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfiguracionUnidadHospitalResponse[]>;
        }));
    }

    protected processGetConfiguracionUnidadHospitalesList(response: HttpResponseBase): Observable<ConfiguracionUnidadHospitalResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConfiguracionUnidadHospitalResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createConfiguracionUnidadHospital(request: ConfiguracionUnidadHospitalCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/configurarhospital/createconfiguracionunidadhospital";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateConfiguracionUnidadHospital(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateConfiguracionUnidadHospital(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateConfiguracionUnidadHospital(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteConfiguracionUnidadHospital(request: ConfiguracionUnidadHospitalDeleteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/configurarhospital/deleteconfiguracionunidadhospital";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConfiguracionUnidadHospital(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConfiguracionUnidadHospital(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteConfiguracionUnidadHospital(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ControlEstatusMaquinaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getControlEstatusMaquina(request: ControlEstatusMaquinaGetByIdQuery): Observable<ControlEstatusMaquinaResponse> {
        let url_ = this.baseUrl + "/api/controlestatusmaquina/getcontrolestatusmaquina";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlEstatusMaquina(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlEstatusMaquina(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlEstatusMaquinaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlEstatusMaquinaResponse>;
        }));
    }

    protected processGetControlEstatusMaquina(response: HttpResponseBase): Observable<ControlEstatusMaquinaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ControlEstatusMaquinaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getControlEstatusMaquinaActivo(request: ControlEstatusMaquinaGetActivoByMaquinaIdQuery): Observable<ControlEstatusMaquinaResponse> {
        let url_ = this.baseUrl + "/api/controlestatusmaquina/getcontrolestatusmaquinaactivo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlEstatusMaquinaActivo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlEstatusMaquinaActivo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlEstatusMaquinaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlEstatusMaquinaResponse>;
        }));
    }

    protected processGetControlEstatusMaquinaActivo(response: HttpResponseBase): Observable<ControlEstatusMaquinaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ControlEstatusMaquinaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getControlEstatusMaquinaList(request: ControlEstatusMaquinaGetListQuery): Observable<PagedResultDtoOfControlEstatusMaquinaForListResponse> {
        let url_ = this.baseUrl + "/api/controlestatusmaquina/getcontrolestatusmaquinalist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlEstatusMaquinaList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlEstatusMaquinaList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfControlEstatusMaquinaForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfControlEstatusMaquinaForListResponse>;
        }));
    }

    protected processGetControlEstatusMaquinaList(response: HttpResponseBase): Observable<PagedResultDtoOfControlEstatusMaquinaForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfControlEstatusMaquinaForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createControlEstatusMaquina(request: ControlEstatusMaquinaCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/controlestatusmaquina/createcontrolestatusmaquina";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateControlEstatusMaquina(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateControlEstatusMaquina(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateControlEstatusMaquina(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ControlEstatusPacienteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getControlEstatusPaciente(request: ControlEstatusGetByIdQuery): Observable<ControlEstatusPacienteResponse> {
        let url_ = this.baseUrl + "/api/controlestatuspaciente/getcontrolestatuspaciente";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlEstatusPaciente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlEstatusPaciente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlEstatusPacienteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlEstatusPacienteResponse>;
        }));
    }

    protected processGetControlEstatusPaciente(response: HttpResponseBase): Observable<ControlEstatusPacienteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ControlEstatusPacienteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getControlEstatusActivoPaciente(request: ControlEstatusGetAcftivoByPacienteIdQuery): Observable<ControlEstatusPacienteResponse> {
        let url_ = this.baseUrl + "/api/controlestatuspaciente/getcontrolestatusactivopaciente";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlEstatusActivoPaciente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlEstatusActivoPaciente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlEstatusPacienteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlEstatusPacienteResponse>;
        }));
    }

    protected processGetControlEstatusActivoPaciente(response: HttpResponseBase): Observable<ControlEstatusPacienteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ControlEstatusPacienteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getControlEstatusPacienteList(request: ControlEstatusGetListQuery): Observable<ControlEstatusForListResponse[]> {
        let url_ = this.baseUrl + "/api/controlestatuspaciente/getcontrolestatuspacientelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlEstatusPacienteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlEstatusPacienteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlEstatusForListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlEstatusForListResponse[]>;
        }));
    }

    protected processGetControlEstatusPacienteList(response: HttpResponseBase): Observable<ControlEstatusForListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ControlEstatusForListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createControlEstatusPaciente(request: ControlEstatusCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/controlestatuspaciente/createcontrolestatuspaciente";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateControlEstatusPaciente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateControlEstatusPaciente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateControlEstatusPaciente(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EstudiosPacientesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getEstudiosPacienteList(request: EstudiosPacientesGetListQuery): Observable<PagedResultDtoOfEstudioPacienteForListResponse> {
        let url_ = this.baseUrl + "/api/estudiospacientes/getestudiospacientelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEstudiosPacienteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEstudiosPacienteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfEstudioPacienteForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfEstudioPacienteForListResponse>;
        }));
    }

    protected processGetEstudiosPacienteList(response: HttpResponseBase): Observable<PagedResultDtoOfEstudioPacienteForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEstudioPacienteForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEstudiosPacienteById(request: EstudiosPacientesGetByIdQuery): Observable<EstudioPacienteResponse> {
        let url_ = this.baseUrl + "/api/estudiospacientes/getestudiospacientebyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEstudiosPacienteById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEstudiosPacienteById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EstudioPacienteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EstudioPacienteResponse>;
        }));
    }

    protected processGetEstudiosPacienteById(response: HttpResponseBase): Observable<EstudioPacienteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EstudioPacienteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEstudiosPacienteByTipoYFecha(request: EstudiosPacientesGetByTipoYFechaQuery): Observable<EstudioPacienteResponse> {
        let url_ = this.baseUrl + "/api/estudiospacientes/getestudiospacientebytipoyfecha";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEstudiosPacienteByTipoYFecha(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEstudiosPacienteByTipoYFecha(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EstudioPacienteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EstudioPacienteResponse>;
        }));
    }

    protected processGetEstudiosPacienteByTipoYFecha(response: HttpResponseBase): Observable<EstudioPacienteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EstudioPacienteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createOrUpdateEstudiosPaciente(request: EstudioPacienteCreateOrUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/estudiospacientes/createorupdateestudiospaciente";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEstudiosPaciente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEstudiosPaciente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrUpdateEstudiosPaciente(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPruebasEstudiosList(request: EstudiosPacientesGetPruebasListQuery): Observable<EstudioPacienteDetalleResponse[]> {
        let url_ = this.baseUrl + "/api/estudiospacientes/getpruebasestudioslist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPruebasEstudiosList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPruebasEstudiosList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EstudioPacienteDetalleResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EstudioPacienteDetalleResponse[]>;
        }));
    }

    protected processGetPruebasEstudiosList(response: HttpResponseBase): Observable<EstudioPacienteDetalleResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EstudioPacienteDetalleResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importarEstudios(request: EstudioPacienteImportCommand): Observable<EstudioPacienteImportarResultDto[]> {
        let url_ = this.baseUrl + "/api/estudiospacientes/importarestudios";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportarEstudios(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportarEstudios(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EstudioPacienteImportarResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EstudioPacienteImportarResultDto[]>;
        }));
    }

    protected processImportarEstudios(response: HttpResponseBase): Observable<EstudioPacienteImportarResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EstudioPacienteImportarResultDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EvolucionMedicaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getEvolucionMedicaList(request: EvolucionMedicaGetListQuery): Observable<PagedResultDtoOfEvolucionMedicaForListResponse> {
        let url_ = this.baseUrl + "/api/evolucionmedica/getevolucionmedicalist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvolucionMedicaList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvolucionMedicaList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfEvolucionMedicaForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfEvolucionMedicaForListResponse>;
        }));
    }

    protected processGetEvolucionMedicaList(response: HttpResponseBase): Observable<PagedResultDtoOfEvolucionMedicaForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEvolucionMedicaForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEvolucionMedicaForEdit(request: EvolucionMedicaGetForEditQuery): Observable<EvolucionMedicaForEditResponse> {
        let url_ = this.baseUrl + "/api/evolucionmedica/getevolucionmedicaforedit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvolucionMedicaForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvolucionMedicaForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EvolucionMedicaForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EvolucionMedicaForEditResponse>;
        }));
    }

    protected processGetEvolucionMedicaForEdit(response: HttpResponseBase): Observable<EvolucionMedicaForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EvolucionMedicaForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createEvolucionMedica(dto: EvolucionMedicaCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/evolucionmedica/createevolucionmedica";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEvolucionMedica(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEvolucionMedica(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateEvolucionMedica(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEvolucionMedica(dto: EvolucionMedicaUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/evolucionmedica/updateevolucionmedica";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEvolucionMedica(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEvolucionMedica(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateEvolucionMedica(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MensajesHL7ServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getMensajeHL7sList(request: MensajeHL7GetListQuery): Observable<PagedResultDtoOfMensajeHL7ForListResponse> {
        let url_ = this.baseUrl + "/api/mensajeshl7/getmensajehl7slist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMensajeHL7sList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMensajeHL7sList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMensajeHL7ForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMensajeHL7ForListResponse>;
        }));
    }

    protected processGetMensajeHL7sList(response: HttpResponseBase): Observable<PagedResultDtoOfMensajeHL7ForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMensajeHL7ForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    programarReenvioMensajesHL7(request: MensajeHL7ResendScheduleCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/mensajeshl7/programarreenviomensajeshl7";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProgramarReenvioMensajesHL7(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgramarReenvioMensajesHL7(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processProgramarReenvioMensajesHL7(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportMensajesHL7Detallado(query: ReportMensajeHL7ExportQuery): Observable<DownloadFileResponseCommon> {
        let url_ = this.baseUrl + "/api/mensajeshl7/getreportmensajeshl7detallado";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportMensajesHL7Detallado(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportMensajesHL7Detallado(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResponseCommon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResponseCommon>;
        }));
    }

    protected processGetReportMensajesHL7Detallado(response: HttpResponseBase): Observable<DownloadFileResponseCommon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponseCommon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportMensajesHL7Concentrado(query: ReportMensajeHL7ConcentradoExportQuery): Observable<DownloadFileResponseCommon> {
        let url_ = this.baseUrl + "/api/mensajeshl7/getreportmensajeshl7concentrado";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportMensajesHL7Concentrado(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportMensajesHL7Concentrado(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResponseCommon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResponseCommon>;
        }));
    }

    protected processGetReportMensajesHL7Concentrado(response: HttpResponseBase): Observable<DownloadFileResponseCommon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponseCommon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getXmlSolicitud(query: MensajeHL7GetSolicitudQuery): Observable<DownloadFileResponseCommon> {
        let url_ = this.baseUrl + "/api/mensajeshl7/getxmlsolicitud";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetXmlSolicitud(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetXmlSolicitud(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResponseCommon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResponseCommon>;
        }));
    }

    protected processGetXmlSolicitud(response: HttpResponseBase): Observable<DownloadFileResponseCommon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponseCommon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getXmlRespuesta(query: MensajeHL7GetRespuestaQuery): Observable<DownloadFileResponseCommon> {
        let url_ = this.baseUrl + "/api/mensajeshl7/getxmlrespuesta";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetXmlRespuesta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetXmlRespuesta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadFileResponseCommon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadFileResponseCommon>;
        }));
    }

    protected processGetXmlRespuesta(response: HttpResponseBase): Observable<DownloadFileResponseCommon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponseCommon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getXmlRespuestasList(query: MensajeHL7GetRespuestasListQuery): Observable<MensajeHL7RespuestaForListResponse[]> {
        let url_ = this.baseUrl + "/api/mensajeshl7/getxmlrespuestaslist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetXmlRespuestasList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetXmlRespuestasList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MensajeHL7RespuestaForListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MensajeHL7RespuestaForListResponse[]>;
        }));
    }

    protected processGetXmlRespuestasList(response: HttpResponseBase): Observable<MensajeHL7RespuestaForListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MensajeHL7RespuestaForListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IntegracionIMSSServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getPacientesPorUrgenciasIMSS(request: BusquedaUrgenciasGetListQuery): Observable<BusquedaIMSSResultDto[]> {
        let url_ = this.baseUrl + "/api/integracionimss/getpacientesporurgenciasimss";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPacientesPorUrgenciasIMSS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPacientesPorUrgenciasIMSS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusquedaIMSSResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusquedaIMSSResultDto[]>;
        }));
    }

    protected processGetPacientesPorUrgenciasIMSS(response: HttpResponseBase): Observable<BusquedaIMSSResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BusquedaIMSSResultDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPacientesPorIMSS(request: BusquedaIMSSGetListQuery): Observable<BusquedaIMSSResponse> {
        let url_ = this.baseUrl + "/api/integracionimss/getpacientesporimss";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPacientesPorIMSS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPacientesPorIMSS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusquedaIMSSResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusquedaIMSSResponse>;
        }));
    }

    protected processGetPacientesPorIMSS(response: HttpResponseBase): Observable<BusquedaIMSSResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BusquedaIMSSResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPacienteIMSSPorIDEE(request: BusquedaIMSSGetByIDEEQuery): Observable<BusquedaIMSSResultDto> {
        let url_ = this.baseUrl + "/api/integracionimss/getpacienteimssporidee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPacienteIMSSPorIDEE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPacienteIMSSPorIDEE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusquedaIMSSResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusquedaIMSSResultDto>;
        }));
    }

    protected processGetPacienteIMSSPorIDEE(response: HttpResponseBase): Observable<BusquedaIMSSResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BusquedaIMSSResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reenviarMensaje(request: BusquedaIMSSReenviarMensajeCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/integracionimss/reenviarmensaje";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReenviarMensaje(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReenviarMensaje(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processReenviarMensaje(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    crearPacienteEnIMSS(request: BusquedaIMSSCrearPacienteCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/integracionimss/crearpacienteenimss";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCrearPacienteEnIMSS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCrearPacienteEnIMSS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCrearPacienteEnIMSS(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CatalogosGeneralesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getPaisesForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getpaisesforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaisesForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaisesForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetPaisesForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEstadosForCombobox(paisId: number | undefined): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getestadosforcombobox?";
        if (paisId === null)
            throw new Error("The parameter 'paisId' cannot be null.");
        else if (paisId !== undefined)
            url_ += "paisId=" + encodeURIComponent("" + paisId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEstadosForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEstadosForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetEstadosForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMunicipiosForCombobox(estadoId: number | undefined): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getmunicipiosforcombobox?";
        if (estadoId === null)
            throw new Error("The parameter 'estadoId' cannot be null.");
        else if (estadoId !== undefined)
            url_ += "estadoId=" + encodeURIComponent("" + estadoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMunicipiosForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMunicipiosForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetMunicipiosForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDelegacionesForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getdelegacionesforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDelegacionesForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDelegacionesForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetDelegacionesForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHospitalesForCombobox(delegacionId: number | null | undefined): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/gethospitalesforcombobox?";
        if (delegacionId !== undefined && delegacionId !== null)
            url_ += "delegacionId=" + encodeURIComponent("" + delegacionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHospitalesForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHospitalesForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetHospitalesForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHospitalByClavePresupuestal(clavePresupuestal: string | null | undefined): Observable<HospitalDto> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/gethospitalbyclavepresupuestal?";
        if (clavePresupuestal !== undefined && clavePresupuestal !== null)
            url_ += "clavePresupuestal=" + encodeURIComponent("" + clavePresupuestal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHospitalByClavePresupuestal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHospitalByClavePresupuestal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HospitalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HospitalDto>;
        }));
    }

    protected processGetHospitalByClavePresupuestal(response: HttpResponseBase): Observable<HospitalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HospitalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInstitucionesAseguradasForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getinstitucionesaseguradasforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInstitucionesAseguradasForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInstitucionesAseguradasForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetInstitucionesAseguradasForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEstatusForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getestatusforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEstatusForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEstatusForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetEstatusForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEstatusEgresosForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getestatusegresosforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEstatusEgresosForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEstatusEgresosForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetEstatusEgresosForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEstatusPermitidosParaPacienteForCombobox(request: EstatusGetPermitidosParaPacienteForComboboxQuery): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getestatuspermitidosparapacienteforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEstatusPermitidosParaPacienteForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEstatusPermitidosParaPacienteForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetEstatusPermitidosParaPacienteForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSexosForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getsexosforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSexosForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSexosForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetSexosForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTiposPacientesIMSSForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/gettipospacientesimssforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiposPacientesIMSSForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiposPacientesIMSSForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetTiposPacientesIMSSForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTiposPacientesIMSSConClaveIMSSForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/gettipospacientesimssconclaveimssforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiposPacientesIMSSConClaveIMSSForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiposPacientesIMSSConClaveIMSSForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetTiposPacientesIMSSConClaveIMSSForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTiposEventosForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/gettiposeventosforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiposEventosForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiposEventosForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetTiposEventosForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTiposCatalogosForCombobox(tipoEventoId: number | undefined): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/gettiposcatalogosforcombobox?";
        if (tipoEventoId === null)
            throw new Error("The parameter 'tipoEventoId' cannot be null.");
        else if (tipoEventoId !== undefined)
            url_ += "tipoEventoId=" + encodeURIComponent("" + tipoEventoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiposCatalogosForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiposCatalogosForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetTiposCatalogosForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMotivosForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getmotivosforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMotivosForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMotivosForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetMotivosForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMotivosIngresoForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getmotivosingresoforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMotivosIngresoForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMotivosIngresoForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetMotivosIngresoForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMotivosSuspensionForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getmotivossuspensionforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMotivosSuspensionForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMotivosSuspensionForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetMotivosSuspensionForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCausasInclusionProgramaList(request: CausaInclusionProgramaGetListQuery): Observable<PagedResultDtoOfCausaInclusionProgramaResponse> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getcausasinclusionprogramalist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCausasInclusionProgramaList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCausasInclusionProgramaList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCausaInclusionProgramaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCausaInclusionProgramaResponse>;
        }));
    }

    protected processGetCausasInclusionProgramaList(response: HttpResponseBase): Observable<PagedResultDtoOfCausaInclusionProgramaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCausaInclusionProgramaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEventosList(request: EventoGetListQuery): Observable<PagedResultDtoOfEventoResponse> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/geteventoslist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventosList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventosList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfEventoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfEventoResponse>;
        }));
    }

    protected processGetEventosList(response: HttpResponseBase): Observable<PagedResultDtoOfEventoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEventoResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMedicamentosList(request: MedicamentoGetListQuery): Observable<PagedResultDtoOfMedicamentoResponse> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getmedicamentoslist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicamentosList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicamentosList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMedicamentoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMedicamentoResponse>;
        }));
    }

    protected processGetMedicamentosList(response: HttpResponseBase): Observable<PagedResultDtoOfMedicamentoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMedicamentoResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFaunaForCombobox(faunaType: number | undefined): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getfaunaforcombobox?";
        if (faunaType === null)
            throw new Error("The parameter 'faunaType' cannot be null.");
        else if (faunaType !== undefined)
            url_ += "faunaType=" + encodeURIComponent("" + faunaType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFaunaForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFaunaForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetFaunaForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTiposAccesosForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/gettiposaccesosforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiposAccesosForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiposAccesosForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetTiposAccesosForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSubTiposAccesosForCombobox(tipoAccesoId: number | undefined): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getsubtiposaccesosforcombobox?";
        if (tipoAccesoId === null)
            throw new Error("The parameter 'tipoAccesoId' cannot be null.");
        else if (tipoAccesoId !== undefined)
            url_ += "tipoAccesoId=" + encodeURIComponent("" + tipoAccesoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubTiposAccesosForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubTiposAccesosForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetSubTiposAccesosForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTiposAccesosVascularesForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/gettiposaccesosvascularesforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiposAccesosVascularesForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiposAccesosVascularesForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetTiposAccesosVascularesForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTecnicasAccesosForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/gettecnicasaccesosforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTecnicasAccesosForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTecnicasAccesosForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetTecnicasAccesosForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCausasFinalesAccesoForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getcausasfinalesaccesoforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCausasFinalesAccesoForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCausasFinalesAccesoForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetCausasFinalesAccesoForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCausasFinalesAccesoParaHDForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getcausasfinalesaccesoparahdforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCausasFinalesAccesoParaHDForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCausasFinalesAccesoParaHDForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetCausasFinalesAccesoParaHDForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTiposTransfusionesForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/gettipostransfusionesforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiposTransfusionesForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiposTransfusionesForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetTiposTransfusionesForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getIncidenciasForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getincidenciasforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncidenciasForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncidenciasForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetIncidenciasForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCausasCambioForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getcausascambioforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCausasCambioForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCausasCambioForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetCausasCambioForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getServiciosHospitalesForCombobox(hospitalId: number | null | undefined): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getservicioshospitalesforcombobox?";
        if (hospitalId !== undefined && hospitalId !== null)
            url_ += "hospitalId=" + encodeURIComponent("" + hospitalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiciosHospitalesForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiciosHospitalesForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetServiciosHospitalesForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getParentescosForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getparentescosforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParentescosForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParentescosForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetParentescosForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSalasHemodialisisForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getsalashemodialisisforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalasHemodialisisForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalasHemodialisisForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetSalasHemodialisisForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMaquinasForCombobox(salaId: number | undefined): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getmaquinasforcombobox?";
        if (salaId === null)
            throw new Error("The parameter 'salaId' cannot be null.");
        else if (salaId !== undefined)
            url_ += "salaId=" + encodeURIComponent("" + salaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaquinasForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaquinasForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetMaquinasForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMaquinasConNumeroSerieForCombobox(salaId: number | undefined): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getmaquinasconnumeroserieforcombobox?";
        if (salaId === null)
            throw new Error("The parameter 'salaId' cannot be null.");
        else if (salaId !== undefined)
            url_ += "salaId=" + encodeURIComponent("" + salaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaquinasConNumeroSerieForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaquinasConNumeroSerieForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetMaquinasConNumeroSerieForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTiposPacientesForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/gettipospacientesforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiposPacientesForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiposPacientesForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetTiposPacientesForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTiposHemodialisisForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/gettiposhemodialisisforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiposHemodialisisForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiposHemodialisisForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetTiposHemodialisisForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTiposPerfilesSodioForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/gettiposperfilessodioforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiposPerfilesSodioForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiposPerfilesSodioForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetTiposPerfilesSodioForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTiposHeparinaForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/gettiposheparinaforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiposHeparinaForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiposHeparinaForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetTiposHeparinaForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTiposFiltrosDializadoresForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/gettiposfiltrosdializadoresforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiposFiltrosDializadoresForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiposFiltrosDializadoresForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetTiposFiltrosDializadoresForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTipoFiltroDializador(id: number | undefined): Observable<TipoFiltroDializadorDto> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/gettipofiltrodializador?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipoFiltroDializador(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipoFiltroDializador(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipoFiltroDializadorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipoFiltroDializadorDto>;
        }));
    }

    protected processGetTipoFiltroDializador(response: HttpResponseBase): Observable<TipoFiltroDializadorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TipoFiltroDializadorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTiposConcentradosForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/gettiposconcentradosforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiposConcentradosForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiposConcentradosForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetTiposConcentradosForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTipoConcentrado(id: number | undefined): Observable<TipoConcentradoDto> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/gettipoconcentrado?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipoConcentrado(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipoConcentrado(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipoConcentradoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipoConcentradoDto>;
        }));
    }

    protected processGetTipoConcentrado(response: HttpResponseBase): Observable<TipoConcentradoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TipoConcentradoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEstatusMaquinasForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getestatusmaquinasforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEstatusMaquinasForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEstatusMaquinasForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetEstatusMaquinasForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEstatusCitasForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getestatuscitasforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEstatusCitasForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEstatusCitasForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetEstatusCitasForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTiposSesionesHDForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/gettipossesioneshdforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiposSesionesHDForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiposSesionesHDForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetTiposSesionesHDForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMaterialesForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getmaterialesforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaterialesForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialesForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetMaterialesForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSigosSintomasForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getsigossintomasforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSigosSintomasForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSigosSintomasForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetSigosSintomasForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGruposSanguineosForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getgrupossanguineosforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGruposSanguineosForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGruposSanguineosForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetGruposSanguineosForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTiposDiagnosticosForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/gettiposdiagnosticosforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiposDiagnosticosForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiposDiagnosticosForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetTiposDiagnosticosForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGruposAlimentosForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getgruposalimentosforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGruposAlimentosForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGruposAlimentosForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetGruposAlimentosForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAlimentosForCombobox(grupoAlimentoId: number | null | undefined): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getalimentosforcombobox?";
        if (grupoAlimentoId !== undefined && grupoAlimentoId !== null)
            url_ += "grupoAlimentoId=" + encodeURIComponent("" + grupoAlimentoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlimentosForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlimentosForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetAlimentosForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAlimento(alimentoId: number | undefined): Observable<AlimentoDto> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getalimento?";
        if (alimentoId === null)
            throw new Error("The parameter 'alimentoId' cannot be null.");
        else if (alimentoId !== undefined)
            url_ += "alimentoId=" + encodeURIComponent("" + alimentoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlimento(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlimento(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlimentoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlimentoDto>;
        }));
    }

    protected processGetAlimento(response: HttpResponseBase): Observable<AlimentoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlimentoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTiposContantesMaquinasHdPorTipoContante(tipoConstanteId: number | undefined): Observable<TipoConstanteMaquinaHDDto[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/gettiposcontantesmaquinashdportipocontante?";
        if (tipoConstanteId === null)
            throw new Error("The parameter 'tipoConstanteId' cannot be null.");
        else if (tipoConstanteId !== undefined)
            url_ += "tipoConstanteId=" + encodeURIComponent("" + tipoConstanteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiposContantesMaquinasHdPorTipoContante(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiposContantesMaquinasHdPorTipoContante(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipoConstanteMaquinaHDDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipoConstanteMaquinaHDDto[]>;
        }));
    }

    protected processGetTiposContantesMaquinasHdPorTipoContante(response: HttpResponseBase): Observable<TipoConstanteMaquinaHDDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TipoConstanteMaquinaHDDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTiposMensajesHL7ForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/gettiposmensajeshl7forcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiposMensajesHL7ForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiposMensajesHL7ForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetTiposMensajesHL7ForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCodigosRespuestasMensajesHL7ForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getcodigosrespuestasmensajeshl7forcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCodigosRespuestasMensajesHL7ForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCodigosRespuestasMensajesHL7ForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetCodigosRespuestasMensajesHL7ForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEstatusMensajesHL7ForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/getestatusmensajeshl7forcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEstatusMensajesHL7ForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEstatusMensajesHL7ForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetEstatusMensajesHL7ForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTiposEstudiosForCombobox(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/catalogosgenerales/gettiposestudiosforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiposEstudiosForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiposEstudiosForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetTiposEstudiosForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DynamicCatalogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getForCombobox(request: DynamicCatalogGetComboboxQuery): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/dynamiccatalog/getforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetForCombobox(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDynamicCatalogVistaDefinitionsList(request: DynamicCatalogGetVistaInfoQuery): Observable<DynamicCatalogViewInfoResponse> {
        let url_ = this.baseUrl + "/api/dynamiccatalog/getdynamiccatalogvistadefinitionslist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDynamicCatalogVistaDefinitionsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDynamicCatalogVistaDefinitionsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DynamicCatalogViewInfoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DynamicCatalogViewInfoResponse>;
        }));
    }

    protected processGetDynamicCatalogVistaDefinitionsList(response: HttpResponseBase): Observable<DynamicCatalogViewInfoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DynamicCatalogViewInfoResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDynamicCatalogFormDefinitionsList(request: DynamicCatalogGetFormInfoQuery): Observable<DynamicCatalogFormInfoResponse> {
        let url_ = this.baseUrl + "/api/dynamiccatalog/getdynamiccatalogformdefinitionslist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDynamicCatalogFormDefinitionsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDynamicCatalogFormDefinitionsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DynamicCatalogFormInfoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DynamicCatalogFormInfoResponse>;
        }));
    }

    protected processGetDynamicCatalogFormDefinitionsList(response: HttpResponseBase): Observable<DynamicCatalogFormInfoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DynamicCatalogFormInfoResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getList(request: DataListQuery): Observable<{ [key: string]: any; }[]> {
        let url_ = this.baseUrl + "/api/dynamiccatalog/getlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: any; }[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: any; }[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<{ [key: string]: any; }[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(request: DataByIdQuery): Observable<{ [key: string]: any; }> {
        let url_ = this.baseUrl + "/api/dynamiccatalog/getbyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: any; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: any; }>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<{ [key: string]: any; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(request: DynamicCatalogCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/dynamiccatalog/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(request: DynamicCatalogUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/dynamiccatalog/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(request: DynamicCatalogDeleteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/dynamiccatalog/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReferencedCombobox(request: GetReferencedComboboxQuery): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/dynamiccatalog/getreferencedcombobox";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReferencedCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReferencedCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetReferencedCombobox(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDynamicCombobox(): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/dynamiccatalog/getdynamiccombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDynamicCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDynamicCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetDynamicCombobox(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HospitalesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getHospitalesList(request: HospitalGetListQuery): Observable<PagedResultDtoOfHospitalForListResponse> {
        let url_ = this.baseUrl + "/api/hospitales/gethospitaleslist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHospitalesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHospitalesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfHospitalForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfHospitalForListResponse>;
        }));
    }

    protected processGetHospitalesList(response: HttpResponseBase): Observable<PagedResultDtoOfHospitalForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfHospitalForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHospitalForEdit(request: HospitalGetForEditQuery): Observable<HospitalForEditResponse> {
        let url_ = this.baseUrl + "/api/hospitales/gethospitalforedit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHospitalForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHospitalForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HospitalForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HospitalForEditResponse>;
        }));
    }

    protected processGetHospitalForEdit(response: HttpResponseBase): Observable<HospitalForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HospitalForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHospitalesForCombobox(request: HospitalGetForComboboxQuery): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/hospitales/gethospitalesforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHospitalesForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHospitalesForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetHospitalesForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHospitalById(request: HospitalGetByIdQuery): Observable<HospitalResponse> {
        let url_ = this.baseUrl + "/api/hospitales/gethospitalbyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHospitalById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHospitalById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HospitalResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HospitalResponse>;
        }));
    }

    protected processGetHospitalById(response: HttpResponseBase): Observable<HospitalResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HospitalResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createHospital(request: HospitalCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/hospitales/createhospital";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateHospital(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateHospital(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateHospital(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateHospital(request: HospitalUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/hospitales/updatehospital";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateHospital(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateHospital(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateHospital(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MedicosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getMedicosList(request: MedicoGetListQuery): Observable<PagedResultDtoOfMedicoForListResponse> {
        let url_ = this.baseUrl + "/api/medicos/getmedicoslist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicosList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicosList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMedicoForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMedicoForListResponse>;
        }));
    }

    protected processGetMedicosList(response: HttpResponseBase): Observable<PagedResultDtoOfMedicoForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMedicoForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMedicosAutocompleteList(request: MedicoGetAutocompleteListQuery): Observable<MedicoForListResponse[]> {
        let url_ = this.baseUrl + "/api/medicos/getmedicosautocompletelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicosAutocompleteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicosAutocompleteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicoForListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicoForListResponse[]>;
        }));
    }

    protected processGetMedicosAutocompleteList(response: HttpResponseBase): Observable<MedicoForListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MedicoForListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMedicoForEdit(request: MedicoGetForEditQuery): Observable<MedicoForEditResponse> {
        let url_ = this.baseUrl + "/api/medicos/getmedicoforedit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicoForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicoForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicoForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicoForEditResponse>;
        }));
    }

    protected processGetMedicoForEdit(response: HttpResponseBase): Observable<MedicoForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicoForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMedicosForCombobox(request: MedicoGetForComboboxQuery): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/medicos/getmedicosforcombobox";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicosForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicosForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetMedicosForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMedicoById(request: MedicoGetByIdQuery): Observable<MedicoResponse> {
        let url_ = this.baseUrl + "/api/medicos/getmedicobyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicoById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicoById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicoResponse>;
        }));
    }

    protected processGetMedicoById(response: HttpResponseBase): Observable<MedicoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicoResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParametrosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getParametro(query: ParametroGetByNameQuery): Observable<ParametroResponse> {
        let url_ = this.baseUrl + "/api/parametros/getparametro";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParametro(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParametro(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParametroResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParametroResponse>;
        }));
    }

    protected processGetParametro(response: HttpResponseBase): Observable<ParametroResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParametroResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PatientsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getPatientList(request: PatientGetListQuery): Observable<PagedResultDtoOfPatientForListResponse> {
        let url_ = this.baseUrl + "/api/patients/getpatientlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPatientForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPatientForListResponse>;
        }));
    }

    protected processGetPatientList(response: HttpResponseBase): Observable<PagedResultDtoOfPatientForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPatientForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPatientsLocalSearchList(request: GetPatientLocalSearchListQuery): Observable<PagedResultDtoOfPatientForListResponse> {
        let url_ = this.baseUrl + "/api/patients/getpatientslocalsearchlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientsLocalSearchList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientsLocalSearchList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPatientForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPatientForListResponse>;
        }));
    }

    protected processGetPatientsLocalSearchList(response: HttpResponseBase): Observable<PagedResultDtoOfPatientForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPatientForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPatientForEdit(request: PatientGetForEditQuery): Observable<PatientForEditResponse> {
        let url_ = this.baseUrl + "/api/patients/getpatientforedit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientForEditResponse>;
        }));
    }

    protected processGetPatientForEdit(response: HttpResponseBase): Observable<PatientForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPatientById(request: PatientGetByIdQuery): Observable<PatientResponse> {
        let url_ = this.baseUrl + "/api/patients/getpatientbyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientResponse>;
        }));
    }

    protected processGetPatientById(response: HttpResponseBase): Observable<PatientResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPatientByCURP(request: PatientGetByCURPQuery): Observable<PatientResponse> {
        let url_ = this.baseUrl + "/api/patients/getpatientbycurp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientByCURP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientByCURP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientResponse>;
        }));
    }

    protected processGetPatientByCURP(response: HttpResponseBase): Observable<PatientResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPatient(request: PatientCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/patients/createpatient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePatient(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePatient(request: PatientUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/patients/updatepatient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdatePatient(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPatientFaunaList(request: PatientFaunaGetListQuery): Observable<PagedResultDtoOfPatientFaunaForListResponse> {
        let url_ = this.baseUrl + "/api/patients/getpatientfaunalist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientFaunaList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientFaunaList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPatientFaunaForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPatientFaunaForListResponse>;
        }));
    }

    protected processGetPatientFaunaList(response: HttpResponseBase): Observable<PagedResultDtoOfPatientFaunaForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPatientFaunaForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPatientFauna(request: PatientFaunaCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/patients/createpatientfauna";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePatientFauna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePatientFauna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePatientFauna(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePatientFauna(request: PatientFaunaDeleteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/patients/deletepatientfauna";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePatientFauna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePatientFauna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeletePatientFauna(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPatientAllergieList(request: PatientAllergieGetListQuery): Observable<PagedResultDtoOfPatientAllergieForListResponse> {
        let url_ = this.baseUrl + "/api/patients/getpatientallergielist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientAllergieList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientAllergieList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPatientAllergieForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPatientAllergieForListResponse>;
        }));
    }

    protected processGetPatientAllergieList(response: HttpResponseBase): Observable<PagedResultDtoOfPatientAllergieForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPatientAllergieForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPatientAllergie(request: PatientAllergieCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/patients/createpatientallergie";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePatientAllergie(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePatientAllergie(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePatientAllergie(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePatientAllergie(request: PatientAllergieDeleteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/patients/deletepatientallergie";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePatientAllergie(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePatientAllergie(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeletePatientAllergie(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPatientMedicalHistoryList(request: PatientMedicalHistoryGetListQuery): Observable<PagedResultDtoOfPatientMedicalHistoryForListResponse> {
        let url_ = this.baseUrl + "/api/patients/getpatientmedicalhistorylist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientMedicalHistoryList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientMedicalHistoryList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPatientMedicalHistoryForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPatientMedicalHistoryForListResponse>;
        }));
    }

    protected processGetPatientMedicalHistoryList(response: HttpResponseBase): Observable<PagedResultDtoOfPatientMedicalHistoryForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPatientMedicalHistoryForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPatientMedicalHistoryById(request: PatientMedicalHistoryGetByIdQuery): Observable<PatientMedicalHistoryResponse> {
        let url_ = this.baseUrl + "/api/patients/getpatientmedicalhistorybyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientMedicalHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientMedicalHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientMedicalHistoryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientMedicalHistoryResponse>;
        }));
    }

    protected processGetPatientMedicalHistoryById(response: HttpResponseBase): Observable<PatientMedicalHistoryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicalHistoryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPatientMedicalHistory(request: PatientMedicalHistoryCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/patients/createpatientmedicalhistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePatientMedicalHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePatientMedicalHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePatientMedicalHistory(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePatientMedicalHistory(request: PatientMedicalHistoryDeleteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/patients/deletepatientmedicalhistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePatientMedicalHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePatientMedicalHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeletePatientMedicalHistory(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPatientMedicationList(request: PatientMedicationGetListQuery): Observable<PagedResultDtoOfPatientMedicationForListResponse> {
        let url_ = this.baseUrl + "/api/patients/getpatientmedicationlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientMedicationList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientMedicationList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPatientMedicationForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPatientMedicationForListResponse>;
        }));
    }

    protected processGetPatientMedicationList(response: HttpResponseBase): Observable<PagedResultDtoOfPatientMedicationForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPatientMedicationForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPatientMedicationById(request: PatientMedicationGetByIdQuery): Observable<PatientMedicationResponse> {
        let url_ = this.baseUrl + "/api/patients/getpatientmedicationbyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientMedicationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientMedicationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientMedicationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientMedicationResponse>;
        }));
    }

    protected processGetPatientMedicationById(response: HttpResponseBase): Observable<PatientMedicationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPatientMedication(request: PatientMedicationCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/patients/createpatientmedication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePatientMedication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePatientMedication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePatientMedication(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePatientMedication(request: PatientMedicationDeleteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/patients/deletepatientmedication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePatientMedication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePatientMedication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeletePatientMedication(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isValidPatientOnCIRC(query: PatientGetIsCIRCValidQuery): Observable<PatientIsValidCIRCResponse> {
        let url_ = this.baseUrl + "/api/patients/isvalidpatientoncirc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsValidPatientOnCIRC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsValidPatientOnCIRC(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientIsValidCIRCResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientIsValidCIRCResponse>;
        }));
    }

    protected processIsValidPatientOnCIRC(response: HttpResponseBase): Observable<PatientIsValidCIRCResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientIsValidCIRCResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getAuditLogList(query: AuditLogGetListQuery): Observable<PagedResultDtoOfAuditLogListResponse> {
        let url_ = this.baseUrl + "/api/auditlog/getauditloglist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAuditLogListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAuditLogListResponse>;
        }));
    }

    protected processGetAuditLogList(response: HttpResponseBase): Observable<PagedResultDtoOfAuditLogListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAuditLogListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAuditLogsToExcel(query: AuditLogGetExcelQuery): Observable<AuditLogExcelResponse> {
        let url_ = this.baseUrl + "/api/auditlog/getauditlogstoexcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditLogExcelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditLogExcelResponse>;
        }));
    }

    protected processGetAuditLogsToExcel(response: HttpResponseBase): Observable<AuditLogExcelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditLogExcelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportAuditLog(query: AuditLogExportQuery): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/auditlog/exportauditlog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAuditLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAuditLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportAuditLog(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportCSVAuditLog(query: AuditLogExportCSVQuery): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/auditlog/exportcsvauditlog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCSVAuditLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCSVAuditLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportCSVAuditLog(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPDFAuditLog(query: AuditLogExportPDFQuery): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/auditlog/exportpdfauditlog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPDFAuditLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPDFAuditLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportPDFAuditLog(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    login(query: UserLoginQuery): Observable<SessionLoginResponseController> {
        let url_ = this.baseUrl + "/api/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SessionLoginResponseController>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SessionLoginResponseController>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<SessionLoginResponseController> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SessionLoginResponseController.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    loginByToken(): Observable<SessionLoginResponseController> {
        let url_ = this.baseUrl + "/api/auth/loginbytoken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginByToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginByToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SessionLoginResponseController>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SessionLoginResponseController>;
        }));
    }

    protected processLoginByToken(response: HttpResponseBase): Observable<SessionLoginResponseController> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SessionLoginResponseController.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    loginByMicrosoft(query: UserLoginMicrosoftQuery): Observable<SessionLoginResponseController> {
        let url_ = this.baseUrl + "/api/auth/loginbymicrosoft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginByMicrosoft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginByMicrosoft(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SessionLoginResponseController>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SessionLoginResponseController>;
        }));
    }

    protected processLoginByMicrosoft(response: HttpResponseBase): Observable<SessionLoginResponseController> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SessionLoginResponseController.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    impersonalizeTenant(query: UserImpersonalizeQuery): Observable<SessionLoginResponseController> {
        let url_ = this.baseUrl + "/api/auth/impersonalizetenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonalizeTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonalizeTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SessionLoginResponseController>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SessionLoginResponseController>;
        }));
    }

    protected processImpersonalizeTenant(response: HttpResponseBase): Observable<SessionLoginResponseController> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SessionLoginResponseController.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    impersonalizeUser(user: number | undefined): Observable<SessionLoginResponseController> {
        let url_ = this.baseUrl + "/api/auth/impersonalizeuser?";
        if (user === null)
            throw new Error("The parameter 'user' cannot be null.");
        else if (user !== undefined)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonalizeUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonalizeUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SessionLoginResponseController>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SessionLoginResponseController>;
        }));
    }

    protected processImpersonalizeUser(response: HttpResponseBase): Observable<SessionLoginResponseController> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SessionLoginResponseController.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changePassword(dto: UserChangePasswordCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/auth/changep";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPassword(dto: UserResetPasswordCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/auth/resetp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    confirmResetPassword(dto: ConfirmPasswordCommandReset): Observable<number> {
        let url_ = this.baseUrl + "/api/auth/confirmresetp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processConfirmResetPassword(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    logout(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/auth/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ChangeLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getChangeLogList(query: ChangeLogGetListQuery): Observable<PagedResultDtoOfChangeLogForListResponse> {
        let url_ = this.baseUrl + "/api/changelog/getchangeloglist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChangeLogList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChangeLogList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfChangeLogForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfChangeLogForListResponse>;
        }));
    }

    protected processGetChangeLogList(response: HttpResponseBase): Observable<PagedResultDtoOfChangeLogForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfChangeLogForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ChatMessageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getChatMessageList(query: ChatMessageGetListQuery): Observable<PagedResultDtoOfChatMessageListResponse> {
        let url_ = this.baseUrl + "/api/chatmessage/getchatmessagelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatMessageList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatMessageList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfChatMessageListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfChatMessageListResponse>;
        }));
    }

    protected processGetChatMessageList(response: HttpResponseBase): Observable<PagedResultDtoOfChatMessageListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfChatMessageListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markAllUnreadMessagesOfUserAsRead(query: ChatMessageMarkReadCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/chatmessage/markallunreadmessagesofuserasread";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAllUnreadMessagesOfUserAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAllUnreadMessagesOfUserAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processMarkAllUnreadMessagesOfUserAsRead(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ChatRoomServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getChatRoomList(query: ChatRoomGetListQuery): Observable<PagedResultDtoOfChatRoomForListResponse> {
        let url_ = this.baseUrl + "/api/chatroom/getchatroomlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatRoomList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatRoomList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfChatRoomForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfChatRoomForListResponse>;
        }));
    }

    protected processGetChatRoomList(response: HttpResponseBase): Observable<PagedResultDtoOfChatRoomForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfChatRoomForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChatRoom(id: number): Observable<ChatRoomResponse> {
        let url_ = this.baseUrl + "/api/chatroom/getchatroom/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatRoom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatRoom(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatRoomResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatRoomResponse>;
        }));
    }

    protected processGetChatRoom(response: HttpResponseBase): Observable<ChatRoomResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatRoomResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChatRoomByChatRoomId(chatRoomId: string | null | undefined): Observable<ChatRoomResponse> {
        let url_ = this.baseUrl + "/api/chatroom/getchatroombychatroomid?";
        if (chatRoomId !== undefined && chatRoomId !== null)
            url_ += "chatRoomId=" + encodeURIComponent("" + chatRoomId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatRoomByChatRoomId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatRoomByChatRoomId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatRoomResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatRoomResponse>;
        }));
    }

    protected processGetChatRoomByChatRoomId(response: HttpResponseBase): Observable<ChatRoomResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatRoomResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChatRoomForEdit(dto: ChatRoomGetForEditQuery): Observable<ChatRoomForEditResponse> {
        let url_ = this.baseUrl + "/api/chatroom/getchatroomforedit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatRoomForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatRoomForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatRoomForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatRoomForEditResponse>;
        }));
    }

    protected processGetChatRoomForEdit(response: HttpResponseBase): Observable<ChatRoomForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatRoomForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrCreateChatRoom(dto: ChatRoomGetOrCreateCommand): Observable<ChatRoomResponse> {
        let url_ = this.baseUrl + "/api/chatroom/getorcreatechatroom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrCreateChatRoom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrCreateChatRoom(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatRoomResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatRoomResponse>;
        }));
    }

    protected processGetOrCreateChatRoom(response: HttpResponseBase): Observable<ChatRoomResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatRoomResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createChatRoom(dto: ChatRoomCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/chatroom/createchatroom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateChatRoom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateChatRoom(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateChatRoom(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateChatRoom(dto: ChatRoomUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/chatroom/updatechatroom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateChatRoom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateChatRoom(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateChatRoom(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChatRoomChatList(query: ChatRoomChatGetListQuery): Observable<PagedResultDtoOfChatRoomChatForListResponse> {
        let url_ = this.baseUrl + "/api/chatroom/getchatroomchatlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatRoomChatList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatRoomChatList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfChatRoomChatForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfChatRoomChatForListResponse>;
        }));
    }

    protected processGetChatRoomChatList(response: HttpResponseBase): Observable<PagedResultDtoOfChatRoomChatForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfChatRoomChatForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChatRoomChatForLogList(request: ChatRoomChatGetForLogListQuery): Observable<ChatRoomChatForListResponse[]> {
        let url_ = this.baseUrl + "/api/chatroom/getchatroomchatforloglist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatRoomChatForLogList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatRoomChatForLogList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatRoomChatForListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatRoomChatForListResponse[]>;
        }));
    }

    protected processGetChatRoomChatForLogList(response: HttpResponseBase): Observable<ChatRoomChatForListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChatRoomChatForListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createChatRoomChat(dto: ChatRoomChatCreateCommand): Observable<ChatRoomChatResponse> {
        let url_ = this.baseUrl + "/api/chatroom/createchatroomchat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateChatRoomChat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateChatRoomChat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatRoomChatResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatRoomChatResponse>;
        }));
    }

    protected processCreateChatRoomChat(response: HttpResponseBase): Observable<ChatRoomChatResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatRoomChatResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getFile(uuid: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/file/getfile?";
        if (uuid !== undefined && uuid !== null)
            url_ += "uuid=" + encodeURIComponent("" + uuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadFileByUUID(uuid: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/file/downloadfilebyuuid?";
        if (uuid !== undefined && uuid !== null)
            url_ += "uuid=" + encodeURIComponent("" + uuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFileByUUID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFileByUUID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadFileByUUID(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFileB64(uuid: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/file/getfileb64?";
        if (uuid !== undefined && uuid !== null)
            url_ += "uuid=" + encodeURIComponent("" + uuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileB64(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileB64(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFileB64(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadTemp(file: FileParameter | null | undefined): Observable<FileUploadResponse> {
        let url_ = this.baseUrl + "/api/file/uploadtemp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadTemp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadTemp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadResponse>;
        }));
    }

    protected processUploadTemp(response: HttpResponseBase): Observable<FileUploadResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFileTemp(tempFileName: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/file/getfiletemp?";
        if (tempFileName !== undefined && tempFileName !== null)
            url_ += "tempFileName=" + encodeURIComponent("" + tempFileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileTemp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileTemp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetFileTemp(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadTempFile(fileName: string | null | undefined, fileType: string | null | undefined, fileToken: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/file/downloadtempfile?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (fileType !== undefined && fileType !== null)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (fileToken !== undefined && fileToken !== null)
            url_ += "fileToken=" + encodeURIComponent("" + fileToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTempFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTempFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadTempFile(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadTempFilePDF(tempFileName: string | null | undefined, downloadName: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/file/downloadtempfilepdf?";
        if (tempFileName !== undefined && tempFileName !== null)
            url_ += "tempFileName=" + encodeURIComponent("" + tempFileName) + "&";
        if (downloadName !== undefined && downloadName !== null)
            url_ += "downloadName=" + encodeURIComponent("" + downloadName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTempFilePDF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTempFilePDF(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadTempFilePDF(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FriendshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getFriendshipList(query: FriendshipGetListQuery): Observable<PagedResultDtoOfFriendshipListResponse> {
        let url_ = this.baseUrl + "/api/friendship/getfriendshiplist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFriendshipList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFriendshipList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfFriendshipListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfFriendshipListResponse>;
        }));
    }

    protected processGetFriendshipList(response: HttpResponseBase): Observable<PagedResultDtoOfFriendshipListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfFriendshipListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createFriendship(query: FriendshipCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/friendship/createfriendship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFriendship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFriendship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateFriendship(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    blockFriendship(query: FriendshipBlockCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/friendship/blockfriendship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBlockFriendship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBlockFriendship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processBlockFriendship(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unblockFriendship(query: FriendshipUnblockCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/friendship/unblockfriendship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnblockFriendship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnblockFriendship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUnblockFriendship(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HelpServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getHelpList(query: HelpGetListQuery): Observable<PagedResultDtoOfHelpForListResponse> {
        let url_ = this.baseUrl + "/api/help/gethelplist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHelpList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHelpList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfHelpForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfHelpForListResponse>;
        }));
    }

    protected processGetHelpList(response: HttpResponseBase): Observable<PagedResultDtoOfHelpForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfHelpForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportHelp(query: HelpExportQuery): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/help/exporthelp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportHelp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportHelp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportHelp(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportCSVHelp(query: HelpExportCSVQuery): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/help/exportcsvhelp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCSVHelp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCSVHelp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportCSVHelp(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPDFHelp(query: HelpExportPDFQuery): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/help/exportpdfhelp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPDFHelp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPDFHelp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportPDFHelp(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHelp(id: number): Observable<HelpResponse> {
        let url_ = this.baseUrl + "/api/help/gethelp/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHelp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHelp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HelpResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HelpResponse>;
        }));
    }

    protected processGetHelp(response: HttpResponseBase): Observable<HelpResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HelpResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHelpByKeyForCurrentUser(key: string): Observable<HelpResponse> {
        let url_ = this.baseUrl + "/api/help/gethelpbykeyforcurrentuser/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHelpByKeyForCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHelpByKeyForCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HelpResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HelpResponse>;
        }));
    }

    protected processGetHelpByKeyForCurrentUser(response: HttpResponseBase): Observable<HelpResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HelpResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHelpForEdit(dto: HelpGetForEditQuery): Observable<HelpForEditResponse> {
        let url_ = this.baseUrl + "/api/help/gethelpforedit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHelpForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHelpForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HelpForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HelpForEditResponse>;
        }));
    }

    protected processGetHelpForEdit(response: HttpResponseBase): Observable<HelpForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HelpForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createHelp(dto: HelpCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/help/createhelp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateHelp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateHelp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateHelp(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateHelp(dto: HelpUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/help/updatehelp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateHelp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateHelp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateHelp(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteHelp(id: number): Observable<number> {
        let url_ = this.baseUrl + "/api/help/deletehelp/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteHelp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteHelp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteHelp(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HostSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getSettingsForEdit(dto: HostSettingsGetForEditQuery): Observable<HostSettingsForEditResponse> {
        let url_ = this.baseUrl + "/api/hostsettings/getsettingsforedit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettingsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettingsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HostSettingsForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HostSettingsForEditResponse>;
        }));
    }

    protected processGetSettingsForEdit(response: HttpResponseBase): Observable<HostSettingsForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HostSettingsForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAllSettings(dto: HostSettingsUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/hostsettings/updateallsettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendTestEmail(dto: HostSettingsSendTestEmailCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/hostsettings/sendtestemail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LanguageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getLanguageList(query: LanguageGetListQuery): Observable<PagedResultDtoOfLanguageForListResponse> {
        let url_ = this.baseUrl + "/api/language/getlanguagelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLanguageForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLanguageForListResponse>;
        }));
    }

    protected processGetLanguageList(response: HttpResponseBase): Observable<PagedResultDtoOfLanguageForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLanguageForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportLanguage(query: LanguageExportQuery): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/language/exportlanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportLanguage(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportCSVLanguage(query: LanguageExportCSVQuery): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/language/exportcsvlanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCSVLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCSVLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportCSVLanguage(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPDFLanguage(query: LanguageExportPDFQuery): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/language/exportpdflanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPDFLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPDFLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportPDFLanguage(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLanguage(id: number): Observable<LanguageResponse> {
        let url_ = this.baseUrl + "/api/language/getlanguage/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LanguageResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LanguageResponse>;
        }));
    }

    protected processGetLanguage(response: HttpResponseBase): Observable<LanguageResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LanguageResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLanguageForEdit(dto: LanguageGetForEditQuery): Observable<LanguageForEditResponse> {
        let url_ = this.baseUrl + "/api/language/getlanguageforedit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LanguageForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LanguageForEditResponse>;
        }));
    }

    protected processGetLanguageForEdit(response: HttpResponseBase): Observable<LanguageForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LanguageForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createLanguage(dto: LanguageCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/language/createlanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateLanguage(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateLanguage(dto: LanguageUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/language/updatelanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateLanguage(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteLanguage(id: number): Observable<number> {
        let url_ = this.baseUrl + "/api/language/deletelanguage/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteLanguage(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setLanguageDefault(language: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/language/setlanguagedefault?";
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetLanguageDefault(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetLanguageDefault(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSetLanguageDefault(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLanguageTextList(query: LanguageTextGetListQuery): Observable<PagedResultDtoOfLanguageTextForListResponse> {
        let url_ = this.baseUrl + "/api/language/getlanguagetextlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageTextList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageTextList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLanguageTextForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLanguageTextForListResponse>;
        }));
    }

    protected processGetLanguageTextList(response: HttpResponseBase): Observable<PagedResultDtoOfLanguageTextForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLanguageTextForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLanguageText(id: number): Observable<LanguageTextResponse> {
        let url_ = this.baseUrl + "/api/language/getlanguagetext/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LanguageTextResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LanguageTextResponse>;
        }));
    }

    protected processGetLanguageText(response: HttpResponseBase): Observable<LanguageTextResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LanguageTextResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLanguageTextForEdit(dto: LanguageTextGetForEditQuery): Observable<LanguageTextForEditResponse> {
        let url_ = this.baseUrl + "/api/language/getlanguagetextforedit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageTextForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageTextForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LanguageTextForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LanguageTextForEditResponse>;
        }));
    }

    protected processGetLanguageTextForEdit(response: HttpResponseBase): Observable<LanguageTextForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LanguageTextForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateLanguageText(dto: LanguageTextUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/language/updatelanguagetext";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLanguageText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLanguageText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateLanguageText(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MailGroupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getMailGroupList(query: MailGroupGetListQuery): Observable<PagedResultDtoOfMailGroupListResponse> {
        let url_ = this.baseUrl + "/api/mailgroup/getmailgrouplist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailGroupList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailGroupList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMailGroupListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMailGroupListResponse>;
        }));
    }

    protected processGetMailGroupList(response: HttpResponseBase): Observable<PagedResultDtoOfMailGroupListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMailGroupListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createMailGroup(dto: MailGroupCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/mailgroup/createmailgroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMailGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMailGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateMailGroup(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateMailGroup(dto: MailGroupUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/mailgroup/updatemailgroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMailGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMailGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateMailGroup(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMailGroupForEdit(dto: MailGroupGetForEditQuery): Observable<MailGroupForEditResponse> {
        let url_ = this.baseUrl + "/api/mailgroup/getmailgroupforedit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailGroupForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailGroupForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailGroupForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailGroupForEditResponse>;
        }));
    }

    protected processGetMailGroupForEdit(response: HttpResponseBase): Observable<MailGroupForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MailGroupForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copyMailGroup(dto: MailGroupCopyCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/mailgroup/copymailgroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyMailGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyMailGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCopyMailGroup(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkMailGroup(dto: MailGroupCheckCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/mailgroup/checkmailgroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckMailGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckMailGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCheckMailGroup(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unCheckMailGroup(dto: MailGroupUnCheckCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/mailgroup/uncheckmailgroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnCheckMailGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnCheckMailGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUnCheckMailGroup(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMailTemplateList(query: MailTemplateGetListQuery): Observable<PagedResultDtoOfMailTemplateListResponse> {
        let url_ = this.baseUrl + "/api/mailgroup/getmailtemplatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailTemplateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailTemplateList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMailTemplateListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMailTemplateListResponse>;
        }));
    }

    protected processGetMailTemplateList(response: HttpResponseBase): Observable<PagedResultDtoOfMailTemplateListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMailTemplateListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createMailTemplate(dto: MailTemplateCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/mailgroup/createmailtemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMailTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateMailTemplate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateMailTemplate(dto: MailTemplateUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/mailgroup/updatemailtemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMailTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateMailTemplate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMailTemplateForEdit(dto: MailTemplateGetForEditQuery): Observable<MailTemplateForEditResponse> {
        let url_ = this.baseUrl + "/api/mailgroup/getmailtemplateforedit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailTemplateForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailTemplateForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailTemplateForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailTemplateForEditResponse>;
        }));
    }

    protected processGetMailTemplateForEdit(response: HttpResponseBase): Observable<MailTemplateForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MailTemplateForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendTestEmail(dto: MailTemplateSendTestCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/mailgroup/sendtestemail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMailTemplateGetBodyParamList(query: MailTemplateGetBodyParamListQuery): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/mailgroup/getmailtemplategetbodyparamlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailTemplateGetBodyParamList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailTemplateGetBodyParamList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetMailTemplateGetBodyParamList(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMailTemplateGetMailKeyAvailableList(query: MailTemplateGetMailKeyAvailableListQuery): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/mailgroup/getmailtemplategetmailkeyavailablelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailTemplateGetMailKeyAvailableList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailTemplateGetMailKeyAvailableList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetMailTemplateGetMailKeyAvailableList(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrgUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getOrgUnitList(query: OrgUnitGetListQuery): Observable<PagedResultDtoOfOrgUnitForListResponse> {
        let url_ = this.baseUrl + "/api/orgunit/getorgunitlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrgUnitList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrgUnitList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrgUnitForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrgUnitForListResponse>;
        }));
    }

    protected processGetOrgUnitList(response: HttpResponseBase): Observable<PagedResultDtoOfOrgUnitForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrgUnitForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrgUnitByParentOUList(parentOU: number | undefined): Observable<OrgUnitForListResponse[]> {
        let url_ = this.baseUrl + "/api/orgunit/getorgunitbyparentoulist?";
        if (parentOU === null)
            throw new Error("The parameter 'parentOU' cannot be null.");
        else if (parentOU !== undefined)
            url_ += "parentOU=" + encodeURIComponent("" + parentOU) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrgUnitByParentOUList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrgUnitByParentOUList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrgUnitForListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrgUnitForListResponse[]>;
        }));
    }

    protected processGetOrgUnitByParentOUList(response: HttpResponseBase): Observable<OrgUnitForListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrgUnitForListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrgUnit(id: number): Observable<OrgUnitResponse> {
        let url_ = this.baseUrl + "/api/orgunit/getorgunit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrgUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrgUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrgUnitResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrgUnitResponse>;
        }));
    }

    protected processGetOrgUnit(response: HttpResponseBase): Observable<OrgUnitResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrgUnitResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrgUnitCombo(query: OrgUnitGetComboQuery): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/orgunit/getorgunitcombo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrgUnitCombo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrgUnitCombo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetOrgUnitCombo(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrgUnitForEdit(dto: OrgUnitGetForEditQuery): Observable<OrgUnitForEditResponse> {
        let url_ = this.baseUrl + "/api/orgunit/getorgunitforedit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrgUnitForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrgUnitForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrgUnitForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrgUnitForEditResponse>;
        }));
    }

    protected processGetOrgUnitForEdit(response: HttpResponseBase): Observable<OrgUnitForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrgUnitForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createOrgUnit(dto: OrgUnitCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/orgunit/createorgunit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrgUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrgUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrgUnit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateOrgUnit(dto: OrgUnitUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/orgunit/updateorgunit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrgUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrgUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateOrgUnit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteOrgUnit(id: number): Observable<number> {
        let url_ = this.baseUrl + "/api/orgunit/deleteorgunit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrgUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrgUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteOrgUnit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrgUnitUserList(query: OrgUnitUserGetListQuery): Observable<PagedResultDtoOfOrgUnitUserForListResponse> {
        let url_ = this.baseUrl + "/api/orgunit/getorgunituserlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrgUnitUserList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrgUnitUserList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrgUnitUserForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrgUnitUserForListResponse>;
        }));
    }

    protected processGetOrgUnitUserList(response: HttpResponseBase): Observable<PagedResultDtoOfOrgUnitUserForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrgUnitUserForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createOrgUnitUser(dto: OrgUnitUserCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/orgunit/createorgunituser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrgUnitUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrgUnitUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrgUnitUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteOrgUnitUser(id: number): Observable<number> {
        let url_ = this.baseUrl + "/api/orgunit/deleteorgunituser/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrgUnitUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrgUnitUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteOrgUnitUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PermissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getPermissionsTree(request: PermissionGetTreeQuery): Observable<Permission> {
        let url_ = this.baseUrl + "/api/permission/getpermissionstree";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPermissionsTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPermissionsTree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Permission>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Permission>;
        }));
    }

    protected processGetPermissionsTree(response: HttpResponseBase): Observable<Permission> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Permission.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RegisterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    create(dto: TenantCreateRegistrationCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/register/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    confirm(dto: TenantConfirmRegistrationCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/register/confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getRoleList(query: RoleGetListQuery): Observable<PagedResultDtoOfRoleForListResponse> {
        let url_ = this.baseUrl + "/api/role/getrolelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfRoleForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfRoleForListResponse>;
        }));
    }

    protected processGetRoleList(response: HttpResponseBase): Observable<PagedResultDtoOfRoleForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfRoleForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportRole(query: RoleExportQuery): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/role/exportrole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportRole(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportCSVRole(query: RoleExportCSVQuery): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/role/exportcsvrole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCSVRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCSVRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportCSVRole(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPDFRole(query: RoleExportPDFQuery): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/role/exportpdfrole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPDFRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPDFRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportPDFRole(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(dto: RoleGetByIdQuery): Observable<RoleResponse> {
        let url_ = this.baseUrl + "/api/role/get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createRole(dto: RoleCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/role/createrole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateRole(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateRole(dto: RoleUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/role/updaterole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateRole(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteRole(dto: RoleDeleteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/role/deleterole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRoleForEdit(dto: RoleGetForEditQuery): Observable<RoleForEditReponse> {
        let url_ = this.baseUrl + "/api/role/getroleforedit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleForEditReponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleForEditReponse>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<RoleForEditReponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleForEditReponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRoleListActive(query: RoleGetForListActiveQuery): Observable<RoleForListActiveResponse[]> {
        let url_ = this.baseUrl + "/api/role/getrolelistactive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleListActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleListActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleForListActiveResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleForListActiveResponse[]>;
        }));
    }

    protected processGetRoleListActive(response: HttpResponseBase): Observable<RoleForListActiveResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleForListActiveResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getSessionList(query: SessionGetListQuery): Observable<PagedResultDtoOfSessionForListResponse> {
        let url_ = this.baseUrl + "/api/session/getsessionlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSessionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSessionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSessionForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSessionForListResponse>;
        }));
    }

    protected processGetSessionList(response: HttpResponseBase): Observable<PagedResultDtoOfSessionForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSessionForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSession(id: number): Observable<number> {
        let url_ = this.baseUrl + "/api/session/deletesession/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteSession(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SettingClientServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    changeSettingClient(dto: SettingClientChangeCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/settingclient/changesettingclient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeSettingClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeSettingClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processChangeSettingClient(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    exportTenant(query: TenantExportQuery): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/tenant/exporttenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportTenant(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportCSVTenant(query: TenantExportCSVQuery): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/tenant/exportcsvtenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCSVTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCSVTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportCSVTenant(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPDFTenant(query: TenantExportPDFQuery): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/tenant/exportpdftenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPDFTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPDFTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportPDFTenant(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTenantById(id: number): Observable<TenantResponse> {
        let url_ = this.baseUrl + "/api/tenant/gettenantbyid/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantResponse>;
        }));
    }

    protected processGetTenantById(response: HttpResponseBase): Observable<TenantResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createTenant(command: TenantCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/tenant/createtenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateTenant(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateTenant(command: UpdateTenantCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/tenant/updatetenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateTenant(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTenantsList(query: TenantGetListQuery): Observable<PagedResultDtoOfTenantListResponse> {
        let url_ = this.baseUrl + "/api/tenant/gettenantslist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTenantListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTenantListResponse>;
        }));
    }

    protected processGetTenantsList(response: HttpResponseBase): Observable<PagedResultDtoOfTenantListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTenantListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTenantsForLoginList(): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/tenant/gettenantsforloginlist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantsForLoginList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantsForLoginList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetTenantsForLoginList(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTenantsListCompleter(query: TenantGetListCompleterQuery): Observable<TenantListResponse[]> {
        let url_ = this.baseUrl + "/api/tenant/gettenantslistcompleter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantsListCompleter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantsListCompleter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantListResponse[]>;
        }));
    }

    protected processGetTenantsListCompleter(response: HttpResponseBase): Observable<TenantListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteTenant(dto: TenantDeleteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/tenant/deletetenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteTenant(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getSettingsForEdit(dto: TenantSettingsGetForEditQuery): Observable<TenantSettingsForEditResponse> {
        let url_ = this.baseUrl + "/api/tenantsettings/getsettingsforedit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettingsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettingsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantSettingsForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantSettingsForEditResponse>;
        }));
    }

    protected processGetSettingsForEdit(response: HttpResponseBase): Observable<TenantSettingsForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantSettingsForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAllSettings(dto: TenantSettingsUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/tenantsettings/updateallsettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendTestEmail(dto: TenantSettingsSendTestEmailCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/tenantsettings/sendtestemail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getAll(dto: UserConfigurationGetAllQuery): Observable<UserConfigurationResponse> {
        let url_ = this.baseUrl + "/api/userconfiguration/getall";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserConfigurationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserConfigurationResponse>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserConfigurationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserConfigurationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getUserList(query: UserGetListQuery): Observable<PagedResultDtoOfUserListResponse> {
        let url_ = this.baseUrl + "/api/user/getuserlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserListResponse>;
        }));
    }

    protected processGetUserList(response: HttpResponseBase): Observable<PagedResultDtoOfUserListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportUser(query: UserExportQuery): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/user/exportuser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportUser(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportCSVUser(query: UserExportCSVQuery): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/user/exportcsvuser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCSVUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCSVUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportCSVUser(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPDFUser(query: UserExportPDFQuery): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/user/exportpdfuser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPDFUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPDFUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportPDFUser(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserAutocompleteList(term: string | null | undefined): Observable<UserListResponse[]> {
        let url_ = this.baseUrl + "/api/user/getuserautocompletelist?";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAutocompleteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAutocompleteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListResponse[]>;
        }));
    }

    protected processGetUserAutocompleteList(response: HttpResponseBase): Observable<UserListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserForEditorAutocompleteList(term: string | null | undefined): Observable<any[]> {
        let url_ = this.baseUrl + "/api/user/getuserforeditorautocompletelist?";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserForEditorAutocompleteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserForEditorAutocompleteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any[]>;
        }));
    }

    protected processGetUserForEditorAutocompleteList(response: HttpResponseBase): Observable<any[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createUser(dto: UserCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/user/createuser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUser(dto: UserUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/user/updateuser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserForEdit(dto: UserGetForEditQuery): Observable<UserForEditResponse> {
        let url_ = this.baseUrl + "/api/user/getuserforedit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserForEditResponse>;
        }));
    }

    protected processGetUserForEdit(response: HttpResponseBase): Observable<UserForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserProfile(dto: UserProfileQuery): Observable<UserForEditResponse> {
        let url_ = this.baseUrl + "/api/user/getuserprofile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserForEditResponse>;
        }));
    }

    protected processGetUserProfile(response: HttpResponseBase): Observable<UserForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUserProfile(dto: UserUpdateProfileCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/user/updateuserprofile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateUserProfile(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPictureProfile(id: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/user/getpictureprofile?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPictureProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPictureProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetPictureProfile(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteUser(dto: UserDeleteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/user/deleteuser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    lockUser(id: number): Observable<number> {
        let url_ = this.baseUrl + "/api/user/lockuser/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processLockUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unlockUser(id: number): Observable<number> {
        let url_ = this.baseUrl + "/api/user/unlockuser/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUnlockUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51155";
    }

    getLatestWebLogs(query: WebLogGetLastestQuery): Observable<WebLogGetLastestResponse> {
        let url_ = this.baseUrl + "/api/weblog/getlatestweblogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebLogGetLastestResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebLogGetLastestResponse>;
        }));
    }

    protected processGetLatestWebLogs(response: HttpResponseBase): Observable<WebLogGetLastestResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebLogGetLastestResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadWebLogs(query: WebLogDownloadZipQuery): Observable<WebLogDownloadZipResponse> {
        let url_ = this.baseUrl + "/api/weblog/downloadweblogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebLogDownloadZipResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebLogDownloadZipResponse>;
        }));
    }

    protected processDownloadWebLogs(response: HttpResponseBase): Observable<WebLogDownloadZipResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebLogDownloadZipResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class DownloadFileResponseCommon implements IDownloadFileResponseCommon {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;

    constructor(data?: IDownloadFileResponseCommon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): DownloadFileResponseCommon {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadFileResponseCommon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IDownloadFileResponseCommon {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
}

export class ReportInformeIngresosExportQuery implements IReportInformeIngresosExportQuery {
    delegacion?: number | undefined;
    hospitalList?: number[] | undefined;
    periodicidad?: ReportInformeIngresosPeriodicidad | undefined;
    fechaInicial?: moment.Moment | undefined;
    anio?: number | undefined;
    mes?: number | undefined;
    diagnostico?: number | undefined;
    tipoExportacion?: ReportInformeIngresosExportType | undefined;
    institucion?: number | undefined;

    constructor(data?: IReportInformeIngresosExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.delegacion = _data["delegacion"];
            if (Array.isArray(_data["hospitalList"])) {
                this.hospitalList = [] as any;
                for (let item of _data["hospitalList"])
                    this.hospitalList!.push(item);
            }
            this.periodicidad = _data["periodicidad"];
            this.fechaInicial = _data["fechaInicial"] ? moment(_data["fechaInicial"].toString()) : <any>undefined;
            this.anio = _data["anio"];
            this.mes = _data["mes"];
            this.diagnostico = _data["diagnostico"];
            this.tipoExportacion = _data["tipoExportacion"];
            this.institucion = _data["institucion"];
        }
    }

    static fromJS(data: any): ReportInformeIngresosExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportInformeIngresosExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delegacion"] = this.delegacion;
        if (Array.isArray(this.hospitalList)) {
            data["hospitalList"] = [];
            for (let item of this.hospitalList)
                data["hospitalList"].push(item);
        }
        data["periodicidad"] = this.periodicidad;
        data["fechaInicial"] = this.fechaInicial ? this.fechaInicial.toISOString() : <any>undefined;
        data["anio"] = this.anio;
        data["mes"] = this.mes;
        data["diagnostico"] = this.diagnostico;
        data["tipoExportacion"] = this.tipoExportacion;
        data["institucion"] = this.institucion;
        return data;
    }
}

export interface IReportInformeIngresosExportQuery {
    delegacion?: number | undefined;
    hospitalList?: number[] | undefined;
    periodicidad?: ReportInformeIngresosPeriodicidad | undefined;
    fechaInicial?: moment.Moment | undefined;
    anio?: number | undefined;
    mes?: number | undefined;
    diagnostico?: number | undefined;
    tipoExportacion?: ReportInformeIngresosExportType | undefined;
    institucion?: number | undefined;
}

export enum ReportInformeIngresosPeriodicidad {
    Semanal = 1,
    Mensual = 2,
}

export enum ReportInformeIngresosExportType {
    Excel = 1,
    PDF = 2,
}

export class ReportInformeEgresosExportQuery implements IReportInformeEgresosExportQuery {
    delegacion?: number | undefined;
    hospitalList?: number[] | undefined;
    periodicidad?: ReportInformeEgresosPeriodicidad | undefined;
    fechaInicial?: moment.Moment | undefined;
    anio?: number | undefined;
    mes?: number | undefined;
    diagnostico?: number | undefined;
    tipoExportacion?: ReportInformeEgresosExportType | undefined;
    estatusList?: number[] | undefined;
    nombre?: string | undefined;
    institucion?: number | undefined;

    constructor(data?: IReportInformeEgresosExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.delegacion = _data["delegacion"];
            if (Array.isArray(_data["hospitalList"])) {
                this.hospitalList = [] as any;
                for (let item of _data["hospitalList"])
                    this.hospitalList!.push(item);
            }
            this.periodicidad = _data["periodicidad"];
            this.fechaInicial = _data["fechaInicial"] ? moment(_data["fechaInicial"].toString()) : <any>undefined;
            this.anio = _data["anio"];
            this.mes = _data["mes"];
            this.diagnostico = _data["diagnostico"];
            this.tipoExportacion = _data["tipoExportacion"];
            if (Array.isArray(_data["estatusList"])) {
                this.estatusList = [] as any;
                for (let item of _data["estatusList"])
                    this.estatusList!.push(item);
            }
            this.nombre = _data["nombre"];
            this.institucion = _data["institucion"];
        }
    }

    static fromJS(data: any): ReportInformeEgresosExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportInformeEgresosExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delegacion"] = this.delegacion;
        if (Array.isArray(this.hospitalList)) {
            data["hospitalList"] = [];
            for (let item of this.hospitalList)
                data["hospitalList"].push(item);
        }
        data["periodicidad"] = this.periodicidad;
        data["fechaInicial"] = this.fechaInicial ? this.fechaInicial.toISOString() : <any>undefined;
        data["anio"] = this.anio;
        data["mes"] = this.mes;
        data["diagnostico"] = this.diagnostico;
        data["tipoExportacion"] = this.tipoExportacion;
        if (Array.isArray(this.estatusList)) {
            data["estatusList"] = [];
            for (let item of this.estatusList)
                data["estatusList"].push(item);
        }
        data["nombre"] = this.nombre;
        data["institucion"] = this.institucion;
        return data;
    }
}

export interface IReportInformeEgresosExportQuery {
    delegacion?: number | undefined;
    hospitalList?: number[] | undefined;
    periodicidad?: ReportInformeEgresosPeriodicidad | undefined;
    fechaInicial?: moment.Moment | undefined;
    anio?: number | undefined;
    mes?: number | undefined;
    diagnostico?: number | undefined;
    tipoExportacion?: ReportInformeEgresosExportType | undefined;
    estatusList?: number[] | undefined;
    nombre?: string | undefined;
    institucion?: number | undefined;
}

export enum ReportInformeEgresosPeriodicidad {
    Semanal = 1,
    Mensual = 2,
}

export enum ReportInformeEgresosExportType {
    Excel = 1,
    PDF = 2,
}

export class ReportInformeSesionesProgramadasForEditResponse implements IReportInformeSesionesProgramadasForEditResponse {
    maquinaCombo?: ComboboxItemDtoOfLong[] | undefined;
    turnoHospitalCombo?: ComboboxItemDtoOfLong[] | undefined;
    institucionCombo?: ComboboxItemDtoOfLong[] | undefined;

    constructor(data?: IReportInformeSesionesProgramadasForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["maquinaCombo"])) {
                this.maquinaCombo = [] as any;
                for (let item of _data["maquinaCombo"])
                    this.maquinaCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["turnoHospitalCombo"])) {
                this.turnoHospitalCombo = [] as any;
                for (let item of _data["turnoHospitalCombo"])
                    this.turnoHospitalCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["institucionCombo"])) {
                this.institucionCombo = [] as any;
                for (let item of _data["institucionCombo"])
                    this.institucionCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportInformeSesionesProgramadasForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportInformeSesionesProgramadasForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.maquinaCombo)) {
            data["maquinaCombo"] = [];
            for (let item of this.maquinaCombo)
                data["maquinaCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.turnoHospitalCombo)) {
            data["turnoHospitalCombo"] = [];
            for (let item of this.turnoHospitalCombo)
                data["turnoHospitalCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.institucionCombo)) {
            data["institucionCombo"] = [];
            for (let item of this.institucionCombo)
                data["institucionCombo"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReportInformeSesionesProgramadasForEditResponse {
    maquinaCombo?: ComboboxItemDtoOfLong[] | undefined;
    turnoHospitalCombo?: ComboboxItemDtoOfLong[] | undefined;
    institucionCombo?: ComboboxItemDtoOfLong[] | undefined;
}

export class ComboboxItemDtoOfLong implements IComboboxItemDtoOfLong {
    value!: number;
    label?: string | undefined;

    constructor(data?: IComboboxItemDtoOfLong) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): ComboboxItemDtoOfLong {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDtoOfLong();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IComboboxItemDtoOfLong {
    value: number;
    label?: string | undefined;
}

export class ReportInformeSesionesProgramadasExportQuery implements IReportInformeSesionesProgramadasExportQuery {
    turnoHospital?: number | undefined;
    maquina?: number | undefined;
    institucion?: number | undefined;
    periodicidad?: ReportInformeSesionesProgramadasPeriodicidad | undefined;
    fechaInicial?: moment.Moment | undefined;
    anio?: number | undefined;
    mes?: number | undefined;
    tipoExportacion?: ReportInformeSesionesProgramadasExportType | undefined;
    hospitalList?: number[] | undefined;

    constructor(data?: IReportInformeSesionesProgramadasExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.turnoHospital = _data["turnoHospital"];
            this.maquina = _data["maquina"];
            this.institucion = _data["institucion"];
            this.periodicidad = _data["periodicidad"];
            this.fechaInicial = _data["fechaInicial"] ? moment(_data["fechaInicial"].toString()) : <any>undefined;
            this.anio = _data["anio"];
            this.mes = _data["mes"];
            this.tipoExportacion = _data["tipoExportacion"];
            if (Array.isArray(_data["hospitalList"])) {
                this.hospitalList = [] as any;
                for (let item of _data["hospitalList"])
                    this.hospitalList!.push(item);
            }
        }
    }

    static fromJS(data: any): ReportInformeSesionesProgramadasExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportInformeSesionesProgramadasExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["turnoHospital"] = this.turnoHospital;
        data["maquina"] = this.maquina;
        data["institucion"] = this.institucion;
        data["periodicidad"] = this.periodicidad;
        data["fechaInicial"] = this.fechaInicial ? this.fechaInicial.toISOString() : <any>undefined;
        data["anio"] = this.anio;
        data["mes"] = this.mes;
        data["tipoExportacion"] = this.tipoExportacion;
        if (Array.isArray(this.hospitalList)) {
            data["hospitalList"] = [];
            for (let item of this.hospitalList)
                data["hospitalList"].push(item);
        }
        return data;
    }
}

export interface IReportInformeSesionesProgramadasExportQuery {
    turnoHospital?: number | undefined;
    maquina?: number | undefined;
    institucion?: number | undefined;
    periodicidad?: ReportInformeSesionesProgramadasPeriodicidad | undefined;
    fechaInicial?: moment.Moment | undefined;
    anio?: number | undefined;
    mes?: number | undefined;
    tipoExportacion?: ReportInformeSesionesProgramadasExportType | undefined;
    hospitalList?: number[] | undefined;
}

export enum ReportInformeSesionesProgramadasPeriodicidad {
    Semanal = 1,
    Mensual = 2,
}

export enum ReportInformeSesionesProgramadasExportType {
    Excel = 1,
    PDF = 2,
}

export class ReportRelacionPacientesServicioHDForEditResponse implements IReportRelacionPacientesServicioHDForEditResponse {
    delegacionCombo?: ComboboxItemDtoOfLong[] | undefined;
    servicioCombo?: ComboboxItemDtoOfLong[] | undefined;
    origenPacienteCombo?: ComboboxItemDtoOfLong[] | undefined;

    constructor(data?: IReportRelacionPacientesServicioHDForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["delegacionCombo"])) {
                this.delegacionCombo = [] as any;
                for (let item of _data["delegacionCombo"])
                    this.delegacionCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["servicioCombo"])) {
                this.servicioCombo = [] as any;
                for (let item of _data["servicioCombo"])
                    this.servicioCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["origenPacienteCombo"])) {
                this.origenPacienteCombo = [] as any;
                for (let item of _data["origenPacienteCombo"])
                    this.origenPacienteCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportRelacionPacientesServicioHDForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportRelacionPacientesServicioHDForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.delegacionCombo)) {
            data["delegacionCombo"] = [];
            for (let item of this.delegacionCombo)
                data["delegacionCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.servicioCombo)) {
            data["servicioCombo"] = [];
            for (let item of this.servicioCombo)
                data["servicioCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.origenPacienteCombo)) {
            data["origenPacienteCombo"] = [];
            for (let item of this.origenPacienteCombo)
                data["origenPacienteCombo"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReportRelacionPacientesServicioHDForEditResponse {
    delegacionCombo?: ComboboxItemDtoOfLong[] | undefined;
    servicioCombo?: ComboboxItemDtoOfLong[] | undefined;
    origenPacienteCombo?: ComboboxItemDtoOfLong[] | undefined;
}

export class ReportRelacionPacientesServicioHDExportQuery implements IReportRelacionPacientesServicioHDExportQuery {
    delegacion?: number | undefined;
    hospitalList?: number[] | undefined;
    periodicidad?: ReportRelacionPacientesServicioHDPeriodicidad | undefined;
    fechaInicial?: moment.Moment | undefined;
    fechaFinal?: moment.Moment | undefined;
    anio?: number | undefined;
    mes?: number | undefined;
    diagnostico?: number | undefined;
    servicio?: number | undefined;
    origenPaciente?: number | undefined;
    tipoExportacion?: ReportRelacionPacientesServicioHDExportType | undefined;
    institucion?: number | undefined;

    constructor(data?: IReportRelacionPacientesServicioHDExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.delegacion = _data["delegacion"];
            if (Array.isArray(_data["hospitalList"])) {
                this.hospitalList = [] as any;
                for (let item of _data["hospitalList"])
                    this.hospitalList!.push(item);
            }
            this.periodicidad = _data["periodicidad"];
            this.fechaInicial = _data["fechaInicial"] ? moment(_data["fechaInicial"].toString()) : <any>undefined;
            this.fechaFinal = _data["fechaFinal"] ? moment(_data["fechaFinal"].toString()) : <any>undefined;
            this.anio = _data["anio"];
            this.mes = _data["mes"];
            this.diagnostico = _data["diagnostico"];
            this.servicio = _data["servicio"];
            this.origenPaciente = _data["origenPaciente"];
            this.tipoExportacion = _data["tipoExportacion"];
            this.institucion = _data["institucion"];
        }
    }

    static fromJS(data: any): ReportRelacionPacientesServicioHDExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportRelacionPacientesServicioHDExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delegacion"] = this.delegacion;
        if (Array.isArray(this.hospitalList)) {
            data["hospitalList"] = [];
            for (let item of this.hospitalList)
                data["hospitalList"].push(item);
        }
        data["periodicidad"] = this.periodicidad;
        data["fechaInicial"] = this.fechaInicial ? this.fechaInicial.toISOString() : <any>undefined;
        data["fechaFinal"] = this.fechaFinal ? this.fechaFinal.toISOString() : <any>undefined;
        data["anio"] = this.anio;
        data["mes"] = this.mes;
        data["diagnostico"] = this.diagnostico;
        data["servicio"] = this.servicio;
        data["origenPaciente"] = this.origenPaciente;
        data["tipoExportacion"] = this.tipoExportacion;
        data["institucion"] = this.institucion;
        return data;
    }
}

export interface IReportRelacionPacientesServicioHDExportQuery {
    delegacion?: number | undefined;
    hospitalList?: number[] | undefined;
    periodicidad?: ReportRelacionPacientesServicioHDPeriodicidad | undefined;
    fechaInicial?: moment.Moment | undefined;
    fechaFinal?: moment.Moment | undefined;
    anio?: number | undefined;
    mes?: number | undefined;
    diagnostico?: number | undefined;
    servicio?: number | undefined;
    origenPaciente?: number | undefined;
    tipoExportacion?: ReportRelacionPacientesServicioHDExportType | undefined;
    institucion?: number | undefined;
}

export enum ReportRelacionPacientesServicioHDPeriodicidad {
    Diario = 1,
    Semanal = 2,
    Mensual = 3,
}

export enum ReportRelacionPacientesServicioHDExportType {
    Excel = 1,
    PDF = 2,
}

export class ReportInformeSesionesEfectOtorgPacienteExportQuery implements IReportInformeSesionesEfectOtorgPacienteExportQuery {
    delegacion!: number;
    hospital?: number | undefined;
    periodicidad?: ReportInformeSesionesEfectOtorgPacientePeriodicidad | undefined;
    fechaInicial?: moment.Moment | undefined;
    fechaFinal?: moment.Moment | undefined;
    anio?: number | undefined;
    mes?: number | undefined;
    idee?: string | undefined;
    nss?: string | undefined;
    nombre?: string | undefined;
    agregadoMedico?: string | undefined;
    tipoExportacion?: ReportInformeSesionesEfectOtorgPacienteExportType | undefined;
    institucion?: number | undefined;
    excluirSuspendidas!: boolean;

    constructor(data?: IReportInformeSesionesEfectOtorgPacienteExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.delegacion = _data["delegacion"];
            this.hospital = _data["hospital"];
            this.periodicidad = _data["periodicidad"];
            this.fechaInicial = _data["fechaInicial"] ? moment(_data["fechaInicial"].toString()) : <any>undefined;
            this.fechaFinal = _data["fechaFinal"] ? moment(_data["fechaFinal"].toString()) : <any>undefined;
            this.anio = _data["anio"];
            this.mes = _data["mes"];
            this.idee = _data["idee"];
            this.nss = _data["nss"];
            this.nombre = _data["nombre"];
            this.agregadoMedico = _data["agregadoMedico"];
            this.tipoExportacion = _data["tipoExportacion"];
            this.institucion = _data["institucion"];
            this.excluirSuspendidas = _data["excluirSuspendidas"];
        }
    }

    static fromJS(data: any): ReportInformeSesionesEfectOtorgPacienteExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportInformeSesionesEfectOtorgPacienteExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delegacion"] = this.delegacion;
        data["hospital"] = this.hospital;
        data["periodicidad"] = this.periodicidad;
        data["fechaInicial"] = this.fechaInicial ? this.fechaInicial.toISOString() : <any>undefined;
        data["fechaFinal"] = this.fechaFinal ? this.fechaFinal.toISOString() : <any>undefined;
        data["anio"] = this.anio;
        data["mes"] = this.mes;
        data["idee"] = this.idee;
        data["nss"] = this.nss;
        data["nombre"] = this.nombre;
        data["agregadoMedico"] = this.agregadoMedico;
        data["tipoExportacion"] = this.tipoExportacion;
        data["institucion"] = this.institucion;
        data["excluirSuspendidas"] = this.excluirSuspendidas;
        return data;
    }
}

export interface IReportInformeSesionesEfectOtorgPacienteExportQuery {
    delegacion: number;
    hospital?: number | undefined;
    periodicidad?: ReportInformeSesionesEfectOtorgPacientePeriodicidad | undefined;
    fechaInicial?: moment.Moment | undefined;
    fechaFinal?: moment.Moment | undefined;
    anio?: number | undefined;
    mes?: number | undefined;
    idee?: string | undefined;
    nss?: string | undefined;
    nombre?: string | undefined;
    agregadoMedico?: string | undefined;
    tipoExportacion?: ReportInformeSesionesEfectOtorgPacienteExportType | undefined;
    institucion?: number | undefined;
    excluirSuspendidas: boolean;
}

export enum ReportInformeSesionesEfectOtorgPacientePeriodicidad {
    Mensual = 1,
    Fechas = 2,
}

export enum ReportInformeSesionesEfectOtorgPacienteExportType {
    Excel = 1,
    PDF = 2,
}

export class ReportEstadisticosUnidadHDExportQuery implements IReportEstadisticosUnidadHDExportQuery {
    delegacion?: number | undefined;
    hospital?: number | undefined;
    fechaInicial?: moment.Moment | undefined;
    fechaFinal?: moment.Moment | undefined;
    institucion?: number | undefined;

    constructor(data?: IReportEstadisticosUnidadHDExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.delegacion = _data["delegacion"];
            this.hospital = _data["hospital"];
            this.fechaInicial = _data["fechaInicial"] ? moment(_data["fechaInicial"].toString()) : <any>undefined;
            this.fechaFinal = _data["fechaFinal"] ? moment(_data["fechaFinal"].toString()) : <any>undefined;
            this.institucion = _data["institucion"];
        }
    }

    static fromJS(data: any): ReportEstadisticosUnidadHDExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportEstadisticosUnidadHDExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delegacion"] = this.delegacion;
        data["hospital"] = this.hospital;
        data["fechaInicial"] = this.fechaInicial ? this.fechaInicial.toISOString() : <any>undefined;
        data["fechaFinal"] = this.fechaFinal ? this.fechaFinal.toISOString() : <any>undefined;
        data["institucion"] = this.institucion;
        return data;
    }
}

export interface IReportEstadisticosUnidadHDExportQuery {
    delegacion?: number | undefined;
    hospital?: number | undefined;
    fechaInicial?: moment.Moment | undefined;
    fechaFinal?: moment.Moment | undefined;
    institucion?: number | undefined;
}

export class ReportResumenClinicoExportQuery implements IReportResumenClinicoExportQuery {
    anio?: number | undefined;
    mes?: number | undefined;
    comentarios?: string | undefined;
    pacienteId?: number | undefined;

    constructor(data?: IReportResumenClinicoExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anio = _data["anio"];
            this.mes = _data["mes"];
            this.comentarios = _data["comentarios"];
            this.pacienteId = _data["pacienteId"];
        }
    }

    static fromJS(data: any): ReportResumenClinicoExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportResumenClinicoExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["anio"] = this.anio;
        data["mes"] = this.mes;
        data["comentarios"] = this.comentarios;
        data["pacienteId"] = this.pacienteId;
        return data;
    }
}

export interface IReportResumenClinicoExportQuery {
    anio?: number | undefined;
    mes?: number | undefined;
    comentarios?: string | undefined;
    pacienteId?: number | undefined;
}

export class ReportResumenClinicoEnviarQuery implements IReportResumenClinicoEnviarQuery {
    tenantId?: number | undefined;
    pacienteId?: number | undefined;
    anio?: number | undefined;
    mes?: number | undefined;
    comentarios?: string | undefined;

    constructor(data?: IReportResumenClinicoEnviarQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.pacienteId = _data["pacienteId"];
            this.anio = _data["anio"];
            this.mes = _data["mes"];
            this.comentarios = _data["comentarios"];
        }
    }

    static fromJS(data: any): ReportResumenClinicoEnviarQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportResumenClinicoEnviarQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["pacienteId"] = this.pacienteId;
        data["anio"] = this.anio;
        data["mes"] = this.mes;
        data["comentarios"] = this.comentarios;
        return data;
    }
}

export interface IReportResumenClinicoEnviarQuery {
    tenantId?: number | undefined;
    pacienteId?: number | undefined;
    anio?: number | undefined;
    mes?: number | undefined;
    comentarios?: string | undefined;
}

export class ReportNotaInicialExportQuery implements IReportNotaInicialExportQuery {
    paciente?: number | undefined;
    tipoExportacion?: ReportNotaInicialExportType | undefined;

    constructor(data?: IReportNotaInicialExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paciente = _data["paciente"];
            this.tipoExportacion = _data["tipoExportacion"];
        }
    }

    static fromJS(data: any): ReportNotaInicialExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportNotaInicialExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paciente"] = this.paciente;
        data["tipoExportacion"] = this.tipoExportacion;
        return data;
    }
}

export interface IReportNotaInicialExportQuery {
    paciente?: number | undefined;
    tipoExportacion?: ReportNotaInicialExportType | undefined;
}

export enum ReportNotaInicialExportType {
    Excel = 1,
    PDF = 2,
}

export class ReportHistoriaClinicaExportQuery implements IReportHistoriaClinicaExportQuery {
    paciente?: number | undefined;
    tipoExportacion?: ReportHistoriaClinicaExportType | undefined;

    constructor(data?: IReportHistoriaClinicaExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paciente = _data["paciente"];
            this.tipoExportacion = _data["tipoExportacion"];
        }
    }

    static fromJS(data: any): ReportHistoriaClinicaExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportHistoriaClinicaExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paciente"] = this.paciente;
        data["tipoExportacion"] = this.tipoExportacion;
        return data;
    }
}

export interface IReportHistoriaClinicaExportQuery {
    paciente?: number | undefined;
    tipoExportacion?: ReportHistoriaClinicaExportType | undefined;
}

export enum ReportHistoriaClinicaExportType {
    Excel = 1,
    PDF = 2,
}

export class ReportEvolucionMedicaExportQuery implements IReportEvolucionMedicaExportQuery {
    id!: number;
    paciente?: number | undefined;
    anio?: number | undefined;
    mes?: number | undefined;
    tipoExportacion?: ReportEvolucionMedicaExportType | undefined;

    constructor(data?: IReportEvolucionMedicaExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.paciente = _data["paciente"];
            this.anio = _data["anio"];
            this.mes = _data["mes"];
            this.tipoExportacion = _data["tipoExportacion"];
        }
    }

    static fromJS(data: any): ReportEvolucionMedicaExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportEvolucionMedicaExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["paciente"] = this.paciente;
        data["anio"] = this.anio;
        data["mes"] = this.mes;
        data["tipoExportacion"] = this.tipoExportacion;
        return data;
    }
}

export interface IReportEvolucionMedicaExportQuery {
    id: number;
    paciente?: number | undefined;
    anio?: number | undefined;
    mes?: number | undefined;
    tipoExportacion?: ReportEvolucionMedicaExportType | undefined;
}

export enum ReportEvolucionMedicaExportType {
    Excel = 1,
    PDF = 2,
}

export class ReportInternoSesionesOtorgadasExportQuery implements IReportInternoSesionesOtorgadasExportQuery {
    fechaInicial?: moment.Moment | undefined;
    fechaFinal?: moment.Moment | undefined;
    unidadesList?: number[] | undefined;
    tipoExportacion?: ReportInternoSesionesOtorgadasExportType | undefined;

    constructor(data?: IReportInternoSesionesOtorgadasExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fechaInicial = _data["fechaInicial"] ? moment(_data["fechaInicial"].toString()) : <any>undefined;
            this.fechaFinal = _data["fechaFinal"] ? moment(_data["fechaFinal"].toString()) : <any>undefined;
            if (Array.isArray(_data["unidadesList"])) {
                this.unidadesList = [] as any;
                for (let item of _data["unidadesList"])
                    this.unidadesList!.push(item);
            }
            this.tipoExportacion = _data["tipoExportacion"];
        }
    }

    static fromJS(data: any): ReportInternoSesionesOtorgadasExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportInternoSesionesOtorgadasExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fechaInicial"] = this.fechaInicial ? this.fechaInicial.toISOString() : <any>undefined;
        data["fechaFinal"] = this.fechaFinal ? this.fechaFinal.toISOString() : <any>undefined;
        if (Array.isArray(this.unidadesList)) {
            data["unidadesList"] = [];
            for (let item of this.unidadesList)
                data["unidadesList"].push(item);
        }
        data["tipoExportacion"] = this.tipoExportacion;
        return data;
    }
}

export interface IReportInternoSesionesOtorgadasExportQuery {
    fechaInicial?: moment.Moment | undefined;
    fechaFinal?: moment.Moment | undefined;
    unidadesList?: number[] | undefined;
    tipoExportacion?: ReportInternoSesionesOtorgadasExportType | undefined;
}

export enum ReportInternoSesionesOtorgadasExportType {
    Excel = 1,
    PDF = 2,
}

export class ReportInternoSesionesAbiertasExportQuery implements IReportInternoSesionesAbiertasExportQuery {
    fechaInicial?: moment.Moment | undefined;
    fechaFinal?: moment.Moment | undefined;
    unidadesList?: number[] | undefined;
    tipoExportacion?: ReportInternoSesionesAbiertasExportType | undefined;

    constructor(data?: IReportInternoSesionesAbiertasExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fechaInicial = _data["fechaInicial"] ? moment(_data["fechaInicial"].toString()) : <any>undefined;
            this.fechaFinal = _data["fechaFinal"] ? moment(_data["fechaFinal"].toString()) : <any>undefined;
            if (Array.isArray(_data["unidadesList"])) {
                this.unidadesList = [] as any;
                for (let item of _data["unidadesList"])
                    this.unidadesList!.push(item);
            }
            this.tipoExportacion = _data["tipoExportacion"];
        }
    }

    static fromJS(data: any): ReportInternoSesionesAbiertasExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportInternoSesionesAbiertasExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fechaInicial"] = this.fechaInicial ? this.fechaInicial.toISOString() : <any>undefined;
        data["fechaFinal"] = this.fechaFinal ? this.fechaFinal.toISOString() : <any>undefined;
        if (Array.isArray(this.unidadesList)) {
            data["unidadesList"] = [];
            for (let item of this.unidadesList)
                data["unidadesList"].push(item);
        }
        data["tipoExportacion"] = this.tipoExportacion;
        return data;
    }
}

export interface IReportInternoSesionesAbiertasExportQuery {
    fechaInicial?: moment.Moment | undefined;
    fechaFinal?: moment.Moment | undefined;
    unidadesList?: number[] | undefined;
    tipoExportacion?: ReportInternoSesionesAbiertasExportType | undefined;
}

export enum ReportInternoSesionesAbiertasExportType {
    Excel = 1,
    PDF = 2,
}

export class ReportInternoSesionesEliminadasExportQuery implements IReportInternoSesionesEliminadasExportQuery {
    fechaInicial?: moment.Moment | undefined;
    fechaFinal?: moment.Moment | undefined;
    unidadesList?: number[] | undefined;
    tipoExportacion?: ReportInternoSesionesEliminadasExportType | undefined;

    constructor(data?: IReportInternoSesionesEliminadasExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fechaInicial = _data["fechaInicial"] ? moment(_data["fechaInicial"].toString()) : <any>undefined;
            this.fechaFinal = _data["fechaFinal"] ? moment(_data["fechaFinal"].toString()) : <any>undefined;
            if (Array.isArray(_data["unidadesList"])) {
                this.unidadesList = [] as any;
                for (let item of _data["unidadesList"])
                    this.unidadesList!.push(item);
            }
            this.tipoExportacion = _data["tipoExportacion"];
        }
    }

    static fromJS(data: any): ReportInternoSesionesEliminadasExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportInternoSesionesEliminadasExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fechaInicial"] = this.fechaInicial ? this.fechaInicial.toISOString() : <any>undefined;
        data["fechaFinal"] = this.fechaFinal ? this.fechaFinal.toISOString() : <any>undefined;
        if (Array.isArray(this.unidadesList)) {
            data["unidadesList"] = [];
            for (let item of this.unidadesList)
                data["unidadesList"].push(item);
        }
        data["tipoExportacion"] = this.tipoExportacion;
        return data;
    }
}

export interface IReportInternoSesionesEliminadasExportQuery {
    fechaInicial?: moment.Moment | undefined;
    fechaFinal?: moment.Moment | undefined;
    unidadesList?: number[] | undefined;
    tipoExportacion?: ReportInternoSesionesEliminadasExportType | undefined;
}

export enum ReportInternoSesionesEliminadasExportType {
    Excel = 1,
    CSV = 2,
}

export class ReportInternoSesionesSuspendidasExportQuery implements IReportInternoSesionesSuspendidasExportQuery {
    fechaInicial?: moment.Moment | undefined;
    fechaFinal?: moment.Moment | undefined;
    unidadesList?: number[] | undefined;
    tipoExportacion?: ReportInternoSesionesSuspendidasExportType | undefined;

    constructor(data?: IReportInternoSesionesSuspendidasExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fechaInicial = _data["fechaInicial"] ? moment(_data["fechaInicial"].toString()) : <any>undefined;
            this.fechaFinal = _data["fechaFinal"] ? moment(_data["fechaFinal"].toString()) : <any>undefined;
            if (Array.isArray(_data["unidadesList"])) {
                this.unidadesList = [] as any;
                for (let item of _data["unidadesList"])
                    this.unidadesList!.push(item);
            }
            this.tipoExportacion = _data["tipoExportacion"];
        }
    }

    static fromJS(data: any): ReportInternoSesionesSuspendidasExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportInternoSesionesSuspendidasExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fechaInicial"] = this.fechaInicial ? this.fechaInicial.toISOString() : <any>undefined;
        data["fechaFinal"] = this.fechaFinal ? this.fechaFinal.toISOString() : <any>undefined;
        if (Array.isArray(this.unidadesList)) {
            data["unidadesList"] = [];
            for (let item of this.unidadesList)
                data["unidadesList"].push(item);
        }
        data["tipoExportacion"] = this.tipoExportacion;
        return data;
    }
}

export interface IReportInternoSesionesSuspendidasExportQuery {
    fechaInicial?: moment.Moment | undefined;
    fechaFinal?: moment.Moment | undefined;
    unidadesList?: number[] | undefined;
    tipoExportacion?: ReportInternoSesionesSuspendidasExportType | undefined;
}

export enum ReportInternoSesionesSuspendidasExportType {
    Excel = 1,
    CSV = 2,
}

export class ReportInternoDetalleSesionesExportQuery implements IReportInternoDetalleSesionesExportQuery {
    fechaInicial?: moment.Moment | undefined;
    fechaFinal?: moment.Moment | undefined;
    unidadesList?: number[] | undefined;
    tipoExportacion?: ReportInternoDetalleSesionesExportType | undefined;

    constructor(data?: IReportInternoDetalleSesionesExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fechaInicial = _data["fechaInicial"] ? moment(_data["fechaInicial"].toString()) : <any>undefined;
            this.fechaFinal = _data["fechaFinal"] ? moment(_data["fechaFinal"].toString()) : <any>undefined;
            if (Array.isArray(_data["unidadesList"])) {
                this.unidadesList = [] as any;
                for (let item of _data["unidadesList"])
                    this.unidadesList!.push(item);
            }
            this.tipoExportacion = _data["tipoExportacion"];
        }
    }

    static fromJS(data: any): ReportInternoDetalleSesionesExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportInternoDetalleSesionesExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fechaInicial"] = this.fechaInicial ? this.fechaInicial.toISOString() : <any>undefined;
        data["fechaFinal"] = this.fechaFinal ? this.fechaFinal.toISOString() : <any>undefined;
        if (Array.isArray(this.unidadesList)) {
            data["unidadesList"] = [];
            for (let item of this.unidadesList)
                data["unidadesList"].push(item);
        }
        data["tipoExportacion"] = this.tipoExportacion;
        return data;
    }
}

export interface IReportInternoDetalleSesionesExportQuery {
    fechaInicial?: moment.Moment | undefined;
    fechaFinal?: moment.Moment | undefined;
    unidadesList?: number[] | undefined;
    tipoExportacion?: ReportInternoDetalleSesionesExportType | undefined;
}

export enum ReportInternoDetalleSesionesExportType {
    Excel = 1,
    CSV = 2,
}

export class ReportInternoSesionesMensajesHL7ExportQuery implements IReportInternoSesionesMensajesHL7ExportQuery {
    fechaInicial?: moment.Moment | undefined;
    fechaFinal?: moment.Moment | undefined;
    unidadesList?: number[] | undefined;
    tipoExportacion?: ReportInternoSesionesMensajesHL7ExportType | undefined;

    constructor(data?: IReportInternoSesionesMensajesHL7ExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fechaInicial = _data["fechaInicial"] ? moment(_data["fechaInicial"].toString()) : <any>undefined;
            this.fechaFinal = _data["fechaFinal"] ? moment(_data["fechaFinal"].toString()) : <any>undefined;
            if (Array.isArray(_data["unidadesList"])) {
                this.unidadesList = [] as any;
                for (let item of _data["unidadesList"])
                    this.unidadesList!.push(item);
            }
            this.tipoExportacion = _data["tipoExportacion"];
        }
    }

    static fromJS(data: any): ReportInternoSesionesMensajesHL7ExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportInternoSesionesMensajesHL7ExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fechaInicial"] = this.fechaInicial ? this.fechaInicial.toISOString() : <any>undefined;
        data["fechaFinal"] = this.fechaFinal ? this.fechaFinal.toISOString() : <any>undefined;
        if (Array.isArray(this.unidadesList)) {
            data["unidadesList"] = [];
            for (let item of this.unidadesList)
                data["unidadesList"].push(item);
        }
        data["tipoExportacion"] = this.tipoExportacion;
        return data;
    }
}

export interface IReportInternoSesionesMensajesHL7ExportQuery {
    fechaInicial?: moment.Moment | undefined;
    fechaFinal?: moment.Moment | undefined;
    unidadesList?: number[] | undefined;
    tipoExportacion?: ReportInternoSesionesMensajesHL7ExportType | undefined;
}

export enum ReportInternoSesionesMensajesHL7ExportType {
    Excel = 1,
    CSV = 2,
}

export class PagedResultDtoOfMedicoUnidadResponse implements IPagedResultDtoOfMedicoUnidadResponse {
    totalCount!: number;
    items?: MedicoUnidadResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfMedicoUnidadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MedicoUnidadResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMedicoUnidadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMedicoUnidadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfMedicoUnidadResponse {
    totalCount: number;
    items?: MedicoUnidadResponse[] | undefined;
}

export class MedicoUnidadResponse implements IMedicoUnidadResponse {
    id?: number | undefined;
    hospitalId?: number | undefined;
    hospitalName?: string | undefined;
    medicoId?: number | undefined;
    nombreCompleto?: string | undefined;
    usuarioId!: number;
    nombreUsuario?: string | undefined;
    nombre?: string | undefined;
    apellidoPaterno?: string | undefined;
    apellidoMaterno?: string | undefined;
    curp?: string | undefined;
    matricula?: string | undefined;
    cedula?: string | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;
    puestoId?: number | undefined;
    puestoDesc?: string | undefined;
    especialidadId?: number | undefined;
    especialdadDesc?: string | undefined;
    institucionesAseguradasId?: number | undefined;
    institucionesAseguradasDesc?: string | undefined;

    constructor(data?: IMedicoUnidadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hospitalId = _data["hospitalId"];
            this.hospitalName = _data["hospitalName"];
            this.medicoId = _data["medicoId"];
            this.nombreCompleto = _data["nombreCompleto"];
            this.usuarioId = _data["usuarioId"];
            this.nombreUsuario = _data["nombreUsuario"];
            this.nombre = _data["nombre"];
            this.apellidoPaterno = _data["apellidoPaterno"];
            this.apellidoMaterno = _data["apellidoMaterno"];
            this.curp = _data["curp"];
            this.matricula = _data["matricula"];
            this.cedula = _data["cedula"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.puestoId = _data["puestoId"];
            this.puestoDesc = _data["puestoDesc"];
            this.especialidadId = _data["especialidadId"];
            this.especialdadDesc = _data["especialdadDesc"];
            this.institucionesAseguradasId = _data["institucionesAseguradasId"];
            this.institucionesAseguradasDesc = _data["institucionesAseguradasDesc"];
        }
    }

    static fromJS(data: any): MedicoUnidadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MedicoUnidadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hospitalId"] = this.hospitalId;
        data["hospitalName"] = this.hospitalName;
        data["medicoId"] = this.medicoId;
        data["nombreCompleto"] = this.nombreCompleto;
        data["usuarioId"] = this.usuarioId;
        data["nombreUsuario"] = this.nombreUsuario;
        data["nombre"] = this.nombre;
        data["apellidoPaterno"] = this.apellidoPaterno;
        data["apellidoMaterno"] = this.apellidoMaterno;
        data["curp"] = this.curp;
        data["matricula"] = this.matricula;
        data["cedula"] = this.cedula;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["puestoId"] = this.puestoId;
        data["puestoDesc"] = this.puestoDesc;
        data["especialidadId"] = this.especialidadId;
        data["especialdadDesc"] = this.especialdadDesc;
        data["institucionesAseguradasId"] = this.institucionesAseguradasId;
        data["institucionesAseguradasDesc"] = this.institucionesAseguradasDesc;
        return data;
    }
}

export interface IMedicoUnidadResponse {
    id?: number | undefined;
    hospitalId?: number | undefined;
    hospitalName?: string | undefined;
    medicoId?: number | undefined;
    nombreCompleto?: string | undefined;
    usuarioId: number;
    nombreUsuario?: string | undefined;
    nombre?: string | undefined;
    apellidoPaterno?: string | undefined;
    apellidoMaterno?: string | undefined;
    curp?: string | undefined;
    matricula?: string | undefined;
    cedula?: string | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
    puestoId?: number | undefined;
    puestoDesc?: string | undefined;
    especialidadId?: number | undefined;
    especialdadDesc?: string | undefined;
    institucionesAseguradasId?: number | undefined;
    institucionesAseguradasDesc?: string | undefined;
}

export class PageListByDto implements IPageListByDto {
    sorting?: string | undefined;
    filter?: string | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
    isPaged!: boolean;

    constructor(data?: IPageListByDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sorting = _data["sorting"];
            this.filter = _data["filter"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.isPaged = _data["isPaged"];
        }
    }

    static fromJS(data: any): PageListByDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageListByDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["filter"] = this.filter;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["isPaged"] = this.isPaged;
        return data;
    }
}

export interface IPageListByDto {
    sorting?: string | undefined;
    filter?: string | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
    isPaged: boolean;
}

export class MedicoUnidadGetForListQuery extends PageListByDto implements IMedicoUnidadGetForListQuery {

    constructor(data?: IMedicoUnidadGetForListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MedicoUnidadGetForListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MedicoUnidadGetForListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMedicoUnidadGetForListQuery extends IPageListByDto {
}

export class MedicoUnidadGetAutocompleteListQuery implements IMedicoUnidadGetAutocompleteListQuery {
    criterio?: string | undefined;

    constructor(data?: IMedicoUnidadGetAutocompleteListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.criterio = _data["criterio"];
        }
    }

    static fromJS(data: any): MedicoUnidadGetAutocompleteListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MedicoUnidadGetAutocompleteListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criterio"] = this.criterio;
        return data;
    }
}

export interface IMedicoUnidadGetAutocompleteListQuery {
    criterio?: string | undefined;
}

export class MedicoUnidadGetForComboboxQuery extends PageListByDto implements IMedicoUnidadGetForComboboxQuery {

    constructor(data?: IMedicoUnidadGetForComboboxQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MedicoUnidadGetForComboboxQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MedicoUnidadGetForComboboxQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMedicoUnidadGetForComboboxQuery extends IPageListByDto {
}

export class MedicoUnidadGetByIdQuery implements IMedicoUnidadGetByIdQuery {
    id!: number;

    constructor(data?: IMedicoUnidadGetByIdQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicoUnidadGetByIdQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MedicoUnidadGetByIdQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IMedicoUnidadGetByIdQuery {
    id: number;
}

export class MedicoUnidadCreateCommand implements IMedicoUnidadCreateCommand {
    medicoId?: number | undefined;
    usuarioId?: number | undefined;

    constructor(data?: IMedicoUnidadCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicoId = _data["medicoId"];
            this.usuarioId = _data["usuarioId"];
        }
    }

    static fromJS(data: any): MedicoUnidadCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MedicoUnidadCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicoId"] = this.medicoId;
        data["usuarioId"] = this.usuarioId;
        return data;
    }
}

export interface IMedicoUnidadCreateCommand {
    medicoId?: number | undefined;
    usuarioId?: number | undefined;
}

export class MedicoUnidadUpdateCommand implements IMedicoUnidadUpdateCommand {
    id?: number | undefined;
    medicoId?: number | undefined;
    usuarioId?: number | undefined;

    constructor(data?: IMedicoUnidadUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.medicoId = _data["medicoId"];
            this.usuarioId = _data["usuarioId"];
        }
    }

    static fromJS(data: any): MedicoUnidadUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MedicoUnidadUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["medicoId"] = this.medicoId;
        data["usuarioId"] = this.usuarioId;
        return data;
    }
}

export interface IMedicoUnidadUpdateCommand {
    id?: number | undefined;
    medicoId?: number | undefined;
    usuarioId?: number | undefined;
}

export class MedicoUnidadDeleteCommand implements IMedicoUnidadDeleteCommand {
    id?: number | undefined;

    constructor(data?: IMedicoUnidadDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicoUnidadDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MedicoUnidadDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IMedicoUnidadDeleteCommand {
    id?: number | undefined;
}

export class MonitorMaquinaBellcoResponse implements IMonitorMaquinaBellcoResponse {
    equipo?: string | undefined;
    etiqueta?: string | undefined;
    sala?: string | undefined;
    ultimaLectura!: moment.Moment;

    constructor(data?: IMonitorMaquinaBellcoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.equipo = _data["equipo"];
            this.etiqueta = _data["etiqueta"];
            this.sala = _data["sala"];
            this.ultimaLectura = _data["ultimaLectura"] ? moment(_data["ultimaLectura"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MonitorMaquinaBellcoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MonitorMaquinaBellcoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["equipo"] = this.equipo;
        data["etiqueta"] = this.etiqueta;
        data["sala"] = this.sala;
        data["ultimaLectura"] = this.ultimaLectura ? this.ultimaLectura.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMonitorMaquinaBellcoResponse {
    equipo?: string | undefined;
    etiqueta?: string | undefined;
    sala?: string | undefined;
    ultimaLectura: moment.Moment;
}

export class MonitorMaquinaBellcoErrorResponse implements IMonitorMaquinaBellcoErrorResponse {
    fecha!: moment.Moment;
    equipo?: string | undefined;
    etiqueta?: string | undefined;
    sala?: string | undefined;
    mensaje?: string | undefined;

    constructor(data?: IMonitorMaquinaBellcoErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fecha = _data["fecha"] ? moment(_data["fecha"].toString()) : <any>undefined;
            this.equipo = _data["equipo"];
            this.etiqueta = _data["etiqueta"];
            this.sala = _data["sala"];
            this.mensaje = _data["mensaje"];
        }
    }

    static fromJS(data: any): MonitorMaquinaBellcoErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MonitorMaquinaBellcoErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fecha"] = this.fecha ? this.fecha.toISOString() : <any>undefined;
        data["equipo"] = this.equipo;
        data["etiqueta"] = this.etiqueta;
        data["sala"] = this.sala;
        data["mensaje"] = this.mensaje;
        return data;
    }
}

export interface IMonitorMaquinaBellcoErrorResponse {
    fecha: moment.Moment;
    equipo?: string | undefined;
    etiqueta?: string | undefined;
    sala?: string | undefined;
    mensaje?: string | undefined;
}

export class PrescripcionHDForListResponse implements IPrescripcionHDForListResponse {
    id!: number;
    tipoPacienteDesc?: string | undefined;
    tipoHemodialisisDesc?: string | undefined;
    horas?: number | undefined;
    minutos?: number | undefined;
    fechaInicio!: moment.Moment;
    fechaCierre?: moment.Moment | undefined;
    planEstudios?: string | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;

    constructor(data?: IPrescripcionHDForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tipoPacienteDesc = _data["tipoPacienteDesc"];
            this.tipoHemodialisisDesc = _data["tipoHemodialisisDesc"];
            this.horas = _data["horas"];
            this.minutos = _data["minutos"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaCierre = _data["fechaCierre"] ? moment(_data["fechaCierre"].toString()) : <any>undefined;
            this.planEstudios = _data["planEstudios"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): PrescripcionHDForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescripcionHDForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tipoPacienteDesc"] = this.tipoPacienteDesc;
        data["tipoHemodialisisDesc"] = this.tipoHemodialisisDesc;
        data["horas"] = this.horas;
        data["minutos"] = this.minutos;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaCierre"] = this.fechaCierre ? this.fechaCierre.toISOString() : <any>undefined;
        data["planEstudios"] = this.planEstudios;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IPrescripcionHDForListResponse {
    id: number;
    tipoPacienteDesc?: string | undefined;
    tipoHemodialisisDesc?: string | undefined;
    horas?: number | undefined;
    minutos?: number | undefined;
    fechaInicio: moment.Moment;
    fechaCierre?: moment.Moment | undefined;
    planEstudios?: string | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
}

export class PrescripcionHDGetListQuery implements IPrescripcionHDGetListQuery {
    pacienteId!: number;

    constructor(data?: IPrescripcionHDGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
        }
    }

    static fromJS(data: any): PrescripcionHDGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PrescripcionHDGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        return data;
    }
}

export interface IPrescripcionHDGetListQuery {
    pacienteId: number;
}

export class PrescripcionHDResponse implements IPrescripcionHDResponse {
    id!: number;
    pacienteId?: number | undefined;
    nombrePaciente?: string | undefined;
    tipoPacienteId?: number | undefined;
    tipoPacienteDesc?: string | undefined;
    tipoHemodialisisId?: number | undefined;
    tipoHemodialisisDesc?: string | undefined;
    tipoPerfilSodioId?: number | undefined;
    tipoPerfilSodioDesc?: string | undefined;
    accesoVascularId?: number | undefined;
    accesoVascularDesc?: string | undefined;
    tipoFiltroDializadorId?: number | undefined;
    tipoFiltroDializadorDesc?: string | undefined;
    tipoConcentradoId?: number | undefined;
    tipoConcentradoDesc?: string | undefined;
    fechaInicio!: moment.Moment;
    fechaCierre?: moment.Moment | undefined;
    horas?: number | undefined;
    minutos?: number | undefined;
    pesoSeco?: number | undefined;
    talla?: number | undefined;
    volumen?: number | undefined;
    indicacionesPreHd?: string | undefined;
    reuso!: boolean;
    planEstudios?: string | undefined;
    pronostico?: string | undefined;
    riesgoCaida?: number | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;
    maquinaInfo?: PrescripcionHDMaquinaResponse | undefined;
    heparinizacionInfo?: PrescripcionHDHeparinizacionResponse | undefined;
    patronCitasInfo?: PrescripcionHDPatronCitaResponse | undefined;
    motivoCambioInfo?: PrescripcionHDMotivosCambiosCitasResponse | undefined;

    constructor(data?: IPrescripcionHDResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pacienteId = _data["pacienteId"];
            this.nombrePaciente = _data["nombrePaciente"];
            this.tipoPacienteId = _data["tipoPacienteId"];
            this.tipoPacienteDesc = _data["tipoPacienteDesc"];
            this.tipoHemodialisisId = _data["tipoHemodialisisId"];
            this.tipoHemodialisisDesc = _data["tipoHemodialisisDesc"];
            this.tipoPerfilSodioId = _data["tipoPerfilSodioId"];
            this.tipoPerfilSodioDesc = _data["tipoPerfilSodioDesc"];
            this.accesoVascularId = _data["accesoVascularId"];
            this.accesoVascularDesc = _data["accesoVascularDesc"];
            this.tipoFiltroDializadorId = _data["tipoFiltroDializadorId"];
            this.tipoFiltroDializadorDesc = _data["tipoFiltroDializadorDesc"];
            this.tipoConcentradoId = _data["tipoConcentradoId"];
            this.tipoConcentradoDesc = _data["tipoConcentradoDesc"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaCierre = _data["fechaCierre"] ? moment(_data["fechaCierre"].toString()) : <any>undefined;
            this.horas = _data["horas"];
            this.minutos = _data["minutos"];
            this.pesoSeco = _data["pesoSeco"];
            this.talla = _data["talla"];
            this.volumen = _data["volumen"];
            this.indicacionesPreHd = _data["indicacionesPreHd"];
            this.reuso = _data["reuso"];
            this.planEstudios = _data["planEstudios"];
            this.pronostico = _data["pronostico"];
            this.riesgoCaida = _data["riesgoCaida"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.maquinaInfo = _data["maquinaInfo"] ? PrescripcionHDMaquinaResponse.fromJS(_data["maquinaInfo"]) : <any>undefined;
            this.heparinizacionInfo = _data["heparinizacionInfo"] ? PrescripcionHDHeparinizacionResponse.fromJS(_data["heparinizacionInfo"]) : <any>undefined;
            this.patronCitasInfo = _data["patronCitasInfo"] ? PrescripcionHDPatronCitaResponse.fromJS(_data["patronCitasInfo"]) : <any>undefined;
            this.motivoCambioInfo = _data["motivoCambioInfo"] ? PrescripcionHDMotivosCambiosCitasResponse.fromJS(_data["motivoCambioInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PrescripcionHDResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescripcionHDResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pacienteId"] = this.pacienteId;
        data["nombrePaciente"] = this.nombrePaciente;
        data["tipoPacienteId"] = this.tipoPacienteId;
        data["tipoPacienteDesc"] = this.tipoPacienteDesc;
        data["tipoHemodialisisId"] = this.tipoHemodialisisId;
        data["tipoHemodialisisDesc"] = this.tipoHemodialisisDesc;
        data["tipoPerfilSodioId"] = this.tipoPerfilSodioId;
        data["tipoPerfilSodioDesc"] = this.tipoPerfilSodioDesc;
        data["accesoVascularId"] = this.accesoVascularId;
        data["accesoVascularDesc"] = this.accesoVascularDesc;
        data["tipoFiltroDializadorId"] = this.tipoFiltroDializadorId;
        data["tipoFiltroDializadorDesc"] = this.tipoFiltroDializadorDesc;
        data["tipoConcentradoId"] = this.tipoConcentradoId;
        data["tipoConcentradoDesc"] = this.tipoConcentradoDesc;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaCierre"] = this.fechaCierre ? this.fechaCierre.toISOString() : <any>undefined;
        data["horas"] = this.horas;
        data["minutos"] = this.minutos;
        data["pesoSeco"] = this.pesoSeco;
        data["talla"] = this.talla;
        data["volumen"] = this.volumen;
        data["indicacionesPreHd"] = this.indicacionesPreHd;
        data["reuso"] = this.reuso;
        data["planEstudios"] = this.planEstudios;
        data["pronostico"] = this.pronostico;
        data["riesgoCaida"] = this.riesgoCaida;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["maquinaInfo"] = this.maquinaInfo ? this.maquinaInfo.toJSON() : <any>undefined;
        data["heparinizacionInfo"] = this.heparinizacionInfo ? this.heparinizacionInfo.toJSON() : <any>undefined;
        data["patronCitasInfo"] = this.patronCitasInfo ? this.patronCitasInfo.toJSON() : <any>undefined;
        data["motivoCambioInfo"] = this.motivoCambioInfo ? this.motivoCambioInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPrescripcionHDResponse {
    id: number;
    pacienteId?: number | undefined;
    nombrePaciente?: string | undefined;
    tipoPacienteId?: number | undefined;
    tipoPacienteDesc?: string | undefined;
    tipoHemodialisisId?: number | undefined;
    tipoHemodialisisDesc?: string | undefined;
    tipoPerfilSodioId?: number | undefined;
    tipoPerfilSodioDesc?: string | undefined;
    accesoVascularId?: number | undefined;
    accesoVascularDesc?: string | undefined;
    tipoFiltroDializadorId?: number | undefined;
    tipoFiltroDializadorDesc?: string | undefined;
    tipoConcentradoId?: number | undefined;
    tipoConcentradoDesc?: string | undefined;
    fechaInicio: moment.Moment;
    fechaCierre?: moment.Moment | undefined;
    horas?: number | undefined;
    minutos?: number | undefined;
    pesoSeco?: number | undefined;
    talla?: number | undefined;
    volumen?: number | undefined;
    indicacionesPreHd?: string | undefined;
    reuso: boolean;
    planEstudios?: string | undefined;
    pronostico?: string | undefined;
    riesgoCaida?: number | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
    maquinaInfo?: PrescripcionHDMaquinaResponse | undefined;
    heparinizacionInfo?: PrescripcionHDHeparinizacionResponse | undefined;
    patronCitasInfo?: PrescripcionHDPatronCitaResponse | undefined;
    motivoCambioInfo?: PrescripcionHDMotivosCambiosCitasResponse | undefined;
}

export class PrescripcionHDMaquinaResponse implements IPrescripcionHDMaquinaResponse {
    prescripcoinHDId!: number;
    flujoSanguineo?: number | undefined;
    flujoLiquido?: number | undefined;
    conductividad?: number | undefined;
    temperatura?: number | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;

    constructor(data?: IPrescripcionHDMaquinaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescripcoinHDId = _data["prescripcoinHDId"];
            this.flujoSanguineo = _data["flujoSanguineo"];
            this.flujoLiquido = _data["flujoLiquido"];
            this.conductividad = _data["conductividad"];
            this.temperatura = _data["temperatura"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): PrescripcionHDMaquinaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescripcionHDMaquinaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescripcoinHDId"] = this.prescripcoinHDId;
        data["flujoSanguineo"] = this.flujoSanguineo;
        data["flujoLiquido"] = this.flujoLiquido;
        data["conductividad"] = this.conductividad;
        data["temperatura"] = this.temperatura;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IPrescripcionHDMaquinaResponse {
    prescripcoinHDId: number;
    flujoSanguineo?: number | undefined;
    flujoLiquido?: number | undefined;
    conductividad?: number | undefined;
    temperatura?: number | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
}

export class PrescripcionHDHeparinizacionResponse implements IPrescripcionHDHeparinizacionResponse {
    prescripcoinHDId!: number;
    tipoHeparinaId?: number | undefined;
    tipoHeparinaDesc?: string | undefined;
    cantidad1Hr?: number | undefined;
    cantidad2Hr?: number | undefined;
    cantidad3Hr?: number | undefined;
    cantidad4Hr?: number | undefined;
    cantidad5Hr?: number | undefined;
    cantidad6Hr?: number | undefined;
    prestop?: string | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;

    constructor(data?: IPrescripcionHDHeparinizacionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescripcoinHDId = _data["prescripcoinHDId"];
            this.tipoHeparinaId = _data["tipoHeparinaId"];
            this.tipoHeparinaDesc = _data["tipoHeparinaDesc"];
            this.cantidad1Hr = _data["cantidad1Hr"];
            this.cantidad2Hr = _data["cantidad2Hr"];
            this.cantidad3Hr = _data["cantidad3Hr"];
            this.cantidad4Hr = _data["cantidad4Hr"];
            this.cantidad5Hr = _data["cantidad5Hr"];
            this.cantidad6Hr = _data["cantidad6Hr"];
            this.prestop = _data["prestop"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): PrescripcionHDHeparinizacionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescripcionHDHeparinizacionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescripcoinHDId"] = this.prescripcoinHDId;
        data["tipoHeparinaId"] = this.tipoHeparinaId;
        data["tipoHeparinaDesc"] = this.tipoHeparinaDesc;
        data["cantidad1Hr"] = this.cantidad1Hr;
        data["cantidad2Hr"] = this.cantidad2Hr;
        data["cantidad3Hr"] = this.cantidad3Hr;
        data["cantidad4Hr"] = this.cantidad4Hr;
        data["cantidad5Hr"] = this.cantidad5Hr;
        data["cantidad6Hr"] = this.cantidad6Hr;
        data["prestop"] = this.prestop;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IPrescripcionHDHeparinizacionResponse {
    prescripcoinHDId: number;
    tipoHeparinaId?: number | undefined;
    tipoHeparinaDesc?: string | undefined;
    cantidad1Hr?: number | undefined;
    cantidad2Hr?: number | undefined;
    cantidad3Hr?: number | undefined;
    cantidad4Hr?: number | undefined;
    cantidad5Hr?: number | undefined;
    cantidad6Hr?: number | undefined;
    prestop?: string | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
}

export class PrescripcionHDPatronCitaResponse implements IPrescripcionHDPatronCitaResponse {
    prescripcoinHDId!: number;
    maquinaId?: number | undefined;
    maquinaDesc?: string | undefined;
    salaId?: number | undefined;
    salaDesc?: string | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    detalle?: PrescripcionHDPatronCitaDetalleResponse[] | undefined;
    isActive!: boolean;

    constructor(data?: IPrescripcionHDPatronCitaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescripcoinHDId = _data["prescripcoinHDId"];
            this.maquinaId = _data["maquinaId"];
            this.maquinaDesc = _data["maquinaDesc"];
            this.salaId = _data["salaId"];
            this.salaDesc = _data["salaDesc"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            if (Array.isArray(_data["detalle"])) {
                this.detalle = [] as any;
                for (let item of _data["detalle"])
                    this.detalle!.push(PrescripcionHDPatronCitaDetalleResponse.fromJS(item));
            }
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): PrescripcionHDPatronCitaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescripcionHDPatronCitaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescripcoinHDId"] = this.prescripcoinHDId;
        data["maquinaId"] = this.maquinaId;
        data["maquinaDesc"] = this.maquinaDesc;
        data["salaId"] = this.salaId;
        data["salaDesc"] = this.salaDesc;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        if (Array.isArray(this.detalle)) {
            data["detalle"] = [];
            for (let item of this.detalle)
                data["detalle"].push(item.toJSON());
        }
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IPrescripcionHDPatronCitaResponse {
    prescripcoinHDId: number;
    maquinaId?: number | undefined;
    maquinaDesc?: string | undefined;
    salaId?: number | undefined;
    salaDesc?: string | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    detalle?: PrescripcionHDPatronCitaDetalleResponse[] | undefined;
    isActive: boolean;
}

export class PrescripcionHDPatronCitaDetalleResponse implements IPrescripcionHDPatronCitaDetalleResponse {
    prescripcoinHDPatronCitaId!: number;
    turnoHospitalId!: number;
    turnoHospitalDesc?: string | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;
    diaSemana!: number;

    constructor(data?: IPrescripcionHDPatronCitaDetalleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescripcoinHDPatronCitaId = _data["prescripcoinHDPatronCitaId"];
            this.turnoHospitalId = _data["turnoHospitalId"];
            this.turnoHospitalDesc = _data["turnoHospitalDesc"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.diaSemana = _data["diaSemana"];
        }
    }

    static fromJS(data: any): PrescripcionHDPatronCitaDetalleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescripcionHDPatronCitaDetalleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescripcoinHDPatronCitaId"] = this.prescripcoinHDPatronCitaId;
        data["turnoHospitalId"] = this.turnoHospitalId;
        data["turnoHospitalDesc"] = this.turnoHospitalDesc;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["diaSemana"] = this.diaSemana;
        return data;
    }
}

export interface IPrescripcionHDPatronCitaDetalleResponse {
    prescripcoinHDPatronCitaId: number;
    turnoHospitalId: number;
    turnoHospitalDesc?: string | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
    diaSemana: number;
}

export class PrescripcionHDMotivosCambiosCitasResponse implements IPrescripcionHDMotivosCambiosCitasResponse {
    id!: number;
    prescripcionHDId!: number;
    userId?: number | undefined;
    userName?: string | undefined;
    motivoCambioCita?: string | undefined;
    fechaCambioCita?: moment.Moment | undefined;

    constructor(data?: IPrescripcionHDMotivosCambiosCitasResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.prescripcionHDId = _data["prescripcionHDId"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.motivoCambioCita = _data["motivoCambioCita"];
            this.fechaCambioCita = _data["fechaCambioCita"] ? moment(_data["fechaCambioCita"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PrescripcionHDMotivosCambiosCitasResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescripcionHDMotivosCambiosCitasResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["prescripcionHDId"] = this.prescripcionHDId;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["motivoCambioCita"] = this.motivoCambioCita;
        data["fechaCambioCita"] = this.fechaCambioCita ? this.fechaCambioCita.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPrescripcionHDMotivosCambiosCitasResponse {
    id: number;
    prescripcionHDId: number;
    userId?: number | undefined;
    userName?: string | undefined;
    motivoCambioCita?: string | undefined;
    fechaCambioCita?: moment.Moment | undefined;
}

export class PrescripcionHDGetForEditQuery implements IPrescripcionHDGetForEditQuery {
    id!: number;

    constructor(data?: IPrescripcionHDGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PrescripcionHDGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PrescripcionHDGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IPrescripcionHDGetForEditQuery {
    id: number;
}

export class PrescripcionHDGetActivaDePacienteQuery implements IPrescripcionHDGetActivaDePacienteQuery {
    pacienteId!: number;

    constructor(data?: IPrescripcionHDGetActivaDePacienteQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
        }
    }

    static fromJS(data: any): PrescripcionHDGetActivaDePacienteQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PrescripcionHDGetActivaDePacienteQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        return data;
    }
}

export interface IPrescripcionHDGetActivaDePacienteQuery {
    pacienteId: number;
}

export class PrescripcionHDCreateCommand implements IPrescripcionHDCreateCommand {
    pacienteId?: number | undefined;
    nombrePaciente?: string | undefined;
    tipoPacienteId?: number | undefined;
    tipoHemodialisisId?: number | undefined;
    tipoPerfilSodioId?: number | undefined;
    accesoVascularId?: number | undefined;
    tipoFiltroDializadorId?: number | undefined;
    tipoConcentradoId?: number | undefined;
    fechaInicio!: moment.Moment;
    fechaCierre?: moment.Moment | undefined;
    horas?: number | undefined;
    minutos?: number | undefined;
    pesoSeco?: number | undefined;
    talla?: number | undefined;
    volumen?: number | undefined;
    indicacionesPreHd?: string | undefined;
    reuso!: boolean;
    planEstudios?: string | undefined;
    pronostico?: string | undefined;
    riesgoCaida?: number | undefined;
    maquinaInfo?: PrescripcionHDMaquinaResponse | undefined;
    heparinizacionInfo?: PrescripcionHDHeparinizacionResponse | undefined;
    patronCitasInfo?: PrescripcionHDPatronCitaResponse | undefined;

    constructor(data?: IPrescripcionHDCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
            this.nombrePaciente = _data["nombrePaciente"];
            this.tipoPacienteId = _data["tipoPacienteId"];
            this.tipoHemodialisisId = _data["tipoHemodialisisId"];
            this.tipoPerfilSodioId = _data["tipoPerfilSodioId"];
            this.accesoVascularId = _data["accesoVascularId"];
            this.tipoFiltroDializadorId = _data["tipoFiltroDializadorId"];
            this.tipoConcentradoId = _data["tipoConcentradoId"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaCierre = _data["fechaCierre"] ? moment(_data["fechaCierre"].toString()) : <any>undefined;
            this.horas = _data["horas"];
            this.minutos = _data["minutos"];
            this.pesoSeco = _data["pesoSeco"];
            this.talla = _data["talla"];
            this.volumen = _data["volumen"];
            this.indicacionesPreHd = _data["indicacionesPreHd"];
            this.reuso = _data["reuso"];
            this.planEstudios = _data["planEstudios"];
            this.pronostico = _data["pronostico"];
            this.riesgoCaida = _data["riesgoCaida"];
            this.maquinaInfo = _data["maquinaInfo"] ? PrescripcionHDMaquinaResponse.fromJS(_data["maquinaInfo"]) : <any>undefined;
            this.heparinizacionInfo = _data["heparinizacionInfo"] ? PrescripcionHDHeparinizacionResponse.fromJS(_data["heparinizacionInfo"]) : <any>undefined;
            this.patronCitasInfo = _data["patronCitasInfo"] ? PrescripcionHDPatronCitaResponse.fromJS(_data["patronCitasInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PrescripcionHDCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PrescripcionHDCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        data["nombrePaciente"] = this.nombrePaciente;
        data["tipoPacienteId"] = this.tipoPacienteId;
        data["tipoHemodialisisId"] = this.tipoHemodialisisId;
        data["tipoPerfilSodioId"] = this.tipoPerfilSodioId;
        data["accesoVascularId"] = this.accesoVascularId;
        data["tipoFiltroDializadorId"] = this.tipoFiltroDializadorId;
        data["tipoConcentradoId"] = this.tipoConcentradoId;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaCierre"] = this.fechaCierre ? this.fechaCierre.toISOString() : <any>undefined;
        data["horas"] = this.horas;
        data["minutos"] = this.minutos;
        data["pesoSeco"] = this.pesoSeco;
        data["talla"] = this.talla;
        data["volumen"] = this.volumen;
        data["indicacionesPreHd"] = this.indicacionesPreHd;
        data["reuso"] = this.reuso;
        data["planEstudios"] = this.planEstudios;
        data["pronostico"] = this.pronostico;
        data["riesgoCaida"] = this.riesgoCaida;
        data["maquinaInfo"] = this.maquinaInfo ? this.maquinaInfo.toJSON() : <any>undefined;
        data["heparinizacionInfo"] = this.heparinizacionInfo ? this.heparinizacionInfo.toJSON() : <any>undefined;
        data["patronCitasInfo"] = this.patronCitasInfo ? this.patronCitasInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPrescripcionHDCreateCommand {
    pacienteId?: number | undefined;
    nombrePaciente?: string | undefined;
    tipoPacienteId?: number | undefined;
    tipoHemodialisisId?: number | undefined;
    tipoPerfilSodioId?: number | undefined;
    accesoVascularId?: number | undefined;
    tipoFiltroDializadorId?: number | undefined;
    tipoConcentradoId?: number | undefined;
    fechaInicio: moment.Moment;
    fechaCierre?: moment.Moment | undefined;
    horas?: number | undefined;
    minutos?: number | undefined;
    pesoSeco?: number | undefined;
    talla?: number | undefined;
    volumen?: number | undefined;
    indicacionesPreHd?: string | undefined;
    reuso: boolean;
    planEstudios?: string | undefined;
    pronostico?: string | undefined;
    riesgoCaida?: number | undefined;
    maquinaInfo?: PrescripcionHDMaquinaResponse | undefined;
    heparinizacionInfo?: PrescripcionHDHeparinizacionResponse | undefined;
    patronCitasInfo?: PrescripcionHDPatronCitaResponse | undefined;
}

export class PrescripcionHDUpdateCommand implements IPrescripcionHDUpdateCommand {
    id?: number | undefined;
    pacienteId?: number | undefined;
    nombrePaciente?: string | undefined;
    tipoPacienteId?: number | undefined;
    tipoHemodialisisId?: number | undefined;
    tipoPerfilSodioId?: number | undefined;
    accesoVascularId?: number | undefined;
    tipoFiltroDializadorId?: number | undefined;
    tipoConcentradoId?: number | undefined;
    fechaInicio!: moment.Moment;
    fechaCierre?: moment.Moment | undefined;
    horas?: number | undefined;
    minutos?: number | undefined;
    pesoSeco?: number | undefined;
    talla?: number | undefined;
    volumen?: number | undefined;
    indicacionesPreHd?: string | undefined;
    reuso!: boolean;
    planEstudios?: string | undefined;
    pronostico?: string | undefined;
    riesgoCaida?: number | undefined;
    maquinaInfo?: PrescripcionHDMaquinaResponse | undefined;
    heparinizacionInfo?: PrescripcionHDHeparinizacionResponse | undefined;
    patronCitasInfo?: PrescripcionHDPatronCitaResponse | undefined;
    motivoCambioInfo?: PrescripcionHDMotivosCambiosCitasResponse | undefined;

    constructor(data?: IPrescripcionHDUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pacienteId = _data["pacienteId"];
            this.nombrePaciente = _data["nombrePaciente"];
            this.tipoPacienteId = _data["tipoPacienteId"];
            this.tipoHemodialisisId = _data["tipoHemodialisisId"];
            this.tipoPerfilSodioId = _data["tipoPerfilSodioId"];
            this.accesoVascularId = _data["accesoVascularId"];
            this.tipoFiltroDializadorId = _data["tipoFiltroDializadorId"];
            this.tipoConcentradoId = _data["tipoConcentradoId"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaCierre = _data["fechaCierre"] ? moment(_data["fechaCierre"].toString()) : <any>undefined;
            this.horas = _data["horas"];
            this.minutos = _data["minutos"];
            this.pesoSeco = _data["pesoSeco"];
            this.talla = _data["talla"];
            this.volumen = _data["volumen"];
            this.indicacionesPreHd = _data["indicacionesPreHd"];
            this.reuso = _data["reuso"];
            this.planEstudios = _data["planEstudios"];
            this.pronostico = _data["pronostico"];
            this.riesgoCaida = _data["riesgoCaida"];
            this.maquinaInfo = _data["maquinaInfo"] ? PrescripcionHDMaquinaResponse.fromJS(_data["maquinaInfo"]) : <any>undefined;
            this.heparinizacionInfo = _data["heparinizacionInfo"] ? PrescripcionHDHeparinizacionResponse.fromJS(_data["heparinizacionInfo"]) : <any>undefined;
            this.patronCitasInfo = _data["patronCitasInfo"] ? PrescripcionHDPatronCitaResponse.fromJS(_data["patronCitasInfo"]) : <any>undefined;
            this.motivoCambioInfo = _data["motivoCambioInfo"] ? PrescripcionHDMotivosCambiosCitasResponse.fromJS(_data["motivoCambioInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PrescripcionHDUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PrescripcionHDUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pacienteId"] = this.pacienteId;
        data["nombrePaciente"] = this.nombrePaciente;
        data["tipoPacienteId"] = this.tipoPacienteId;
        data["tipoHemodialisisId"] = this.tipoHemodialisisId;
        data["tipoPerfilSodioId"] = this.tipoPerfilSodioId;
        data["accesoVascularId"] = this.accesoVascularId;
        data["tipoFiltroDializadorId"] = this.tipoFiltroDializadorId;
        data["tipoConcentradoId"] = this.tipoConcentradoId;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaCierre"] = this.fechaCierre ? this.fechaCierre.toISOString() : <any>undefined;
        data["horas"] = this.horas;
        data["minutos"] = this.minutos;
        data["pesoSeco"] = this.pesoSeco;
        data["talla"] = this.talla;
        data["volumen"] = this.volumen;
        data["indicacionesPreHd"] = this.indicacionesPreHd;
        data["reuso"] = this.reuso;
        data["planEstudios"] = this.planEstudios;
        data["pronostico"] = this.pronostico;
        data["riesgoCaida"] = this.riesgoCaida;
        data["maquinaInfo"] = this.maquinaInfo ? this.maquinaInfo.toJSON() : <any>undefined;
        data["heparinizacionInfo"] = this.heparinizacionInfo ? this.heparinizacionInfo.toJSON() : <any>undefined;
        data["patronCitasInfo"] = this.patronCitasInfo ? this.patronCitasInfo.toJSON() : <any>undefined;
        data["motivoCambioInfo"] = this.motivoCambioInfo ? this.motivoCambioInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPrescripcionHDUpdateCommand {
    id?: number | undefined;
    pacienteId?: number | undefined;
    nombrePaciente?: string | undefined;
    tipoPacienteId?: number | undefined;
    tipoHemodialisisId?: number | undefined;
    tipoPerfilSodioId?: number | undefined;
    accesoVascularId?: number | undefined;
    tipoFiltroDializadorId?: number | undefined;
    tipoConcentradoId?: number | undefined;
    fechaInicio: moment.Moment;
    fechaCierre?: moment.Moment | undefined;
    horas?: number | undefined;
    minutos?: number | undefined;
    pesoSeco?: number | undefined;
    talla?: number | undefined;
    volumen?: number | undefined;
    indicacionesPreHd?: string | undefined;
    reuso: boolean;
    planEstudios?: string | undefined;
    pronostico?: string | undefined;
    riesgoCaida?: number | undefined;
    maquinaInfo?: PrescripcionHDMaquinaResponse | undefined;
    heparinizacionInfo?: PrescripcionHDHeparinizacionResponse | undefined;
    patronCitasInfo?: PrescripcionHDPatronCitaResponse | undefined;
    motivoCambioInfo?: PrescripcionHDMotivosCambiosCitasResponse | undefined;
}

export class PrescripcionHDGetMotivosCambiosListQuery implements IPrescripcionHDGetMotivosCambiosListQuery {
    id!: number;

    constructor(data?: IPrescripcionHDGetMotivosCambiosListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PrescripcionHDGetMotivosCambiosListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PrescripcionHDGetMotivosCambiosListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IPrescripcionHDGetMotivosCambiosListQuery {
    id: number;
}

export class PrescripcionHDNotasMedicasResponse implements IPrescripcionHDNotasMedicasResponse {
    id!: number;
    prescripcionHDId!: number;
    fechaNota!: moment.Moment;
    descripcion?: string | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;

    constructor(data?: IPrescripcionHDNotasMedicasResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.prescripcionHDId = _data["prescripcionHDId"];
            this.fechaNota = _data["fechaNota"] ? moment(_data["fechaNota"].toString()) : <any>undefined;
            this.descripcion = _data["descripcion"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): PrescripcionHDNotasMedicasResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescripcionHDNotasMedicasResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["prescripcionHDId"] = this.prescripcionHDId;
        data["fechaNota"] = this.fechaNota ? this.fechaNota.toISOString() : <any>undefined;
        data["descripcion"] = this.descripcion;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IPrescripcionHDNotasMedicasResponse {
    id: number;
    prescripcionHDId: number;
    fechaNota: moment.Moment;
    descripcion?: string | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
}

export class PrescripcionHDGetNotasMedicasListQuery implements IPrescripcionHDGetNotasMedicasListQuery {
    id!: number;

    constructor(data?: IPrescripcionHDGetNotasMedicasListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PrescripcionHDGetNotasMedicasListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PrescripcionHDGetNotasMedicasListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IPrescripcionHDGetNotasMedicasListQuery {
    id: number;
}

export class PrescripcionHDNotaMedicaCreateCommand implements IPrescripcionHDNotaMedicaCreateCommand {
    prescripcionHDId!: number;
    fechaNota!: moment.Moment;
    descripcion?: string | undefined;

    constructor(data?: IPrescripcionHDNotaMedicaCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescripcionHDId = _data["prescripcionHDId"];
            this.fechaNota = _data["fechaNota"] ? moment(_data["fechaNota"].toString()) : <any>undefined;
            this.descripcion = _data["descripcion"];
        }
    }

    static fromJS(data: any): PrescripcionHDNotaMedicaCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PrescripcionHDNotaMedicaCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescripcionHDId"] = this.prescripcionHDId;
        data["fechaNota"] = this.fechaNota ? this.fechaNota.toISOString() : <any>undefined;
        data["descripcion"] = this.descripcion;
        return data;
    }
}

export interface IPrescripcionHDNotaMedicaCreateCommand {
    prescripcionHDId: number;
    fechaNota: moment.Moment;
    descripcion?: string | undefined;
}

export class PagedResultDtoOfSesionHDForListResponse implements IPagedResultDtoOfSesionHDForListResponse {
    totalCount!: number;
    items?: SesionHDForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfSesionHDForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SesionHDForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSesionHDForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSesionHDForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfSesionHDForListResponse {
    totalCount: number;
    items?: SesionHDForListResponse[] | undefined;
}

export class SesionHDForListResponse implements ISesionHDForListResponse {
    id!: number;
    citaId!: number;
    pacienteId!: number;
    nombrePaciente?: string | undefined;
    prescripcionHdId!: number;
    tipoFiltroDializadorId!: number;
    maquinaId!: number;
    tipoConcentradoId?: number | undefined;
    medicoId?: number | undefined;
    usuarioInicioSesionId!: number;
    usuarioFinSesionId?: number | undefined;
    tipoPacienteId?: number | undefined;
    tipoHeparinaId?: number | undefined;
    tipoSesionId!: number;
    accesoVascularePeritonialId!: number;
    estatusAccesoId!: number;
    fechaSesion!: moment.Moment;
    duracionHoras!: number;
    duracionMinutos!: number;
    horaInicio!: number;
    minutoInicio!: number;
    horaFin?: number | undefined;
    minutoFin?: number | undefined;
    tomasHr?: number | undefined;
    reuso!: boolean;
    numeroReuso?: number | undefined;
    pesoEntrada?: number | undefined;
    pesoAnterior?: number | undefined;
    pesoGanancia?: number | undefined;
    perdidaEstimada?: number | undefined;
    pesoSeco?: number | undefined;
    pesoSalida?: number | undefined;
    aportacion?: number | undefined;
    sodioInicial?: number | undefined;
    sodioFinal?: number | undefined;
    merma!: boolean;
    boloInicial?: number | undefined;
    bolo1?: number | undefined;
    bolo2?: number | undefined;
    bolo3?: number | undefined;
    bolo4?: number | undefined;
    bolo5?: number | undefined;
    bolo6?: number | undefined;
    contrato?: string | undefined;
    tipoHeparina?: string | undefined;
    ultrafiltracionProgramada?: string | undefined;
    ultraFiltracionReal?: string | undefined;
    coeficienteUltraFiltracion?: string | undefined;
    observaciones?: string | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;
    tiempoTranscurrido?: number | undefined;
    tiempoProgramado?: string | undefined;
    estatusCitaClave?: string | undefined;
    estatusCitaDesc?: string | undefined;

    constructor(data?: ISesionHDForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.citaId = _data["citaId"];
            this.pacienteId = _data["pacienteId"];
            this.nombrePaciente = _data["nombrePaciente"];
            this.prescripcionHdId = _data["prescripcionHdId"];
            this.tipoFiltroDializadorId = _data["tipoFiltroDializadorId"];
            this.maquinaId = _data["maquinaId"];
            this.tipoConcentradoId = _data["tipoConcentradoId"];
            this.medicoId = _data["medicoId"];
            this.usuarioInicioSesionId = _data["usuarioInicioSesionId"];
            this.usuarioFinSesionId = _data["usuarioFinSesionId"];
            this.tipoPacienteId = _data["tipoPacienteId"];
            this.tipoHeparinaId = _data["tipoHeparinaId"];
            this.tipoSesionId = _data["tipoSesionId"];
            this.accesoVascularePeritonialId = _data["accesoVascularePeritonialId"];
            this.estatusAccesoId = _data["estatusAccesoId"];
            this.fechaSesion = _data["fechaSesion"] ? moment(_data["fechaSesion"].toString()) : <any>undefined;
            this.duracionHoras = _data["duracionHoras"];
            this.duracionMinutos = _data["duracionMinutos"];
            this.horaInicio = _data["horaInicio"];
            this.minutoInicio = _data["minutoInicio"];
            this.horaFin = _data["horaFin"];
            this.minutoFin = _data["minutoFin"];
            this.tomasHr = _data["tomasHr"];
            this.reuso = _data["reuso"];
            this.numeroReuso = _data["numeroReuso"];
            this.pesoEntrada = _data["pesoEntrada"];
            this.pesoAnterior = _data["pesoAnterior"];
            this.pesoGanancia = _data["pesoGanancia"];
            this.perdidaEstimada = _data["perdidaEstimada"];
            this.pesoSeco = _data["pesoSeco"];
            this.pesoSalida = _data["pesoSalida"];
            this.aportacion = _data["aportacion"];
            this.sodioInicial = _data["sodioInicial"];
            this.sodioFinal = _data["sodioFinal"];
            this.merma = _data["merma"];
            this.boloInicial = _data["boloInicial"];
            this.bolo1 = _data["bolo1"];
            this.bolo2 = _data["bolo2"];
            this.bolo3 = _data["bolo3"];
            this.bolo4 = _data["bolo4"];
            this.bolo5 = _data["bolo5"];
            this.bolo6 = _data["bolo6"];
            this.contrato = _data["contrato"];
            this.tipoHeparina = _data["tipoHeparina"];
            this.ultrafiltracionProgramada = _data["ultrafiltracionProgramada"];
            this.ultraFiltracionReal = _data["ultraFiltracionReal"];
            this.coeficienteUltraFiltracion = _data["coeficienteUltraFiltracion"];
            this.observaciones = _data["observaciones"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.tiempoTranscurrido = _data["tiempoTranscurrido"];
            this.tiempoProgramado = _data["tiempoProgramado"];
            this.estatusCitaClave = _data["estatusCitaClave"];
            this.estatusCitaDesc = _data["estatusCitaDesc"];
        }
    }

    static fromJS(data: any): SesionHDForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["citaId"] = this.citaId;
        data["pacienteId"] = this.pacienteId;
        data["nombrePaciente"] = this.nombrePaciente;
        data["prescripcionHdId"] = this.prescripcionHdId;
        data["tipoFiltroDializadorId"] = this.tipoFiltroDializadorId;
        data["maquinaId"] = this.maquinaId;
        data["tipoConcentradoId"] = this.tipoConcentradoId;
        data["medicoId"] = this.medicoId;
        data["usuarioInicioSesionId"] = this.usuarioInicioSesionId;
        data["usuarioFinSesionId"] = this.usuarioFinSesionId;
        data["tipoPacienteId"] = this.tipoPacienteId;
        data["tipoHeparinaId"] = this.tipoHeparinaId;
        data["tipoSesionId"] = this.tipoSesionId;
        data["accesoVascularePeritonialId"] = this.accesoVascularePeritonialId;
        data["estatusAccesoId"] = this.estatusAccesoId;
        data["fechaSesion"] = this.fechaSesion ? this.fechaSesion.toISOString() : <any>undefined;
        data["duracionHoras"] = this.duracionHoras;
        data["duracionMinutos"] = this.duracionMinutos;
        data["horaInicio"] = this.horaInicio;
        data["minutoInicio"] = this.minutoInicio;
        data["horaFin"] = this.horaFin;
        data["minutoFin"] = this.minutoFin;
        data["tomasHr"] = this.tomasHr;
        data["reuso"] = this.reuso;
        data["numeroReuso"] = this.numeroReuso;
        data["pesoEntrada"] = this.pesoEntrada;
        data["pesoAnterior"] = this.pesoAnterior;
        data["pesoGanancia"] = this.pesoGanancia;
        data["perdidaEstimada"] = this.perdidaEstimada;
        data["pesoSeco"] = this.pesoSeco;
        data["pesoSalida"] = this.pesoSalida;
        data["aportacion"] = this.aportacion;
        data["sodioInicial"] = this.sodioInicial;
        data["sodioFinal"] = this.sodioFinal;
        data["merma"] = this.merma;
        data["boloInicial"] = this.boloInicial;
        data["bolo1"] = this.bolo1;
        data["bolo2"] = this.bolo2;
        data["bolo3"] = this.bolo3;
        data["bolo4"] = this.bolo4;
        data["bolo5"] = this.bolo5;
        data["bolo6"] = this.bolo6;
        data["contrato"] = this.contrato;
        data["tipoHeparina"] = this.tipoHeparina;
        data["ultrafiltracionProgramada"] = this.ultrafiltracionProgramada;
        data["ultraFiltracionReal"] = this.ultraFiltracionReal;
        data["coeficienteUltraFiltracion"] = this.coeficienteUltraFiltracion;
        data["observaciones"] = this.observaciones;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["tiempoTranscurrido"] = this.tiempoTranscurrido;
        data["tiempoProgramado"] = this.tiempoProgramado;
        data["estatusCitaClave"] = this.estatusCitaClave;
        data["estatusCitaDesc"] = this.estatusCitaDesc;
        return data;
    }
}

export interface ISesionHDForListResponse {
    id: number;
    citaId: number;
    pacienteId: number;
    nombrePaciente?: string | undefined;
    prescripcionHdId: number;
    tipoFiltroDializadorId: number;
    maquinaId: number;
    tipoConcentradoId?: number | undefined;
    medicoId?: number | undefined;
    usuarioInicioSesionId: number;
    usuarioFinSesionId?: number | undefined;
    tipoPacienteId?: number | undefined;
    tipoHeparinaId?: number | undefined;
    tipoSesionId: number;
    accesoVascularePeritonialId: number;
    estatusAccesoId: number;
    fechaSesion: moment.Moment;
    duracionHoras: number;
    duracionMinutos: number;
    horaInicio: number;
    minutoInicio: number;
    horaFin?: number | undefined;
    minutoFin?: number | undefined;
    tomasHr?: number | undefined;
    reuso: boolean;
    numeroReuso?: number | undefined;
    pesoEntrada?: number | undefined;
    pesoAnterior?: number | undefined;
    pesoGanancia?: number | undefined;
    perdidaEstimada?: number | undefined;
    pesoSeco?: number | undefined;
    pesoSalida?: number | undefined;
    aportacion?: number | undefined;
    sodioInicial?: number | undefined;
    sodioFinal?: number | undefined;
    merma: boolean;
    boloInicial?: number | undefined;
    bolo1?: number | undefined;
    bolo2?: number | undefined;
    bolo3?: number | undefined;
    bolo4?: number | undefined;
    bolo5?: number | undefined;
    bolo6?: number | undefined;
    contrato?: string | undefined;
    tipoHeparina?: string | undefined;
    ultrafiltracionProgramada?: string | undefined;
    ultraFiltracionReal?: string | undefined;
    coeficienteUltraFiltracion?: string | undefined;
    observaciones?: string | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
    tiempoTranscurrido?: number | undefined;
    tiempoProgramado?: string | undefined;
    estatusCitaClave?: string | undefined;
    estatusCitaDesc?: string | undefined;
}

export class SesionHDGetListQuery extends PageListByDto implements ISesionHDGetListQuery {
    fechaInicio?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    salaId?: number | undefined;
    maquinaId?: number | undefined;

    constructor(data?: ISesionHDGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.salaId = _data["salaId"];
            this.maquinaId = _data["maquinaId"];
        }
    }

    static override fromJS(data: any): SesionHDGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["salaId"] = this.salaId;
        data["maquinaId"] = this.maquinaId;
        super.toJSON(data);
        return data;
    }
}

export interface ISesionHDGetListQuery extends IPageListByDto {
    fechaInicio?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    salaId?: number | undefined;
    maquinaId?: number | undefined;
}

export class SesionHDResponse implements ISesionHDResponse {
    id!: number;
    folioSesionHd!: number;
    citaId!: number;
    pacienteId!: number;
    nombrePaciente?: string | undefined;
    prescripcionHdId!: number;
    tipoFiltroDializadorId!: number;
    salaId!: number;
    maquinaId!: number;
    tipoConcentradoId?: number | undefined;
    medicoId?: number | undefined;
    usuarioInicioSesionId!: number;
    usuarioFinSesionId?: number | undefined;
    tipoPacienteId?: number | undefined;
    tipoHeparinaId?: number | undefined;
    tipoSesionId!: number;
    accesoVascularePeritonialId!: number;
    estatusAccesoId!: number;
    fechaSesion!: moment.Moment;
    duracionHoras!: number;
    duracionMinutos!: number;
    horaInicio!: number;
    minutoInicio!: number;
    horaFin?: number | undefined;
    minutoFin?: number | undefined;
    tiempoTranscurrido?: number | undefined;
    tomasHr?: number | undefined;
    reuso!: boolean;
    numeroReuso?: number | undefined;
    pesoEntrada?: number | undefined;
    pesoAnterior?: number | undefined;
    pesoGanancia?: number | undefined;
    perdidaEstimada?: number | undefined;
    pesoSeco?: number | undefined;
    pesoSalida?: number | undefined;
    aportacion?: number | undefined;
    sodioInicial?: number | undefined;
    sodioFinal?: number | undefined;
    merma!: boolean;
    boloInicial?: number | undefined;
    bolo1?: number | undefined;
    bolo2?: number | undefined;
    bolo3?: number | undefined;
    bolo4?: number | undefined;
    bolo5?: number | undefined;
    bolo6?: number | undefined;
    contrato?: string | undefined;
    tipoHeparina?: string | undefined;
    ultrafiltracionProgramada?: string | undefined;
    ultraFiltracionReal?: string | undefined;
    coeficienteUltraFiltracion?: string | undefined;
    observaciones?: string | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;
    tipoPacienteDesc?: string | undefined;
    qb?: number | undefined;
    qd?: number | undefined;
    condTotal?: number | undefined;
    tempQD?: number | undefined;
    estatusCitaId!: number;
    estatusCitaClave?: string | undefined;
    estatusCitaDesc?: string | undefined;
    esSesionCerrada!: boolean;
    riesgoCaida?: number | undefined;
    aportes?: SesionHDAportesResponse | undefined;
    observacionesEnfermeria?: SesionHDObservacionesEnfermeriaResponse | undefined;
    indicadoresKtvNpcr?: SesionHDKtvNpcrResponse | undefined;
    informacionDePersonal?: SesionHDPersonalResponse | undefined;
    medicionesList?: SesionHDMedicionResponse[] | undefined;

    constructor(data?: ISesionHDResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.folioSesionHd = _data["folioSesionHd"];
            this.citaId = _data["citaId"];
            this.pacienteId = _data["pacienteId"];
            this.nombrePaciente = _data["nombrePaciente"];
            this.prescripcionHdId = _data["prescripcionHdId"];
            this.tipoFiltroDializadorId = _data["tipoFiltroDializadorId"];
            this.salaId = _data["salaId"];
            this.maquinaId = _data["maquinaId"];
            this.tipoConcentradoId = _data["tipoConcentradoId"];
            this.medicoId = _data["medicoId"];
            this.usuarioInicioSesionId = _data["usuarioInicioSesionId"];
            this.usuarioFinSesionId = _data["usuarioFinSesionId"];
            this.tipoPacienteId = _data["tipoPacienteId"];
            this.tipoHeparinaId = _data["tipoHeparinaId"];
            this.tipoSesionId = _data["tipoSesionId"];
            this.accesoVascularePeritonialId = _data["accesoVascularePeritonialId"];
            this.estatusAccesoId = _data["estatusAccesoId"];
            this.fechaSesion = _data["fechaSesion"] ? moment(_data["fechaSesion"].toString()) : <any>undefined;
            this.duracionHoras = _data["duracionHoras"];
            this.duracionMinutos = _data["duracionMinutos"];
            this.horaInicio = _data["horaInicio"];
            this.minutoInicio = _data["minutoInicio"];
            this.horaFin = _data["horaFin"];
            this.minutoFin = _data["minutoFin"];
            this.tiempoTranscurrido = _data["tiempoTranscurrido"];
            this.tomasHr = _data["tomasHr"];
            this.reuso = _data["reuso"];
            this.numeroReuso = _data["numeroReuso"];
            this.pesoEntrada = _data["pesoEntrada"];
            this.pesoAnterior = _data["pesoAnterior"];
            this.pesoGanancia = _data["pesoGanancia"];
            this.perdidaEstimada = _data["perdidaEstimada"];
            this.pesoSeco = _data["pesoSeco"];
            this.pesoSalida = _data["pesoSalida"];
            this.aportacion = _data["aportacion"];
            this.sodioInicial = _data["sodioInicial"];
            this.sodioFinal = _data["sodioFinal"];
            this.merma = _data["merma"];
            this.boloInicial = _data["boloInicial"];
            this.bolo1 = _data["bolo1"];
            this.bolo2 = _data["bolo2"];
            this.bolo3 = _data["bolo3"];
            this.bolo4 = _data["bolo4"];
            this.bolo5 = _data["bolo5"];
            this.bolo6 = _data["bolo6"];
            this.contrato = _data["contrato"];
            this.tipoHeparina = _data["tipoHeparina"];
            this.ultrafiltracionProgramada = _data["ultrafiltracionProgramada"];
            this.ultraFiltracionReal = _data["ultraFiltracionReal"];
            this.coeficienteUltraFiltracion = _data["coeficienteUltraFiltracion"];
            this.observaciones = _data["observaciones"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.tipoPacienteDesc = _data["tipoPacienteDesc"];
            this.qb = _data["qb"];
            this.qd = _data["qd"];
            this.condTotal = _data["condTotal"];
            this.tempQD = _data["tempQD"];
            this.estatusCitaId = _data["estatusCitaId"];
            this.estatusCitaClave = _data["estatusCitaClave"];
            this.estatusCitaDesc = _data["estatusCitaDesc"];
            this.esSesionCerrada = _data["esSesionCerrada"];
            this.riesgoCaida = _data["riesgoCaida"];
            this.aportes = _data["aportes"] ? SesionHDAportesResponse.fromJS(_data["aportes"]) : <any>undefined;
            this.observacionesEnfermeria = _data["observacionesEnfermeria"] ? SesionHDObservacionesEnfermeriaResponse.fromJS(_data["observacionesEnfermeria"]) : <any>undefined;
            this.indicadoresKtvNpcr = _data["indicadoresKtvNpcr"] ? SesionHDKtvNpcrResponse.fromJS(_data["indicadoresKtvNpcr"]) : <any>undefined;
            this.informacionDePersonal = _data["informacionDePersonal"] ? SesionHDPersonalResponse.fromJS(_data["informacionDePersonal"]) : <any>undefined;
            if (Array.isArray(_data["medicionesList"])) {
                this.medicionesList = [] as any;
                for (let item of _data["medicionesList"])
                    this.medicionesList!.push(SesionHDMedicionResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SesionHDResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["folioSesionHd"] = this.folioSesionHd;
        data["citaId"] = this.citaId;
        data["pacienteId"] = this.pacienteId;
        data["nombrePaciente"] = this.nombrePaciente;
        data["prescripcionHdId"] = this.prescripcionHdId;
        data["tipoFiltroDializadorId"] = this.tipoFiltroDializadorId;
        data["salaId"] = this.salaId;
        data["maquinaId"] = this.maquinaId;
        data["tipoConcentradoId"] = this.tipoConcentradoId;
        data["medicoId"] = this.medicoId;
        data["usuarioInicioSesionId"] = this.usuarioInicioSesionId;
        data["usuarioFinSesionId"] = this.usuarioFinSesionId;
        data["tipoPacienteId"] = this.tipoPacienteId;
        data["tipoHeparinaId"] = this.tipoHeparinaId;
        data["tipoSesionId"] = this.tipoSesionId;
        data["accesoVascularePeritonialId"] = this.accesoVascularePeritonialId;
        data["estatusAccesoId"] = this.estatusAccesoId;
        data["fechaSesion"] = this.fechaSesion ? this.fechaSesion.toISOString() : <any>undefined;
        data["duracionHoras"] = this.duracionHoras;
        data["duracionMinutos"] = this.duracionMinutos;
        data["horaInicio"] = this.horaInicio;
        data["minutoInicio"] = this.minutoInicio;
        data["horaFin"] = this.horaFin;
        data["minutoFin"] = this.minutoFin;
        data["tiempoTranscurrido"] = this.tiempoTranscurrido;
        data["tomasHr"] = this.tomasHr;
        data["reuso"] = this.reuso;
        data["numeroReuso"] = this.numeroReuso;
        data["pesoEntrada"] = this.pesoEntrada;
        data["pesoAnterior"] = this.pesoAnterior;
        data["pesoGanancia"] = this.pesoGanancia;
        data["perdidaEstimada"] = this.perdidaEstimada;
        data["pesoSeco"] = this.pesoSeco;
        data["pesoSalida"] = this.pesoSalida;
        data["aportacion"] = this.aportacion;
        data["sodioInicial"] = this.sodioInicial;
        data["sodioFinal"] = this.sodioFinal;
        data["merma"] = this.merma;
        data["boloInicial"] = this.boloInicial;
        data["bolo1"] = this.bolo1;
        data["bolo2"] = this.bolo2;
        data["bolo3"] = this.bolo3;
        data["bolo4"] = this.bolo4;
        data["bolo5"] = this.bolo5;
        data["bolo6"] = this.bolo6;
        data["contrato"] = this.contrato;
        data["tipoHeparina"] = this.tipoHeparina;
        data["ultrafiltracionProgramada"] = this.ultrafiltracionProgramada;
        data["ultraFiltracionReal"] = this.ultraFiltracionReal;
        data["coeficienteUltraFiltracion"] = this.coeficienteUltraFiltracion;
        data["observaciones"] = this.observaciones;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["tipoPacienteDesc"] = this.tipoPacienteDesc;
        data["qb"] = this.qb;
        data["qd"] = this.qd;
        data["condTotal"] = this.condTotal;
        data["tempQD"] = this.tempQD;
        data["estatusCitaId"] = this.estatusCitaId;
        data["estatusCitaClave"] = this.estatusCitaClave;
        data["estatusCitaDesc"] = this.estatusCitaDesc;
        data["esSesionCerrada"] = this.esSesionCerrada;
        data["riesgoCaida"] = this.riesgoCaida;
        data["aportes"] = this.aportes ? this.aportes.toJSON() : <any>undefined;
        data["observacionesEnfermeria"] = this.observacionesEnfermeria ? this.observacionesEnfermeria.toJSON() : <any>undefined;
        data["indicadoresKtvNpcr"] = this.indicadoresKtvNpcr ? this.indicadoresKtvNpcr.toJSON() : <any>undefined;
        data["informacionDePersonal"] = this.informacionDePersonal ? this.informacionDePersonal.toJSON() : <any>undefined;
        if (Array.isArray(this.medicionesList)) {
            data["medicionesList"] = [];
            for (let item of this.medicionesList)
                data["medicionesList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISesionHDResponse {
    id: number;
    folioSesionHd: number;
    citaId: number;
    pacienteId: number;
    nombrePaciente?: string | undefined;
    prescripcionHdId: number;
    tipoFiltroDializadorId: number;
    salaId: number;
    maquinaId: number;
    tipoConcentradoId?: number | undefined;
    medicoId?: number | undefined;
    usuarioInicioSesionId: number;
    usuarioFinSesionId?: number | undefined;
    tipoPacienteId?: number | undefined;
    tipoHeparinaId?: number | undefined;
    tipoSesionId: number;
    accesoVascularePeritonialId: number;
    estatusAccesoId: number;
    fechaSesion: moment.Moment;
    duracionHoras: number;
    duracionMinutos: number;
    horaInicio: number;
    minutoInicio: number;
    horaFin?: number | undefined;
    minutoFin?: number | undefined;
    tiempoTranscurrido?: number | undefined;
    tomasHr?: number | undefined;
    reuso: boolean;
    numeroReuso?: number | undefined;
    pesoEntrada?: number | undefined;
    pesoAnterior?: number | undefined;
    pesoGanancia?: number | undefined;
    perdidaEstimada?: number | undefined;
    pesoSeco?: number | undefined;
    pesoSalida?: number | undefined;
    aportacion?: number | undefined;
    sodioInicial?: number | undefined;
    sodioFinal?: number | undefined;
    merma: boolean;
    boloInicial?: number | undefined;
    bolo1?: number | undefined;
    bolo2?: number | undefined;
    bolo3?: number | undefined;
    bolo4?: number | undefined;
    bolo5?: number | undefined;
    bolo6?: number | undefined;
    contrato?: string | undefined;
    tipoHeparina?: string | undefined;
    ultrafiltracionProgramada?: string | undefined;
    ultraFiltracionReal?: string | undefined;
    coeficienteUltraFiltracion?: string | undefined;
    observaciones?: string | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
    tipoPacienteDesc?: string | undefined;
    qb?: number | undefined;
    qd?: number | undefined;
    condTotal?: number | undefined;
    tempQD?: number | undefined;
    estatusCitaId: number;
    estatusCitaClave?: string | undefined;
    estatusCitaDesc?: string | undefined;
    esSesionCerrada: boolean;
    riesgoCaida?: number | undefined;
    aportes?: SesionHDAportesResponse | undefined;
    observacionesEnfermeria?: SesionHDObservacionesEnfermeriaResponse | undefined;
    indicadoresKtvNpcr?: SesionHDKtvNpcrResponse | undefined;
    informacionDePersonal?: SesionHDPersonalResponse | undefined;
    medicionesList?: SesionHDMedicionResponse[] | undefined;
}

export class SesionHDAportesResponse implements ISesionHDAportesResponse {
    id!: number;
    sesionHDId!: number;
    sueroSalino?: number | undefined;
    sueroGlucosa?: number | undefined;
    sangreTotal?: number | undefined;
    albumina?: number | undefined;
    expansores?: number | undefined;
    otros?: number | undefined;

    constructor(data?: ISesionHDAportesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionHDId = _data["sesionHDId"];
            this.sueroSalino = _data["sueroSalino"];
            this.sueroGlucosa = _data["sueroGlucosa"];
            this.sangreTotal = _data["sangreTotal"];
            this.albumina = _data["albumina"];
            this.expansores = _data["expansores"];
            this.otros = _data["otros"];
        }
    }

    static fromJS(data: any): SesionHDAportesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDAportesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionHDId"] = this.sesionHDId;
        data["sueroSalino"] = this.sueroSalino;
        data["sueroGlucosa"] = this.sueroGlucosa;
        data["sangreTotal"] = this.sangreTotal;
        data["albumina"] = this.albumina;
        data["expansores"] = this.expansores;
        data["otros"] = this.otros;
        return data;
    }
}

export interface ISesionHDAportesResponse {
    id: number;
    sesionHDId: number;
    sueroSalino?: number | undefined;
    sueroGlucosa?: number | undefined;
    sangreTotal?: number | undefined;
    albumina?: number | undefined;
    expansores?: number | undefined;
    otros?: number | undefined;
}

export class SesionHDObservacionesEnfermeriaResponse implements ISesionHDObservacionesEnfermeriaResponse {
    id!: number;
    sesionHdId!: number;
    motivoSuspensionId?: number | undefined;
    motivoSuspensionDesc?: string | undefined;
    indicacionesPreHd?: string | undefined;
    incidenciasHd?: string | undefined;
    medidasCorrectivasHd?: string | undefined;
    observaciones?: string | undefined;
    comentariosSuspension?: string | undefined;
    responsableIndicacionesPreHd?: string | undefined;
    responsableIncidenciasHd?: string | undefined;
    responsableMedidasCorrectivasHd?: string | undefined;
    responsableObservaciones?: string | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;

    constructor(data?: ISesionHDObservacionesEnfermeriaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionHdId = _data["sesionHdId"];
            this.motivoSuspensionId = _data["motivoSuspensionId"];
            this.motivoSuspensionDesc = _data["motivoSuspensionDesc"];
            this.indicacionesPreHd = _data["indicacionesPreHd"];
            this.incidenciasHd = _data["incidenciasHd"];
            this.medidasCorrectivasHd = _data["medidasCorrectivasHd"];
            this.observaciones = _data["observaciones"];
            this.comentariosSuspension = _data["comentariosSuspension"];
            this.responsableIndicacionesPreHd = _data["responsableIndicacionesPreHd"];
            this.responsableIncidenciasHd = _data["responsableIncidenciasHd"];
            this.responsableMedidasCorrectivasHd = _data["responsableMedidasCorrectivasHd"];
            this.responsableObservaciones = _data["responsableObservaciones"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SesionHDObservacionesEnfermeriaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDObservacionesEnfermeriaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionHdId"] = this.sesionHdId;
        data["motivoSuspensionId"] = this.motivoSuspensionId;
        data["motivoSuspensionDesc"] = this.motivoSuspensionDesc;
        data["indicacionesPreHd"] = this.indicacionesPreHd;
        data["incidenciasHd"] = this.incidenciasHd;
        data["medidasCorrectivasHd"] = this.medidasCorrectivasHd;
        data["observaciones"] = this.observaciones;
        data["comentariosSuspension"] = this.comentariosSuspension;
        data["responsableIndicacionesPreHd"] = this.responsableIndicacionesPreHd;
        data["responsableIncidenciasHd"] = this.responsableIncidenciasHd;
        data["responsableMedidasCorrectivasHd"] = this.responsableMedidasCorrectivasHd;
        data["responsableObservaciones"] = this.responsableObservaciones;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISesionHDObservacionesEnfermeriaResponse {
    id: number;
    sesionHdId: number;
    motivoSuspensionId?: number | undefined;
    motivoSuspensionDesc?: string | undefined;
    indicacionesPreHd?: string | undefined;
    incidenciasHd?: string | undefined;
    medidasCorrectivasHd?: string | undefined;
    observaciones?: string | undefined;
    comentariosSuspension?: string | undefined;
    responsableIndicacionesPreHd?: string | undefined;
    responsableIncidenciasHd?: string | undefined;
    responsableMedidasCorrectivasHd?: string | undefined;
    responsableObservaciones?: string | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
}

export class SesionHDKtvNpcrResponse implements ISesionHDKtvNpcrResponse {
    id!: number;
    sesionHdId!: number;
    pesoSeco?: number | undefined;
    pesoPostDialisis?: number | undefined;
    pesoGanancia?: number | undefined;
    tiempoInterDialisis?: number | undefined;
    volumenAgua?: number | undefined;
    volumenUltraFiltra?: number | undefined;
    duracionTratamiento?: number | undefined;
    ureaPreDialisis?: number | undefined;
    ureaPostDialisis?: number | undefined;
    ureaPreDialProxSesion?: number | undefined;
    ureaOrina24h?: number | undefined;
    ureaOrina48h?: number | undefined;
    diuresis24h?: number | undefined;
    diuresis48h?: number | undefined;
    ktvIdeal?: number | undefined;
    npcrIdeal?: number | undefined;
    ktv?: number | undefined;
    npcr?: number | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;

    constructor(data?: ISesionHDKtvNpcrResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionHdId = _data["sesionHdId"];
            this.pesoSeco = _data["pesoSeco"];
            this.pesoPostDialisis = _data["pesoPostDialisis"];
            this.pesoGanancia = _data["pesoGanancia"];
            this.tiempoInterDialisis = _data["tiempoInterDialisis"];
            this.volumenAgua = _data["volumenAgua"];
            this.volumenUltraFiltra = _data["volumenUltraFiltra"];
            this.duracionTratamiento = _data["duracionTratamiento"];
            this.ureaPreDialisis = _data["ureaPreDialisis"];
            this.ureaPostDialisis = _data["ureaPostDialisis"];
            this.ureaPreDialProxSesion = _data["ureaPreDialProxSesion"];
            this.ureaOrina24h = _data["ureaOrina24h"];
            this.ureaOrina48h = _data["ureaOrina48h"];
            this.diuresis24h = _data["diuresis24h"];
            this.diuresis48h = _data["diuresis48h"];
            this.ktvIdeal = _data["ktvIdeal"];
            this.npcrIdeal = _data["npcrIdeal"];
            this.ktv = _data["ktv"];
            this.npcr = _data["npcr"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SesionHDKtvNpcrResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDKtvNpcrResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionHdId"] = this.sesionHdId;
        data["pesoSeco"] = this.pesoSeco;
        data["pesoPostDialisis"] = this.pesoPostDialisis;
        data["pesoGanancia"] = this.pesoGanancia;
        data["tiempoInterDialisis"] = this.tiempoInterDialisis;
        data["volumenAgua"] = this.volumenAgua;
        data["volumenUltraFiltra"] = this.volumenUltraFiltra;
        data["duracionTratamiento"] = this.duracionTratamiento;
        data["ureaPreDialisis"] = this.ureaPreDialisis;
        data["ureaPostDialisis"] = this.ureaPostDialisis;
        data["ureaPreDialProxSesion"] = this.ureaPreDialProxSesion;
        data["ureaOrina24h"] = this.ureaOrina24h;
        data["ureaOrina48h"] = this.ureaOrina48h;
        data["diuresis24h"] = this.diuresis24h;
        data["diuresis48h"] = this.diuresis48h;
        data["ktvIdeal"] = this.ktvIdeal;
        data["npcrIdeal"] = this.npcrIdeal;
        data["ktv"] = this.ktv;
        data["npcr"] = this.npcr;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISesionHDKtvNpcrResponse {
    id: number;
    sesionHdId: number;
    pesoSeco?: number | undefined;
    pesoPostDialisis?: number | undefined;
    pesoGanancia?: number | undefined;
    tiempoInterDialisis?: number | undefined;
    volumenAgua?: number | undefined;
    volumenUltraFiltra?: number | undefined;
    duracionTratamiento?: number | undefined;
    ureaPreDialisis?: number | undefined;
    ureaPostDialisis?: number | undefined;
    ureaPreDialProxSesion?: number | undefined;
    ureaOrina24h?: number | undefined;
    ureaOrina48h?: number | undefined;
    diuresis24h?: number | undefined;
    diuresis48h?: number | undefined;
    ktvIdeal?: number | undefined;
    npcrIdeal?: number | undefined;
    ktv?: number | undefined;
    npcr?: number | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
}

export class SesionHDPersonalResponse implements ISesionHDPersonalResponse {
    medicoApPaterno?: string | undefined;
    medicoApMaterno?: string | undefined;
    medicoNombre?: string | undefined;
    medicoMatricula?: string | undefined;
    medicoCedula?: string | undefined;
    usuarioIniciaApPaterno?: string | undefined;
    usuarioIniciaApMaterno?: string | undefined;
    usuarioIniciaNombre?: string | undefined;
    usuarioIniciaMatricula?: string | undefined;
    usuarioIniciaCedula?: string | undefined;
    usuarioFinApPaterno?: string | undefined;
    usuarioFinApMaterno?: string | undefined;
    usuarioFinNombre?: string | undefined;
    usuarioFinMatricula?: string | undefined;
    usuarioFinCedula?: string | undefined;

    constructor(data?: ISesionHDPersonalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicoApPaterno = _data["medicoApPaterno"];
            this.medicoApMaterno = _data["medicoApMaterno"];
            this.medicoNombre = _data["medicoNombre"];
            this.medicoMatricula = _data["medicoMatricula"];
            this.medicoCedula = _data["medicoCedula"];
            this.usuarioIniciaApPaterno = _data["usuarioIniciaApPaterno"];
            this.usuarioIniciaApMaterno = _data["usuarioIniciaApMaterno"];
            this.usuarioIniciaNombre = _data["usuarioIniciaNombre"];
            this.usuarioIniciaMatricula = _data["usuarioIniciaMatricula"];
            this.usuarioIniciaCedula = _data["usuarioIniciaCedula"];
            this.usuarioFinApPaterno = _data["usuarioFinApPaterno"];
            this.usuarioFinApMaterno = _data["usuarioFinApMaterno"];
            this.usuarioFinNombre = _data["usuarioFinNombre"];
            this.usuarioFinMatricula = _data["usuarioFinMatricula"];
            this.usuarioFinCedula = _data["usuarioFinCedula"];
        }
    }

    static fromJS(data: any): SesionHDPersonalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDPersonalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicoApPaterno"] = this.medicoApPaterno;
        data["medicoApMaterno"] = this.medicoApMaterno;
        data["medicoNombre"] = this.medicoNombre;
        data["medicoMatricula"] = this.medicoMatricula;
        data["medicoCedula"] = this.medicoCedula;
        data["usuarioIniciaApPaterno"] = this.usuarioIniciaApPaterno;
        data["usuarioIniciaApMaterno"] = this.usuarioIniciaApMaterno;
        data["usuarioIniciaNombre"] = this.usuarioIniciaNombre;
        data["usuarioIniciaMatricula"] = this.usuarioIniciaMatricula;
        data["usuarioIniciaCedula"] = this.usuarioIniciaCedula;
        data["usuarioFinApPaterno"] = this.usuarioFinApPaterno;
        data["usuarioFinApMaterno"] = this.usuarioFinApMaterno;
        data["usuarioFinNombre"] = this.usuarioFinNombre;
        data["usuarioFinMatricula"] = this.usuarioFinMatricula;
        data["usuarioFinCedula"] = this.usuarioFinCedula;
        return data;
    }
}

export interface ISesionHDPersonalResponse {
    medicoApPaterno?: string | undefined;
    medicoApMaterno?: string | undefined;
    medicoNombre?: string | undefined;
    medicoMatricula?: string | undefined;
    medicoCedula?: string | undefined;
    usuarioIniciaApPaterno?: string | undefined;
    usuarioIniciaApMaterno?: string | undefined;
    usuarioIniciaNombre?: string | undefined;
    usuarioIniciaMatricula?: string | undefined;
    usuarioIniciaCedula?: string | undefined;
    usuarioFinApPaterno?: string | undefined;
    usuarioFinApMaterno?: string | undefined;
    usuarioFinNombre?: string | undefined;
    usuarioFinMatricula?: string | undefined;
    usuarioFinCedula?: string | undefined;
}

export class SesionHDMedicionResponse implements ISesionHDMedicionResponse {
    id!: number;
    sesionHdId!: number;
    tipoConstanteId!: number;
    tipoConstanteDesc?: string | undefined;
    hora!: number;
    toma!: number;
    cantidad?: number | undefined;

    constructor(data?: ISesionHDMedicionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionHdId = _data["sesionHdId"];
            this.tipoConstanteId = _data["tipoConstanteId"];
            this.tipoConstanteDesc = _data["tipoConstanteDesc"];
            this.hora = _data["hora"];
            this.toma = _data["toma"];
            this.cantidad = _data["cantidad"];
        }
    }

    static fromJS(data: any): SesionHDMedicionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDMedicionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionHdId"] = this.sesionHdId;
        data["tipoConstanteId"] = this.tipoConstanteId;
        data["tipoConstanteDesc"] = this.tipoConstanteDesc;
        data["hora"] = this.hora;
        data["toma"] = this.toma;
        data["cantidad"] = this.cantidad;
        return data;
    }
}

export interface ISesionHDMedicionResponse {
    id: number;
    sesionHdId: number;
    tipoConstanteId: number;
    tipoConstanteDesc?: string | undefined;
    hora: number;
    toma: number;
    cantidad?: number | undefined;
}

export class SesionHDGetForEditQuery implements ISesionHDGetForEditQuery {
    id!: number;

    constructor(data?: ISesionHDGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SesionHDGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ISesionHDGetForEditQuery {
    id: number;
}

export class SesionHDGetSesionCerradaPacientePorFechaQuery implements ISesionHDGetSesionCerradaPacientePorFechaQuery {
    pacienteId!: number;
    fecha!: moment.Moment;

    constructor(data?: ISesionHDGetSesionCerradaPacientePorFechaQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
            this.fecha = _data["fecha"] ? moment(_data["fecha"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SesionHDGetSesionCerradaPacientePorFechaQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDGetSesionCerradaPacientePorFechaQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        data["fecha"] = this.fecha ? this.fecha.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISesionHDGetSesionCerradaPacientePorFechaQuery {
    pacienteId: number;
    fecha: moment.Moment;
}

export class SesionHDCreateCommand implements ISesionHDCreateCommand {
    citaId?: number | undefined;
    pacienteId?: number | undefined;
    prescripcionHdId?: number | undefined;
    tipoFiltroDializadorId?: number | undefined;
    maquinaId?: number | undefined;
    tipoConcentradoId?: number | undefined;
    tipoHeparinaId?: number | undefined;
    tipoSesionId?: number | undefined;
    accesoVascularePeritonialId?: number | undefined;
    estatusAccesoId?: number | undefined;
    fechaSesion!: moment.Moment;
    duracionHoras?: number | undefined;
    duracionMinutos?: number | undefined;
    horaInicio?: number | undefined;
    minutoInicio?: number | undefined;
    horaFin?: number | undefined;
    minutoFin?: number | undefined;
    tomasHr?: number | undefined;
    reuso!: boolean;
    numeroReuso?: number | undefined;
    pesoEntrada?: number | undefined;
    pesoAnterior?: number | undefined;
    pesoGanancia?: number | undefined;
    perdidaEstimada?: number | undefined;
    pesoSeco?: number | undefined;
    pesoSalida?: number | undefined;
    aportacion?: number | undefined;
    sodioInicial?: number | undefined;
    sodioFinal?: number | undefined;
    merma!: boolean;
    tipoHeparina?: string | undefined;
    ultrafiltracionProgramada?: string | undefined;
    ultraFiltracionReal?: string | undefined;
    coeficienteUltraFiltracion?: string | undefined;
    observaciones?: string | undefined;
    motigoIngresoInfo?: SesionHDMotivoIngresoResponse | undefined;
    riesgoCaida?: number | undefined;

    constructor(data?: ISesionHDCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.citaId = _data["citaId"];
            this.pacienteId = _data["pacienteId"];
            this.prescripcionHdId = _data["prescripcionHdId"];
            this.tipoFiltroDializadorId = _data["tipoFiltroDializadorId"];
            this.maquinaId = _data["maquinaId"];
            this.tipoConcentradoId = _data["tipoConcentradoId"];
            this.tipoHeparinaId = _data["tipoHeparinaId"];
            this.tipoSesionId = _data["tipoSesionId"];
            this.accesoVascularePeritonialId = _data["accesoVascularePeritonialId"];
            this.estatusAccesoId = _data["estatusAccesoId"];
            this.fechaSesion = _data["fechaSesion"] ? moment(_data["fechaSesion"].toString()) : <any>undefined;
            this.duracionHoras = _data["duracionHoras"];
            this.duracionMinutos = _data["duracionMinutos"];
            this.horaInicio = _data["horaInicio"];
            this.minutoInicio = _data["minutoInicio"];
            this.horaFin = _data["horaFin"];
            this.minutoFin = _data["minutoFin"];
            this.tomasHr = _data["tomasHr"];
            this.reuso = _data["reuso"];
            this.numeroReuso = _data["numeroReuso"];
            this.pesoEntrada = _data["pesoEntrada"];
            this.pesoAnterior = _data["pesoAnterior"];
            this.pesoGanancia = _data["pesoGanancia"];
            this.perdidaEstimada = _data["perdidaEstimada"];
            this.pesoSeco = _data["pesoSeco"];
            this.pesoSalida = _data["pesoSalida"];
            this.aportacion = _data["aportacion"];
            this.sodioInicial = _data["sodioInicial"];
            this.sodioFinal = _data["sodioFinal"];
            this.merma = _data["merma"];
            this.tipoHeparina = _data["tipoHeparina"];
            this.ultrafiltracionProgramada = _data["ultrafiltracionProgramada"];
            this.ultraFiltracionReal = _data["ultraFiltracionReal"];
            this.coeficienteUltraFiltracion = _data["coeficienteUltraFiltracion"];
            this.observaciones = _data["observaciones"];
            this.motigoIngresoInfo = _data["motigoIngresoInfo"] ? SesionHDMotivoIngresoResponse.fromJS(_data["motigoIngresoInfo"]) : <any>undefined;
            this.riesgoCaida = _data["riesgoCaida"];
        }
    }

    static fromJS(data: any): SesionHDCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["citaId"] = this.citaId;
        data["pacienteId"] = this.pacienteId;
        data["prescripcionHdId"] = this.prescripcionHdId;
        data["tipoFiltroDializadorId"] = this.tipoFiltroDializadorId;
        data["maquinaId"] = this.maquinaId;
        data["tipoConcentradoId"] = this.tipoConcentradoId;
        data["tipoHeparinaId"] = this.tipoHeparinaId;
        data["tipoSesionId"] = this.tipoSesionId;
        data["accesoVascularePeritonialId"] = this.accesoVascularePeritonialId;
        data["estatusAccesoId"] = this.estatusAccesoId;
        data["fechaSesion"] = this.fechaSesion ? this.fechaSesion.toISOString() : <any>undefined;
        data["duracionHoras"] = this.duracionHoras;
        data["duracionMinutos"] = this.duracionMinutos;
        data["horaInicio"] = this.horaInicio;
        data["minutoInicio"] = this.minutoInicio;
        data["horaFin"] = this.horaFin;
        data["minutoFin"] = this.minutoFin;
        data["tomasHr"] = this.tomasHr;
        data["reuso"] = this.reuso;
        data["numeroReuso"] = this.numeroReuso;
        data["pesoEntrada"] = this.pesoEntrada;
        data["pesoAnterior"] = this.pesoAnterior;
        data["pesoGanancia"] = this.pesoGanancia;
        data["perdidaEstimada"] = this.perdidaEstimada;
        data["pesoSeco"] = this.pesoSeco;
        data["pesoSalida"] = this.pesoSalida;
        data["aportacion"] = this.aportacion;
        data["sodioInicial"] = this.sodioInicial;
        data["sodioFinal"] = this.sodioFinal;
        data["merma"] = this.merma;
        data["tipoHeparina"] = this.tipoHeparina;
        data["ultrafiltracionProgramada"] = this.ultrafiltracionProgramada;
        data["ultraFiltracionReal"] = this.ultraFiltracionReal;
        data["coeficienteUltraFiltracion"] = this.coeficienteUltraFiltracion;
        data["observaciones"] = this.observaciones;
        data["motigoIngresoInfo"] = this.motigoIngresoInfo ? this.motigoIngresoInfo.toJSON() : <any>undefined;
        data["riesgoCaida"] = this.riesgoCaida;
        return data;
    }
}

export interface ISesionHDCreateCommand {
    citaId?: number | undefined;
    pacienteId?: number | undefined;
    prescripcionHdId?: number | undefined;
    tipoFiltroDializadorId?: number | undefined;
    maquinaId?: number | undefined;
    tipoConcentradoId?: number | undefined;
    tipoHeparinaId?: number | undefined;
    tipoSesionId?: number | undefined;
    accesoVascularePeritonialId?: number | undefined;
    estatusAccesoId?: number | undefined;
    fechaSesion: moment.Moment;
    duracionHoras?: number | undefined;
    duracionMinutos?: number | undefined;
    horaInicio?: number | undefined;
    minutoInicio?: number | undefined;
    horaFin?: number | undefined;
    minutoFin?: number | undefined;
    tomasHr?: number | undefined;
    reuso: boolean;
    numeroReuso?: number | undefined;
    pesoEntrada?: number | undefined;
    pesoAnterior?: number | undefined;
    pesoGanancia?: number | undefined;
    perdidaEstimada?: number | undefined;
    pesoSeco?: number | undefined;
    pesoSalida?: number | undefined;
    aportacion?: number | undefined;
    sodioInicial?: number | undefined;
    sodioFinal?: number | undefined;
    merma: boolean;
    tipoHeparina?: string | undefined;
    ultrafiltracionProgramada?: string | undefined;
    ultraFiltracionReal?: string | undefined;
    coeficienteUltraFiltracion?: string | undefined;
    observaciones?: string | undefined;
    motigoIngresoInfo?: SesionHDMotivoIngresoResponse | undefined;
    riesgoCaida?: number | undefined;
}

export class SesionHDMotivoIngresoResponse implements ISesionHDMotivoIngresoResponse {
    id!: number;
    motivoIngresoId!: number;
    motivoIngresoDesc?: string | undefined;
    comentarios?: string | undefined;

    constructor(data?: ISesionHDMotivoIngresoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.motivoIngresoId = _data["motivoIngresoId"];
            this.motivoIngresoDesc = _data["motivoIngresoDesc"];
            this.comentarios = _data["comentarios"];
        }
    }

    static fromJS(data: any): SesionHDMotivoIngresoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDMotivoIngresoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["motivoIngresoId"] = this.motivoIngresoId;
        data["motivoIngresoDesc"] = this.motivoIngresoDesc;
        data["comentarios"] = this.comentarios;
        return data;
    }
}

export interface ISesionHDMotivoIngresoResponse {
    id: number;
    motivoIngresoId: number;
    motivoIngresoDesc?: string | undefined;
    comentarios?: string | undefined;
}

export class SesionHDUpdateCommand implements ISesionHDUpdateCommand {
    id!: number;
    tipoFiltroDializadorId?: number | undefined;
    maquinaId?: number | undefined;
    tipoConcentradoId?: number | undefined;
    tipoHeparinaId?: number | undefined;
    tipoSesionId?: number | undefined;
    accesoVascularePeritonialId?: number | undefined;
    estatusAccesoId?: number | undefined;
    fechaSesion!: moment.Moment;
    duracionHoras?: number | undefined;
    duracionMinutos?: number | undefined;
    horaInicio?: number | undefined;
    minutoInicio?: number | undefined;
    horaFin?: number | undefined;
    minutoFin?: number | undefined;
    tomasHr?: number | undefined;
    reuso!: boolean;
    numeroReuso?: number | undefined;
    pesoEntrada?: number | undefined;
    pesoAnterior?: number | undefined;
    pesoGanancia?: number | undefined;
    perdidaEstimada?: number | undefined;
    pesoSeco?: number | undefined;
    pesoSalida?: number | undefined;
    aportacion?: number | undefined;
    sodioInicial?: number | undefined;
    sodioFinal?: number | undefined;
    merma!: boolean;
    tipoHeparina?: string | undefined;
    ultrafiltracionProgramada?: string | undefined;
    ultraFiltracionReal?: string | undefined;
    coeficienteUltraFiltracion?: string | undefined;
    observaciones?: string | undefined;
    boloInicial?: number | undefined;
    bolo1?: number | undefined;
    bolo2?: number | undefined;
    bolo3?: number | undefined;
    bolo4?: number | undefined;
    bolo5?: number | undefined;
    bolo6?: number | undefined;
    aportes?: SesionHDAportesResponse | undefined;
    observacionesEnfermeria?: SesionHDObservacionesEnfermeriaResponse | undefined;
    indicadoresKtvNpcr?: SesionHDKtvNpcrResponse | undefined;
    medicionesList?: SesionHDMedicionResponse[] | undefined;
    motigoIngresoInfo?: SesionHDMotivoIngresoResponse | undefined;
    riesgoCaida?: number | undefined;
    hasSesionMatch!: boolean;
    sesionIntHdId?: number | undefined;

    constructor(data?: ISesionHDUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tipoFiltroDializadorId = _data["tipoFiltroDializadorId"];
            this.maquinaId = _data["maquinaId"];
            this.tipoConcentradoId = _data["tipoConcentradoId"];
            this.tipoHeparinaId = _data["tipoHeparinaId"];
            this.tipoSesionId = _data["tipoSesionId"];
            this.accesoVascularePeritonialId = _data["accesoVascularePeritonialId"];
            this.estatusAccesoId = _data["estatusAccesoId"];
            this.fechaSesion = _data["fechaSesion"] ? moment(_data["fechaSesion"].toString()) : <any>undefined;
            this.duracionHoras = _data["duracionHoras"];
            this.duracionMinutos = _data["duracionMinutos"];
            this.horaInicio = _data["horaInicio"];
            this.minutoInicio = _data["minutoInicio"];
            this.horaFin = _data["horaFin"];
            this.minutoFin = _data["minutoFin"];
            this.tomasHr = _data["tomasHr"];
            this.reuso = _data["reuso"];
            this.numeroReuso = _data["numeroReuso"];
            this.pesoEntrada = _data["pesoEntrada"];
            this.pesoAnterior = _data["pesoAnterior"];
            this.pesoGanancia = _data["pesoGanancia"];
            this.perdidaEstimada = _data["perdidaEstimada"];
            this.pesoSeco = _data["pesoSeco"];
            this.pesoSalida = _data["pesoSalida"];
            this.aportacion = _data["aportacion"];
            this.sodioInicial = _data["sodioInicial"];
            this.sodioFinal = _data["sodioFinal"];
            this.merma = _data["merma"];
            this.tipoHeparina = _data["tipoHeparina"];
            this.ultrafiltracionProgramada = _data["ultrafiltracionProgramada"];
            this.ultraFiltracionReal = _data["ultraFiltracionReal"];
            this.coeficienteUltraFiltracion = _data["coeficienteUltraFiltracion"];
            this.observaciones = _data["observaciones"];
            this.boloInicial = _data["boloInicial"];
            this.bolo1 = _data["bolo1"];
            this.bolo2 = _data["bolo2"];
            this.bolo3 = _data["bolo3"];
            this.bolo4 = _data["bolo4"];
            this.bolo5 = _data["bolo5"];
            this.bolo6 = _data["bolo6"];
            this.aportes = _data["aportes"] ? SesionHDAportesResponse.fromJS(_data["aportes"]) : <any>undefined;
            this.observacionesEnfermeria = _data["observacionesEnfermeria"] ? SesionHDObservacionesEnfermeriaResponse.fromJS(_data["observacionesEnfermeria"]) : <any>undefined;
            this.indicadoresKtvNpcr = _data["indicadoresKtvNpcr"] ? SesionHDKtvNpcrResponse.fromJS(_data["indicadoresKtvNpcr"]) : <any>undefined;
            if (Array.isArray(_data["medicionesList"])) {
                this.medicionesList = [] as any;
                for (let item of _data["medicionesList"])
                    this.medicionesList!.push(SesionHDMedicionResponse.fromJS(item));
            }
            this.motigoIngresoInfo = _data["motigoIngresoInfo"] ? SesionHDMotivoIngresoResponse.fromJS(_data["motigoIngresoInfo"]) : <any>undefined;
            this.riesgoCaida = _data["riesgoCaida"];
            this.hasSesionMatch = _data["hasSesionMatch"];
            this.sesionIntHdId = _data["sesionIntHdId"];
        }
    }

    static fromJS(data: any): SesionHDUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tipoFiltroDializadorId"] = this.tipoFiltroDializadorId;
        data["maquinaId"] = this.maquinaId;
        data["tipoConcentradoId"] = this.tipoConcentradoId;
        data["tipoHeparinaId"] = this.tipoHeparinaId;
        data["tipoSesionId"] = this.tipoSesionId;
        data["accesoVascularePeritonialId"] = this.accesoVascularePeritonialId;
        data["estatusAccesoId"] = this.estatusAccesoId;
        data["fechaSesion"] = this.fechaSesion ? this.fechaSesion.toISOString() : <any>undefined;
        data["duracionHoras"] = this.duracionHoras;
        data["duracionMinutos"] = this.duracionMinutos;
        data["horaInicio"] = this.horaInicio;
        data["minutoInicio"] = this.minutoInicio;
        data["horaFin"] = this.horaFin;
        data["minutoFin"] = this.minutoFin;
        data["tomasHr"] = this.tomasHr;
        data["reuso"] = this.reuso;
        data["numeroReuso"] = this.numeroReuso;
        data["pesoEntrada"] = this.pesoEntrada;
        data["pesoAnterior"] = this.pesoAnterior;
        data["pesoGanancia"] = this.pesoGanancia;
        data["perdidaEstimada"] = this.perdidaEstimada;
        data["pesoSeco"] = this.pesoSeco;
        data["pesoSalida"] = this.pesoSalida;
        data["aportacion"] = this.aportacion;
        data["sodioInicial"] = this.sodioInicial;
        data["sodioFinal"] = this.sodioFinal;
        data["merma"] = this.merma;
        data["tipoHeparina"] = this.tipoHeparina;
        data["ultrafiltracionProgramada"] = this.ultrafiltracionProgramada;
        data["ultraFiltracionReal"] = this.ultraFiltracionReal;
        data["coeficienteUltraFiltracion"] = this.coeficienteUltraFiltracion;
        data["observaciones"] = this.observaciones;
        data["boloInicial"] = this.boloInicial;
        data["bolo1"] = this.bolo1;
        data["bolo2"] = this.bolo2;
        data["bolo3"] = this.bolo3;
        data["bolo4"] = this.bolo4;
        data["bolo5"] = this.bolo5;
        data["bolo6"] = this.bolo6;
        data["aportes"] = this.aportes ? this.aportes.toJSON() : <any>undefined;
        data["observacionesEnfermeria"] = this.observacionesEnfermeria ? this.observacionesEnfermeria.toJSON() : <any>undefined;
        data["indicadoresKtvNpcr"] = this.indicadoresKtvNpcr ? this.indicadoresKtvNpcr.toJSON() : <any>undefined;
        if (Array.isArray(this.medicionesList)) {
            data["medicionesList"] = [];
            for (let item of this.medicionesList)
                data["medicionesList"].push(item.toJSON());
        }
        data["motigoIngresoInfo"] = this.motigoIngresoInfo ? this.motigoIngresoInfo.toJSON() : <any>undefined;
        data["riesgoCaida"] = this.riesgoCaida;
        data["hasSesionMatch"] = this.hasSesionMatch;
        data["sesionIntHdId"] = this.sesionIntHdId;
        return data;
    }
}

export interface ISesionHDUpdateCommand {
    id: number;
    tipoFiltroDializadorId?: number | undefined;
    maquinaId?: number | undefined;
    tipoConcentradoId?: number | undefined;
    tipoHeparinaId?: number | undefined;
    tipoSesionId?: number | undefined;
    accesoVascularePeritonialId?: number | undefined;
    estatusAccesoId?: number | undefined;
    fechaSesion: moment.Moment;
    duracionHoras?: number | undefined;
    duracionMinutos?: number | undefined;
    horaInicio?: number | undefined;
    minutoInicio?: number | undefined;
    horaFin?: number | undefined;
    minutoFin?: number | undefined;
    tomasHr?: number | undefined;
    reuso: boolean;
    numeroReuso?: number | undefined;
    pesoEntrada?: number | undefined;
    pesoAnterior?: number | undefined;
    pesoGanancia?: number | undefined;
    perdidaEstimada?: number | undefined;
    pesoSeco?: number | undefined;
    pesoSalida?: number | undefined;
    aportacion?: number | undefined;
    sodioInicial?: number | undefined;
    sodioFinal?: number | undefined;
    merma: boolean;
    tipoHeparina?: string | undefined;
    ultrafiltracionProgramada?: string | undefined;
    ultraFiltracionReal?: string | undefined;
    coeficienteUltraFiltracion?: string | undefined;
    observaciones?: string | undefined;
    boloInicial?: number | undefined;
    bolo1?: number | undefined;
    bolo2?: number | undefined;
    bolo3?: number | undefined;
    bolo4?: number | undefined;
    bolo5?: number | undefined;
    bolo6?: number | undefined;
    aportes?: SesionHDAportesResponse | undefined;
    observacionesEnfermeria?: SesionHDObservacionesEnfermeriaResponse | undefined;
    indicadoresKtvNpcr?: SesionHDKtvNpcrResponse | undefined;
    medicionesList?: SesionHDMedicionResponse[] | undefined;
    motigoIngresoInfo?: SesionHDMotivoIngresoResponse | undefined;
    riesgoCaida?: number | undefined;
    hasSesionMatch: boolean;
    sesionIntHdId?: number | undefined;
}

export class SesionHDDeleteCommand implements ISesionHDDeleteCommand {
    id!: number;

    constructor(data?: ISesionHDDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SesionHDDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ISesionHDDeleteCommand {
    id: number;
}

export class SesionHDValidarInicioSesionQuery implements ISesionHDValidarInicioSesionQuery {
    citaId!: number;

    constructor(data?: ISesionHDValidarInicioSesionQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.citaId = _data["citaId"];
        }
    }

    static fromJS(data: any): SesionHDValidarInicioSesionQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDValidarInicioSesionQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["citaId"] = this.citaId;
        return data;
    }
}

export interface ISesionHDValidarInicioSesionQuery {
    citaId: number;
}

export class SesionHDAlimentoResponse implements ISesionHDAlimentoResponse {
    id!: number;
    sesionHDId!: number;
    alimentoId!: number;
    alimentoDesc?: string | undefined;
    fechaAlimento!: moment.Moment;
    cantidad?: number | undefined;
    esRefrigerio!: boolean;

    constructor(data?: ISesionHDAlimentoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionHDId = _data["sesionHDId"];
            this.alimentoId = _data["alimentoId"];
            this.alimentoDesc = _data["alimentoDesc"];
            this.fechaAlimento = _data["fechaAlimento"] ? moment(_data["fechaAlimento"].toString()) : <any>undefined;
            this.cantidad = _data["cantidad"];
            this.esRefrigerio = _data["esRefrigerio"];
        }
    }

    static fromJS(data: any): SesionHDAlimentoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDAlimentoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionHDId"] = this.sesionHDId;
        data["alimentoId"] = this.alimentoId;
        data["alimentoDesc"] = this.alimentoDesc;
        data["fechaAlimento"] = this.fechaAlimento ? this.fechaAlimento.toISOString() : <any>undefined;
        data["cantidad"] = this.cantidad;
        data["esRefrigerio"] = this.esRefrigerio;
        return data;
    }
}

export interface ISesionHDAlimentoResponse {
    id: number;
    sesionHDId: number;
    alimentoId: number;
    alimentoDesc?: string | undefined;
    fechaAlimento: moment.Moment;
    cantidad?: number | undefined;
    esRefrigerio: boolean;
}

export class SesionHDGetAlimentosListQuery implements ISesionHDGetAlimentosListQuery {
    sesionHDId!: number;

    constructor(data?: ISesionHDGetAlimentosListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionHDId = _data["sesionHDId"];
        }
    }

    static fromJS(data: any): SesionHDGetAlimentosListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDGetAlimentosListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionHDId"] = this.sesionHDId;
        return data;
    }
}

export interface ISesionHDGetAlimentosListQuery {
    sesionHDId: number;
}

export class SesionHDAlimentoCreateCommand implements ISesionHDAlimentoCreateCommand {
    sesionHDId?: number | undefined;
    alimentoId?: number | undefined;
    fechaAlimento?: moment.Moment | undefined;
    cantidad?: number | undefined;
    esRefrigerio?: boolean | undefined;

    constructor(data?: ISesionHDAlimentoCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionHDId = _data["sesionHDId"];
            this.alimentoId = _data["alimentoId"];
            this.fechaAlimento = _data["fechaAlimento"] ? moment(_data["fechaAlimento"].toString()) : <any>undefined;
            this.cantidad = _data["cantidad"];
            this.esRefrigerio = _data["esRefrigerio"];
        }
    }

    static fromJS(data: any): SesionHDAlimentoCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDAlimentoCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionHDId"] = this.sesionHDId;
        data["alimentoId"] = this.alimentoId;
        data["fechaAlimento"] = this.fechaAlimento ? this.fechaAlimento.toISOString() : <any>undefined;
        data["cantidad"] = this.cantidad;
        data["esRefrigerio"] = this.esRefrigerio;
        return data;
    }
}

export interface ISesionHDAlimentoCreateCommand {
    sesionHDId?: number | undefined;
    alimentoId?: number | undefined;
    fechaAlimento?: moment.Moment | undefined;
    cantidad?: number | undefined;
    esRefrigerio?: boolean | undefined;
}

export class SesionHDMedicamentoResponse implements ISesionHDMedicamentoResponse {
    id!: number;
    sesionHDId!: number;
    medicamentoId!: number;
    codigoMedicamento?: string | undefined;
    medicamentoDesc?: string | undefined;
    horaAdministracion!: number;
    minutoAdministracion!: number;
    horaAdministracionDesc?: string | undefined;
    dosis?: string | undefined;
    presentacionId?: number | undefined;
    presentacion?: string | undefined;
    presentacionLarga?: string | undefined;
    viaAdministracionDesc?: string | undefined;
    responsable?: string | undefined;

    constructor(data?: ISesionHDMedicamentoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionHDId = _data["sesionHDId"];
            this.medicamentoId = _data["medicamentoId"];
            this.codigoMedicamento = _data["codigoMedicamento"];
            this.medicamentoDesc = _data["medicamentoDesc"];
            this.horaAdministracion = _data["horaAdministracion"];
            this.minutoAdministracion = _data["minutoAdministracion"];
            this.horaAdministracionDesc = _data["horaAdministracionDesc"];
            this.dosis = _data["dosis"];
            this.presentacionId = _data["presentacionId"];
            this.presentacion = _data["presentacion"];
            this.presentacionLarga = _data["presentacionLarga"];
            this.viaAdministracionDesc = _data["viaAdministracionDesc"];
            this.responsable = _data["responsable"];
        }
    }

    static fromJS(data: any): SesionHDMedicamentoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDMedicamentoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionHDId"] = this.sesionHDId;
        data["medicamentoId"] = this.medicamentoId;
        data["codigoMedicamento"] = this.codigoMedicamento;
        data["medicamentoDesc"] = this.medicamentoDesc;
        data["horaAdministracion"] = this.horaAdministracion;
        data["minutoAdministracion"] = this.minutoAdministracion;
        data["horaAdministracionDesc"] = this.horaAdministracionDesc;
        data["dosis"] = this.dosis;
        data["presentacionId"] = this.presentacionId;
        data["presentacion"] = this.presentacion;
        data["presentacionLarga"] = this.presentacionLarga;
        data["viaAdministracionDesc"] = this.viaAdministracionDesc;
        data["responsable"] = this.responsable;
        return data;
    }
}

export interface ISesionHDMedicamentoResponse {
    id: number;
    sesionHDId: number;
    medicamentoId: number;
    codigoMedicamento?: string | undefined;
    medicamentoDesc?: string | undefined;
    horaAdministracion: number;
    minutoAdministracion: number;
    horaAdministracionDesc?: string | undefined;
    dosis?: string | undefined;
    presentacionId?: number | undefined;
    presentacion?: string | undefined;
    presentacionLarga?: string | undefined;
    viaAdministracionDesc?: string | undefined;
    responsable?: string | undefined;
}

export class SesionHDGetMedicamentosListQuery implements ISesionHDGetMedicamentosListQuery {
    sesionHDId!: number;

    constructor(data?: ISesionHDGetMedicamentosListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionHDId = _data["sesionHDId"];
        }
    }

    static fromJS(data: any): SesionHDGetMedicamentosListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDGetMedicamentosListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionHDId"] = this.sesionHDId;
        return data;
    }
}

export interface ISesionHDGetMedicamentosListQuery {
    sesionHDId: number;
}

export class SesionHDMedicamentoCreateCommand implements ISesionHDMedicamentoCreateCommand {
    sesionHDId?: number | undefined;
    medicamentoId?: number | undefined;
    hora?: number | undefined;
    minuto?: number | undefined;
    dosis?: string | undefined;
    responsable?: string | undefined;

    constructor(data?: ISesionHDMedicamentoCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionHDId = _data["sesionHDId"];
            this.medicamentoId = _data["medicamentoId"];
            this.hora = _data["hora"];
            this.minuto = _data["minuto"];
            this.dosis = _data["dosis"];
            this.responsable = _data["responsable"];
        }
    }

    static fromJS(data: any): SesionHDMedicamentoCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDMedicamentoCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionHDId"] = this.sesionHDId;
        data["medicamentoId"] = this.medicamentoId;
        data["hora"] = this.hora;
        data["minuto"] = this.minuto;
        data["dosis"] = this.dosis;
        data["responsable"] = this.responsable;
        return data;
    }
}

export interface ISesionHDMedicamentoCreateCommand {
    sesionHDId?: number | undefined;
    medicamentoId?: number | undefined;
    hora?: number | undefined;
    minuto?: number | undefined;
    dosis?: string | undefined;
    responsable?: string | undefined;
}

export class SesionHDMedicamentoDeleteCommand implements ISesionHDMedicamentoDeleteCommand {
    sesionHDMedicacionId?: number | undefined;

    constructor(data?: ISesionHDMedicamentoDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionHDMedicacionId = _data["sesionHDMedicacionId"];
        }
    }

    static fromJS(data: any): SesionHDMedicamentoDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDMedicamentoDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionHDMedicacionId"] = this.sesionHDMedicacionId;
        return data;
    }
}

export interface ISesionHDMedicamentoDeleteCommand {
    sesionHDMedicacionId?: number | undefined;
}

export class SesionHDMaterialResponse implements ISesionHDMaterialResponse {
    id!: number;
    sesionHDId!: number;
    materialId!: number;
    claveMaterial?: string | undefined;
    materialDesc?: string | undefined;
    cantidad!: number;

    constructor(data?: ISesionHDMaterialResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionHDId = _data["sesionHDId"];
            this.materialId = _data["materialId"];
            this.claveMaterial = _data["claveMaterial"];
            this.materialDesc = _data["materialDesc"];
            this.cantidad = _data["cantidad"];
        }
    }

    static fromJS(data: any): SesionHDMaterialResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDMaterialResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionHDId"] = this.sesionHDId;
        data["materialId"] = this.materialId;
        data["claveMaterial"] = this.claveMaterial;
        data["materialDesc"] = this.materialDesc;
        data["cantidad"] = this.cantidad;
        return data;
    }
}

export interface ISesionHDMaterialResponse {
    id: number;
    sesionHDId: number;
    materialId: number;
    claveMaterial?: string | undefined;
    materialDesc?: string | undefined;
    cantidad: number;
}

export class SesionHDGetMaterialesListQuery implements ISesionHDGetMaterialesListQuery {
    sesionHDId!: number;

    constructor(data?: ISesionHDGetMaterialesListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionHDId = _data["sesionHDId"];
        }
    }

    static fromJS(data: any): SesionHDGetMaterialesListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDGetMaterialesListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionHDId"] = this.sesionHDId;
        return data;
    }
}

export interface ISesionHDGetMaterialesListQuery {
    sesionHDId: number;
}

export class SesionHDMaterialCreateCommand implements ISesionHDMaterialCreateCommand {
    sesionHDId?: number | undefined;
    materialId?: number | undefined;
    cantidad?: number | undefined;

    constructor(data?: ISesionHDMaterialCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionHDId = _data["sesionHDId"];
            this.materialId = _data["materialId"];
            this.cantidad = _data["cantidad"];
        }
    }

    static fromJS(data: any): SesionHDMaterialCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDMaterialCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionHDId"] = this.sesionHDId;
        data["materialId"] = this.materialId;
        data["cantidad"] = this.cantidad;
        return data;
    }
}

export interface ISesionHDMaterialCreateCommand {
    sesionHDId?: number | undefined;
    materialId?: number | undefined;
    cantidad?: number | undefined;
}

export class SesionHDMaterialDeleteCommand implements ISesionHDMaterialDeleteCommand {
    id?: number | undefined;

    constructor(data?: ISesionHDMaterialDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SesionHDMaterialDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDMaterialDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ISesionHDMaterialDeleteCommand {
    id?: number | undefined;
}

export class SesionHDDiagnosticoProcResponse implements ISesionHDDiagnosticoProcResponse {
    id!: number;
    sesionHdId?: number | undefined;
    pacienteId!: number;
    nombrePaciente?: string | undefined;
    eventoId!: number;
    eventoDesc?: string | undefined;
    parentescoId?: number | undefined;
    parentescoDesc?: string | undefined;
    tipoDiagnosticoId?: number | undefined;
    tipoDiagnosticoDesc?: string | undefined;
    tipoCatalogoId!: number;
    tipoCatalogoDesc?: string | undefined;
    provisional!: boolean;
    edad?: number | undefined;
    fechaEvento?: moment.Moment | undefined;
    observaciones?: string | undefined;
    procede!: boolean;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;
    codigoOficial?: string | undefined;

    constructor(data?: ISesionHDDiagnosticoProcResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionHdId = _data["sesionHdId"];
            this.pacienteId = _data["pacienteId"];
            this.nombrePaciente = _data["nombrePaciente"];
            this.eventoId = _data["eventoId"];
            this.eventoDesc = _data["eventoDesc"];
            this.parentescoId = _data["parentescoId"];
            this.parentescoDesc = _data["parentescoDesc"];
            this.tipoDiagnosticoId = _data["tipoDiagnosticoId"];
            this.tipoDiagnosticoDesc = _data["tipoDiagnosticoDesc"];
            this.tipoCatalogoId = _data["tipoCatalogoId"];
            this.tipoCatalogoDesc = _data["tipoCatalogoDesc"];
            this.provisional = _data["provisional"];
            this.edad = _data["edad"];
            this.fechaEvento = _data["fechaEvento"] ? moment(_data["fechaEvento"].toString()) : <any>undefined;
            this.observaciones = _data["observaciones"];
            this.procede = _data["procede"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.codigoOficial = _data["codigoOficial"];
        }
    }

    static fromJS(data: any): SesionHDDiagnosticoProcResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDDiagnosticoProcResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionHdId"] = this.sesionHdId;
        data["pacienteId"] = this.pacienteId;
        data["nombrePaciente"] = this.nombrePaciente;
        data["eventoId"] = this.eventoId;
        data["eventoDesc"] = this.eventoDesc;
        data["parentescoId"] = this.parentescoId;
        data["parentescoDesc"] = this.parentescoDesc;
        data["tipoDiagnosticoId"] = this.tipoDiagnosticoId;
        data["tipoDiagnosticoDesc"] = this.tipoDiagnosticoDesc;
        data["tipoCatalogoId"] = this.tipoCatalogoId;
        data["tipoCatalogoDesc"] = this.tipoCatalogoDesc;
        data["provisional"] = this.provisional;
        data["edad"] = this.edad;
        data["fechaEvento"] = this.fechaEvento ? this.fechaEvento.toISOString() : <any>undefined;
        data["observaciones"] = this.observaciones;
        data["procede"] = this.procede;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["codigoOficial"] = this.codigoOficial;
        return data;
    }
}

export interface ISesionHDDiagnosticoProcResponse {
    id: number;
    sesionHdId?: number | undefined;
    pacienteId: number;
    nombrePaciente?: string | undefined;
    eventoId: number;
    eventoDesc?: string | undefined;
    parentescoId?: number | undefined;
    parentescoDesc?: string | undefined;
    tipoDiagnosticoId?: number | undefined;
    tipoDiagnosticoDesc?: string | undefined;
    tipoCatalogoId: number;
    tipoCatalogoDesc?: string | undefined;
    provisional: boolean;
    edad?: number | undefined;
    fechaEvento?: moment.Moment | undefined;
    observaciones?: string | undefined;
    procede: boolean;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
    codigoOficial?: string | undefined;
}

export class SesionHDGetDiagnosticosListQuery implements ISesionHDGetDiagnosticosListQuery {
    sesionHDId!: number;

    constructor(data?: ISesionHDGetDiagnosticosListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionHDId = _data["sesionHDId"];
        }
    }

    static fromJS(data: any): SesionHDGetDiagnosticosListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDGetDiagnosticosListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionHDId"] = this.sesionHDId;
        return data;
    }
}

export interface ISesionHDGetDiagnosticosListQuery {
    sesionHDId: number;
}

export class SesionHDDiagnosticoProcCreateCommand implements ISesionHDDiagnosticoProcCreateCommand {
    sesionHDId?: number | undefined;
    eventoId?: number | undefined;
    tipoDiagnosticoId?: number | undefined;
    observaciones?: string | undefined;
    fechaEvento?: moment.Moment | undefined;
    provisional?: boolean | undefined;

    constructor(data?: ISesionHDDiagnosticoProcCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionHDId = _data["sesionHDId"];
            this.eventoId = _data["eventoId"];
            this.tipoDiagnosticoId = _data["tipoDiagnosticoId"];
            this.observaciones = _data["observaciones"];
            this.fechaEvento = _data["fechaEvento"] ? moment(_data["fechaEvento"].toString()) : <any>undefined;
            this.provisional = _data["provisional"];
        }
    }

    static fromJS(data: any): SesionHDDiagnosticoProcCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDDiagnosticoProcCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionHDId"] = this.sesionHDId;
        data["eventoId"] = this.eventoId;
        data["tipoDiagnosticoId"] = this.tipoDiagnosticoId;
        data["observaciones"] = this.observaciones;
        data["fechaEvento"] = this.fechaEvento ? this.fechaEvento.toISOString() : <any>undefined;
        data["provisional"] = this.provisional;
        return data;
    }
}

export interface ISesionHDDiagnosticoProcCreateCommand {
    sesionHDId?: number | undefined;
    eventoId?: number | undefined;
    tipoDiagnosticoId?: number | undefined;
    observaciones?: string | undefined;
    fechaEvento?: moment.Moment | undefined;
    provisional?: boolean | undefined;
}

export class SesionHDDiagnosticoProcDeleteCommand implements ISesionHDDiagnosticoProcDeleteCommand {
    pacienteEventoId?: number | undefined;

    constructor(data?: ISesionHDDiagnosticoProcDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteEventoId = _data["pacienteEventoId"];
        }
    }

    static fromJS(data: any): SesionHDDiagnosticoProcDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDDiagnosticoProcDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteEventoId"] = this.pacienteEventoId;
        return data;
    }
}

export interface ISesionHDDiagnosticoProcDeleteCommand {
    pacienteEventoId?: number | undefined;
}

export class SesionHDSignosYSintomasResponse implements ISesionHDSignosYSintomasResponse {
    id!: number;
    sesionHDId!: number;
    signoSintomaId!: number;
    signoSintomaDesc?: string | undefined;
    hayDolor!: boolean;
    localizacionDolor?: string | undefined;
    escalaDolor?: number | undefined;

    constructor(data?: ISesionHDSignosYSintomasResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionHDId = _data["sesionHDId"];
            this.signoSintomaId = _data["signoSintomaId"];
            this.signoSintomaDesc = _data["signoSintomaDesc"];
            this.hayDolor = _data["hayDolor"];
            this.localizacionDolor = _data["localizacionDolor"];
            this.escalaDolor = _data["escalaDolor"];
        }
    }

    static fromJS(data: any): SesionHDSignosYSintomasResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDSignosYSintomasResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionHDId"] = this.sesionHDId;
        data["signoSintomaId"] = this.signoSintomaId;
        data["signoSintomaDesc"] = this.signoSintomaDesc;
        data["hayDolor"] = this.hayDolor;
        data["localizacionDolor"] = this.localizacionDolor;
        data["escalaDolor"] = this.escalaDolor;
        return data;
    }
}

export interface ISesionHDSignosYSintomasResponse {
    id: number;
    sesionHDId: number;
    signoSintomaId: number;
    signoSintomaDesc?: string | undefined;
    hayDolor: boolean;
    localizacionDolor?: string | undefined;
    escalaDolor?: number | undefined;
}

export class SesionHDGetSignosSintomasListQuery implements ISesionHDGetSignosSintomasListQuery {
    sesionHDId!: number;

    constructor(data?: ISesionHDGetSignosSintomasListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionHDId = _data["sesionHDId"];
        }
    }

    static fromJS(data: any): SesionHDGetSignosSintomasListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDGetSignosSintomasListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionHDId"] = this.sesionHDId;
        return data;
    }
}

export interface ISesionHDGetSignosSintomasListQuery {
    sesionHDId: number;
}

export class SesionHDSignoSintomaCreateCommand implements ISesionHDSignoSintomaCreateCommand {
    sesionHDId?: number | undefined;
    signoSintomaId?: number | undefined;
    hayDolor?: boolean | undefined;
    localizacionDolor?: string | undefined;
    escalaDolor?: number | undefined;

    constructor(data?: ISesionHDSignoSintomaCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionHDId = _data["sesionHDId"];
            this.signoSintomaId = _data["signoSintomaId"];
            this.hayDolor = _data["hayDolor"];
            this.localizacionDolor = _data["localizacionDolor"];
            this.escalaDolor = _data["escalaDolor"];
        }
    }

    static fromJS(data: any): SesionHDSignoSintomaCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDSignoSintomaCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionHDId"] = this.sesionHDId;
        data["signoSintomaId"] = this.signoSintomaId;
        data["hayDolor"] = this.hayDolor;
        data["localizacionDolor"] = this.localizacionDolor;
        data["escalaDolor"] = this.escalaDolor;
        return data;
    }
}

export interface ISesionHDSignoSintomaCreateCommand {
    sesionHDId?: number | undefined;
    signoSintomaId?: number | undefined;
    hayDolor?: boolean | undefined;
    localizacionDolor?: string | undefined;
    escalaDolor?: number | undefined;
}

export class SesionHDSignoSintomaDeleteCommand implements ISesionHDSignoSintomaDeleteCommand {
    id?: number | undefined;

    constructor(data?: ISesionHDSignoSintomaDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SesionHDSignoSintomaDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDSignoSintomaDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ISesionHDSignoSintomaDeleteCommand {
    id?: number | undefined;
}

export class SesionHDTransfusionResponse implements ISesionHDTransfusionResponse {
    id!: number;
    sesionHDId!: number;
    grupoSanguineoId!: number;
    grupoSanguineoDesc?: string | undefined;
    numeroUnidadSangre?: string | undefined;
    observaciones?: string | undefined;

    constructor(data?: ISesionHDTransfusionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionHDId = _data["sesionHDId"];
            this.grupoSanguineoId = _data["grupoSanguineoId"];
            this.grupoSanguineoDesc = _data["grupoSanguineoDesc"];
            this.numeroUnidadSangre = _data["numeroUnidadSangre"];
            this.observaciones = _data["observaciones"];
        }
    }

    static fromJS(data: any): SesionHDTransfusionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDTransfusionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionHDId"] = this.sesionHDId;
        data["grupoSanguineoId"] = this.grupoSanguineoId;
        data["grupoSanguineoDesc"] = this.grupoSanguineoDesc;
        data["numeroUnidadSangre"] = this.numeroUnidadSangre;
        data["observaciones"] = this.observaciones;
        return data;
    }
}

export interface ISesionHDTransfusionResponse {
    id: number;
    sesionHDId: number;
    grupoSanguineoId: number;
    grupoSanguineoDesc?: string | undefined;
    numeroUnidadSangre?: string | undefined;
    observaciones?: string | undefined;
}

export class SesionHDGetTransfusionesListQuery implements ISesionHDGetTransfusionesListQuery {
    sesionHDId!: number;

    constructor(data?: ISesionHDGetTransfusionesListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionHDId = _data["sesionHDId"];
        }
    }

    static fromJS(data: any): SesionHDGetTransfusionesListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDGetTransfusionesListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionHDId"] = this.sesionHDId;
        return data;
    }
}

export interface ISesionHDGetTransfusionesListQuery {
    sesionHDId: number;
}

export class SesionHDTransfusionCreateCommand implements ISesionHDTransfusionCreateCommand {
    sesionHDId?: number | undefined;
    grupoSanguineoId?: number | undefined;
    numeroUnidadSangre?: string | undefined;
    observaciones?: string | undefined;

    constructor(data?: ISesionHDTransfusionCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionHDId = _data["sesionHDId"];
            this.grupoSanguineoId = _data["grupoSanguineoId"];
            this.numeroUnidadSangre = _data["numeroUnidadSangre"];
            this.observaciones = _data["observaciones"];
        }
    }

    static fromJS(data: any): SesionHDTransfusionCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDTransfusionCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionHDId"] = this.sesionHDId;
        data["grupoSanguineoId"] = this.grupoSanguineoId;
        data["numeroUnidadSangre"] = this.numeroUnidadSangre;
        data["observaciones"] = this.observaciones;
        return data;
    }
}

export interface ISesionHDTransfusionCreateCommand {
    sesionHDId?: number | undefined;
    grupoSanguineoId?: number | undefined;
    numeroUnidadSangre?: string | undefined;
    observaciones?: string | undefined;
}

export class SesionHDTransfusionDeleteCommand implements ISesionHDTransfusionDeleteCommand {
    id?: number | undefined;

    constructor(data?: ISesionHDTransfusionDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SesionHDTransfusionDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDTransfusionDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ISesionHDTransfusionDeleteCommand {
    id?: number | undefined;
}

export class SesionHDGetPacienteSesionObservacionesQuery implements ISesionHDGetPacienteSesionObservacionesQuery {
    pacienteId!: number;
    sesionHDId?: number | undefined;

    constructor(data?: ISesionHDGetPacienteSesionObservacionesQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
            this.sesionHDId = _data["sesionHDId"];
        }
    }

    static fromJS(data: any): SesionHDGetPacienteSesionObservacionesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDGetPacienteSesionObservacionesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        data["sesionHDId"] = this.sesionHDId;
        return data;
    }
}

export interface ISesionHDGetPacienteSesionObservacionesQuery {
    pacienteId: number;
    sesionHDId?: number | undefined;
}

export class SesionHDMatchResponse implements ISesionHDMatchResponse {
    sesionINTHdId!: number;
    fechaHoraInicio?: moment.Moment | undefined;

    constructor(data?: ISesionHDMatchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionINTHdId = _data["sesionINTHdId"];
            this.fechaHoraInicio = _data["fechaHoraInicio"] ? moment(_data["fechaHoraInicio"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SesionHDMatchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDMatchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionINTHdId"] = this.sesionINTHdId;
        data["fechaHoraInicio"] = this.fechaHoraInicio ? this.fechaHoraInicio.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISesionHDMatchResponse {
    sesionINTHdId: number;
    fechaHoraInicio?: moment.Moment | undefined;
}

export class SesionHDGetMatchQuery implements ISesionHDGetMatchQuery {
    sesionHDId!: number;

    constructor(data?: ISesionHDGetMatchQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionHDId = _data["sesionHDId"];
        }
    }

    static fromJS(data: any): SesionHDGetMatchQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDGetMatchQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionHDId"] = this.sesionHDId;
        return data;
    }
}

export interface ISesionHDGetMatchQuery {
    sesionHDId: number;
}

export class SesionHDGetMedicionesMatchQuery implements ISesionHDGetMedicionesMatchQuery {
    sesionIntHDId!: number;

    constructor(data?: ISesionHDGetMedicionesMatchQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionIntHDId = _data["sesionIntHDId"];
        }
    }

    static fromJS(data: any): SesionHDGetMedicionesMatchQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDGetMedicionesMatchQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionIntHDId"] = this.sesionIntHDId;
        return data;
    }
}

export interface ISesionHDGetMedicionesMatchQuery {
    sesionIntHDId: number;
}

export class SesionHDExportPDFQuery implements ISesionHDExportPDFQuery {
    sesionHdId?: number | undefined;

    constructor(data?: ISesionHDExportPDFQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionHdId = _data["sesionHdId"];
        }
    }

    static fromJS(data: any): SesionHDExportPDFQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SesionHDExportPDFQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionHdId"] = this.sesionHdId;
        return data;
    }
}

export interface ISesionHDExportPDFQuery {
    sesionHdId?: number | undefined;
}

export class PagedResultDtoOfTurnoHospitalForListResponse implements IPagedResultDtoOfTurnoHospitalForListResponse {
    totalCount!: number;
    items?: TurnoHospitalForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfTurnoHospitalForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TurnoHospitalForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTurnoHospitalForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTurnoHospitalForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfTurnoHospitalForListResponse {
    totalCount: number;
    items?: TurnoHospitalForListResponse[] | undefined;
}

export class TurnoHospitalForListResponse implements ITurnoHospitalForListResponse {
    id?: number | undefined;
    descripcion?: string | undefined;
    horarioDesc?: string | undefined;
    horaInicial?: moment.Duration | undefined;
    horaFinal?: moment.Duration | undefined;
    lunes?: boolean | undefined;
    martes?: boolean | undefined;
    miercoles?: boolean | undefined;
    jueves?: boolean | undefined;
    viernes?: boolean | undefined;
    sabado?: boolean | undefined;
    domingo?: boolean | undefined;
    fechaAlta?: moment.Moment | undefined;
    fechaModificacion?: moment.Moment | undefined;
    isActive?: boolean | undefined;
    clave?: string | undefined;

    constructor(data?: ITurnoHospitalForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descripcion = _data["descripcion"];
            this.horarioDesc = _data["horarioDesc"];
            this.horaInicial = _data["horaInicial"] ? moment.duration(_data["horaInicial"].toString()) : <any>undefined;
            this.horaFinal = _data["horaFinal"] ? moment.duration(_data["horaFinal"].toString()) : <any>undefined;
            this.lunes = _data["lunes"];
            this.martes = _data["martes"];
            this.miercoles = _data["miercoles"];
            this.jueves = _data["jueves"];
            this.viernes = _data["viernes"];
            this.sabado = _data["sabado"];
            this.domingo = _data["domingo"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.clave = _data["clave"];
        }
    }

    static fromJS(data: any): TurnoHospitalForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoHospitalForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descripcion"] = this.descripcion;
        data["horarioDesc"] = this.horarioDesc;
        data["horaInicial"] = this.horaInicial ? this.horaInicial.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["horaFinal"] = this.horaFinal ? this.horaFinal.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["lunes"] = this.lunes;
        data["martes"] = this.martes;
        data["miercoles"] = this.miercoles;
        data["jueves"] = this.jueves;
        data["viernes"] = this.viernes;
        data["sabado"] = this.sabado;
        data["domingo"] = this.domingo;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["clave"] = this.clave;
        return data;
    }
}

export interface ITurnoHospitalForListResponse {
    id?: number | undefined;
    descripcion?: string | undefined;
    horarioDesc?: string | undefined;
    horaInicial?: moment.Duration | undefined;
    horaFinal?: moment.Duration | undefined;
    lunes?: boolean | undefined;
    martes?: boolean | undefined;
    miercoles?: boolean | undefined;
    jueves?: boolean | undefined;
    viernes?: boolean | undefined;
    sabado?: boolean | undefined;
    domingo?: boolean | undefined;
    fechaAlta?: moment.Moment | undefined;
    fechaModificacion?: moment.Moment | undefined;
    isActive?: boolean | undefined;
    clave?: string | undefined;
}

export class TurnoHospitalGetListQuery extends PageListByDto implements ITurnoHospitalGetListQuery {

    constructor(data?: ITurnoHospitalGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TurnoHospitalGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoHospitalGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITurnoHospitalGetListQuery extends IPageListByDto {
}

export class TurnoHospitalForEditResponse implements ITurnoHospitalForEditResponse {
    id?: number | undefined;
    descripcion?: string | undefined;
    horarioDesc?: string | undefined;
    horaInicial?: moment.Duration | undefined;
    horaFinal?: moment.Duration | undefined;
    lunes?: boolean | undefined;
    martes?: boolean | undefined;
    miercoles?: boolean | undefined;
    jueves?: boolean | undefined;
    viernes?: boolean | undefined;
    sabado?: boolean | undefined;
    domingo?: boolean | undefined;
    fechaAlta?: moment.Moment | undefined;
    fechaModificacion?: moment.Moment | undefined;
    isActive?: boolean | undefined;
    clave?: string | undefined;

    constructor(data?: ITurnoHospitalForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descripcion = _data["descripcion"];
            this.horarioDesc = _data["horarioDesc"];
            this.horaInicial = _data["horaInicial"] ? moment.duration(_data["horaInicial"].toString()) : <any>undefined;
            this.horaFinal = _data["horaFinal"] ? moment.duration(_data["horaFinal"].toString()) : <any>undefined;
            this.lunes = _data["lunes"];
            this.martes = _data["martes"];
            this.miercoles = _data["miercoles"];
            this.jueves = _data["jueves"];
            this.viernes = _data["viernes"];
            this.sabado = _data["sabado"];
            this.domingo = _data["domingo"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.clave = _data["clave"];
        }
    }

    static fromJS(data: any): TurnoHospitalForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoHospitalForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descripcion"] = this.descripcion;
        data["horarioDesc"] = this.horarioDesc;
        data["horaInicial"] = this.horaInicial ? this.horaInicial.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["horaFinal"] = this.horaFinal ? this.horaFinal.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["lunes"] = this.lunes;
        data["martes"] = this.martes;
        data["miercoles"] = this.miercoles;
        data["jueves"] = this.jueves;
        data["viernes"] = this.viernes;
        data["sabado"] = this.sabado;
        data["domingo"] = this.domingo;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["clave"] = this.clave;
        return data;
    }
}

export interface ITurnoHospitalForEditResponse {
    id?: number | undefined;
    descripcion?: string | undefined;
    horarioDesc?: string | undefined;
    horaInicial?: moment.Duration | undefined;
    horaFinal?: moment.Duration | undefined;
    lunes?: boolean | undefined;
    martes?: boolean | undefined;
    miercoles?: boolean | undefined;
    jueves?: boolean | undefined;
    viernes?: boolean | undefined;
    sabado?: boolean | undefined;
    domingo?: boolean | undefined;
    fechaAlta?: moment.Moment | undefined;
    fechaModificacion?: moment.Moment | undefined;
    isActive?: boolean | undefined;
    clave?: string | undefined;
}

export class TurnoHospitalGetForEditQuery implements ITurnoHospitalGetForEditQuery {
    id?: number | undefined;

    constructor(data?: ITurnoHospitalGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TurnoHospitalGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoHospitalGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ITurnoHospitalGetForEditQuery {
    id?: number | undefined;
}

export class TurnoHospitalGetForComboboxQuery implements ITurnoHospitalGetForComboboxQuery {

    constructor(data?: ITurnoHospitalGetForComboboxQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): TurnoHospitalGetForComboboxQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoHospitalGetForComboboxQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ITurnoHospitalGetForComboboxQuery {
}

export class TurnoHospitalCreateCommand implements ITurnoHospitalCreateCommand {
    descripcion?: string | undefined;
    clave?: string | undefined;
    horaInicial?: moment.Duration | undefined;
    horaFinal?: moment.Duration | undefined;
    lunes?: boolean | undefined;
    martes?: boolean | undefined;
    miercoles?: boolean | undefined;
    jueves?: boolean | undefined;
    viernes?: boolean | undefined;
    sabado?: boolean | undefined;
    domingo?: boolean | undefined;
    isActive?: boolean | undefined;

    constructor(data?: ITurnoHospitalCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.descripcion = _data["descripcion"];
            this.clave = _data["clave"];
            this.horaInicial = _data["horaInicial"] ? moment.duration(_data["horaInicial"].toString()) : <any>undefined;
            this.horaFinal = _data["horaFinal"] ? moment.duration(_data["horaFinal"].toString()) : <any>undefined;
            this.lunes = _data["lunes"];
            this.martes = _data["martes"];
            this.miercoles = _data["miercoles"];
            this.jueves = _data["jueves"];
            this.viernes = _data["viernes"];
            this.sabado = _data["sabado"];
            this.domingo = _data["domingo"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TurnoHospitalCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoHospitalCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descripcion"] = this.descripcion;
        data["clave"] = this.clave;
        data["horaInicial"] = this.horaInicial ? this.horaInicial.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["horaFinal"] = this.horaFinal ? this.horaFinal.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["lunes"] = this.lunes;
        data["martes"] = this.martes;
        data["miercoles"] = this.miercoles;
        data["jueves"] = this.jueves;
        data["viernes"] = this.viernes;
        data["sabado"] = this.sabado;
        data["domingo"] = this.domingo;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITurnoHospitalCreateCommand {
    descripcion?: string | undefined;
    clave?: string | undefined;
    horaInicial?: moment.Duration | undefined;
    horaFinal?: moment.Duration | undefined;
    lunes?: boolean | undefined;
    martes?: boolean | undefined;
    miercoles?: boolean | undefined;
    jueves?: boolean | undefined;
    viernes?: boolean | undefined;
    sabado?: boolean | undefined;
    domingo?: boolean | undefined;
    isActive?: boolean | undefined;
}

export class TurnoHospitalUpdateCommand implements ITurnoHospitalUpdateCommand {
    id?: number | undefined;
    descripcion?: string | undefined;
    clave?: string | undefined;
    horaInicial?: moment.Duration | undefined;
    horaFinal?: moment.Duration | undefined;
    lunes?: boolean | undefined;
    martes?: boolean | undefined;
    miercoles?: boolean | undefined;
    jueves?: boolean | undefined;
    viernes?: boolean | undefined;
    sabado?: boolean | undefined;
    domingo?: boolean | undefined;
    isActive?: boolean | undefined;

    constructor(data?: ITurnoHospitalUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descripcion = _data["descripcion"];
            this.clave = _data["clave"];
            this.horaInicial = _data["horaInicial"] ? moment.duration(_data["horaInicial"].toString()) : <any>undefined;
            this.horaFinal = _data["horaFinal"] ? moment.duration(_data["horaFinal"].toString()) : <any>undefined;
            this.lunes = _data["lunes"];
            this.martes = _data["martes"];
            this.miercoles = _data["miercoles"];
            this.jueves = _data["jueves"];
            this.viernes = _data["viernes"];
            this.sabado = _data["sabado"];
            this.domingo = _data["domingo"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TurnoHospitalUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoHospitalUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descripcion"] = this.descripcion;
        data["clave"] = this.clave;
        data["horaInicial"] = this.horaInicial ? this.horaInicial.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["horaFinal"] = this.horaFinal ? this.horaFinal.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["lunes"] = this.lunes;
        data["martes"] = this.martes;
        data["miercoles"] = this.miercoles;
        data["jueves"] = this.jueves;
        data["viernes"] = this.viernes;
        data["sabado"] = this.sabado;
        data["domingo"] = this.domingo;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITurnoHospitalUpdateCommand {
    id?: number | undefined;
    descripcion?: string | undefined;
    clave?: string | undefined;
    horaInicial?: moment.Duration | undefined;
    horaFinal?: moment.Duration | undefined;
    lunes?: boolean | undefined;
    martes?: boolean | undefined;
    miercoles?: boolean | undefined;
    jueves?: boolean | undefined;
    viernes?: boolean | undefined;
    sabado?: boolean | undefined;
    domingo?: boolean | undefined;
    isActive?: boolean | undefined;
}

export class TurnoHospitalResponsableResponse implements ITurnoHospitalResponsableResponse {
    id!: number;
    turnoHospitalId!: number;
    turnoHospitalDesc?: string | undefined;
    salaId!: number;
    salaDesc?: string | undefined;
    medicoId?: number | undefined;
    nombreMedico?: string | undefined;
    esResponsable!: boolean;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;

    constructor(data?: ITurnoHospitalResponsableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.turnoHospitalId = _data["turnoHospitalId"];
            this.turnoHospitalDesc = _data["turnoHospitalDesc"];
            this.salaId = _data["salaId"];
            this.salaDesc = _data["salaDesc"];
            this.medicoId = _data["medicoId"];
            this.nombreMedico = _data["nombreMedico"];
            this.esResponsable = _data["esResponsable"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TurnoHospitalResponsableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoHospitalResponsableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["turnoHospitalId"] = this.turnoHospitalId;
        data["turnoHospitalDesc"] = this.turnoHospitalDesc;
        data["salaId"] = this.salaId;
        data["salaDesc"] = this.salaDesc;
        data["medicoId"] = this.medicoId;
        data["nombreMedico"] = this.nombreMedico;
        data["esResponsable"] = this.esResponsable;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITurnoHospitalResponsableResponse {
    id: number;
    turnoHospitalId: number;
    turnoHospitalDesc?: string | undefined;
    salaId: number;
    salaDesc?: string | undefined;
    medicoId?: number | undefined;
    nombreMedico?: string | undefined;
    esResponsable: boolean;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
}

export class TurnoHospitalResponsableGetListQuery implements ITurnoHospitalResponsableGetListQuery {
    turnoHospitalId!: number;

    constructor(data?: ITurnoHospitalResponsableGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.turnoHospitalId = _data["turnoHospitalId"];
        }
    }

    static fromJS(data: any): TurnoHospitalResponsableGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoHospitalResponsableGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["turnoHospitalId"] = this.turnoHospitalId;
        return data;
    }
}

export interface ITurnoHospitalResponsableGetListQuery {
    turnoHospitalId: number;
}

export class TurnoHospitalResponsableGetForEditQuery implements ITurnoHospitalResponsableGetForEditQuery {
    id!: number;

    constructor(data?: ITurnoHospitalResponsableGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TurnoHospitalResponsableGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoHospitalResponsableGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ITurnoHospitalResponsableGetForEditQuery {
    id: number;
}

export class TurnoHospitalResponsableCreateCommand implements ITurnoHospitalResponsableCreateCommand {
    turnoHospitalId?: number | undefined;
    salaId?: number | undefined;
    medicoId?: number | undefined;
    esResponsable!: boolean;
    isActive!: boolean;

    constructor(data?: ITurnoHospitalResponsableCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.turnoHospitalId = _data["turnoHospitalId"];
            this.salaId = _data["salaId"];
            this.medicoId = _data["medicoId"];
            this.esResponsable = _data["esResponsable"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TurnoHospitalResponsableCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoHospitalResponsableCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["turnoHospitalId"] = this.turnoHospitalId;
        data["salaId"] = this.salaId;
        data["medicoId"] = this.medicoId;
        data["esResponsable"] = this.esResponsable;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITurnoHospitalResponsableCreateCommand {
    turnoHospitalId?: number | undefined;
    salaId?: number | undefined;
    medicoId?: number | undefined;
    esResponsable: boolean;
    isActive: boolean;
}

export class TurnoHospitalResponsableUpdateCommand implements ITurnoHospitalResponsableUpdateCommand {
    id?: number | undefined;
    salaId?: number | undefined;
    medicoId?: number | undefined;
    esResponsable!: boolean;
    isActive!: boolean;

    constructor(data?: ITurnoHospitalResponsableUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.salaId = _data["salaId"];
            this.medicoId = _data["medicoId"];
            this.esResponsable = _data["esResponsable"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TurnoHospitalResponsableUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoHospitalResponsableUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["salaId"] = this.salaId;
        data["medicoId"] = this.medicoId;
        data["esResponsable"] = this.esResponsable;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITurnoHospitalResponsableUpdateCommand {
    id?: number | undefined;
    salaId?: number | undefined;
    medicoId?: number | undefined;
    esResponsable: boolean;
    isActive: boolean;
}

export class TurnoHospitalResponsableDeleteCommand implements ITurnoHospitalResponsableDeleteCommand {
    id?: number | undefined;

    constructor(data?: ITurnoHospitalResponsableDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TurnoHospitalResponsableDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoHospitalResponsableDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ITurnoHospitalResponsableDeleteCommand {
    id?: number | undefined;
}

export class TurnoHospitalMaquinaDisponibilidadResponse implements ITurnoHospitalMaquinaDisponibilidadResponse {
    turnoId!: number;
    turnoDesc?: string | undefined;
    horario?: string | undefined;
    lunes!: boolean;
    martes!: boolean;
    miercoles!: boolean;
    jueves!: boolean;
    viernes!: boolean;
    sabado!: boolean;
    domingo!: boolean;

    constructor(data?: ITurnoHospitalMaquinaDisponibilidadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.turnoId = _data["turnoId"];
            this.turnoDesc = _data["turnoDesc"];
            this.horario = _data["horario"];
            this.lunes = _data["lunes"];
            this.martes = _data["martes"];
            this.miercoles = _data["miercoles"];
            this.jueves = _data["jueves"];
            this.viernes = _data["viernes"];
            this.sabado = _data["sabado"];
            this.domingo = _data["domingo"];
        }
    }

    static fromJS(data: any): TurnoHospitalMaquinaDisponibilidadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoHospitalMaquinaDisponibilidadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["turnoId"] = this.turnoId;
        data["turnoDesc"] = this.turnoDesc;
        data["horario"] = this.horario;
        data["lunes"] = this.lunes;
        data["martes"] = this.martes;
        data["miercoles"] = this.miercoles;
        data["jueves"] = this.jueves;
        data["viernes"] = this.viernes;
        data["sabado"] = this.sabado;
        data["domingo"] = this.domingo;
        return data;
    }
}

export interface ITurnoHospitalMaquinaDisponibilidadResponse {
    turnoId: number;
    turnoDesc?: string | undefined;
    horario?: string | undefined;
    lunes: boolean;
    martes: boolean;
    miercoles: boolean;
    jueves: boolean;
    viernes: boolean;
    sabado: boolean;
    domingo: boolean;
}

export class TurnoHospitalMaquinaDisponibilidadGetListQuery implements ITurnoHospitalMaquinaDisponibilidadGetListQuery {
    maquinaId?: number | undefined;
    pacienteId?: number | undefined;

    constructor(data?: ITurnoHospitalMaquinaDisponibilidadGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maquinaId = _data["maquinaId"];
            this.pacienteId = _data["pacienteId"];
        }
    }

    static fromJS(data: any): TurnoHospitalMaquinaDisponibilidadGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoHospitalMaquinaDisponibilidadGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maquinaId"] = this.maquinaId;
        data["pacienteId"] = this.pacienteId;
        return data;
    }
}

export interface ITurnoHospitalMaquinaDisponibilidadGetListQuery {
    maquinaId?: number | undefined;
    pacienteId?: number | undefined;
}

export class PagedResultDtoOfAccesoVascularPacienteForListResponse implements IPagedResultDtoOfAccesoVascularPacienteForListResponse {
    totalCount!: number;
    items?: AccesoVascularPacienteForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfAccesoVascularPacienteForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AccesoVascularPacienteForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAccesoVascularPacienteForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAccesoVascularPacienteForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfAccesoVascularPacienteForListResponse {
    totalCount: number;
    items?: AccesoVascularPacienteForListResponse[] | undefined;
}

export class AccesoVascularPacienteForListResponse implements IAccesoVascularPacienteForListResponse {
    id!: number;
    subtipoAccesoVascularId!: number;
    subtipoAccesoVascularDesc?: string | undefined;
    causaFinalAccesoId?: number | undefined;
    causaFinalAccesoDesc?: string | undefined;
    fechaRealizacion!: moment.Moment;
    fechaFinalizacion?: moment.Moment | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;

    constructor(data?: IAccesoVascularPacienteForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subtipoAccesoVascularId = _data["subtipoAccesoVascularId"];
            this.subtipoAccesoVascularDesc = _data["subtipoAccesoVascularDesc"];
            this.causaFinalAccesoId = _data["causaFinalAccesoId"];
            this.causaFinalAccesoDesc = _data["causaFinalAccesoDesc"];
            this.fechaRealizacion = _data["fechaRealizacion"] ? moment(_data["fechaRealizacion"].toString()) : <any>undefined;
            this.fechaFinalizacion = _data["fechaFinalizacion"] ? moment(_data["fechaFinalizacion"].toString()) : <any>undefined;
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): AccesoVascularPacienteForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccesoVascularPacienteForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subtipoAccesoVascularId"] = this.subtipoAccesoVascularId;
        data["subtipoAccesoVascularDesc"] = this.subtipoAccesoVascularDesc;
        data["causaFinalAccesoId"] = this.causaFinalAccesoId;
        data["causaFinalAccesoDesc"] = this.causaFinalAccesoDesc;
        data["fechaRealizacion"] = this.fechaRealizacion ? this.fechaRealizacion.toISOString() : <any>undefined;
        data["fechaFinalizacion"] = this.fechaFinalizacion ? this.fechaFinalizacion.toISOString() : <any>undefined;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IAccesoVascularPacienteForListResponse {
    id: number;
    subtipoAccesoVascularId: number;
    subtipoAccesoVascularDesc?: string | undefined;
    causaFinalAccesoId?: number | undefined;
    causaFinalAccesoDesc?: string | undefined;
    fechaRealizacion: moment.Moment;
    fechaFinalizacion?: moment.Moment | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
}

export class AccesosVascularesPacienteGetListQuery extends PageListByDto implements IAccesosVascularesPacienteGetListQuery {
    pacienteId!: number;

    constructor(data?: IAccesosVascularesPacienteGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pacienteId = _data["pacienteId"];
        }
    }

    static override fromJS(data: any): AccesosVascularesPacienteGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AccesosVascularesPacienteGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        super.toJSON(data);
        return data;
    }
}

export interface IAccesosVascularesPacienteGetListQuery extends IPageListByDto {
    pacienteId: number;
}

export class AccesoVascularPacienteResponse implements IAccesoVascularPacienteResponse {
    id!: number;
    pacienteId!: number;
    nombrePaciente?: string | undefined;
    tipoAccesoId!: number;
    tipoAccesoDesc?: string | undefined;
    subtipoAccesoVascularId!: number;
    subtipoAccesoVascularDesc?: string | undefined;
    motivoId!: number;
    motivoDesc?: string | undefined;
    tipoAccesoVascularId?: number | undefined;
    tipoAccesoVascularDesc?: string | undefined;
    causaFinalAccesoId?: number | undefined;
    causaFinalAccesoDesc?: string | undefined;
    tecnicaAccesoId?: number | undefined;
    tecnicaAccesoDesc?: string | undefined;
    anatomicoColocacion?: number | undefined;
    fechaRealizacion!: moment.Moment;
    fechaPrimero?: moment.Moment | undefined;
    flujoSangre?: number | undefined;
    presionVenosa?: number | undefined;
    diuresisActual?: string | undefined;
    observaciones?: string | undefined;
    fechaCateter?: moment.Moment | undefined;
    fechaFinalizacion?: moment.Moment | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;
    hospitalizacion?: HospitalizacionPacienteResponse | undefined;
    reparacion?: AccesoVascularPacienteReparacionResponse | undefined;
    incidencia?: AccesoVascularPacienteIncidenciaResponse | undefined;
    antecedentes?: AntecedentePersonaleNefrologicoResponse | undefined;

    constructor(data?: IAccesoVascularPacienteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pacienteId = _data["pacienteId"];
            this.nombrePaciente = _data["nombrePaciente"];
            this.tipoAccesoId = _data["tipoAccesoId"];
            this.tipoAccesoDesc = _data["tipoAccesoDesc"];
            this.subtipoAccesoVascularId = _data["subtipoAccesoVascularId"];
            this.subtipoAccesoVascularDesc = _data["subtipoAccesoVascularDesc"];
            this.motivoId = _data["motivoId"];
            this.motivoDesc = _data["motivoDesc"];
            this.tipoAccesoVascularId = _data["tipoAccesoVascularId"];
            this.tipoAccesoVascularDesc = _data["tipoAccesoVascularDesc"];
            this.causaFinalAccesoId = _data["causaFinalAccesoId"];
            this.causaFinalAccesoDesc = _data["causaFinalAccesoDesc"];
            this.tecnicaAccesoId = _data["tecnicaAccesoId"];
            this.tecnicaAccesoDesc = _data["tecnicaAccesoDesc"];
            this.anatomicoColocacion = _data["anatomicoColocacion"];
            this.fechaRealizacion = _data["fechaRealizacion"] ? moment(_data["fechaRealizacion"].toString()) : <any>undefined;
            this.fechaPrimero = _data["fechaPrimero"] ? moment(_data["fechaPrimero"].toString()) : <any>undefined;
            this.flujoSangre = _data["flujoSangre"];
            this.presionVenosa = _data["presionVenosa"];
            this.diuresisActual = _data["diuresisActual"];
            this.observaciones = _data["observaciones"];
            this.fechaCateter = _data["fechaCateter"] ? moment(_data["fechaCateter"].toString()) : <any>undefined;
            this.fechaFinalizacion = _data["fechaFinalizacion"] ? moment(_data["fechaFinalizacion"].toString()) : <any>undefined;
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.hospitalizacion = _data["hospitalizacion"] ? HospitalizacionPacienteResponse.fromJS(_data["hospitalizacion"]) : <any>undefined;
            this.reparacion = _data["reparacion"] ? AccesoVascularPacienteReparacionResponse.fromJS(_data["reparacion"]) : <any>undefined;
            this.incidencia = _data["incidencia"] ? AccesoVascularPacienteIncidenciaResponse.fromJS(_data["incidencia"]) : <any>undefined;
            this.antecedentes = _data["antecedentes"] ? AntecedentePersonaleNefrologicoResponse.fromJS(_data["antecedentes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AccesoVascularPacienteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccesoVascularPacienteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pacienteId"] = this.pacienteId;
        data["nombrePaciente"] = this.nombrePaciente;
        data["tipoAccesoId"] = this.tipoAccesoId;
        data["tipoAccesoDesc"] = this.tipoAccesoDesc;
        data["subtipoAccesoVascularId"] = this.subtipoAccesoVascularId;
        data["subtipoAccesoVascularDesc"] = this.subtipoAccesoVascularDesc;
        data["motivoId"] = this.motivoId;
        data["motivoDesc"] = this.motivoDesc;
        data["tipoAccesoVascularId"] = this.tipoAccesoVascularId;
        data["tipoAccesoVascularDesc"] = this.tipoAccesoVascularDesc;
        data["causaFinalAccesoId"] = this.causaFinalAccesoId;
        data["causaFinalAccesoDesc"] = this.causaFinalAccesoDesc;
        data["tecnicaAccesoId"] = this.tecnicaAccesoId;
        data["tecnicaAccesoDesc"] = this.tecnicaAccesoDesc;
        data["anatomicoColocacion"] = this.anatomicoColocacion;
        data["fechaRealizacion"] = this.fechaRealizacion ? this.fechaRealizacion.toISOString() : <any>undefined;
        data["fechaPrimero"] = this.fechaPrimero ? this.fechaPrimero.toISOString() : <any>undefined;
        data["flujoSangre"] = this.flujoSangre;
        data["presionVenosa"] = this.presionVenosa;
        data["diuresisActual"] = this.diuresisActual;
        data["observaciones"] = this.observaciones;
        data["fechaCateter"] = this.fechaCateter ? this.fechaCateter.toISOString() : <any>undefined;
        data["fechaFinalizacion"] = this.fechaFinalizacion ? this.fechaFinalizacion.toISOString() : <any>undefined;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["hospitalizacion"] = this.hospitalizacion ? this.hospitalizacion.toJSON() : <any>undefined;
        data["reparacion"] = this.reparacion ? this.reparacion.toJSON() : <any>undefined;
        data["incidencia"] = this.incidencia ? this.incidencia.toJSON() : <any>undefined;
        data["antecedentes"] = this.antecedentes ? this.antecedentes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAccesoVascularPacienteResponse {
    id: number;
    pacienteId: number;
    nombrePaciente?: string | undefined;
    tipoAccesoId: number;
    tipoAccesoDesc?: string | undefined;
    subtipoAccesoVascularId: number;
    subtipoAccesoVascularDesc?: string | undefined;
    motivoId: number;
    motivoDesc?: string | undefined;
    tipoAccesoVascularId?: number | undefined;
    tipoAccesoVascularDesc?: string | undefined;
    causaFinalAccesoId?: number | undefined;
    causaFinalAccesoDesc?: string | undefined;
    tecnicaAccesoId?: number | undefined;
    tecnicaAccesoDesc?: string | undefined;
    anatomicoColocacion?: number | undefined;
    fechaRealizacion: moment.Moment;
    fechaPrimero?: moment.Moment | undefined;
    flujoSangre?: number | undefined;
    presionVenosa?: number | undefined;
    diuresisActual?: string | undefined;
    observaciones?: string | undefined;
    fechaCateter?: moment.Moment | undefined;
    fechaFinalizacion?: moment.Moment | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
    hospitalizacion?: HospitalizacionPacienteResponse | undefined;
    reparacion?: AccesoVascularPacienteReparacionResponse | undefined;
    incidencia?: AccesoVascularPacienteIncidenciaResponse | undefined;
    antecedentes?: AntecedentePersonaleNefrologicoResponse | undefined;
}

export class HospitalizacionPacienteResponse implements IHospitalizacionPacienteResponse {
    accesoVascularPacienteId!: number;
    servicioHospitalId?: number | undefined;
    servicioHospitalDesc?: string | undefined;
    tipoTransfusionId?: number | undefined;
    tipoTransfusionDesc?: string | undefined;
    fechaIngreso?: moment.Moment | undefined;
    fechaSalida?: moment.Moment | undefined;
    numeroPiso?: string | undefined;
    numeroCama?: string | undefined;
    requiereTransfusion?: boolean | undefined;
    fechaTransfusion?: moment.Moment | undefined;
    bolsa1?: string | undefined;
    bolsa2?: string | undefined;
    volumenInfluido?: string | undefined;
    observaciones?: string | undefined;
    fechaAlta?: moment.Moment | undefined;
    fechaModificacion?: moment.Moment | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IHospitalizacionPacienteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accesoVascularPacienteId = _data["accesoVascularPacienteId"];
            this.servicioHospitalId = _data["servicioHospitalId"];
            this.servicioHospitalDesc = _data["servicioHospitalDesc"];
            this.tipoTransfusionId = _data["tipoTransfusionId"];
            this.tipoTransfusionDesc = _data["tipoTransfusionDesc"];
            this.fechaIngreso = _data["fechaIngreso"] ? moment(_data["fechaIngreso"].toString()) : <any>undefined;
            this.fechaSalida = _data["fechaSalida"] ? moment(_data["fechaSalida"].toString()) : <any>undefined;
            this.numeroPiso = _data["numeroPiso"];
            this.numeroCama = _data["numeroCama"];
            this.requiereTransfusion = _data["requiereTransfusion"];
            this.fechaTransfusion = _data["fechaTransfusion"] ? moment(_data["fechaTransfusion"].toString()) : <any>undefined;
            this.bolsa1 = _data["bolsa1"];
            this.bolsa2 = _data["bolsa2"];
            this.volumenInfluido = _data["volumenInfluido"];
            this.observaciones = _data["observaciones"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): HospitalizacionPacienteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HospitalizacionPacienteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accesoVascularPacienteId"] = this.accesoVascularPacienteId;
        data["servicioHospitalId"] = this.servicioHospitalId;
        data["servicioHospitalDesc"] = this.servicioHospitalDesc;
        data["tipoTransfusionId"] = this.tipoTransfusionId;
        data["tipoTransfusionDesc"] = this.tipoTransfusionDesc;
        data["fechaIngreso"] = this.fechaIngreso ? this.fechaIngreso.toISOString() : <any>undefined;
        data["fechaSalida"] = this.fechaSalida ? this.fechaSalida.toISOString() : <any>undefined;
        data["numeroPiso"] = this.numeroPiso;
        data["numeroCama"] = this.numeroCama;
        data["requiereTransfusion"] = this.requiereTransfusion;
        data["fechaTransfusion"] = this.fechaTransfusion ? this.fechaTransfusion.toISOString() : <any>undefined;
        data["bolsa1"] = this.bolsa1;
        data["bolsa2"] = this.bolsa2;
        data["volumenInfluido"] = this.volumenInfluido;
        data["observaciones"] = this.observaciones;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IHospitalizacionPacienteResponse {
    accesoVascularPacienteId: number;
    servicioHospitalId?: number | undefined;
    servicioHospitalDesc?: string | undefined;
    tipoTransfusionId?: number | undefined;
    tipoTransfusionDesc?: string | undefined;
    fechaIngreso?: moment.Moment | undefined;
    fechaSalida?: moment.Moment | undefined;
    numeroPiso?: string | undefined;
    numeroCama?: string | undefined;
    requiereTransfusion?: boolean | undefined;
    fechaTransfusion?: moment.Moment | undefined;
    bolsa1?: string | undefined;
    bolsa2?: string | undefined;
    volumenInfluido?: string | undefined;
    observaciones?: string | undefined;
    fechaAlta?: moment.Moment | undefined;
    fechaModificacion?: moment.Moment | undefined;
    isActive?: boolean | undefined;
}

export class AccesoVascularPacienteReparacionResponse implements IAccesoVascularPacienteReparacionResponse {
    id?: number | undefined;
    accesoVascularPacienteId?: number | undefined;
    fechaReparacion?: moment.Moment | undefined;
    descripcion?: string | undefined;
    observaciones?: string | undefined;
    fechaAlta?: moment.Moment | undefined;
    fechaModificacion?: moment.Moment | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IAccesoVascularPacienteReparacionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accesoVascularPacienteId = _data["accesoVascularPacienteId"];
            this.fechaReparacion = _data["fechaReparacion"] ? moment(_data["fechaReparacion"].toString()) : <any>undefined;
            this.descripcion = _data["descripcion"];
            this.observaciones = _data["observaciones"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): AccesoVascularPacienteReparacionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccesoVascularPacienteReparacionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accesoVascularPacienteId"] = this.accesoVascularPacienteId;
        data["fechaReparacion"] = this.fechaReparacion ? this.fechaReparacion.toISOString() : <any>undefined;
        data["descripcion"] = this.descripcion;
        data["observaciones"] = this.observaciones;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IAccesoVascularPacienteReparacionResponse {
    id?: number | undefined;
    accesoVascularPacienteId?: number | undefined;
    fechaReparacion?: moment.Moment | undefined;
    descripcion?: string | undefined;
    observaciones?: string | undefined;
    fechaAlta?: moment.Moment | undefined;
    fechaModificacion?: moment.Moment | undefined;
    isActive?: boolean | undefined;
}

export class AccesoVascularPacienteIncidenciaResponse implements IAccesoVascularPacienteIncidenciaResponse {
    accesoVascularPeritonialId?: number | undefined;
    incidenciaId?: number | undefined;
    incidenciaDesc?: string | undefined;
    fechaIncidencia?: moment.Moment | undefined;
    medidaCorrectiva?: string | undefined;
    observaciones?: string | undefined;
    fechaAlta?: moment.Moment | undefined;
    fechaModificacion?: moment.Moment | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IAccesoVascularPacienteIncidenciaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accesoVascularPeritonialId = _data["accesoVascularPeritonialId"];
            this.incidenciaId = _data["incidenciaId"];
            this.incidenciaDesc = _data["incidenciaDesc"];
            this.fechaIncidencia = _data["fechaIncidencia"] ? moment(_data["fechaIncidencia"].toString()) : <any>undefined;
            this.medidaCorrectiva = _data["medidaCorrectiva"];
            this.observaciones = _data["observaciones"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): AccesoVascularPacienteIncidenciaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccesoVascularPacienteIncidenciaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accesoVascularPeritonialId"] = this.accesoVascularPeritonialId;
        data["incidenciaId"] = this.incidenciaId;
        data["incidenciaDesc"] = this.incidenciaDesc;
        data["fechaIncidencia"] = this.fechaIncidencia ? this.fechaIncidencia.toISOString() : <any>undefined;
        data["medidaCorrectiva"] = this.medidaCorrectiva;
        data["observaciones"] = this.observaciones;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IAccesoVascularPacienteIncidenciaResponse {
    accesoVascularPeritonialId?: number | undefined;
    incidenciaId?: number | undefined;
    incidenciaDesc?: string | undefined;
    fechaIncidencia?: moment.Moment | undefined;
    medidaCorrectiva?: string | undefined;
    observaciones?: string | undefined;
    fechaAlta?: moment.Moment | undefined;
    fechaModificacion?: moment.Moment | undefined;
    isActive?: boolean | undefined;
}

export class AntecedentePersonaleNefrologicoResponse implements IAntecedentePersonaleNefrologicoResponse {
    accesoVascularPeritonialId?: number | undefined;
    causaCambioId?: number | undefined;
    causaCambioDesc?: string | undefined;
    otroTipoTsr?: number | undefined;
    tiempoPermanecioDp?: string | undefined;
    eventosInfeccionAccesoVascular?: number | undefined;
    numeroCateter?: number | undefined;
    transplanteRenal?: number | undefined;
    fechaTransplante?: moment.Moment | undefined;
    tiempoFuncionalidad?: string | undefined;
    causaPerdida?: string | undefined;
    fechaRechazo?: moment.Moment | undefined;
    otro?: string | undefined;

    constructor(data?: IAntecedentePersonaleNefrologicoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accesoVascularPeritonialId = _data["accesoVascularPeritonialId"];
            this.causaCambioId = _data["causaCambioId"];
            this.causaCambioDesc = _data["causaCambioDesc"];
            this.otroTipoTsr = _data["otroTipoTsr"];
            this.tiempoPermanecioDp = _data["tiempoPermanecioDp"];
            this.eventosInfeccionAccesoVascular = _data["eventosInfeccionAccesoVascular"];
            this.numeroCateter = _data["numeroCateter"];
            this.transplanteRenal = _data["transplanteRenal"];
            this.fechaTransplante = _data["fechaTransplante"] ? moment(_data["fechaTransplante"].toString()) : <any>undefined;
            this.tiempoFuncionalidad = _data["tiempoFuncionalidad"];
            this.causaPerdida = _data["causaPerdida"];
            this.fechaRechazo = _data["fechaRechazo"] ? moment(_data["fechaRechazo"].toString()) : <any>undefined;
            this.otro = _data["otro"];
        }
    }

    static fromJS(data: any): AntecedentePersonaleNefrologicoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AntecedentePersonaleNefrologicoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accesoVascularPeritonialId"] = this.accesoVascularPeritonialId;
        data["causaCambioId"] = this.causaCambioId;
        data["causaCambioDesc"] = this.causaCambioDesc;
        data["otroTipoTsr"] = this.otroTipoTsr;
        data["tiempoPermanecioDp"] = this.tiempoPermanecioDp;
        data["eventosInfeccionAccesoVascular"] = this.eventosInfeccionAccesoVascular;
        data["numeroCateter"] = this.numeroCateter;
        data["transplanteRenal"] = this.transplanteRenal;
        data["fechaTransplante"] = this.fechaTransplante ? this.fechaTransplante.toISOString() : <any>undefined;
        data["tiempoFuncionalidad"] = this.tiempoFuncionalidad;
        data["causaPerdida"] = this.causaPerdida;
        data["fechaRechazo"] = this.fechaRechazo ? this.fechaRechazo.toISOString() : <any>undefined;
        data["otro"] = this.otro;
        return data;
    }
}

export interface IAntecedentePersonaleNefrologicoResponse {
    accesoVascularPeritonialId?: number | undefined;
    causaCambioId?: number | undefined;
    causaCambioDesc?: string | undefined;
    otroTipoTsr?: number | undefined;
    tiempoPermanecioDp?: string | undefined;
    eventosInfeccionAccesoVascular?: number | undefined;
    numeroCateter?: number | undefined;
    transplanteRenal?: number | undefined;
    fechaTransplante?: moment.Moment | undefined;
    tiempoFuncionalidad?: string | undefined;
    causaPerdida?: string | undefined;
    fechaRechazo?: moment.Moment | undefined;
    otro?: string | undefined;
}

export class AccesosVascularesPacienteGetByIdQuery implements IAccesosVascularesPacienteGetByIdQuery {
    id!: number;

    constructor(data?: IAccesosVascularesPacienteGetByIdQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AccesosVascularesPacienteGetByIdQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AccesosVascularesPacienteGetByIdQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IAccesosVascularesPacienteGetByIdQuery {
    id: number;
}

export class AccesosVascularesPacienteGetActivoPorPacienteQuery implements IAccesosVascularesPacienteGetActivoPorPacienteQuery {
    pacienteId!: number;

    constructor(data?: IAccesosVascularesPacienteGetActivoPorPacienteQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
        }
    }

    static fromJS(data: any): AccesosVascularesPacienteGetActivoPorPacienteQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AccesosVascularesPacienteGetActivoPorPacienteQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        return data;
    }
}

export interface IAccesosVascularesPacienteGetActivoPorPacienteQuery {
    pacienteId: number;
}

export class AccesosVascularesPacienteGetForComboboxQuery extends PageListByDto implements IAccesosVascularesPacienteGetForComboboxQuery {
    pacienteId!: number;

    constructor(data?: IAccesosVascularesPacienteGetForComboboxQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pacienteId = _data["pacienteId"];
        }
    }

    static override fromJS(data: any): AccesosVascularesPacienteGetForComboboxQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AccesosVascularesPacienteGetForComboboxQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        super.toJSON(data);
        return data;
    }
}

export interface IAccesosVascularesPacienteGetForComboboxQuery extends IPageListByDto {
    pacienteId: number;
}

export class AccesoVascularCreateCommand implements IAccesoVascularCreateCommand {
    id?: number | undefined;
    pacienteId?: number | undefined;
    nombrePaciente?: string | undefined;
    tipoAccesoId?: number | undefined;
    subtipoAccesoVascularId?: number | undefined;
    motivoId?: number | undefined;
    tipoAccesoVascularId?: number | undefined;
    causaFinalAccesoId?: number | undefined;
    tecnicaAccesoId?: number | undefined;
    anatomicoColocacion?: number | undefined;
    fechaRealizacion?: moment.Moment | undefined;
    fechaPrimero?: moment.Moment | undefined;
    fechaPrimeroRequerida!: boolean;
    flujoSangre?: number | undefined;
    presionVenosa?: number | undefined;
    diuresisActual?: string | undefined;
    observaciones?: string | undefined;
    fechaCateter?: moment.Moment | undefined;
    fechaFinalizacion?: moment.Moment | undefined;
    hospitalizacion?: HospitalizacionPacienteCreateOrUpdateCommand | undefined;
    reparacion?: ReparacionCreateOrUpdateCommand | undefined;
    incidencia?: IncidenciaCreateOrUpdateCommand | undefined;
    antecedentes?: AntecedentesNefrologicosCreateOrUpdateCommand | undefined;

    constructor(data?: IAccesoVascularCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pacienteId = _data["pacienteId"];
            this.nombrePaciente = _data["nombrePaciente"];
            this.tipoAccesoId = _data["tipoAccesoId"];
            this.subtipoAccesoVascularId = _data["subtipoAccesoVascularId"];
            this.motivoId = _data["motivoId"];
            this.tipoAccesoVascularId = _data["tipoAccesoVascularId"];
            this.causaFinalAccesoId = _data["causaFinalAccesoId"];
            this.tecnicaAccesoId = _data["tecnicaAccesoId"];
            this.anatomicoColocacion = _data["anatomicoColocacion"];
            this.fechaRealizacion = _data["fechaRealizacion"] ? moment(_data["fechaRealizacion"].toString()) : <any>undefined;
            this.fechaPrimero = _data["fechaPrimero"] ? moment(_data["fechaPrimero"].toString()) : <any>undefined;
            this.fechaPrimeroRequerida = _data["fechaPrimeroRequerida"];
            this.flujoSangre = _data["flujoSangre"];
            this.presionVenosa = _data["presionVenosa"];
            this.diuresisActual = _data["diuresisActual"];
            this.observaciones = _data["observaciones"];
            this.fechaCateter = _data["fechaCateter"] ? moment(_data["fechaCateter"].toString()) : <any>undefined;
            this.fechaFinalizacion = _data["fechaFinalizacion"] ? moment(_data["fechaFinalizacion"].toString()) : <any>undefined;
            this.hospitalizacion = _data["hospitalizacion"] ? HospitalizacionPacienteCreateOrUpdateCommand.fromJS(_data["hospitalizacion"]) : <any>undefined;
            this.reparacion = _data["reparacion"] ? ReparacionCreateOrUpdateCommand.fromJS(_data["reparacion"]) : <any>undefined;
            this.incidencia = _data["incidencia"] ? IncidenciaCreateOrUpdateCommand.fromJS(_data["incidencia"]) : <any>undefined;
            this.antecedentes = _data["antecedentes"] ? AntecedentesNefrologicosCreateOrUpdateCommand.fromJS(_data["antecedentes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AccesoVascularCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AccesoVascularCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pacienteId"] = this.pacienteId;
        data["nombrePaciente"] = this.nombrePaciente;
        data["tipoAccesoId"] = this.tipoAccesoId;
        data["subtipoAccesoVascularId"] = this.subtipoAccesoVascularId;
        data["motivoId"] = this.motivoId;
        data["tipoAccesoVascularId"] = this.tipoAccesoVascularId;
        data["causaFinalAccesoId"] = this.causaFinalAccesoId;
        data["tecnicaAccesoId"] = this.tecnicaAccesoId;
        data["anatomicoColocacion"] = this.anatomicoColocacion;
        data["fechaRealizacion"] = this.fechaRealizacion ? this.fechaRealizacion.toISOString() : <any>undefined;
        data["fechaPrimero"] = this.fechaPrimero ? this.fechaPrimero.toISOString() : <any>undefined;
        data["fechaPrimeroRequerida"] = this.fechaPrimeroRequerida;
        data["flujoSangre"] = this.flujoSangre;
        data["presionVenosa"] = this.presionVenosa;
        data["diuresisActual"] = this.diuresisActual;
        data["observaciones"] = this.observaciones;
        data["fechaCateter"] = this.fechaCateter ? this.fechaCateter.toISOString() : <any>undefined;
        data["fechaFinalizacion"] = this.fechaFinalizacion ? this.fechaFinalizacion.toISOString() : <any>undefined;
        data["hospitalizacion"] = this.hospitalizacion ? this.hospitalizacion.toJSON() : <any>undefined;
        data["reparacion"] = this.reparacion ? this.reparacion.toJSON() : <any>undefined;
        data["incidencia"] = this.incidencia ? this.incidencia.toJSON() : <any>undefined;
        data["antecedentes"] = this.antecedentes ? this.antecedentes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAccesoVascularCreateCommand {
    id?: number | undefined;
    pacienteId?: number | undefined;
    nombrePaciente?: string | undefined;
    tipoAccesoId?: number | undefined;
    subtipoAccesoVascularId?: number | undefined;
    motivoId?: number | undefined;
    tipoAccesoVascularId?: number | undefined;
    causaFinalAccesoId?: number | undefined;
    tecnicaAccesoId?: number | undefined;
    anatomicoColocacion?: number | undefined;
    fechaRealizacion?: moment.Moment | undefined;
    fechaPrimero?: moment.Moment | undefined;
    fechaPrimeroRequerida: boolean;
    flujoSangre?: number | undefined;
    presionVenosa?: number | undefined;
    diuresisActual?: string | undefined;
    observaciones?: string | undefined;
    fechaCateter?: moment.Moment | undefined;
    fechaFinalizacion?: moment.Moment | undefined;
    hospitalizacion?: HospitalizacionPacienteCreateOrUpdateCommand | undefined;
    reparacion?: ReparacionCreateOrUpdateCommand | undefined;
    incidencia?: IncidenciaCreateOrUpdateCommand | undefined;
    antecedentes?: AntecedentesNefrologicosCreateOrUpdateCommand | undefined;
}

export class HospitalizacionPacienteCreateOrUpdateCommand implements IHospitalizacionPacienteCreateOrUpdateCommand {
    id?: number | undefined;
    servicioHospitalId?: number | undefined;
    tipoTransfusionId?: number | undefined;
    fechaIngreso?: moment.Moment | undefined;
    fechaSalida?: moment.Moment | undefined;
    numeroPiso?: string | undefined;
    numeroCama?: string | undefined;
    requiereTransfusion?: boolean | undefined;
    fechaTransfusion?: moment.Moment | undefined;
    bolsa1?: string | undefined;
    bolsa2?: string | undefined;
    volumenInfluido?: string | undefined;
    observaciones?: string | undefined;

    constructor(data?: IHospitalizacionPacienteCreateOrUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.servicioHospitalId = _data["servicioHospitalId"];
            this.tipoTransfusionId = _data["tipoTransfusionId"];
            this.fechaIngreso = _data["fechaIngreso"] ? moment(_data["fechaIngreso"].toString()) : <any>undefined;
            this.fechaSalida = _data["fechaSalida"] ? moment(_data["fechaSalida"].toString()) : <any>undefined;
            this.numeroPiso = _data["numeroPiso"];
            this.numeroCama = _data["numeroCama"];
            this.requiereTransfusion = _data["requiereTransfusion"];
            this.fechaTransfusion = _data["fechaTransfusion"] ? moment(_data["fechaTransfusion"].toString()) : <any>undefined;
            this.bolsa1 = _data["bolsa1"];
            this.bolsa2 = _data["bolsa2"];
            this.volumenInfluido = _data["volumenInfluido"];
            this.observaciones = _data["observaciones"];
        }
    }

    static fromJS(data: any): HospitalizacionPacienteCreateOrUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new HospitalizacionPacienteCreateOrUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["servicioHospitalId"] = this.servicioHospitalId;
        data["tipoTransfusionId"] = this.tipoTransfusionId;
        data["fechaIngreso"] = this.fechaIngreso ? this.fechaIngreso.toISOString() : <any>undefined;
        data["fechaSalida"] = this.fechaSalida ? this.fechaSalida.toISOString() : <any>undefined;
        data["numeroPiso"] = this.numeroPiso;
        data["numeroCama"] = this.numeroCama;
        data["requiereTransfusion"] = this.requiereTransfusion;
        data["fechaTransfusion"] = this.fechaTransfusion ? this.fechaTransfusion.toISOString() : <any>undefined;
        data["bolsa1"] = this.bolsa1;
        data["bolsa2"] = this.bolsa2;
        data["volumenInfluido"] = this.volumenInfluido;
        data["observaciones"] = this.observaciones;
        return data;
    }
}

export interface IHospitalizacionPacienteCreateOrUpdateCommand {
    id?: number | undefined;
    servicioHospitalId?: number | undefined;
    tipoTransfusionId?: number | undefined;
    fechaIngreso?: moment.Moment | undefined;
    fechaSalida?: moment.Moment | undefined;
    numeroPiso?: string | undefined;
    numeroCama?: string | undefined;
    requiereTransfusion?: boolean | undefined;
    fechaTransfusion?: moment.Moment | undefined;
    bolsa1?: string | undefined;
    bolsa2?: string | undefined;
    volumenInfluido?: string | undefined;
    observaciones?: string | undefined;
}

export class ReparacionCreateOrUpdateCommand implements IReparacionCreateOrUpdateCommand {
    fechaReparacion?: moment.Moment | undefined;
    descripcion?: string | undefined;
    observaciones?: string | undefined;

    constructor(data?: IReparacionCreateOrUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fechaReparacion = _data["fechaReparacion"] ? moment(_data["fechaReparacion"].toString()) : <any>undefined;
            this.descripcion = _data["descripcion"];
            this.observaciones = _data["observaciones"];
        }
    }

    static fromJS(data: any): ReparacionCreateOrUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReparacionCreateOrUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fechaReparacion"] = this.fechaReparacion ? this.fechaReparacion.toISOString() : <any>undefined;
        data["descripcion"] = this.descripcion;
        data["observaciones"] = this.observaciones;
        return data;
    }
}

export interface IReparacionCreateOrUpdateCommand {
    fechaReparacion?: moment.Moment | undefined;
    descripcion?: string | undefined;
    observaciones?: string | undefined;
}

export class IncidenciaCreateOrUpdateCommand implements IIncidenciaCreateOrUpdateCommand {
    incidenciaId?: number | undefined;
    fechaIncidencia?: moment.Moment | undefined;
    medidaCorrectiva?: string | undefined;
    observaciones?: string | undefined;
    fechaAlta?: moment.Moment | undefined;
    fechaModificacion?: moment.Moment | undefined;

    constructor(data?: IIncidenciaCreateOrUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incidenciaId = _data["incidenciaId"];
            this.fechaIncidencia = _data["fechaIncidencia"] ? moment(_data["fechaIncidencia"].toString()) : <any>undefined;
            this.medidaCorrectiva = _data["medidaCorrectiva"];
            this.observaciones = _data["observaciones"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IncidenciaCreateOrUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new IncidenciaCreateOrUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incidenciaId"] = this.incidenciaId;
        data["fechaIncidencia"] = this.fechaIncidencia ? this.fechaIncidencia.toISOString() : <any>undefined;
        data["medidaCorrectiva"] = this.medidaCorrectiva;
        data["observaciones"] = this.observaciones;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        return data;
    }
}

export interface IIncidenciaCreateOrUpdateCommand {
    incidenciaId?: number | undefined;
    fechaIncidencia?: moment.Moment | undefined;
    medidaCorrectiva?: string | undefined;
    observaciones?: string | undefined;
    fechaAlta?: moment.Moment | undefined;
    fechaModificacion?: moment.Moment | undefined;
}

export class AntecedentesNefrologicosCreateOrUpdateCommand implements IAntecedentesNefrologicosCreateOrUpdateCommand {
    accesoVascularPeritonialId?: number | undefined;
    causaCambioId?: number | undefined;
    otroTipoTsr?: number | undefined;
    tiempoPermanecioDp?: string | undefined;
    eventosInfeccionAccesoVascular?: number | undefined;
    numeroCateter?: number | undefined;
    transplanteRenal?: number | undefined;
    fechaTransplante?: moment.Moment | undefined;
    tiempoFuncionalidad?: string | undefined;
    causaPerdida?: string | undefined;
    fechaRechazo?: moment.Moment | undefined;
    otro?: string | undefined;

    constructor(data?: IAntecedentesNefrologicosCreateOrUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accesoVascularPeritonialId = _data["accesoVascularPeritonialId"];
            this.causaCambioId = _data["causaCambioId"];
            this.otroTipoTsr = _data["otroTipoTsr"];
            this.tiempoPermanecioDp = _data["tiempoPermanecioDp"];
            this.eventosInfeccionAccesoVascular = _data["eventosInfeccionAccesoVascular"];
            this.numeroCateter = _data["numeroCateter"];
            this.transplanteRenal = _data["transplanteRenal"];
            this.fechaTransplante = _data["fechaTransplante"] ? moment(_data["fechaTransplante"].toString()) : <any>undefined;
            this.tiempoFuncionalidad = _data["tiempoFuncionalidad"];
            this.causaPerdida = _data["causaPerdida"];
            this.fechaRechazo = _data["fechaRechazo"] ? moment(_data["fechaRechazo"].toString()) : <any>undefined;
            this.otro = _data["otro"];
        }
    }

    static fromJS(data: any): AntecedentesNefrologicosCreateOrUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AntecedentesNefrologicosCreateOrUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accesoVascularPeritonialId"] = this.accesoVascularPeritonialId;
        data["causaCambioId"] = this.causaCambioId;
        data["otroTipoTsr"] = this.otroTipoTsr;
        data["tiempoPermanecioDp"] = this.tiempoPermanecioDp;
        data["eventosInfeccionAccesoVascular"] = this.eventosInfeccionAccesoVascular;
        data["numeroCateter"] = this.numeroCateter;
        data["transplanteRenal"] = this.transplanteRenal;
        data["fechaTransplante"] = this.fechaTransplante ? this.fechaTransplante.toISOString() : <any>undefined;
        data["tiempoFuncionalidad"] = this.tiempoFuncionalidad;
        data["causaPerdida"] = this.causaPerdida;
        data["fechaRechazo"] = this.fechaRechazo ? this.fechaRechazo.toISOString() : <any>undefined;
        data["otro"] = this.otro;
        return data;
    }
}

export interface IAntecedentesNefrologicosCreateOrUpdateCommand {
    accesoVascularPeritonialId?: number | undefined;
    causaCambioId?: number | undefined;
    otroTipoTsr?: number | undefined;
    tiempoPermanecioDp?: string | undefined;
    eventosInfeccionAccesoVascular?: number | undefined;
    numeroCateter?: number | undefined;
    transplanteRenal?: number | undefined;
    fechaTransplante?: moment.Moment | undefined;
    tiempoFuncionalidad?: string | undefined;
    causaPerdida?: string | undefined;
    fechaRechazo?: moment.Moment | undefined;
    otro?: string | undefined;
}

export class AccesoVascularUpdateCommand implements IAccesoVascularUpdateCommand {
    id?: number | undefined;
    pacienteId?: number | undefined;
    nombrePaciente?: string | undefined;
    subtipoAccesoVascularId?: number | undefined;
    motivoId?: number | undefined;
    tipoAccesoId?: number | undefined;
    tipoAccesoVascularId?: number | undefined;
    causaFinalAccesoId?: number | undefined;
    tecnicaAccesoId?: number | undefined;
    anatomicoColocacion?: number | undefined;
    fechaRealizacion?: moment.Moment | undefined;
    fechaPrimero?: moment.Moment | undefined;
    fechaPrimeroRequerida!: boolean;
    flujoSangre?: number | undefined;
    presionVenosa?: number | undefined;
    diuresisActual?: string | undefined;
    observaciones?: string | undefined;
    fechaCateter?: moment.Moment | undefined;
    fechaFinalizacion?: moment.Moment | undefined;
    hospitalizacion?: HospitalizacionPacienteCreateOrUpdateCommand | undefined;
    reparacion?: ReparacionCreateOrUpdateCommand | undefined;
    incidencia?: IncidenciaCreateOrUpdateCommand | undefined;
    antecedentes?: AntecedentesNefrologicosCreateOrUpdateCommand | undefined;

    constructor(data?: IAccesoVascularUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pacienteId = _data["pacienteId"];
            this.nombrePaciente = _data["nombrePaciente"];
            this.subtipoAccesoVascularId = _data["subtipoAccesoVascularId"];
            this.motivoId = _data["motivoId"];
            this.tipoAccesoId = _data["tipoAccesoId"];
            this.tipoAccesoVascularId = _data["tipoAccesoVascularId"];
            this.causaFinalAccesoId = _data["causaFinalAccesoId"];
            this.tecnicaAccesoId = _data["tecnicaAccesoId"];
            this.anatomicoColocacion = _data["anatomicoColocacion"];
            this.fechaRealizacion = _data["fechaRealizacion"] ? moment(_data["fechaRealizacion"].toString()) : <any>undefined;
            this.fechaPrimero = _data["fechaPrimero"] ? moment(_data["fechaPrimero"].toString()) : <any>undefined;
            this.fechaPrimeroRequerida = _data["fechaPrimeroRequerida"];
            this.flujoSangre = _data["flujoSangre"];
            this.presionVenosa = _data["presionVenosa"];
            this.diuresisActual = _data["diuresisActual"];
            this.observaciones = _data["observaciones"];
            this.fechaCateter = _data["fechaCateter"] ? moment(_data["fechaCateter"].toString()) : <any>undefined;
            this.fechaFinalizacion = _data["fechaFinalizacion"] ? moment(_data["fechaFinalizacion"].toString()) : <any>undefined;
            this.hospitalizacion = _data["hospitalizacion"] ? HospitalizacionPacienteCreateOrUpdateCommand.fromJS(_data["hospitalizacion"]) : <any>undefined;
            this.reparacion = _data["reparacion"] ? ReparacionCreateOrUpdateCommand.fromJS(_data["reparacion"]) : <any>undefined;
            this.incidencia = _data["incidencia"] ? IncidenciaCreateOrUpdateCommand.fromJS(_data["incidencia"]) : <any>undefined;
            this.antecedentes = _data["antecedentes"] ? AntecedentesNefrologicosCreateOrUpdateCommand.fromJS(_data["antecedentes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AccesoVascularUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AccesoVascularUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pacienteId"] = this.pacienteId;
        data["nombrePaciente"] = this.nombrePaciente;
        data["subtipoAccesoVascularId"] = this.subtipoAccesoVascularId;
        data["motivoId"] = this.motivoId;
        data["tipoAccesoId"] = this.tipoAccesoId;
        data["tipoAccesoVascularId"] = this.tipoAccesoVascularId;
        data["causaFinalAccesoId"] = this.causaFinalAccesoId;
        data["tecnicaAccesoId"] = this.tecnicaAccesoId;
        data["anatomicoColocacion"] = this.anatomicoColocacion;
        data["fechaRealizacion"] = this.fechaRealizacion ? this.fechaRealizacion.toISOString() : <any>undefined;
        data["fechaPrimero"] = this.fechaPrimero ? this.fechaPrimero.toISOString() : <any>undefined;
        data["fechaPrimeroRequerida"] = this.fechaPrimeroRequerida;
        data["flujoSangre"] = this.flujoSangre;
        data["presionVenosa"] = this.presionVenosa;
        data["diuresisActual"] = this.diuresisActual;
        data["observaciones"] = this.observaciones;
        data["fechaCateter"] = this.fechaCateter ? this.fechaCateter.toISOString() : <any>undefined;
        data["fechaFinalizacion"] = this.fechaFinalizacion ? this.fechaFinalizacion.toISOString() : <any>undefined;
        data["hospitalizacion"] = this.hospitalizacion ? this.hospitalizacion.toJSON() : <any>undefined;
        data["reparacion"] = this.reparacion ? this.reparacion.toJSON() : <any>undefined;
        data["incidencia"] = this.incidencia ? this.incidencia.toJSON() : <any>undefined;
        data["antecedentes"] = this.antecedentes ? this.antecedentes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAccesoVascularUpdateCommand {
    id?: number | undefined;
    pacienteId?: number | undefined;
    nombrePaciente?: string | undefined;
    subtipoAccesoVascularId?: number | undefined;
    motivoId?: number | undefined;
    tipoAccesoId?: number | undefined;
    tipoAccesoVascularId?: number | undefined;
    causaFinalAccesoId?: number | undefined;
    tecnicaAccesoId?: number | undefined;
    anatomicoColocacion?: number | undefined;
    fechaRealizacion?: moment.Moment | undefined;
    fechaPrimero?: moment.Moment | undefined;
    fechaPrimeroRequerida: boolean;
    flujoSangre?: number | undefined;
    presionVenosa?: number | undefined;
    diuresisActual?: string | undefined;
    observaciones?: string | undefined;
    fechaCateter?: moment.Moment | undefined;
    fechaFinalizacion?: moment.Moment | undefined;
    hospitalizacion?: HospitalizacionPacienteCreateOrUpdateCommand | undefined;
    reparacion?: ReparacionCreateOrUpdateCommand | undefined;
    incidencia?: IncidenciaCreateOrUpdateCommand | undefined;
    antecedentes?: AntecedentesNefrologicosCreateOrUpdateCommand | undefined;
}

export class PagedResultDtoOfCitaForListResponse implements IPagedResultDtoOfCitaForListResponse {
    totalCount!: number;
    items?: CitaForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfCitaForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CitaForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCitaForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCitaForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfCitaForListResponse {
    totalCount: number;
    items?: CitaForListResponse[] | undefined;
}

export class CitaForListResponse implements ICitaForListResponse {
    id!: number;
    pacienteId!: number;
    nombrePaciente?: string | undefined;
    idee?: string | undefined;
    estatusCitaId!: number;
    estatusCitaClave?: string | undefined;
    estatusDesc?: string | undefined;
    sesionHdId?: number | undefined;
    salaHemodialisisId!: number;
    salaDesc?: string | undefined;
    maquinaId?: number | undefined;
    maquinaDesc?: string | undefined;
    turnoHospitalId!: number;
    turnoHospitalDesc?: string | undefined;
    diaSemana!: number;
    horaInicio?: moment.Duration | undefined;
    horaInicioDesc?: string | undefined;
    fechaCita!: moment.Moment;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;
    tipoInstitucion?: string | undefined;
    isConfirmada!: boolean;

    constructor(data?: ICitaForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pacienteId = _data["pacienteId"];
            this.nombrePaciente = _data["nombrePaciente"];
            this.idee = _data["idee"];
            this.estatusCitaId = _data["estatusCitaId"];
            this.estatusCitaClave = _data["estatusCitaClave"];
            this.estatusDesc = _data["estatusDesc"];
            this.sesionHdId = _data["sesionHdId"];
            this.salaHemodialisisId = _data["salaHemodialisisId"];
            this.salaDesc = _data["salaDesc"];
            this.maquinaId = _data["maquinaId"];
            this.maquinaDesc = _data["maquinaDesc"];
            this.turnoHospitalId = _data["turnoHospitalId"];
            this.turnoHospitalDesc = _data["turnoHospitalDesc"];
            this.diaSemana = _data["diaSemana"];
            this.horaInicio = _data["horaInicio"] ? moment.duration(_data["horaInicio"].toString()) : <any>undefined;
            this.horaInicioDesc = _data["horaInicioDesc"];
            this.fechaCita = _data["fechaCita"] ? moment(_data["fechaCita"].toString()) : <any>undefined;
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.tipoInstitucion = _data["tipoInstitucion"];
            this.isConfirmada = _data["isConfirmada"];
        }
    }

    static fromJS(data: any): CitaForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CitaForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pacienteId"] = this.pacienteId;
        data["nombrePaciente"] = this.nombrePaciente;
        data["idee"] = this.idee;
        data["estatusCitaId"] = this.estatusCitaId;
        data["estatusCitaClave"] = this.estatusCitaClave;
        data["estatusDesc"] = this.estatusDesc;
        data["sesionHdId"] = this.sesionHdId;
        data["salaHemodialisisId"] = this.salaHemodialisisId;
        data["salaDesc"] = this.salaDesc;
        data["maquinaId"] = this.maquinaId;
        data["maquinaDesc"] = this.maquinaDesc;
        data["turnoHospitalId"] = this.turnoHospitalId;
        data["turnoHospitalDesc"] = this.turnoHospitalDesc;
        data["diaSemana"] = this.diaSemana;
        data["horaInicio"] = this.horaInicio ? this.horaInicio.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["horaInicioDesc"] = this.horaInicioDesc;
        data["fechaCita"] = this.fechaCita ? this.fechaCita.toISOString() : <any>undefined;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["tipoInstitucion"] = this.tipoInstitucion;
        data["isConfirmada"] = this.isConfirmada;
        return data;
    }
}

export interface ICitaForListResponse {
    id: number;
    pacienteId: number;
    nombrePaciente?: string | undefined;
    idee?: string | undefined;
    estatusCitaId: number;
    estatusCitaClave?: string | undefined;
    estatusDesc?: string | undefined;
    sesionHdId?: number | undefined;
    salaHemodialisisId: number;
    salaDesc?: string | undefined;
    maquinaId?: number | undefined;
    maquinaDesc?: string | undefined;
    turnoHospitalId: number;
    turnoHospitalDesc?: string | undefined;
    diaSemana: number;
    horaInicio?: moment.Duration | undefined;
    horaInicioDesc?: string | undefined;
    fechaCita: moment.Moment;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
    tipoInstitucion?: string | undefined;
    isConfirmada: boolean;
}

export class CitaGetListQuery extends PageListByDto implements ICitaGetListQuery {
    fechaInicio?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    hospitalList?: number[] | undefined;
    salaId?: number | undefined;
    excluirCerradasYCanceladas!: boolean;
    maquinaId?: number | undefined;
    medicoAsignadoId?: number | undefined;
    pacienteId?: number | undefined;
    estatusId?: number | undefined;
    tipo!: number;

    constructor(data?: ICitaGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            if (Array.isArray(_data["hospitalList"])) {
                this.hospitalList = [] as any;
                for (let item of _data["hospitalList"])
                    this.hospitalList!.push(item);
            }
            this.salaId = _data["salaId"];
            this.excluirCerradasYCanceladas = _data["excluirCerradasYCanceladas"];
            this.maquinaId = _data["maquinaId"];
            this.medicoAsignadoId = _data["medicoAsignadoId"];
            this.pacienteId = _data["pacienteId"];
            this.estatusId = _data["estatusId"];
            this.tipo = _data["tipo"];
        }
    }

    static override fromJS(data: any): CitaGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CitaGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        if (Array.isArray(this.hospitalList)) {
            data["hospitalList"] = [];
            for (let item of this.hospitalList)
                data["hospitalList"].push(item);
        }
        data["salaId"] = this.salaId;
        data["excluirCerradasYCanceladas"] = this.excluirCerradasYCanceladas;
        data["maquinaId"] = this.maquinaId;
        data["medicoAsignadoId"] = this.medicoAsignadoId;
        data["pacienteId"] = this.pacienteId;
        data["estatusId"] = this.estatusId;
        data["tipo"] = this.tipo;
        super.toJSON(data);
        return data;
    }
}

export interface ICitaGetListQuery extends IPageListByDto {
    fechaInicio?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    hospitalList?: number[] | undefined;
    salaId?: number | undefined;
    excluirCerradasYCanceladas: boolean;
    maquinaId?: number | undefined;
    medicoAsignadoId?: number | undefined;
    pacienteId?: number | undefined;
    estatusId?: number | undefined;
    tipo: number;
}

export class CitaProgramadaNoOtorgadaGetListQuery extends PageListByDto implements ICitaProgramadaNoOtorgadaGetListQuery {
    tipo!: number;

    constructor(data?: ICitaProgramadaNoOtorgadaGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipo = _data["tipo"];
        }
    }

    static override fromJS(data: any): CitaProgramadaNoOtorgadaGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CitaProgramadaNoOtorgadaGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipo"] = this.tipo;
        super.toJSON(data);
        return data;
    }
}

export interface ICitaProgramadaNoOtorgadaGetListQuery extends IPageListByDto {
    tipo: number;
}

export class CitaResponse implements ICitaResponse {
    id!: number;
    pacienteId!: number;
    nombrePaciente?: string | undefined;
    estatusCitaId!: number;
    estatusCitaClave?: string | undefined;
    estatusDesc?: string | undefined;
    sesionHdId?: number | undefined;
    salaHemodialisisId!: number;
    salaDesc?: string | undefined;
    maquinaId?: number | undefined;
    maquinaDesc?: string | undefined;
    turnoHospitalId!: number;
    turnoHospitalDesc?: string | undefined;
    diaSemana!: number;
    horaInicio?: moment.Duration | undefined;
    horaInicioDesc?: string | undefined;
    fechaCita!: moment.Moment;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;

    constructor(data?: ICitaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pacienteId = _data["pacienteId"];
            this.nombrePaciente = _data["nombrePaciente"];
            this.estatusCitaId = _data["estatusCitaId"];
            this.estatusCitaClave = _data["estatusCitaClave"];
            this.estatusDesc = _data["estatusDesc"];
            this.sesionHdId = _data["sesionHdId"];
            this.salaHemodialisisId = _data["salaHemodialisisId"];
            this.salaDesc = _data["salaDesc"];
            this.maquinaId = _data["maquinaId"];
            this.maquinaDesc = _data["maquinaDesc"];
            this.turnoHospitalId = _data["turnoHospitalId"];
            this.turnoHospitalDesc = _data["turnoHospitalDesc"];
            this.diaSemana = _data["diaSemana"];
            this.horaInicio = _data["horaInicio"] ? moment.duration(_data["horaInicio"].toString()) : <any>undefined;
            this.horaInicioDesc = _data["horaInicioDesc"];
            this.fechaCita = _data["fechaCita"] ? moment(_data["fechaCita"].toString()) : <any>undefined;
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CitaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CitaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pacienteId"] = this.pacienteId;
        data["nombrePaciente"] = this.nombrePaciente;
        data["estatusCitaId"] = this.estatusCitaId;
        data["estatusCitaClave"] = this.estatusCitaClave;
        data["estatusDesc"] = this.estatusDesc;
        data["sesionHdId"] = this.sesionHdId;
        data["salaHemodialisisId"] = this.salaHemodialisisId;
        data["salaDesc"] = this.salaDesc;
        data["maquinaId"] = this.maquinaId;
        data["maquinaDesc"] = this.maquinaDesc;
        data["turnoHospitalId"] = this.turnoHospitalId;
        data["turnoHospitalDesc"] = this.turnoHospitalDesc;
        data["diaSemana"] = this.diaSemana;
        data["horaInicio"] = this.horaInicio ? this.horaInicio.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["horaInicioDesc"] = this.horaInicioDesc;
        data["fechaCita"] = this.fechaCita ? this.fechaCita.toISOString() : <any>undefined;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICitaResponse {
    id: number;
    pacienteId: number;
    nombrePaciente?: string | undefined;
    estatusCitaId: number;
    estatusCitaClave?: string | undefined;
    estatusDesc?: string | undefined;
    sesionHdId?: number | undefined;
    salaHemodialisisId: number;
    salaDesc?: string | undefined;
    maquinaId?: number | undefined;
    maquinaDesc?: string | undefined;
    turnoHospitalId: number;
    turnoHospitalDesc?: string | undefined;
    diaSemana: number;
    horaInicio?: moment.Duration | undefined;
    horaInicioDesc?: string | undefined;
    fechaCita: moment.Moment;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
}

export class CitaGetByIdQuery implements ICitaGetByIdQuery {
    id?: number | undefined;

    constructor(data?: ICitaGetByIdQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CitaGetByIdQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CitaGetByIdQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICitaGetByIdQuery {
    id?: number | undefined;
}

export class CitaCreateCommand implements ICitaCreateCommand {
    id?: number | undefined;
    pacienteId?: number | undefined;
    salaId?: number | undefined;
    maquinaId?: number | undefined;
    turnoHospitalId?: number | undefined;
    diaSemana?: number | undefined;
    fechaCita?: moment.Moment | undefined;
    comentarios?: string | undefined;

    constructor(data?: ICitaCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pacienteId = _data["pacienteId"];
            this.salaId = _data["salaId"];
            this.maquinaId = _data["maquinaId"];
            this.turnoHospitalId = _data["turnoHospitalId"];
            this.diaSemana = _data["diaSemana"];
            this.fechaCita = _data["fechaCita"] ? moment(_data["fechaCita"].toString()) : <any>undefined;
            this.comentarios = _data["comentarios"];
        }
    }

    static fromJS(data: any): CitaCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CitaCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pacienteId"] = this.pacienteId;
        data["salaId"] = this.salaId;
        data["maquinaId"] = this.maquinaId;
        data["turnoHospitalId"] = this.turnoHospitalId;
        data["diaSemana"] = this.diaSemana;
        data["fechaCita"] = this.fechaCita ? this.fechaCita.toISOString() : <any>undefined;
        data["comentarios"] = this.comentarios;
        return data;
    }
}

export interface ICitaCreateCommand {
    id?: number | undefined;
    pacienteId?: number | undefined;
    salaId?: number | undefined;
    maquinaId?: number | undefined;
    turnoHospitalId?: number | undefined;
    diaSemana?: number | undefined;
    fechaCita?: moment.Moment | undefined;
    comentarios?: string | undefined;
}

export class CitaCancelarCommand implements ICitaCancelarCommand {
    citaId?: number | undefined;

    constructor(data?: ICitaCancelarCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.citaId = _data["citaId"];
        }
    }

    static fromJS(data: any): CitaCancelarCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CitaCancelarCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["citaId"] = this.citaId;
        return data;
    }
}

export interface ICitaCancelarCommand {
    citaId?: number | undefined;
}

export class CitaConfirmarCommand implements ICitaConfirmarCommand {
    citaId?: number | undefined;

    constructor(data?: ICitaConfirmarCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.citaId = _data["citaId"];
        }
    }

    static fromJS(data: any): CitaConfirmarCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CitaConfirmarCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["citaId"] = this.citaId;
        return data;
    }
}

export interface ICitaConfirmarCommand {
    citaId?: number | undefined;
}

export class CitasExportIMSSQuery extends PageListByDto implements ICitasExportIMSSQuery {
    fechaInicio?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    hospitalList?: number[] | undefined;
    salaId?: number | undefined;
    excluirCerradasYCanceladas!: boolean;
    maquinaId?: number | undefined;
    medicoAsignadoId?: number | undefined;
    pacienteId?: number | undefined;
    estatusId?: number | undefined;
    tipo!: number;

    constructor(data?: ICitasExportIMSSQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            if (Array.isArray(_data["hospitalList"])) {
                this.hospitalList = [] as any;
                for (let item of _data["hospitalList"])
                    this.hospitalList!.push(item);
            }
            this.salaId = _data["salaId"];
            this.excluirCerradasYCanceladas = _data["excluirCerradasYCanceladas"];
            this.maquinaId = _data["maquinaId"];
            this.medicoAsignadoId = _data["medicoAsignadoId"];
            this.pacienteId = _data["pacienteId"];
            this.estatusId = _data["estatusId"];
            this.tipo = _data["tipo"];
        }
    }

    static override fromJS(data: any): CitasExportIMSSQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CitasExportIMSSQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        if (Array.isArray(this.hospitalList)) {
            data["hospitalList"] = [];
            for (let item of this.hospitalList)
                data["hospitalList"].push(item);
        }
        data["salaId"] = this.salaId;
        data["excluirCerradasYCanceladas"] = this.excluirCerradasYCanceladas;
        data["maquinaId"] = this.maquinaId;
        data["medicoAsignadoId"] = this.medicoAsignadoId;
        data["pacienteId"] = this.pacienteId;
        data["estatusId"] = this.estatusId;
        data["tipo"] = this.tipo;
        super.toJSON(data);
        return data;
    }
}

export interface ICitasExportIMSSQuery extends IPageListByDto {
    fechaInicio?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    hospitalList?: number[] | undefined;
    salaId?: number | undefined;
    excluirCerradasYCanceladas: boolean;
    maquinaId?: number | undefined;
    medicoAsignadoId?: number | undefined;
    pacienteId?: number | undefined;
    estatusId?: number | undefined;
    tipo: number;
}

export class ConfiguracionUnidadResponse implements IConfiguracionUnidadResponse {
    id?: number | undefined;
    delegacionId?: number | undefined;
    delegacionDesc?: string | undefined;
    nombreUnidad?: string | undefined;
    hospitalLogoUUID?: string | undefined;
    identificadorAplicacion?: string | undefined;
    centralizacion?: string | undefined;
    urlWS?: string | undefined;
    usuarioWS?: string | undefined;
    passwordWS?: string | undefined;
    razonSocial?: string | undefined;
    domicilio?: string | undefined;
    tenantId?: number | undefined;

    constructor(data?: IConfiguracionUnidadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.delegacionId = _data["delegacionId"];
            this.delegacionDesc = _data["delegacionDesc"];
            this.nombreUnidad = _data["nombreUnidad"];
            this.hospitalLogoUUID = _data["hospitalLogoUUID"];
            this.identificadorAplicacion = _data["identificadorAplicacion"];
            this.centralizacion = _data["centralizacion"];
            this.urlWS = _data["urlWS"];
            this.usuarioWS = _data["usuarioWS"];
            this.passwordWS = _data["passwordWS"];
            this.razonSocial = _data["razonSocial"];
            this.domicilio = _data["domicilio"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): ConfiguracionUnidadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfiguracionUnidadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["delegacionId"] = this.delegacionId;
        data["delegacionDesc"] = this.delegacionDesc;
        data["nombreUnidad"] = this.nombreUnidad;
        data["hospitalLogoUUID"] = this.hospitalLogoUUID;
        data["identificadorAplicacion"] = this.identificadorAplicacion;
        data["centralizacion"] = this.centralizacion;
        data["urlWS"] = this.urlWS;
        data["usuarioWS"] = this.usuarioWS;
        data["passwordWS"] = this.passwordWS;
        data["razonSocial"] = this.razonSocial;
        data["domicilio"] = this.domicilio;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IConfiguracionUnidadResponse {
    id?: number | undefined;
    delegacionId?: number | undefined;
    delegacionDesc?: string | undefined;
    nombreUnidad?: string | undefined;
    hospitalLogoUUID?: string | undefined;
    identificadorAplicacion?: string | undefined;
    centralizacion?: string | undefined;
    urlWS?: string | undefined;
    usuarioWS?: string | undefined;
    passwordWS?: string | undefined;
    razonSocial?: string | undefined;
    domicilio?: string | undefined;
    tenantId?: number | undefined;
}

export class ConfiguracionUnidadCreateCommand implements IConfiguracionUnidadCreateCommand {
    delegacionId?: number | undefined;
    nombreUnidad?: string | undefined;
    hospitalLogoTempName?: string | undefined;
    identificadorAplicacion?: string | undefined;
    centralizacion?: string | undefined;
    urlWS?: string | undefined;
    usuarioWS?: string | undefined;
    passwordWS?: string | undefined;
    razonSocial?: string | undefined;
    domicilio?: string | undefined;

    constructor(data?: IConfiguracionUnidadCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.delegacionId = _data["delegacionId"];
            this.nombreUnidad = _data["nombreUnidad"];
            this.hospitalLogoTempName = _data["hospitalLogoTempName"];
            this.identificadorAplicacion = _data["identificadorAplicacion"];
            this.centralizacion = _data["centralizacion"];
            this.urlWS = _data["urlWS"];
            this.usuarioWS = _data["usuarioWS"];
            this.passwordWS = _data["passwordWS"];
            this.razonSocial = _data["razonSocial"];
            this.domicilio = _data["domicilio"];
        }
    }

    static fromJS(data: any): ConfiguracionUnidadCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConfiguracionUnidadCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delegacionId"] = this.delegacionId;
        data["nombreUnidad"] = this.nombreUnidad;
        data["hospitalLogoTempName"] = this.hospitalLogoTempName;
        data["identificadorAplicacion"] = this.identificadorAplicacion;
        data["centralizacion"] = this.centralizacion;
        data["urlWS"] = this.urlWS;
        data["usuarioWS"] = this.usuarioWS;
        data["passwordWS"] = this.passwordWS;
        data["razonSocial"] = this.razonSocial;
        data["domicilio"] = this.domicilio;
        return data;
    }
}

export interface IConfiguracionUnidadCreateCommand {
    delegacionId?: number | undefined;
    nombreUnidad?: string | undefined;
    hospitalLogoTempName?: string | undefined;
    identificadorAplicacion?: string | undefined;
    centralizacion?: string | undefined;
    urlWS?: string | undefined;
    usuarioWS?: string | undefined;
    passwordWS?: string | undefined;
    razonSocial?: string | undefined;
    domicilio?: string | undefined;
}

export class ConfiguracionUnidadHospitalResponse implements IConfiguracionUnidadHospitalResponse {
    id!: number;
    hospitalId!: number;
    hospitalName?: string | undefined;
    rfc?: string | undefined;
    contrato?: string | undefined;
    clavePresupuestal?: string | undefined;

    constructor(data?: IConfiguracionUnidadHospitalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hospitalId = _data["hospitalId"];
            this.hospitalName = _data["hospitalName"];
            this.rfc = _data["rfc"];
            this.contrato = _data["contrato"];
            this.clavePresupuestal = _data["clavePresupuestal"];
        }
    }

    static fromJS(data: any): ConfiguracionUnidadHospitalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfiguracionUnidadHospitalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hospitalId"] = this.hospitalId;
        data["hospitalName"] = this.hospitalName;
        data["rfc"] = this.rfc;
        data["contrato"] = this.contrato;
        data["clavePresupuestal"] = this.clavePresupuestal;
        return data;
    }
}

export interface IConfiguracionUnidadHospitalResponse {
    id: number;
    hospitalId: number;
    hospitalName?: string | undefined;
    rfc?: string | undefined;
    contrato?: string | undefined;
    clavePresupuestal?: string | undefined;
}

export class ConfiguracionUnidadHospitalCreateCommand implements IConfiguracionUnidadHospitalCreateCommand {
    configuracionUnidadId!: number;
    hospitalId?: number | undefined;

    constructor(data?: IConfiguracionUnidadHospitalCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configuracionUnidadId = _data["configuracionUnidadId"];
            this.hospitalId = _data["hospitalId"];
        }
    }

    static fromJS(data: any): ConfiguracionUnidadHospitalCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConfiguracionUnidadHospitalCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configuracionUnidadId"] = this.configuracionUnidadId;
        data["hospitalId"] = this.hospitalId;
        return data;
    }
}

export interface IConfiguracionUnidadHospitalCreateCommand {
    configuracionUnidadId: number;
    hospitalId?: number | undefined;
}

export class ConfiguracionUnidadHospitalDeleteCommand implements IConfiguracionUnidadHospitalDeleteCommand {
    id!: number;

    constructor(data?: IConfiguracionUnidadHospitalDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ConfiguracionUnidadHospitalDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConfiguracionUnidadHospitalDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IConfiguracionUnidadHospitalDeleteCommand {
    id: number;
}

export class ControlEstatusMaquinaResponse implements IControlEstatusMaquinaResponse {
    id!: number;
    maquinaId!: number;
    maquinaDesc?: string | undefined;
    salaId!: number;
    salaDesc?: string | undefined;
    estatusMaquinaId!: number;
    estatusMaquinaDesc?: string | undefined;
    fechaInicio!: moment.Moment;
    fechaFin?: moment.Moment | undefined;
    observaciones?: string | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;

    constructor(data?: IControlEstatusMaquinaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.maquinaId = _data["maquinaId"];
            this.maquinaDesc = _data["maquinaDesc"];
            this.salaId = _data["salaId"];
            this.salaDesc = _data["salaDesc"];
            this.estatusMaquinaId = _data["estatusMaquinaId"];
            this.estatusMaquinaDesc = _data["estatusMaquinaDesc"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.observaciones = _data["observaciones"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ControlEstatusMaquinaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ControlEstatusMaquinaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["maquinaId"] = this.maquinaId;
        data["maquinaDesc"] = this.maquinaDesc;
        data["salaId"] = this.salaId;
        data["salaDesc"] = this.salaDesc;
        data["estatusMaquinaId"] = this.estatusMaquinaId;
        data["estatusMaquinaDesc"] = this.estatusMaquinaDesc;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["observaciones"] = this.observaciones;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IControlEstatusMaquinaResponse {
    id: number;
    maquinaId: number;
    maquinaDesc?: string | undefined;
    salaId: number;
    salaDesc?: string | undefined;
    estatusMaquinaId: number;
    estatusMaquinaDesc?: string | undefined;
    fechaInicio: moment.Moment;
    fechaFin?: moment.Moment | undefined;
    observaciones?: string | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
}

export class ControlEstatusMaquinaGetByIdQuery implements IControlEstatusMaquinaGetByIdQuery {
    id!: number;

    constructor(data?: IControlEstatusMaquinaGetByIdQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ControlEstatusMaquinaGetByIdQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ControlEstatusMaquinaGetByIdQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IControlEstatusMaquinaGetByIdQuery {
    id: number;
}

export class ControlEstatusMaquinaGetActivoByMaquinaIdQuery implements IControlEstatusMaquinaGetActivoByMaquinaIdQuery {
    pacienteId!: number;

    constructor(data?: IControlEstatusMaquinaGetActivoByMaquinaIdQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
        }
    }

    static fromJS(data: any): ControlEstatusMaquinaGetActivoByMaquinaIdQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ControlEstatusMaquinaGetActivoByMaquinaIdQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        return data;
    }
}

export interface IControlEstatusMaquinaGetActivoByMaquinaIdQuery {
    pacienteId: number;
}

export class PagedResultDtoOfControlEstatusMaquinaForListResponse implements IPagedResultDtoOfControlEstatusMaquinaForListResponse {
    totalCount!: number;
    items?: ControlEstatusMaquinaForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfControlEstatusMaquinaForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ControlEstatusMaquinaForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfControlEstatusMaquinaForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfControlEstatusMaquinaForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfControlEstatusMaquinaForListResponse {
    totalCount: number;
    items?: ControlEstatusMaquinaForListResponse[] | undefined;
}

export class ControlEstatusMaquinaForListResponse implements IControlEstatusMaquinaForListResponse {
    id!: number;
    maquinaId!: number;
    maquinaDesc?: string | undefined;
    salaId!: number;
    salaDesc?: string | undefined;
    estatusMaquinaId!: number;
    estatusMaquinaDesc?: string | undefined;
    fechaInicio!: moment.Moment;
    fechaFin?: moment.Moment | undefined;
    observaciones?: string | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;

    constructor(data?: IControlEstatusMaquinaForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.maquinaId = _data["maquinaId"];
            this.maquinaDesc = _data["maquinaDesc"];
            this.salaId = _data["salaId"];
            this.salaDesc = _data["salaDesc"];
            this.estatusMaquinaId = _data["estatusMaquinaId"];
            this.estatusMaquinaDesc = _data["estatusMaquinaDesc"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.observaciones = _data["observaciones"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ControlEstatusMaquinaForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ControlEstatusMaquinaForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["maquinaId"] = this.maquinaId;
        data["maquinaDesc"] = this.maquinaDesc;
        data["salaId"] = this.salaId;
        data["salaDesc"] = this.salaDesc;
        data["estatusMaquinaId"] = this.estatusMaquinaId;
        data["estatusMaquinaDesc"] = this.estatusMaquinaDesc;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["observaciones"] = this.observaciones;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IControlEstatusMaquinaForListResponse {
    id: number;
    maquinaId: number;
    maquinaDesc?: string | undefined;
    salaId: number;
    salaDesc?: string | undefined;
    estatusMaquinaId: number;
    estatusMaquinaDesc?: string | undefined;
    fechaInicio: moment.Moment;
    fechaFin?: moment.Moment | undefined;
    observaciones?: string | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
}

export class ControlEstatusMaquinaGetListQuery extends PageListByDto implements IControlEstatusMaquinaGetListQuery {
    salaId?: number | undefined;
    maquinaId?: number | undefined;

    constructor(data?: IControlEstatusMaquinaGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.salaId = _data["salaId"];
            this.maquinaId = _data["maquinaId"];
        }
    }

    static override fromJS(data: any): ControlEstatusMaquinaGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ControlEstatusMaquinaGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salaId"] = this.salaId;
        data["maquinaId"] = this.maquinaId;
        super.toJSON(data);
        return data;
    }
}

export interface IControlEstatusMaquinaGetListQuery extends IPageListByDto {
    salaId?: number | undefined;
    maquinaId?: number | undefined;
}

export class ControlEstatusMaquinaCreateCommand implements IControlEstatusMaquinaCreateCommand {
    fechaInicio?: moment.Moment | undefined;
    salaId?: number | undefined;
    maquinaId?: number | undefined;
    estatusId?: number | undefined;
    observaciones?: string | undefined;

    constructor(data?: IControlEstatusMaquinaCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.salaId = _data["salaId"];
            this.maquinaId = _data["maquinaId"];
            this.estatusId = _data["estatusId"];
            this.observaciones = _data["observaciones"];
        }
    }

    static fromJS(data: any): ControlEstatusMaquinaCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ControlEstatusMaquinaCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["salaId"] = this.salaId;
        data["maquinaId"] = this.maquinaId;
        data["estatusId"] = this.estatusId;
        data["observaciones"] = this.observaciones;
        return data;
    }
}

export interface IControlEstatusMaquinaCreateCommand {
    fechaInicio?: moment.Moment | undefined;
    salaId?: number | undefined;
    maquinaId?: number | undefined;
    estatusId?: number | undefined;
    observaciones?: string | undefined;
}

export class ControlEstatusPacienteResponse implements IControlEstatusPacienteResponse {
    id!: number;
    pacienteId!: number;
    nombrePaciente?: string | undefined;
    medicoId!: number;
    nombreMedico?: string | undefined;
    estatusId!: number;
    estatusDesc?: string | undefined;
    estatusCodigo?: string | undefined;
    diagnosticoPrincipalId!: number;
    diagnosticoPrincipalDesc?: string | undefined;
    estatusEgresoId?: number | undefined;
    estatusEgresoDesc?: string | undefined;
    estatusEgresoCodigo?: string | undefined;
    diagnosticoSecundarioId?: number | undefined;
    diagnosticoSecundarioDesc?: string | undefined;
    fechaTRS?: moment.Moment | undefined;
    fechaUltimoInforme?: moment.Moment | undefined;
    complementoDiagnosticoPrincipal?: string | undefined;
    complementoDiagnosticoSecundario?: string | undefined;
    observaciones?: string | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;
    diasDuracion!: number;
    duracionDesc?: string | undefined;

    constructor(data?: IControlEstatusPacienteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pacienteId = _data["pacienteId"];
            this.nombrePaciente = _data["nombrePaciente"];
            this.medicoId = _data["medicoId"];
            this.nombreMedico = _data["nombreMedico"];
            this.estatusId = _data["estatusId"];
            this.estatusDesc = _data["estatusDesc"];
            this.estatusCodigo = _data["estatusCodigo"];
            this.diagnosticoPrincipalId = _data["diagnosticoPrincipalId"];
            this.diagnosticoPrincipalDesc = _data["diagnosticoPrincipalDesc"];
            this.estatusEgresoId = _data["estatusEgresoId"];
            this.estatusEgresoDesc = _data["estatusEgresoDesc"];
            this.estatusEgresoCodigo = _data["estatusEgresoCodigo"];
            this.diagnosticoSecundarioId = _data["diagnosticoSecundarioId"];
            this.diagnosticoSecundarioDesc = _data["diagnosticoSecundarioDesc"];
            this.fechaTRS = _data["fechaTRS"] ? moment(_data["fechaTRS"].toString()) : <any>undefined;
            this.fechaUltimoInforme = _data["fechaUltimoInforme"] ? moment(_data["fechaUltimoInforme"].toString()) : <any>undefined;
            this.complementoDiagnosticoPrincipal = _data["complementoDiagnosticoPrincipal"];
            this.complementoDiagnosticoSecundario = _data["complementoDiagnosticoSecundario"];
            this.observaciones = _data["observaciones"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.diasDuracion = _data["diasDuracion"];
            this.duracionDesc = _data["duracionDesc"];
        }
    }

    static fromJS(data: any): ControlEstatusPacienteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ControlEstatusPacienteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pacienteId"] = this.pacienteId;
        data["nombrePaciente"] = this.nombrePaciente;
        data["medicoId"] = this.medicoId;
        data["nombreMedico"] = this.nombreMedico;
        data["estatusId"] = this.estatusId;
        data["estatusDesc"] = this.estatusDesc;
        data["estatusCodigo"] = this.estatusCodigo;
        data["diagnosticoPrincipalId"] = this.diagnosticoPrincipalId;
        data["diagnosticoPrincipalDesc"] = this.diagnosticoPrincipalDesc;
        data["estatusEgresoId"] = this.estatusEgresoId;
        data["estatusEgresoDesc"] = this.estatusEgresoDesc;
        data["estatusEgresoCodigo"] = this.estatusEgresoCodigo;
        data["diagnosticoSecundarioId"] = this.diagnosticoSecundarioId;
        data["diagnosticoSecundarioDesc"] = this.diagnosticoSecundarioDesc;
        data["fechaTRS"] = this.fechaTRS ? this.fechaTRS.toISOString() : <any>undefined;
        data["fechaUltimoInforme"] = this.fechaUltimoInforme ? this.fechaUltimoInforme.toISOString() : <any>undefined;
        data["complementoDiagnosticoPrincipal"] = this.complementoDiagnosticoPrincipal;
        data["complementoDiagnosticoSecundario"] = this.complementoDiagnosticoSecundario;
        data["observaciones"] = this.observaciones;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["diasDuracion"] = this.diasDuracion;
        data["duracionDesc"] = this.duracionDesc;
        return data;
    }
}

export interface IControlEstatusPacienteResponse {
    id: number;
    pacienteId: number;
    nombrePaciente?: string | undefined;
    medicoId: number;
    nombreMedico?: string | undefined;
    estatusId: number;
    estatusDesc?: string | undefined;
    estatusCodigo?: string | undefined;
    diagnosticoPrincipalId: number;
    diagnosticoPrincipalDesc?: string | undefined;
    estatusEgresoId?: number | undefined;
    estatusEgresoDesc?: string | undefined;
    estatusEgresoCodigo?: string | undefined;
    diagnosticoSecundarioId?: number | undefined;
    diagnosticoSecundarioDesc?: string | undefined;
    fechaTRS?: moment.Moment | undefined;
    fechaUltimoInforme?: moment.Moment | undefined;
    complementoDiagnosticoPrincipal?: string | undefined;
    complementoDiagnosticoSecundario?: string | undefined;
    observaciones?: string | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
    diasDuracion: number;
    duracionDesc?: string | undefined;
}

export class ControlEstatusGetByIdQuery implements IControlEstatusGetByIdQuery {
    id!: number;

    constructor(data?: IControlEstatusGetByIdQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ControlEstatusGetByIdQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ControlEstatusGetByIdQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IControlEstatusGetByIdQuery {
    id: number;
}

export class ControlEstatusGetAcftivoByPacienteIdQuery implements IControlEstatusGetAcftivoByPacienteIdQuery {
    pacienteId!: number;

    constructor(data?: IControlEstatusGetAcftivoByPacienteIdQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
        }
    }

    static fromJS(data: any): ControlEstatusGetAcftivoByPacienteIdQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ControlEstatusGetAcftivoByPacienteIdQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        return data;
    }
}

export interface IControlEstatusGetAcftivoByPacienteIdQuery {
    pacienteId: number;
}

export class ControlEstatusForListResponse implements IControlEstatusForListResponse {
    id!: number;
    fechaInicio?: moment.Moment | undefined;
    estatusId!: number;
    estatusDesc?: string | undefined;
    diasDuracion!: number;
    isActive!: boolean;
    duracionDesc?: string | undefined;

    constructor(data?: IControlEstatusForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.estatusId = _data["estatusId"];
            this.estatusDesc = _data["estatusDesc"];
            this.diasDuracion = _data["diasDuracion"];
            this.isActive = _data["isActive"];
            this.duracionDesc = _data["duracionDesc"];
        }
    }

    static fromJS(data: any): ControlEstatusForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ControlEstatusForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["estatusId"] = this.estatusId;
        data["estatusDesc"] = this.estatusDesc;
        data["diasDuracion"] = this.diasDuracion;
        data["isActive"] = this.isActive;
        data["duracionDesc"] = this.duracionDesc;
        return data;
    }
}

export interface IControlEstatusForListResponse {
    id: number;
    fechaInicio?: moment.Moment | undefined;
    estatusId: number;
    estatusDesc?: string | undefined;
    diasDuracion: number;
    isActive: boolean;
    duracionDesc?: string | undefined;
}

export class ControlEstatusGetListQuery implements IControlEstatusGetListQuery {
    pacienteId!: number;

    constructor(data?: IControlEstatusGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
        }
    }

    static fromJS(data: any): ControlEstatusGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ControlEstatusGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        return data;
    }
}

export interface IControlEstatusGetListQuery {
    pacienteId: number;
}

export class ControlEstatusCreateCommand implements IControlEstatusCreateCommand {
    fechaInicio?: moment.Moment | undefined;
    pacienteId?: number | undefined;
    medicoId?: number | undefined;
    estatusId?: number | undefined;
    diagnosticoPrincipalId?: number | undefined;
    diagnosticoSecundarioId?: number | undefined;
    complementoDiagnosticoPrincipal?: string | undefined;
    complementoDiagnosticoSecundario?: string | undefined;
    observaciones?: string | undefined;

    constructor(data?: IControlEstatusCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.medicoId = _data["medicoId"];
            this.estatusId = _data["estatusId"];
            this.diagnosticoPrincipalId = _data["diagnosticoPrincipalId"];
            this.diagnosticoSecundarioId = _data["diagnosticoSecundarioId"];
            this.complementoDiagnosticoPrincipal = _data["complementoDiagnosticoPrincipal"];
            this.complementoDiagnosticoSecundario = _data["complementoDiagnosticoSecundario"];
            this.observaciones = _data["observaciones"];
        }
    }

    static fromJS(data: any): ControlEstatusCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ControlEstatusCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["medicoId"] = this.medicoId;
        data["estatusId"] = this.estatusId;
        data["diagnosticoPrincipalId"] = this.diagnosticoPrincipalId;
        data["diagnosticoSecundarioId"] = this.diagnosticoSecundarioId;
        data["complementoDiagnosticoPrincipal"] = this.complementoDiagnosticoPrincipal;
        data["complementoDiagnosticoSecundario"] = this.complementoDiagnosticoSecundario;
        data["observaciones"] = this.observaciones;
        return data;
    }
}

export interface IControlEstatusCreateCommand {
    fechaInicio?: moment.Moment | undefined;
    pacienteId?: number | undefined;
    medicoId?: number | undefined;
    estatusId?: number | undefined;
    diagnosticoPrincipalId?: number | undefined;
    diagnosticoSecundarioId?: number | undefined;
    complementoDiagnosticoPrincipal?: string | undefined;
    complementoDiagnosticoSecundario?: string | undefined;
    observaciones?: string | undefined;
}

export class PagedResultDtoOfEstudioPacienteForListResponse implements IPagedResultDtoOfEstudioPacienteForListResponse {
    totalCount!: number;
    items?: EstudioPacienteForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfEstudioPacienteForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EstudioPacienteForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEstudioPacienteForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEstudioPacienteForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfEstudioPacienteForListResponse {
    totalCount: number;
    items?: EstudioPacienteForListResponse[] | undefined;
}

export class EstudioPacienteForListResponse implements IEstudioPacienteForListResponse {
    id!: number;
    pacienteId!: number;
    nombrePaciente?: string | undefined;
    tipoEstudioId!: number;
    tipoEstudio?: string | undefined;
    fechaEstudio!: moment.Moment;
    horaEstudio!: moment.Duration;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;
    detallesList?: EstudioPacienteDetalleResponse[] | undefined;

    constructor(data?: IEstudioPacienteForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pacienteId = _data["pacienteId"];
            this.nombrePaciente = _data["nombrePaciente"];
            this.tipoEstudioId = _data["tipoEstudioId"];
            this.tipoEstudio = _data["tipoEstudio"];
            this.fechaEstudio = _data["fechaEstudio"] ? moment(_data["fechaEstudio"].toString()) : <any>undefined;
            this.horaEstudio = _data["horaEstudio"] ? moment.duration(_data["horaEstudio"].toString()) : <any>undefined;
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["detallesList"])) {
                this.detallesList = [] as any;
                for (let item of _data["detallesList"])
                    this.detallesList!.push(EstudioPacienteDetalleResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EstudioPacienteForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EstudioPacienteForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pacienteId"] = this.pacienteId;
        data["nombrePaciente"] = this.nombrePaciente;
        data["tipoEstudioId"] = this.tipoEstudioId;
        data["tipoEstudio"] = this.tipoEstudio;
        data["fechaEstudio"] = this.fechaEstudio ? this.fechaEstudio.toISOString() : <any>undefined;
        data["horaEstudio"] = this.horaEstudio ? this.horaEstudio.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.detallesList)) {
            data["detallesList"] = [];
            for (let item of this.detallesList)
                data["detallesList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEstudioPacienteForListResponse {
    id: number;
    pacienteId: number;
    nombrePaciente?: string | undefined;
    tipoEstudioId: number;
    tipoEstudio?: string | undefined;
    fechaEstudio: moment.Moment;
    horaEstudio: moment.Duration;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
    detallesList?: EstudioPacienteDetalleResponse[] | undefined;
}

export class EstudioPacienteDetalleResponse implements IEstudioPacienteDetalleResponse {
    id?: number | undefined;
    estudioPacienteId?: number | undefined;
    pruebaEstudioId?: number | undefined;
    pruebaEstudioDesc?: string | undefined;
    tipoPruebaId?: number | undefined;
    tipoPruebaDesc?: string | undefined;
    estudioId?: number | undefined;
    estudioDesc?: string | undefined;
    claveLOINC?: string | undefined;
    periodicidad?: string | undefined;
    minimo?: number | undefined;
    maximo?: number | undefined;
    valor?: string | undefined;
    observaciones?: string | undefined;
    fechaAlta?: moment.Moment | undefined;
    fechaModificacion?: moment.Moment | undefined;

    constructor(data?: IEstudioPacienteDetalleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.estudioPacienteId = _data["estudioPacienteId"];
            this.pruebaEstudioId = _data["pruebaEstudioId"];
            this.pruebaEstudioDesc = _data["pruebaEstudioDesc"];
            this.tipoPruebaId = _data["tipoPruebaId"];
            this.tipoPruebaDesc = _data["tipoPruebaDesc"];
            this.estudioId = _data["estudioId"];
            this.estudioDesc = _data["estudioDesc"];
            this.claveLOINC = _data["claveLOINC"];
            this.periodicidad = _data["periodicidad"];
            this.minimo = _data["minimo"];
            this.maximo = _data["maximo"];
            this.valor = _data["valor"];
            this.observaciones = _data["observaciones"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EstudioPacienteDetalleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EstudioPacienteDetalleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["estudioPacienteId"] = this.estudioPacienteId;
        data["pruebaEstudioId"] = this.pruebaEstudioId;
        data["pruebaEstudioDesc"] = this.pruebaEstudioDesc;
        data["tipoPruebaId"] = this.tipoPruebaId;
        data["tipoPruebaDesc"] = this.tipoPruebaDesc;
        data["estudioId"] = this.estudioId;
        data["estudioDesc"] = this.estudioDesc;
        data["claveLOINC"] = this.claveLOINC;
        data["periodicidad"] = this.periodicidad;
        data["minimo"] = this.minimo;
        data["maximo"] = this.maximo;
        data["valor"] = this.valor;
        data["observaciones"] = this.observaciones;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEstudioPacienteDetalleResponse {
    id?: number | undefined;
    estudioPacienteId?: number | undefined;
    pruebaEstudioId?: number | undefined;
    pruebaEstudioDesc?: string | undefined;
    tipoPruebaId?: number | undefined;
    tipoPruebaDesc?: string | undefined;
    estudioId?: number | undefined;
    estudioDesc?: string | undefined;
    claveLOINC?: string | undefined;
    periodicidad?: string | undefined;
    minimo?: number | undefined;
    maximo?: number | undefined;
    valor?: string | undefined;
    observaciones?: string | undefined;
    fechaAlta?: moment.Moment | undefined;
    fechaModificacion?: moment.Moment | undefined;
}

export class EstudiosPacientesGetListQuery extends PageListByDto implements IEstudiosPacientesGetListQuery {
    pacienteId?: number | undefined;

    constructor(data?: IEstudiosPacientesGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pacienteId = _data["pacienteId"];
        }
    }

    static override fromJS(data: any): EstudiosPacientesGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new EstudiosPacientesGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        super.toJSON(data);
        return data;
    }
}

export interface IEstudiosPacientesGetListQuery extends IPageListByDto {
    pacienteId?: number | undefined;
}

export class EstudioPacienteResponse implements IEstudioPacienteResponse {
    id!: number;
    pacienteId!: number;
    nombrePaciente?: string | undefined;
    tipoEstudioId!: number;
    tipoEstudioDesc?: string | undefined;
    fechaEstudio!: moment.Moment;
    horaEstudio!: moment.Duration;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;
    detallesList?: EstudioPacienteDetalleResponse[] | undefined;

    constructor(data?: IEstudioPacienteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pacienteId = _data["pacienteId"];
            this.nombrePaciente = _data["nombrePaciente"];
            this.tipoEstudioId = _data["tipoEstudioId"];
            this.tipoEstudioDesc = _data["tipoEstudioDesc"];
            this.fechaEstudio = _data["fechaEstudio"] ? moment(_data["fechaEstudio"].toString()) : <any>undefined;
            this.horaEstudio = _data["horaEstudio"] ? moment.duration(_data["horaEstudio"].toString()) : <any>undefined;
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["detallesList"])) {
                this.detallesList = [] as any;
                for (let item of _data["detallesList"])
                    this.detallesList!.push(EstudioPacienteDetalleResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EstudioPacienteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EstudioPacienteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pacienteId"] = this.pacienteId;
        data["nombrePaciente"] = this.nombrePaciente;
        data["tipoEstudioId"] = this.tipoEstudioId;
        data["tipoEstudioDesc"] = this.tipoEstudioDesc;
        data["fechaEstudio"] = this.fechaEstudio ? this.fechaEstudio.toISOString() : <any>undefined;
        data["horaEstudio"] = this.horaEstudio ? this.horaEstudio.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.detallesList)) {
            data["detallesList"] = [];
            for (let item of this.detallesList)
                data["detallesList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEstudioPacienteResponse {
    id: number;
    pacienteId: number;
    nombrePaciente?: string | undefined;
    tipoEstudioId: number;
    tipoEstudioDesc?: string | undefined;
    fechaEstudio: moment.Moment;
    horaEstudio: moment.Duration;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
    detallesList?: EstudioPacienteDetalleResponse[] | undefined;
}

export class EstudiosPacientesGetByIdQuery implements IEstudiosPacientesGetByIdQuery {
    id?: number | undefined;

    constructor(data?: IEstudiosPacientesGetByIdQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EstudiosPacientesGetByIdQuery {
        data = typeof data === 'object' ? data : {};
        let result = new EstudiosPacientesGetByIdQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEstudiosPacientesGetByIdQuery {
    id?: number | undefined;
}

export class EstudiosPacientesGetByTipoYFechaQuery implements IEstudiosPacientesGetByTipoYFechaQuery {
    pacienteId?: number | undefined;
    tipoEstudioId?: number | undefined;
    fechaEstudio?: moment.Moment | undefined;

    constructor(data?: IEstudiosPacientesGetByTipoYFechaQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
            this.tipoEstudioId = _data["tipoEstudioId"];
            this.fechaEstudio = _data["fechaEstudio"] ? moment(_data["fechaEstudio"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EstudiosPacientesGetByTipoYFechaQuery {
        data = typeof data === 'object' ? data : {};
        let result = new EstudiosPacientesGetByTipoYFechaQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        data["tipoEstudioId"] = this.tipoEstudioId;
        data["fechaEstudio"] = this.fechaEstudio ? this.fechaEstudio.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEstudiosPacientesGetByTipoYFechaQuery {
    pacienteId?: number | undefined;
    tipoEstudioId?: number | undefined;
    fechaEstudio?: moment.Moment | undefined;
}

export class EstudioPacienteCreateOrUpdateCommand implements IEstudioPacienteCreateOrUpdateCommand {
    id?: number | undefined;
    pacienteId?: number | undefined;
    tipoEstudioId?: number | undefined;
    fechaEstudio?: moment.Moment | undefined;
    horaEstudio?: moment.Duration | undefined;
    detallesList?: EstudioPacienteDetalleResponse[] | undefined;

    constructor(data?: IEstudioPacienteCreateOrUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pacienteId = _data["pacienteId"];
            this.tipoEstudioId = _data["tipoEstudioId"];
            this.fechaEstudio = _data["fechaEstudio"] ? moment(_data["fechaEstudio"].toString()) : <any>undefined;
            this.horaEstudio = _data["horaEstudio"] ? moment.duration(_data["horaEstudio"].toString()) : <any>undefined;
            if (Array.isArray(_data["detallesList"])) {
                this.detallesList = [] as any;
                for (let item of _data["detallesList"])
                    this.detallesList!.push(EstudioPacienteDetalleResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EstudioPacienteCreateOrUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EstudioPacienteCreateOrUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pacienteId"] = this.pacienteId;
        data["tipoEstudioId"] = this.tipoEstudioId;
        data["fechaEstudio"] = this.fechaEstudio ? this.fechaEstudio.toISOString() : <any>undefined;
        data["horaEstudio"] = this.horaEstudio ? this.horaEstudio.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        if (Array.isArray(this.detallesList)) {
            data["detallesList"] = [];
            for (let item of this.detallesList)
                data["detallesList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEstudioPacienteCreateOrUpdateCommand {
    id?: number | undefined;
    pacienteId?: number | undefined;
    tipoEstudioId?: number | undefined;
    fechaEstudio?: moment.Moment | undefined;
    horaEstudio?: moment.Duration | undefined;
    detallesList?: EstudioPacienteDetalleResponse[] | undefined;
}

export class EstudiosPacientesGetPruebasListQuery implements IEstudiosPacientesGetPruebasListQuery {

    constructor(data?: IEstudiosPacientesGetPruebasListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): EstudiosPacientesGetPruebasListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new EstudiosPacientesGetPruebasListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IEstudiosPacientesGetPruebasListQuery {
}

export class EstudioPacienteImportarResultDto implements IEstudioPacienteImportarResultDto {
    orden?: string | undefined;
    idsair?: string | undefined;
    nombreCompleto?: string | undefined;
    codigo!: number;
    mensaje?: string | undefined;

    constructor(data?: IEstudioPacienteImportarResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orden = _data["orden"];
            this.idsair = _data["idsair"];
            this.nombreCompleto = _data["nombreCompleto"];
            this.codigo = _data["codigo"];
            this.mensaje = _data["mensaje"];
        }
    }

    static fromJS(data: any): EstudioPacienteImportarResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EstudioPacienteImportarResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orden"] = this.orden;
        data["idsair"] = this.idsair;
        data["nombreCompleto"] = this.nombreCompleto;
        data["codigo"] = this.codigo;
        data["mensaje"] = this.mensaje;
        return data;
    }
}

export interface IEstudioPacienteImportarResultDto {
    orden?: string | undefined;
    idsair?: string | undefined;
    nombreCompleto?: string | undefined;
    codigo: number;
    mensaje?: string | undefined;
}

export class EstudioPacienteImportCommand implements IEstudioPacienteImportCommand {
    tipoEstudioId!: number;
    tempFileName?: string | undefined;

    constructor(data?: IEstudioPacienteImportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoEstudioId = _data["tipoEstudioId"];
            this.tempFileName = _data["tempFileName"];
        }
    }

    static fromJS(data: any): EstudioPacienteImportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EstudioPacienteImportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoEstudioId"] = this.tipoEstudioId;
        data["tempFileName"] = this.tempFileName;
        return data;
    }
}

export interface IEstudioPacienteImportCommand {
    tipoEstudioId: number;
    tempFileName?: string | undefined;
}

export class PagedResultDtoOfEvolucionMedicaForListResponse implements IPagedResultDtoOfEvolucionMedicaForListResponse {
    totalCount!: number;
    items?: EvolucionMedicaForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfEvolucionMedicaForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EvolucionMedicaForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEvolucionMedicaForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEvolucionMedicaForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfEvolucionMedicaForListResponse {
    totalCount: number;
    items?: EvolucionMedicaForListResponse[] | undefined;
}

export class EvolucionMedicaForListResponse implements IEvolucionMedicaForListResponse {
    id!: number;
    anio!: number;
    mes!: number;
    mesDesc?: string | undefined;
    fechaGeneracion?: moment.Moment | undefined;
    protocoloTransplante?: string | undefined;
    fechaNota?: moment.Moment | undefined;

    constructor(data?: IEvolucionMedicaForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.anio = _data["anio"];
            this.mes = _data["mes"];
            this.mesDesc = _data["mesDesc"];
            this.fechaGeneracion = _data["fechaGeneracion"] ? moment(_data["fechaGeneracion"].toString()) : <any>undefined;
            this.protocoloTransplante = _data["protocoloTransplante"];
            this.fechaNota = _data["fechaNota"] ? moment(_data["fechaNota"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EvolucionMedicaForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EvolucionMedicaForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["anio"] = this.anio;
        data["mes"] = this.mes;
        data["mesDesc"] = this.mesDesc;
        data["fechaGeneracion"] = this.fechaGeneracion ? this.fechaGeneracion.toISOString() : <any>undefined;
        data["protocoloTransplante"] = this.protocoloTransplante;
        data["fechaNota"] = this.fechaNota ? this.fechaNota.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEvolucionMedicaForListResponse {
    id: number;
    anio: number;
    mes: number;
    mesDesc?: string | undefined;
    fechaGeneracion?: moment.Moment | undefined;
    protocoloTransplante?: string | undefined;
    fechaNota?: moment.Moment | undefined;
}

export class EvolucionMedicaGetListQuery extends PageListByDto implements IEvolucionMedicaGetListQuery {
    paciente?: number | undefined;

    constructor(data?: IEvolucionMedicaGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.paciente = _data["paciente"];
        }
    }

    static override fromJS(data: any): EvolucionMedicaGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new EvolucionMedicaGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paciente"] = this.paciente;
        super.toJSON(data);
        return data;
    }
}

export interface IEvolucionMedicaGetListQuery extends IPageListByDto {
    paciente?: number | undefined;
}

export class EvolucionMedicaForEditResponse implements IEvolucionMedicaForEditResponse {
    id?: number | undefined;
    anio?: number | undefined;
    mes?: number | undefined;
    fechaNota?: moment.Moment | undefined;
    fechaGeneracion?: moment.Moment | undefined;
    gananciaInterdialitica?: number | undefined;
    ktv?: number | undefined;
    urr?: number | undefined;
    protocoloTransplante?: string | undefined;
    isVacunaNeomococo!: boolean;
    vacunaNeomococoFecha?: moment.Moment | undefined;
    isVacunaInfluenza!: boolean;
    vacunaInfluenzaFecha?: moment.Moment | undefined;
    isVacunaHepatitis!: boolean;
    vacunaHepatitisFecha?: moment.Moment | undefined;
    ta?: string | undefined;
    fc?: string | undefined;
    fr?: string | undefined;
    temperatura?: string | undefined;
    resumen?: string | undefined;
    anioCombo?: ComboboxItemDtoOfInteger[] | undefined;
    mesCombo?: ComboboxItemDtoOfInteger[] | undefined;

    constructor(data?: IEvolucionMedicaForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.anio = _data["anio"];
            this.mes = _data["mes"];
            this.fechaNota = _data["fechaNota"] ? moment(_data["fechaNota"].toString()) : <any>undefined;
            this.fechaGeneracion = _data["fechaGeneracion"] ? moment(_data["fechaGeneracion"].toString()) : <any>undefined;
            this.gananciaInterdialitica = _data["gananciaInterdialitica"];
            this.ktv = _data["ktv"];
            this.urr = _data["urr"];
            this.protocoloTransplante = _data["protocoloTransplante"];
            this.isVacunaNeomococo = _data["isVacunaNeomococo"];
            this.vacunaNeomococoFecha = _data["vacunaNeomococoFecha"] ? moment(_data["vacunaNeomococoFecha"].toString()) : <any>undefined;
            this.isVacunaInfluenza = _data["isVacunaInfluenza"];
            this.vacunaInfluenzaFecha = _data["vacunaInfluenzaFecha"] ? moment(_data["vacunaInfluenzaFecha"].toString()) : <any>undefined;
            this.isVacunaHepatitis = _data["isVacunaHepatitis"];
            this.vacunaHepatitisFecha = _data["vacunaHepatitisFecha"] ? moment(_data["vacunaHepatitisFecha"].toString()) : <any>undefined;
            this.ta = _data["ta"];
            this.fc = _data["fc"];
            this.fr = _data["fr"];
            this.temperatura = _data["temperatura"];
            this.resumen = _data["resumen"];
            if (Array.isArray(_data["anioCombo"])) {
                this.anioCombo = [] as any;
                for (let item of _data["anioCombo"])
                    this.anioCombo!.push(ComboboxItemDtoOfInteger.fromJS(item));
            }
            if (Array.isArray(_data["mesCombo"])) {
                this.mesCombo = [] as any;
                for (let item of _data["mesCombo"])
                    this.mesCombo!.push(ComboboxItemDtoOfInteger.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EvolucionMedicaForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EvolucionMedicaForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["anio"] = this.anio;
        data["mes"] = this.mes;
        data["fechaNota"] = this.fechaNota ? this.fechaNota.toISOString() : <any>undefined;
        data["fechaGeneracion"] = this.fechaGeneracion ? this.fechaGeneracion.toISOString() : <any>undefined;
        data["gananciaInterdialitica"] = this.gananciaInterdialitica;
        data["ktv"] = this.ktv;
        data["urr"] = this.urr;
        data["protocoloTransplante"] = this.protocoloTransplante;
        data["isVacunaNeomococo"] = this.isVacunaNeomococo;
        data["vacunaNeomococoFecha"] = this.vacunaNeomococoFecha ? this.vacunaNeomococoFecha.toISOString() : <any>undefined;
        data["isVacunaInfluenza"] = this.isVacunaInfluenza;
        data["vacunaInfluenzaFecha"] = this.vacunaInfluenzaFecha ? this.vacunaInfluenzaFecha.toISOString() : <any>undefined;
        data["isVacunaHepatitis"] = this.isVacunaHepatitis;
        data["vacunaHepatitisFecha"] = this.vacunaHepatitisFecha ? this.vacunaHepatitisFecha.toISOString() : <any>undefined;
        data["ta"] = this.ta;
        data["fc"] = this.fc;
        data["fr"] = this.fr;
        data["temperatura"] = this.temperatura;
        data["resumen"] = this.resumen;
        if (Array.isArray(this.anioCombo)) {
            data["anioCombo"] = [];
            for (let item of this.anioCombo)
                data["anioCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.mesCombo)) {
            data["mesCombo"] = [];
            for (let item of this.mesCombo)
                data["mesCombo"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEvolucionMedicaForEditResponse {
    id?: number | undefined;
    anio?: number | undefined;
    mes?: number | undefined;
    fechaNota?: moment.Moment | undefined;
    fechaGeneracion?: moment.Moment | undefined;
    gananciaInterdialitica?: number | undefined;
    ktv?: number | undefined;
    urr?: number | undefined;
    protocoloTransplante?: string | undefined;
    isVacunaNeomococo: boolean;
    vacunaNeomococoFecha?: moment.Moment | undefined;
    isVacunaInfluenza: boolean;
    vacunaInfluenzaFecha?: moment.Moment | undefined;
    isVacunaHepatitis: boolean;
    vacunaHepatitisFecha?: moment.Moment | undefined;
    ta?: string | undefined;
    fc?: string | undefined;
    fr?: string | undefined;
    temperatura?: string | undefined;
    resumen?: string | undefined;
    anioCombo?: ComboboxItemDtoOfInteger[] | undefined;
    mesCombo?: ComboboxItemDtoOfInteger[] | undefined;
}

export class ComboboxItemDtoOfInteger implements IComboboxItemDtoOfInteger {
    value!: number;
    label?: string | undefined;

    constructor(data?: IComboboxItemDtoOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): ComboboxItemDtoOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDtoOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IComboboxItemDtoOfInteger {
    value: number;
    label?: string | undefined;
}

export class EvolucionMedicaGetForEditQuery implements IEvolucionMedicaGetForEditQuery {
    id?: number | undefined;

    constructor(data?: IEvolucionMedicaGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EvolucionMedicaGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new EvolucionMedicaGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEvolucionMedicaGetForEditQuery {
    id?: number | undefined;
}

export class EvolucionMedicaCreateCommand implements IEvolucionMedicaCreateCommand {
    paciente?: number | undefined;
    anio?: number | undefined;
    mes?: number | undefined;
    gananciaInterdialitica?: number | undefined;
    ktv?: number | undefined;
    urr?: number | undefined;
    protocoloTransplante?: string | undefined;
    isVacunaNeomococo?: boolean | undefined;
    vacunaNeomococoFecha?: moment.Moment | undefined;
    isVacunaInfluenza?: boolean | undefined;
    vacunaInfluenzaFecha?: moment.Moment | undefined;
    isVacunaHepatitis?: boolean | undefined;
    vacunaHepatitisFecha?: moment.Moment | undefined;
    ta?: string | undefined;
    fc?: string | undefined;
    fr?: string | undefined;
    temperatura?: string | undefined;
    resumen?: string | undefined;
    fechaNota?: moment.Moment | undefined;

    constructor(data?: IEvolucionMedicaCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paciente = _data["paciente"];
            this.anio = _data["anio"];
            this.mes = _data["mes"];
            this.gananciaInterdialitica = _data["gananciaInterdialitica"];
            this.ktv = _data["ktv"];
            this.urr = _data["urr"];
            this.protocoloTransplante = _data["protocoloTransplante"];
            this.isVacunaNeomococo = _data["isVacunaNeomococo"];
            this.vacunaNeomococoFecha = _data["vacunaNeomococoFecha"] ? moment(_data["vacunaNeomococoFecha"].toString()) : <any>undefined;
            this.isVacunaInfluenza = _data["isVacunaInfluenza"];
            this.vacunaInfluenzaFecha = _data["vacunaInfluenzaFecha"] ? moment(_data["vacunaInfluenzaFecha"].toString()) : <any>undefined;
            this.isVacunaHepatitis = _data["isVacunaHepatitis"];
            this.vacunaHepatitisFecha = _data["vacunaHepatitisFecha"] ? moment(_data["vacunaHepatitisFecha"].toString()) : <any>undefined;
            this.ta = _data["ta"];
            this.fc = _data["fc"];
            this.fr = _data["fr"];
            this.temperatura = _data["temperatura"];
            this.resumen = _data["resumen"];
            this.fechaNota = _data["fechaNota"] ? moment(_data["fechaNota"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EvolucionMedicaCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EvolucionMedicaCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paciente"] = this.paciente;
        data["anio"] = this.anio;
        data["mes"] = this.mes;
        data["gananciaInterdialitica"] = this.gananciaInterdialitica;
        data["ktv"] = this.ktv;
        data["urr"] = this.urr;
        data["protocoloTransplante"] = this.protocoloTransplante;
        data["isVacunaNeomococo"] = this.isVacunaNeomococo;
        data["vacunaNeomococoFecha"] = this.vacunaNeomococoFecha ? this.vacunaNeomococoFecha.toISOString() : <any>undefined;
        data["isVacunaInfluenza"] = this.isVacunaInfluenza;
        data["vacunaInfluenzaFecha"] = this.vacunaInfluenzaFecha ? this.vacunaInfluenzaFecha.toISOString() : <any>undefined;
        data["isVacunaHepatitis"] = this.isVacunaHepatitis;
        data["vacunaHepatitisFecha"] = this.vacunaHepatitisFecha ? this.vacunaHepatitisFecha.toISOString() : <any>undefined;
        data["ta"] = this.ta;
        data["fc"] = this.fc;
        data["fr"] = this.fr;
        data["temperatura"] = this.temperatura;
        data["resumen"] = this.resumen;
        data["fechaNota"] = this.fechaNota ? this.fechaNota.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEvolucionMedicaCreateCommand {
    paciente?: number | undefined;
    anio?: number | undefined;
    mes?: number | undefined;
    gananciaInterdialitica?: number | undefined;
    ktv?: number | undefined;
    urr?: number | undefined;
    protocoloTransplante?: string | undefined;
    isVacunaNeomococo?: boolean | undefined;
    vacunaNeomococoFecha?: moment.Moment | undefined;
    isVacunaInfluenza?: boolean | undefined;
    vacunaInfluenzaFecha?: moment.Moment | undefined;
    isVacunaHepatitis?: boolean | undefined;
    vacunaHepatitisFecha?: moment.Moment | undefined;
    ta?: string | undefined;
    fc?: string | undefined;
    fr?: string | undefined;
    temperatura?: string | undefined;
    resumen?: string | undefined;
    fechaNota?: moment.Moment | undefined;
}

export class EvolucionMedicaUpdateCommand implements IEvolucionMedicaUpdateCommand {
    id?: number | undefined;
    gananciaInterdialitica?: number | undefined;
    ktv?: number | undefined;
    urr?: number | undefined;
    protocoloTransplante?: string | undefined;
    isVacunaNeomococo?: boolean | undefined;
    vacunaNeomococoFecha?: moment.Moment | undefined;
    isVacunaInfluenza?: boolean | undefined;
    vacunaInfluenzaFecha?: moment.Moment | undefined;
    isVacunaHepatitis?: boolean | undefined;
    vacunaHepatitisFecha?: moment.Moment | undefined;
    ta?: string | undefined;
    fc?: string | undefined;
    fr?: string | undefined;
    temperatura?: string | undefined;
    resumen?: string | undefined;
    fechaNota?: moment.Moment | undefined;

    constructor(data?: IEvolucionMedicaUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gananciaInterdialitica = _data["gananciaInterdialitica"];
            this.ktv = _data["ktv"];
            this.urr = _data["urr"];
            this.protocoloTransplante = _data["protocoloTransplante"];
            this.isVacunaNeomococo = _data["isVacunaNeomococo"];
            this.vacunaNeomococoFecha = _data["vacunaNeomococoFecha"] ? moment(_data["vacunaNeomococoFecha"].toString()) : <any>undefined;
            this.isVacunaInfluenza = _data["isVacunaInfluenza"];
            this.vacunaInfluenzaFecha = _data["vacunaInfluenzaFecha"] ? moment(_data["vacunaInfluenzaFecha"].toString()) : <any>undefined;
            this.isVacunaHepatitis = _data["isVacunaHepatitis"];
            this.vacunaHepatitisFecha = _data["vacunaHepatitisFecha"] ? moment(_data["vacunaHepatitisFecha"].toString()) : <any>undefined;
            this.ta = _data["ta"];
            this.fc = _data["fc"];
            this.fr = _data["fr"];
            this.temperatura = _data["temperatura"];
            this.resumen = _data["resumen"];
            this.fechaNota = _data["fechaNota"] ? moment(_data["fechaNota"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EvolucionMedicaUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EvolucionMedicaUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gananciaInterdialitica"] = this.gananciaInterdialitica;
        data["ktv"] = this.ktv;
        data["urr"] = this.urr;
        data["protocoloTransplante"] = this.protocoloTransplante;
        data["isVacunaNeomococo"] = this.isVacunaNeomococo;
        data["vacunaNeomococoFecha"] = this.vacunaNeomococoFecha ? this.vacunaNeomococoFecha.toISOString() : <any>undefined;
        data["isVacunaInfluenza"] = this.isVacunaInfluenza;
        data["vacunaInfluenzaFecha"] = this.vacunaInfluenzaFecha ? this.vacunaInfluenzaFecha.toISOString() : <any>undefined;
        data["isVacunaHepatitis"] = this.isVacunaHepatitis;
        data["vacunaHepatitisFecha"] = this.vacunaHepatitisFecha ? this.vacunaHepatitisFecha.toISOString() : <any>undefined;
        data["ta"] = this.ta;
        data["fc"] = this.fc;
        data["fr"] = this.fr;
        data["temperatura"] = this.temperatura;
        data["resumen"] = this.resumen;
        data["fechaNota"] = this.fechaNota ? this.fechaNota.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEvolucionMedicaUpdateCommand {
    id?: number | undefined;
    gananciaInterdialitica?: number | undefined;
    ktv?: number | undefined;
    urr?: number | undefined;
    protocoloTransplante?: string | undefined;
    isVacunaNeomococo?: boolean | undefined;
    vacunaNeomococoFecha?: moment.Moment | undefined;
    isVacunaInfluenza?: boolean | undefined;
    vacunaInfluenzaFecha?: moment.Moment | undefined;
    isVacunaHepatitis?: boolean | undefined;
    vacunaHepatitisFecha?: moment.Moment | undefined;
    ta?: string | undefined;
    fc?: string | undefined;
    fr?: string | undefined;
    temperatura?: string | undefined;
    resumen?: string | undefined;
    fechaNota?: moment.Moment | undefined;
}

export class PagedResultDtoOfMensajeHL7ForListResponse implements IPagedResultDtoOfMensajeHL7ForListResponse {
    totalCount!: number;
    items?: MensajeHL7ForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfMensajeHL7ForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MensajeHL7ForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMensajeHL7ForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMensajeHL7ForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfMensajeHL7ForListResponse {
    totalCount: number;
    items?: MensajeHL7ForListResponse[] | undefined;
}

export class MensajeHL7ForListResponse implements IMensajeHL7ForListResponse {
    id?: number | undefined;
    pacienteId?: number | undefined;
    nombrePaciente?: string | undefined;
    idee?: string | undefined;
    nss?: string | undefined;
    hl7TipoMensajeId?: number | undefined;
    hL7TipoMensajeDesc?: string | undefined;
    hl7EstatusId!: number;
    hl7EstatusDesc?: string | undefined;
    hl7CodigoRespuestaId?: number | undefined;
    hl7CodigoRespuestaDesc?: string | undefined;
    refenciaId?: number | undefined;
    detalle?: string | undefined;
    detalleRespuestaImss?: string | undefined;
    fechaEnvio?: moment.Moment | undefined;
    fechaRecepcion?: moment.Moment | undefined;
    numeroEnvio?: number | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    servicio?: string | undefined;
    versionServicio?: string | undefined;
    total!: number;
    delegacionDesc?: string | undefined;
    hospitalDesc?: string | undefined;

    constructor(data?: IMensajeHL7ForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pacienteId = _data["pacienteId"];
            this.nombrePaciente = _data["nombrePaciente"];
            this.idee = _data["idee"];
            this.nss = _data["nss"];
            this.hl7TipoMensajeId = _data["hl7TipoMensajeId"];
            this.hL7TipoMensajeDesc = _data["hL7TipoMensajeDesc"];
            this.hl7EstatusId = _data["hl7EstatusId"];
            this.hl7EstatusDesc = _data["hl7EstatusDesc"];
            this.hl7CodigoRespuestaId = _data["hl7CodigoRespuestaId"];
            this.hl7CodigoRespuestaDesc = _data["hl7CodigoRespuestaDesc"];
            this.refenciaId = _data["refenciaId"];
            this.detalle = _data["detalle"];
            this.detalleRespuestaImss = _data["detalleRespuestaImss"];
            this.fechaEnvio = _data["fechaEnvio"] ? moment(_data["fechaEnvio"].toString()) : <any>undefined;
            this.fechaRecepcion = _data["fechaRecepcion"] ? moment(_data["fechaRecepcion"].toString()) : <any>undefined;
            this.numeroEnvio = _data["numeroEnvio"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.servicio = _data["servicio"];
            this.versionServicio = _data["versionServicio"];
            this.total = _data["total"];
            this.delegacionDesc = _data["delegacionDesc"];
            this.hospitalDesc = _data["hospitalDesc"];
        }
    }

    static fromJS(data: any): MensajeHL7ForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MensajeHL7ForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pacienteId"] = this.pacienteId;
        data["nombrePaciente"] = this.nombrePaciente;
        data["idee"] = this.idee;
        data["nss"] = this.nss;
        data["hl7TipoMensajeId"] = this.hl7TipoMensajeId;
        data["hL7TipoMensajeDesc"] = this.hL7TipoMensajeDesc;
        data["hl7EstatusId"] = this.hl7EstatusId;
        data["hl7EstatusDesc"] = this.hl7EstatusDesc;
        data["hl7CodigoRespuestaId"] = this.hl7CodigoRespuestaId;
        data["hl7CodigoRespuestaDesc"] = this.hl7CodigoRespuestaDesc;
        data["refenciaId"] = this.refenciaId;
        data["detalle"] = this.detalle;
        data["detalleRespuestaImss"] = this.detalleRespuestaImss;
        data["fechaEnvio"] = this.fechaEnvio ? this.fechaEnvio.toISOString() : <any>undefined;
        data["fechaRecepcion"] = this.fechaRecepcion ? this.fechaRecepcion.toISOString() : <any>undefined;
        data["numeroEnvio"] = this.numeroEnvio;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["servicio"] = this.servicio;
        data["versionServicio"] = this.versionServicio;
        data["total"] = this.total;
        data["delegacionDesc"] = this.delegacionDesc;
        data["hospitalDesc"] = this.hospitalDesc;
        return data;
    }
}

export interface IMensajeHL7ForListResponse {
    id?: number | undefined;
    pacienteId?: number | undefined;
    nombrePaciente?: string | undefined;
    idee?: string | undefined;
    nss?: string | undefined;
    hl7TipoMensajeId?: number | undefined;
    hL7TipoMensajeDesc?: string | undefined;
    hl7EstatusId: number;
    hl7EstatusDesc?: string | undefined;
    hl7CodigoRespuestaId?: number | undefined;
    hl7CodigoRespuestaDesc?: string | undefined;
    refenciaId?: number | undefined;
    detalle?: string | undefined;
    detalleRespuestaImss?: string | undefined;
    fechaEnvio?: moment.Moment | undefined;
    fechaRecepcion?: moment.Moment | undefined;
    numeroEnvio?: number | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    servicio?: string | undefined;
    versionServicio?: string | undefined;
    total: number;
    delegacionDesc?: string | undefined;
    hospitalDesc?: string | undefined;
}

export class MensajeHL7GetListQuery extends PageListByDto implements IMensajeHL7GetListQuery {
    fechaInicio?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    hospitalId?: number | undefined;
    tipoMensajeId?: number | undefined;
    estatusId?: number | undefined;
    idee?: string | undefined;
    codigoRespuestaId?: number | undefined;
    pacienteId?: number | undefined;
    fechaEnvio?: moment.Moment | undefined;
    horaEnvio?: moment.Duration | undefined;
    fechaRecepcion?: moment.Moment | undefined;
    horaRecepcion?: moment.Duration | undefined;

    constructor(data?: IMensajeHL7GetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.hospitalId = _data["hospitalId"];
            this.tipoMensajeId = _data["tipoMensajeId"];
            this.estatusId = _data["estatusId"];
            this.idee = _data["idee"];
            this.codigoRespuestaId = _data["codigoRespuestaId"];
            this.pacienteId = _data["pacienteId"];
            this.fechaEnvio = _data["fechaEnvio"] ? moment(_data["fechaEnvio"].toString()) : <any>undefined;
            this.horaEnvio = _data["horaEnvio"] ? moment.duration(_data["horaEnvio"].toString()) : <any>undefined;
            this.fechaRecepcion = _data["fechaRecepcion"] ? moment(_data["fechaRecepcion"].toString()) : <any>undefined;
            this.horaRecepcion = _data["horaRecepcion"] ? moment.duration(_data["horaRecepcion"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): MensajeHL7GetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MensajeHL7GetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["hospitalId"] = this.hospitalId;
        data["tipoMensajeId"] = this.tipoMensajeId;
        data["estatusId"] = this.estatusId;
        data["idee"] = this.idee;
        data["codigoRespuestaId"] = this.codigoRespuestaId;
        data["pacienteId"] = this.pacienteId;
        data["fechaEnvio"] = this.fechaEnvio ? this.fechaEnvio.toISOString() : <any>undefined;
        data["horaEnvio"] = this.horaEnvio ? this.horaEnvio.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["fechaRecepcion"] = this.fechaRecepcion ? this.fechaRecepcion.toISOString() : <any>undefined;
        data["horaRecepcion"] = this.horaRecepcion ? this.horaRecepcion.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IMensajeHL7GetListQuery extends IPageListByDto {
    fechaInicio?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    hospitalId?: number | undefined;
    tipoMensajeId?: number | undefined;
    estatusId?: number | undefined;
    idee?: string | undefined;
    codigoRespuestaId?: number | undefined;
    pacienteId?: number | undefined;
    fechaEnvio?: moment.Moment | undefined;
    horaEnvio?: moment.Duration | undefined;
    fechaRecepcion?: moment.Moment | undefined;
    horaRecepcion?: moment.Duration | undefined;
}

export class MensajeHL7ResendScheduleCommand extends PageListByDto implements IMensajeHL7ResendScheduleCommand {
    fechaInicio?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    hospitalId?: number | undefined;
    tipoMensajeId?: number | undefined;
    estatusId?: number | undefined;
    idee?: string | undefined;
    codigoRespuestaId?: number | undefined;
    pacienteId?: number | undefined;
    fechaEnvio?: moment.Moment | undefined;
    horaEnvio?: moment.Duration | undefined;
    fechaRecepcion?: moment.Moment | undefined;
    horaRecepcion?: moment.Duration | undefined;

    constructor(data?: IMensajeHL7ResendScheduleCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.hospitalId = _data["hospitalId"];
            this.tipoMensajeId = _data["tipoMensajeId"];
            this.estatusId = _data["estatusId"];
            this.idee = _data["idee"];
            this.codigoRespuestaId = _data["codigoRespuestaId"];
            this.pacienteId = _data["pacienteId"];
            this.fechaEnvio = _data["fechaEnvio"] ? moment(_data["fechaEnvio"].toString()) : <any>undefined;
            this.horaEnvio = _data["horaEnvio"] ? moment.duration(_data["horaEnvio"].toString()) : <any>undefined;
            this.fechaRecepcion = _data["fechaRecepcion"] ? moment(_data["fechaRecepcion"].toString()) : <any>undefined;
            this.horaRecepcion = _data["horaRecepcion"] ? moment.duration(_data["horaRecepcion"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): MensajeHL7ResendScheduleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MensajeHL7ResendScheduleCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["hospitalId"] = this.hospitalId;
        data["tipoMensajeId"] = this.tipoMensajeId;
        data["estatusId"] = this.estatusId;
        data["idee"] = this.idee;
        data["codigoRespuestaId"] = this.codigoRespuestaId;
        data["pacienteId"] = this.pacienteId;
        data["fechaEnvio"] = this.fechaEnvio ? this.fechaEnvio.toISOString() : <any>undefined;
        data["horaEnvio"] = this.horaEnvio ? this.horaEnvio.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["fechaRecepcion"] = this.fechaRecepcion ? this.fechaRecepcion.toISOString() : <any>undefined;
        data["horaRecepcion"] = this.horaRecepcion ? this.horaRecepcion.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IMensajeHL7ResendScheduleCommand extends IPageListByDto {
    fechaInicio?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    hospitalId?: number | undefined;
    tipoMensajeId?: number | undefined;
    estatusId?: number | undefined;
    idee?: string | undefined;
    codigoRespuestaId?: number | undefined;
    pacienteId?: number | undefined;
    fechaEnvio?: moment.Moment | undefined;
    horaEnvio?: moment.Duration | undefined;
    fechaRecepcion?: moment.Moment | undefined;
    horaRecepcion?: moment.Duration | undefined;
}

export class ReportMensajeHL7ExportQuery extends PageListByDto implements IReportMensajeHL7ExportQuery {
    fechaInicio?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    hospitalId?: number | undefined;
    tipoMensajeId?: number | undefined;
    estatusId?: number | undefined;
    idee?: string | undefined;
    codigoRespuestaId?: number | undefined;
    pacienteId?: number | undefined;
    fechaEnvio?: moment.Moment | undefined;
    horaEnvio?: moment.Duration | undefined;
    fechaRecepcion?: moment.Moment | undefined;
    horaRecepcion?: moment.Duration | undefined;
    tipoExportacion!: ReportMensajeHL7ExportType;

    constructor(data?: IReportMensajeHL7ExportQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.hospitalId = _data["hospitalId"];
            this.tipoMensajeId = _data["tipoMensajeId"];
            this.estatusId = _data["estatusId"];
            this.idee = _data["idee"];
            this.codigoRespuestaId = _data["codigoRespuestaId"];
            this.pacienteId = _data["pacienteId"];
            this.fechaEnvio = _data["fechaEnvio"] ? moment(_data["fechaEnvio"].toString()) : <any>undefined;
            this.horaEnvio = _data["horaEnvio"] ? moment.duration(_data["horaEnvio"].toString()) : <any>undefined;
            this.fechaRecepcion = _data["fechaRecepcion"] ? moment(_data["fechaRecepcion"].toString()) : <any>undefined;
            this.horaRecepcion = _data["horaRecepcion"] ? moment.duration(_data["horaRecepcion"].toString()) : <any>undefined;
            this.tipoExportacion = _data["tipoExportacion"];
        }
    }

    static override fromJS(data: any): ReportMensajeHL7ExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportMensajeHL7ExportQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["hospitalId"] = this.hospitalId;
        data["tipoMensajeId"] = this.tipoMensajeId;
        data["estatusId"] = this.estatusId;
        data["idee"] = this.idee;
        data["codigoRespuestaId"] = this.codigoRespuestaId;
        data["pacienteId"] = this.pacienteId;
        data["fechaEnvio"] = this.fechaEnvio ? this.fechaEnvio.toISOString() : <any>undefined;
        data["horaEnvio"] = this.horaEnvio ? this.horaEnvio.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["fechaRecepcion"] = this.fechaRecepcion ? this.fechaRecepcion.toISOString() : <any>undefined;
        data["horaRecepcion"] = this.horaRecepcion ? this.horaRecepcion.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["tipoExportacion"] = this.tipoExportacion;
        super.toJSON(data);
        return data;
    }
}

export interface IReportMensajeHL7ExportQuery extends IPageListByDto {
    fechaInicio?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    hospitalId?: number | undefined;
    tipoMensajeId?: number | undefined;
    estatusId?: number | undefined;
    idee?: string | undefined;
    codigoRespuestaId?: number | undefined;
    pacienteId?: number | undefined;
    fechaEnvio?: moment.Moment | undefined;
    horaEnvio?: moment.Duration | undefined;
    fechaRecepcion?: moment.Moment | undefined;
    horaRecepcion?: moment.Duration | undefined;
    tipoExportacion: ReportMensajeHL7ExportType;
}

export enum ReportMensajeHL7ExportType {
    Excel = 1,
    PDF = 2,
}

export class ReportMensajeHL7ConcentradoExportQuery extends PageListByDto implements IReportMensajeHL7ConcentradoExportQuery {
    fechaInicio?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    hospitalId?: number | undefined;
    tipoMensajeId?: number | undefined;
    estatusId?: number | undefined;
    idee?: string | undefined;
    codigoRespuestaId?: number | undefined;
    pacienteId?: number | undefined;
    fechaEnvio?: moment.Moment | undefined;
    horaEnvio?: moment.Duration | undefined;
    fechaRecepcion?: moment.Moment | undefined;
    horaRecepcion?: moment.Duration | undefined;
    tipoExportacion!: ReportMensajeHL7ConcentradoExportType;

    constructor(data?: IReportMensajeHL7ConcentradoExportQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.hospitalId = _data["hospitalId"];
            this.tipoMensajeId = _data["tipoMensajeId"];
            this.estatusId = _data["estatusId"];
            this.idee = _data["idee"];
            this.codigoRespuestaId = _data["codigoRespuestaId"];
            this.pacienteId = _data["pacienteId"];
            this.fechaEnvio = _data["fechaEnvio"] ? moment(_data["fechaEnvio"].toString()) : <any>undefined;
            this.horaEnvio = _data["horaEnvio"] ? moment.duration(_data["horaEnvio"].toString()) : <any>undefined;
            this.fechaRecepcion = _data["fechaRecepcion"] ? moment(_data["fechaRecepcion"].toString()) : <any>undefined;
            this.horaRecepcion = _data["horaRecepcion"] ? moment.duration(_data["horaRecepcion"].toString()) : <any>undefined;
            this.tipoExportacion = _data["tipoExportacion"];
        }
    }

    static override fromJS(data: any): ReportMensajeHL7ConcentradoExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportMensajeHL7ConcentradoExportQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["hospitalId"] = this.hospitalId;
        data["tipoMensajeId"] = this.tipoMensajeId;
        data["estatusId"] = this.estatusId;
        data["idee"] = this.idee;
        data["codigoRespuestaId"] = this.codigoRespuestaId;
        data["pacienteId"] = this.pacienteId;
        data["fechaEnvio"] = this.fechaEnvio ? this.fechaEnvio.toISOString() : <any>undefined;
        data["horaEnvio"] = this.horaEnvio ? this.horaEnvio.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["fechaRecepcion"] = this.fechaRecepcion ? this.fechaRecepcion.toISOString() : <any>undefined;
        data["horaRecepcion"] = this.horaRecepcion ? this.horaRecepcion.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["tipoExportacion"] = this.tipoExportacion;
        super.toJSON(data);
        return data;
    }
}

export interface IReportMensajeHL7ConcentradoExportQuery extends IPageListByDto {
    fechaInicio?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    hospitalId?: number | undefined;
    tipoMensajeId?: number | undefined;
    estatusId?: number | undefined;
    idee?: string | undefined;
    codigoRespuestaId?: number | undefined;
    pacienteId?: number | undefined;
    fechaEnvio?: moment.Moment | undefined;
    horaEnvio?: moment.Duration | undefined;
    fechaRecepcion?: moment.Moment | undefined;
    horaRecepcion?: moment.Duration | undefined;
    tipoExportacion: ReportMensajeHL7ConcentradoExportType;
}

export enum ReportMensajeHL7ConcentradoExportType {
    Excel = 1,
    PDF = 2,
}

export class MensajeHL7GetSolicitudQuery implements IMensajeHL7GetSolicitudQuery {
    mensajeHL7Id!: number;

    constructor(data?: IMensajeHL7GetSolicitudQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mensajeHL7Id = _data["mensajeHL7Id"];
        }
    }

    static fromJS(data: any): MensajeHL7GetSolicitudQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MensajeHL7GetSolicitudQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mensajeHL7Id"] = this.mensajeHL7Id;
        return data;
    }
}

export interface IMensajeHL7GetSolicitudQuery {
    mensajeHL7Id: number;
}

export class MensajeHL7GetRespuestaQuery implements IMensajeHL7GetRespuestaQuery {
    respuestaId!: number;

    constructor(data?: IMensajeHL7GetRespuestaQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.respuestaId = _data["respuestaId"];
        }
    }

    static fromJS(data: any): MensajeHL7GetRespuestaQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MensajeHL7GetRespuestaQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["respuestaId"] = this.respuestaId;
        return data;
    }
}

export interface IMensajeHL7GetRespuestaQuery {
    respuestaId: number;
}

export class MensajeHL7RespuestaForListResponse implements IMensajeHL7RespuestaForListResponse {
    id!: number;
    fechaAlta?: moment.Moment | undefined;
    respuesta?: string | undefined;
    mensajeHL7Id!: number;

    constructor(data?: IMensajeHL7RespuestaForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.respuesta = _data["respuesta"];
            this.mensajeHL7Id = _data["mensajeHL7Id"];
        }
    }

    static fromJS(data: any): MensajeHL7RespuestaForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MensajeHL7RespuestaForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["respuesta"] = this.respuesta;
        data["mensajeHL7Id"] = this.mensajeHL7Id;
        return data;
    }
}

export interface IMensajeHL7RespuestaForListResponse {
    id: number;
    fechaAlta?: moment.Moment | undefined;
    respuesta?: string | undefined;
    mensajeHL7Id: number;
}

export class MensajeHL7GetRespuestasListQuery implements IMensajeHL7GetRespuestasListQuery {
    mensajeHL7Id!: number;

    constructor(data?: IMensajeHL7GetRespuestasListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mensajeHL7Id = _data["mensajeHL7Id"];
        }
    }

    static fromJS(data: any): MensajeHL7GetRespuestasListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MensajeHL7GetRespuestasListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mensajeHL7Id"] = this.mensajeHL7Id;
        return data;
    }
}

export interface IMensajeHL7GetRespuestasListQuery {
    mensajeHL7Id: number;
}

export class BusquedaIMSSResultDto implements IBusquedaIMSSResultDto {
    idee?: string | undefined;
    tipoPaciente?: string | undefined;
    nombre?: string | undefined;
    apellidoPaterno?: string | undefined;
    apellidoMaterno?: string | undefined;
    curp?: string | undefined;
    nss?: string | undefined;
    agregadoMedico?: string | undefined;
    fechaNacimiento?: moment.Moment | undefined;
    calle?: string | undefined;
    colonia?: string | undefined;
    numeroTelefonico?: string | undefined;
    consultorioMedico?: string | undefined;
    fechaVigencia?: moment.Moment | undefined;
    sexo?: string | undefined;
    clavePresupuestal?: string | undefined;
    fotografia?: string | undefined;
    derechoServicioMedico!: boolean;
    fechaDefuncion?: moment.Moment | undefined;
    ciudad?: string | undefined;
    codigoPostal?: string | undefined;
    numeroExterior?: string | undefined;
    numeroInterior?: string | undefined;
    turnoAtencion?: string | undefined;
    registroPatronal?: string | undefined;
    tipoPension?: string | undefined;
    procedencia?: string | undefined;
    tipoConvenio?: string | undefined;
    observaciones?: string | undefined;
    autorizacionSesiones!: boolean;
    derechoIncapacidad!: boolean;
    activo!: boolean;

    constructor(data?: IBusquedaIMSSResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idee = _data["idee"];
            this.tipoPaciente = _data["tipoPaciente"];
            this.nombre = _data["nombre"];
            this.apellidoPaterno = _data["apellidoPaterno"];
            this.apellidoMaterno = _data["apellidoMaterno"];
            this.curp = _data["curp"];
            this.nss = _data["nss"];
            this.agregadoMedico = _data["agregadoMedico"];
            this.fechaNacimiento = _data["fechaNacimiento"] ? moment(_data["fechaNacimiento"].toString()) : <any>undefined;
            this.calle = _data["calle"];
            this.colonia = _data["colonia"];
            this.numeroTelefonico = _data["numeroTelefonico"];
            this.consultorioMedico = _data["consultorioMedico"];
            this.fechaVigencia = _data["fechaVigencia"] ? moment(_data["fechaVigencia"].toString()) : <any>undefined;
            this.sexo = _data["sexo"];
            this.clavePresupuestal = _data["clavePresupuestal"];
            this.fotografia = _data["fotografia"];
            this.derechoServicioMedico = _data["derechoServicioMedico"];
            this.fechaDefuncion = _data["fechaDefuncion"] ? moment(_data["fechaDefuncion"].toString()) : <any>undefined;
            this.ciudad = _data["ciudad"];
            this.codigoPostal = _data["codigoPostal"];
            this.numeroExterior = _data["numeroExterior"];
            this.numeroInterior = _data["numeroInterior"];
            this.turnoAtencion = _data["turnoAtencion"];
            this.registroPatronal = _data["registroPatronal"];
            this.tipoPension = _data["tipoPension"];
            this.procedencia = _data["procedencia"];
            this.tipoConvenio = _data["tipoConvenio"];
            this.observaciones = _data["observaciones"];
            this.autorizacionSesiones = _data["autorizacionSesiones"];
            this.derechoIncapacidad = _data["derechoIncapacidad"];
            this.activo = _data["activo"];
        }
    }

    static fromJS(data: any): BusquedaIMSSResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BusquedaIMSSResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idee"] = this.idee;
        data["tipoPaciente"] = this.tipoPaciente;
        data["nombre"] = this.nombre;
        data["apellidoPaterno"] = this.apellidoPaterno;
        data["apellidoMaterno"] = this.apellidoMaterno;
        data["curp"] = this.curp;
        data["nss"] = this.nss;
        data["agregadoMedico"] = this.agregadoMedico;
        data["fechaNacimiento"] = this.fechaNacimiento ? this.fechaNacimiento.toISOString() : <any>undefined;
        data["calle"] = this.calle;
        data["colonia"] = this.colonia;
        data["numeroTelefonico"] = this.numeroTelefonico;
        data["consultorioMedico"] = this.consultorioMedico;
        data["fechaVigencia"] = this.fechaVigencia ? this.fechaVigencia.toISOString() : <any>undefined;
        data["sexo"] = this.sexo;
        data["clavePresupuestal"] = this.clavePresupuestal;
        data["fotografia"] = this.fotografia;
        data["derechoServicioMedico"] = this.derechoServicioMedico;
        data["fechaDefuncion"] = this.fechaDefuncion ? this.fechaDefuncion.toISOString() : <any>undefined;
        data["ciudad"] = this.ciudad;
        data["codigoPostal"] = this.codigoPostal;
        data["numeroExterior"] = this.numeroExterior;
        data["numeroInterior"] = this.numeroInterior;
        data["turnoAtencion"] = this.turnoAtencion;
        data["registroPatronal"] = this.registroPatronal;
        data["tipoPension"] = this.tipoPension;
        data["procedencia"] = this.procedencia;
        data["tipoConvenio"] = this.tipoConvenio;
        data["observaciones"] = this.observaciones;
        data["autorizacionSesiones"] = this.autorizacionSesiones;
        data["derechoIncapacidad"] = this.derechoIncapacidad;
        data["activo"] = this.activo;
        return data;
    }
}

export interface IBusquedaIMSSResultDto {
    idee?: string | undefined;
    tipoPaciente?: string | undefined;
    nombre?: string | undefined;
    apellidoPaterno?: string | undefined;
    apellidoMaterno?: string | undefined;
    curp?: string | undefined;
    nss?: string | undefined;
    agregadoMedico?: string | undefined;
    fechaNacimiento?: moment.Moment | undefined;
    calle?: string | undefined;
    colonia?: string | undefined;
    numeroTelefonico?: string | undefined;
    consultorioMedico?: string | undefined;
    fechaVigencia?: moment.Moment | undefined;
    sexo?: string | undefined;
    clavePresupuestal?: string | undefined;
    fotografia?: string | undefined;
    derechoServicioMedico: boolean;
    fechaDefuncion?: moment.Moment | undefined;
    ciudad?: string | undefined;
    codigoPostal?: string | undefined;
    numeroExterior?: string | undefined;
    numeroInterior?: string | undefined;
    turnoAtencion?: string | undefined;
    registroPatronal?: string | undefined;
    tipoPension?: string | undefined;
    procedencia?: string | undefined;
    tipoConvenio?: string | undefined;
    observaciones?: string | undefined;
    autorizacionSesiones: boolean;
    derechoIncapacidad: boolean;
    activo: boolean;
}

export class BusquedaUrgenciasGetListQuery implements IBusquedaUrgenciasGetListQuery {
    tipoPaciente?: string | undefined;
    nss?: string | undefined;
    nombre?: string | undefined;
    apellidoPaterno?: string | undefined;
    apellidoMaterno?: string | undefined;
    fechaNacimiento?: moment.Moment | undefined;
    motivoIngreso?: string | undefined;
    agregadoMedico?: string | undefined;
    idee?: string | undefined;
    hospitalId?: number | undefined;

    constructor(data?: IBusquedaUrgenciasGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoPaciente = _data["tipoPaciente"];
            this.nss = _data["nss"];
            this.nombre = _data["nombre"];
            this.apellidoPaterno = _data["apellidoPaterno"];
            this.apellidoMaterno = _data["apellidoMaterno"];
            this.fechaNacimiento = _data["fechaNacimiento"] ? moment(_data["fechaNacimiento"].toString()) : <any>undefined;
            this.motivoIngreso = _data["motivoIngreso"];
            this.agregadoMedico = _data["agregadoMedico"];
            this.idee = _data["idee"];
            this.hospitalId = _data["hospitalId"];
        }
    }

    static fromJS(data: any): BusquedaUrgenciasGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new BusquedaUrgenciasGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoPaciente"] = this.tipoPaciente;
        data["nss"] = this.nss;
        data["nombre"] = this.nombre;
        data["apellidoPaterno"] = this.apellidoPaterno;
        data["apellidoMaterno"] = this.apellidoMaterno;
        data["fechaNacimiento"] = this.fechaNacimiento ? this.fechaNacimiento.toISOString() : <any>undefined;
        data["motivoIngreso"] = this.motivoIngreso;
        data["agregadoMedico"] = this.agregadoMedico;
        data["idee"] = this.idee;
        data["hospitalId"] = this.hospitalId;
        return data;
    }
}

export interface IBusquedaUrgenciasGetListQuery {
    tipoPaciente?: string | undefined;
    nss?: string | undefined;
    nombre?: string | undefined;
    apellidoPaterno?: string | undefined;
    apellidoMaterno?: string | undefined;
    fechaNacimiento?: moment.Moment | undefined;
    motivoIngreso?: string | undefined;
    agregadoMedico?: string | undefined;
    idee?: string | undefined;
    hospitalId?: number | undefined;
}

export class BusquedaIMSSResponse implements IBusquedaIMSSResponse {
    valido!: boolean;
    mensajes?: string[] | undefined;

    constructor(data?: IBusquedaIMSSResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valido = _data["valido"];
            if (Array.isArray(_data["mensajes"])) {
                this.mensajes = [] as any;
                for (let item of _data["mensajes"])
                    this.mensajes!.push(item);
            }
        }
    }

    static fromJS(data: any): BusquedaIMSSResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BusquedaIMSSResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valido"] = this.valido;
        if (Array.isArray(this.mensajes)) {
            data["mensajes"] = [];
            for (let item of this.mensajes)
                data["mensajes"].push(item);
        }
        return data;
    }
}

export interface IBusquedaIMSSResponse {
    valido: boolean;
    mensajes?: string[] | undefined;
}

export class BusquedaIMSSGetListQuery implements IBusquedaIMSSGetListQuery {
    tipoPaciente?: string | undefined;
    nss?: string | undefined;
    nombre?: string | undefined;
    apellidoPaterno?: string | undefined;
    apellidoMaterno?: string | undefined;
    fechaNacimiento?: moment.Moment | undefined;
    motivoIngreso?: string | undefined;
    agregadoMedico?: string | undefined;
    idee?: string | undefined;
    hospitalId?: number | undefined;

    constructor(data?: IBusquedaIMSSGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoPaciente = _data["tipoPaciente"];
            this.nss = _data["nss"];
            this.nombre = _data["nombre"];
            this.apellidoPaterno = _data["apellidoPaterno"];
            this.apellidoMaterno = _data["apellidoMaterno"];
            this.fechaNacimiento = _data["fechaNacimiento"] ? moment(_data["fechaNacimiento"].toString()) : <any>undefined;
            this.motivoIngreso = _data["motivoIngreso"];
            this.agregadoMedico = _data["agregadoMedico"];
            this.idee = _data["idee"];
            this.hospitalId = _data["hospitalId"];
        }
    }

    static fromJS(data: any): BusquedaIMSSGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new BusquedaIMSSGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoPaciente"] = this.tipoPaciente;
        data["nss"] = this.nss;
        data["nombre"] = this.nombre;
        data["apellidoPaterno"] = this.apellidoPaterno;
        data["apellidoMaterno"] = this.apellidoMaterno;
        data["fechaNacimiento"] = this.fechaNacimiento ? this.fechaNacimiento.toISOString() : <any>undefined;
        data["motivoIngreso"] = this.motivoIngreso;
        data["agregadoMedico"] = this.agregadoMedico;
        data["idee"] = this.idee;
        data["hospitalId"] = this.hospitalId;
        return data;
    }
}

export interface IBusquedaIMSSGetListQuery {
    tipoPaciente?: string | undefined;
    nss?: string | undefined;
    nombre?: string | undefined;
    apellidoPaterno?: string | undefined;
    apellidoMaterno?: string | undefined;
    fechaNacimiento?: moment.Moment | undefined;
    motivoIngreso?: string | undefined;
    agregadoMedico?: string | undefined;
    idee?: string | undefined;
    hospitalId?: number | undefined;
}

export class BusquedaIMSSGetByIDEEQuery implements IBusquedaIMSSGetByIDEEQuery {
    tipoPaciente?: string | undefined;
    nss?: string | undefined;
    nombre?: string | undefined;
    apellidoPaterno?: string | undefined;
    apellidoMaterno?: string | undefined;
    fechaNacimiento?: moment.Moment | undefined;
    hospitalId?: number | undefined;

    constructor(data?: IBusquedaIMSSGetByIDEEQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoPaciente = _data["tipoPaciente"];
            this.nss = _data["nss"];
            this.nombre = _data["nombre"];
            this.apellidoPaterno = _data["apellidoPaterno"];
            this.apellidoMaterno = _data["apellidoMaterno"];
            this.fechaNacimiento = _data["fechaNacimiento"] ? moment(_data["fechaNacimiento"].toString()) : <any>undefined;
            this.hospitalId = _data["hospitalId"];
        }
    }

    static fromJS(data: any): BusquedaIMSSGetByIDEEQuery {
        data = typeof data === 'object' ? data : {};
        let result = new BusquedaIMSSGetByIDEEQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoPaciente"] = this.tipoPaciente;
        data["nss"] = this.nss;
        data["nombre"] = this.nombre;
        data["apellidoPaterno"] = this.apellidoPaterno;
        data["apellidoMaterno"] = this.apellidoMaterno;
        data["fechaNacimiento"] = this.fechaNacimiento ? this.fechaNacimiento.toISOString() : <any>undefined;
        data["hospitalId"] = this.hospitalId;
        return data;
    }
}

export interface IBusquedaIMSSGetByIDEEQuery {
    tipoPaciente?: string | undefined;
    nss?: string | undefined;
    nombre?: string | undefined;
    apellidoPaterno?: string | undefined;
    apellidoMaterno?: string | undefined;
    fechaNacimiento?: moment.Moment | undefined;
    hospitalId?: number | undefined;
}

export class BusquedaIMSSReenviarMensajeCommand implements IBusquedaIMSSReenviarMensajeCommand {
    mensajeId!: number;

    constructor(data?: IBusquedaIMSSReenviarMensajeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mensajeId = _data["mensajeId"];
        }
    }

    static fromJS(data: any): BusquedaIMSSReenviarMensajeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BusquedaIMSSReenviarMensajeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mensajeId"] = this.mensajeId;
        return data;
    }
}

export interface IBusquedaIMSSReenviarMensajeCommand {
    mensajeId: number;
}

export class BusquedaIMSSCrearPacienteCommand implements IBusquedaIMSSCrearPacienteCommand {
    curp?: string | undefined;
    origin?: number | undefined;
    agreementType?: number | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    sexKey?: string | undefined;
    street?: string | undefined;
    phone?: string | undefined;
    suburb?: string | undefined;
    observations?: string | undefined;
    birthDate?: moment.Moment | undefined;
    hospitalId?: number | undefined;

    constructor(data?: IBusquedaIMSSCrearPacienteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.curp = _data["curp"];
            this.origin = _data["origin"];
            this.agreementType = _data["agreementType"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.sexKey = _data["sexKey"];
            this.street = _data["street"];
            this.phone = _data["phone"];
            this.suburb = _data["suburb"];
            this.observations = _data["observations"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.hospitalId = _data["hospitalId"];
        }
    }

    static fromJS(data: any): BusquedaIMSSCrearPacienteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BusquedaIMSSCrearPacienteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["curp"] = this.curp;
        data["origin"] = this.origin;
        data["agreementType"] = this.agreementType;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["sexKey"] = this.sexKey;
        data["street"] = this.street;
        data["phone"] = this.phone;
        data["suburb"] = this.suburb;
        data["observations"] = this.observations;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["hospitalId"] = this.hospitalId;
        return data;
    }
}

export interface IBusquedaIMSSCrearPacienteCommand {
    curp?: string | undefined;
    origin?: number | undefined;
    agreementType?: number | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    sexKey?: string | undefined;
    street?: string | undefined;
    phone?: string | undefined;
    suburb?: string | undefined;
    observations?: string | undefined;
    birthDate?: moment.Moment | undefined;
    hospitalId?: number | undefined;
}

export class HospitalDto implements IHospitalDto {
    id!: number;
    delegacionId?: number | undefined;
    municipioId!: number;
    institucionesAseguradasId!: number;
    codigoHospital?: string | undefined;
    nombre?: string | undefined;
    direccion?: string | undefined;
    telefono1?: string | undefined;
    numExt1?: string | undefined;
    telefono2?: string | undefined;
    numExt2?: string | undefined;
    telefono3?: string | undefined;
    numExt3?: string | undefined;
    fax?: string | undefined;
    numeroRegistro?: string | undefined;
    responsable?: string | undefined;
    umf?: string | undefined;
    tratamientoDp!: boolean;
    tratamientoHd!: boolean;
    clavePresupuestal?: string | undefined;
    enviaMensajesHL7?: boolean | undefined;
    contrato?: string | undefined;
    rfc?: string | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;
    delegacionDesc?: string | undefined;
    municipioDesc?: string | undefined;
    institucionesAseguradasDesc?: string | undefined;
    paisId!: number;
    paisDesc?: string | undefined;
    estadoId!: number;
    estadoDesc?: string | undefined;

    constructor(data?: IHospitalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.delegacionId = _data["delegacionId"];
            this.municipioId = _data["municipioId"];
            this.institucionesAseguradasId = _data["institucionesAseguradasId"];
            this.codigoHospital = _data["codigoHospital"];
            this.nombre = _data["nombre"];
            this.direccion = _data["direccion"];
            this.telefono1 = _data["telefono1"];
            this.numExt1 = _data["numExt1"];
            this.telefono2 = _data["telefono2"];
            this.numExt2 = _data["numExt2"];
            this.telefono3 = _data["telefono3"];
            this.numExt3 = _data["numExt3"];
            this.fax = _data["fax"];
            this.numeroRegistro = _data["numeroRegistro"];
            this.responsable = _data["responsable"];
            this.umf = _data["umf"];
            this.tratamientoDp = _data["tratamientoDp"];
            this.tratamientoHd = _data["tratamientoHd"];
            this.clavePresupuestal = _data["clavePresupuestal"];
            this.enviaMensajesHL7 = _data["enviaMensajesHL7"];
            this.contrato = _data["contrato"];
            this.rfc = _data["rfc"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.delegacionDesc = _data["delegacionDesc"];
            this.municipioDesc = _data["municipioDesc"];
            this.institucionesAseguradasDesc = _data["institucionesAseguradasDesc"];
            this.paisId = _data["paisId"];
            this.paisDesc = _data["paisDesc"];
            this.estadoId = _data["estadoId"];
            this.estadoDesc = _data["estadoDesc"];
        }
    }

    static fromJS(data: any): HospitalDto {
        data = typeof data === 'object' ? data : {};
        let result = new HospitalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["delegacionId"] = this.delegacionId;
        data["municipioId"] = this.municipioId;
        data["institucionesAseguradasId"] = this.institucionesAseguradasId;
        data["codigoHospital"] = this.codigoHospital;
        data["nombre"] = this.nombre;
        data["direccion"] = this.direccion;
        data["telefono1"] = this.telefono1;
        data["numExt1"] = this.numExt1;
        data["telefono2"] = this.telefono2;
        data["numExt2"] = this.numExt2;
        data["telefono3"] = this.telefono3;
        data["numExt3"] = this.numExt3;
        data["fax"] = this.fax;
        data["numeroRegistro"] = this.numeroRegistro;
        data["responsable"] = this.responsable;
        data["umf"] = this.umf;
        data["tratamientoDp"] = this.tratamientoDp;
        data["tratamientoHd"] = this.tratamientoHd;
        data["clavePresupuestal"] = this.clavePresupuestal;
        data["enviaMensajesHL7"] = this.enviaMensajesHL7;
        data["contrato"] = this.contrato;
        data["rfc"] = this.rfc;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["delegacionDesc"] = this.delegacionDesc;
        data["municipioDesc"] = this.municipioDesc;
        data["institucionesAseguradasDesc"] = this.institucionesAseguradasDesc;
        data["paisId"] = this.paisId;
        data["paisDesc"] = this.paisDesc;
        data["estadoId"] = this.estadoId;
        data["estadoDesc"] = this.estadoDesc;
        return data;
    }
}

export interface IHospitalDto {
    id: number;
    delegacionId?: number | undefined;
    municipioId: number;
    institucionesAseguradasId: number;
    codigoHospital?: string | undefined;
    nombre?: string | undefined;
    direccion?: string | undefined;
    telefono1?: string | undefined;
    numExt1?: string | undefined;
    telefono2?: string | undefined;
    numExt2?: string | undefined;
    telefono3?: string | undefined;
    numExt3?: string | undefined;
    fax?: string | undefined;
    numeroRegistro?: string | undefined;
    responsable?: string | undefined;
    umf?: string | undefined;
    tratamientoDp: boolean;
    tratamientoHd: boolean;
    clavePresupuestal?: string | undefined;
    enviaMensajesHL7?: boolean | undefined;
    contrato?: string | undefined;
    rfc?: string | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
    delegacionDesc?: string | undefined;
    municipioDesc?: string | undefined;
    institucionesAseguradasDesc?: string | undefined;
    paisId: number;
    paisDesc?: string | undefined;
    estadoId: number;
    estadoDesc?: string | undefined;
}

export class EstatusGetPermitidosParaPacienteForComboboxQuery extends PageListByDto implements IEstatusGetPermitidosParaPacienteForComboboxQuery {
    pacienteId?: number | undefined;

    constructor(data?: IEstatusGetPermitidosParaPacienteForComboboxQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pacienteId = _data["pacienteId"];
        }
    }

    static override fromJS(data: any): EstatusGetPermitidosParaPacienteForComboboxQuery {
        data = typeof data === 'object' ? data : {};
        let result = new EstatusGetPermitidosParaPacienteForComboboxQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        super.toJSON(data);
        return data;
    }
}

export interface IEstatusGetPermitidosParaPacienteForComboboxQuery extends IPageListByDto {
    pacienteId?: number | undefined;
}

export class PagedResultDtoOfCausaInclusionProgramaResponse implements IPagedResultDtoOfCausaInclusionProgramaResponse {
    totalCount!: number;
    items?: CausaInclusionProgramaResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfCausaInclusionProgramaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CausaInclusionProgramaResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCausaInclusionProgramaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCausaInclusionProgramaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfCausaInclusionProgramaResponse {
    totalCount: number;
    items?: CausaInclusionProgramaResponse[] | undefined;
}

export class CausaInclusionProgramaResponse implements ICausaInclusionProgramaResponse {
    id!: number;
    descripcion?: string | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;

    constructor(data?: ICausaInclusionProgramaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descripcion = _data["descripcion"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CausaInclusionProgramaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CausaInclusionProgramaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descripcion"] = this.descripcion;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICausaInclusionProgramaResponse {
    id: number;
    descripcion?: string | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
}

export class CausaInclusionProgramaGetListQuery extends PageListByDto implements ICausaInclusionProgramaGetListQuery {

    constructor(data?: ICausaInclusionProgramaGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CausaInclusionProgramaGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CausaInclusionProgramaGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICausaInclusionProgramaGetListQuery extends IPageListByDto {
}

export class PagedResultDtoOfEventoResponse implements IPagedResultDtoOfEventoResponse {
    totalCount!: number;
    items?: EventoResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfEventoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EventoResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEventoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEventoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfEventoResponse {
    totalCount: number;
    items?: EventoResponse[] | undefined;
}

export class EventoResponse implements IEventoResponse {
    id!: number;
    tipoCatalogoId!: number;
    tipoCatalogoDesc?: string | undefined;
    tipoEventoId!: number;
    tipoEventoDesc?: string | undefined;
    descripcion?: string | undefined;
    descripcionAmpliada?: string | undefined;
    codificacion?: string | undefined;
    codigoOficial?: string | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;

    constructor(data?: IEventoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tipoCatalogoId = _data["tipoCatalogoId"];
            this.tipoCatalogoDesc = _data["tipoCatalogoDesc"];
            this.tipoEventoId = _data["tipoEventoId"];
            this.tipoEventoDesc = _data["tipoEventoDesc"];
            this.descripcion = _data["descripcion"];
            this.descripcionAmpliada = _data["descripcionAmpliada"];
            this.codificacion = _data["codificacion"];
            this.codigoOficial = _data["codigoOficial"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): EventoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EventoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tipoCatalogoId"] = this.tipoCatalogoId;
        data["tipoCatalogoDesc"] = this.tipoCatalogoDesc;
        data["tipoEventoId"] = this.tipoEventoId;
        data["tipoEventoDesc"] = this.tipoEventoDesc;
        data["descripcion"] = this.descripcion;
        data["descripcionAmpliada"] = this.descripcionAmpliada;
        data["codificacion"] = this.codificacion;
        data["codigoOficial"] = this.codigoOficial;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IEventoResponse {
    id: number;
    tipoCatalogoId: number;
    tipoCatalogoDesc?: string | undefined;
    tipoEventoId: number;
    tipoEventoDesc?: string | undefined;
    descripcion?: string | undefined;
    descripcionAmpliada?: string | undefined;
    codificacion?: string | undefined;
    codigoOficial?: string | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
}

export class EventoGetListQuery extends PageListByDto implements IEventoGetListQuery {
    tipoEvento?: number | undefined;
    tipoCatalogo?: number | undefined;

    constructor(data?: IEventoGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipoEvento = _data["tipoEvento"];
            this.tipoCatalogo = _data["tipoCatalogo"];
        }
    }

    static override fromJS(data: any): EventoGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new EventoGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoEvento"] = this.tipoEvento;
        data["tipoCatalogo"] = this.tipoCatalogo;
        super.toJSON(data);
        return data;
    }
}

export interface IEventoGetListQuery extends IPageListByDto {
    tipoEvento?: number | undefined;
    tipoCatalogo?: number | undefined;
}

export class PagedResultDtoOfMedicamentoResponse implements IPagedResultDtoOfMedicamentoResponse {
    totalCount!: number;
    items?: MedicamentoResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfMedicamentoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MedicamentoResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMedicamentoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMedicamentoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfMedicamentoResponse {
    totalCount: number;
    items?: MedicamentoResponse[] | undefined;
}

export class MedicamentoResponse implements IMedicamentoResponse {
    id!: number;
    subGruposMedicamentosId?: number | undefined;
    subGruposMedicamentosDesc?: string | undefined;
    unidadContenidoMedicamentoId?: number | undefined;
    unidadContenidoMedicamentoDesc?: string | undefined;
    unidadMedidaMedicamentoId?: number | undefined;
    unidadMedidaMedicamentoDesc?: string | undefined;
    viaAdministracionMedicamentoId?: number | undefined;
    viaAdministracionMedicamentoDesc?: string | undefined;
    tipoMedicamentoId?: number | undefined;
    tipoMedicamentoDesc?: string | undefined;
    presentacionMedicamentoId?: number | undefined;
    presentacionMedicamentoDesc?: string | undefined;
    codigoMedicamento?: string | undefined;
    descripcion?: string | undefined;
    claveCuadroBasico?: string | undefined;
    presentacion?: string | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;

    constructor(data?: IMedicamentoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subGruposMedicamentosId = _data["subGruposMedicamentosId"];
            this.subGruposMedicamentosDesc = _data["subGruposMedicamentosDesc"];
            this.unidadContenidoMedicamentoId = _data["unidadContenidoMedicamentoId"];
            this.unidadContenidoMedicamentoDesc = _data["unidadContenidoMedicamentoDesc"];
            this.unidadMedidaMedicamentoId = _data["unidadMedidaMedicamentoId"];
            this.unidadMedidaMedicamentoDesc = _data["unidadMedidaMedicamentoDesc"];
            this.viaAdministracionMedicamentoId = _data["viaAdministracionMedicamentoId"];
            this.viaAdministracionMedicamentoDesc = _data["viaAdministracionMedicamentoDesc"];
            this.tipoMedicamentoId = _data["tipoMedicamentoId"];
            this.tipoMedicamentoDesc = _data["tipoMedicamentoDesc"];
            this.presentacionMedicamentoId = _data["presentacionMedicamentoId"];
            this.presentacionMedicamentoDesc = _data["presentacionMedicamentoDesc"];
            this.codigoMedicamento = _data["codigoMedicamento"];
            this.descripcion = _data["descripcion"];
            this.claveCuadroBasico = _data["claveCuadroBasico"];
            this.presentacion = _data["presentacion"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): MedicamentoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MedicamentoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subGruposMedicamentosId"] = this.subGruposMedicamentosId;
        data["subGruposMedicamentosDesc"] = this.subGruposMedicamentosDesc;
        data["unidadContenidoMedicamentoId"] = this.unidadContenidoMedicamentoId;
        data["unidadContenidoMedicamentoDesc"] = this.unidadContenidoMedicamentoDesc;
        data["unidadMedidaMedicamentoId"] = this.unidadMedidaMedicamentoId;
        data["unidadMedidaMedicamentoDesc"] = this.unidadMedidaMedicamentoDesc;
        data["viaAdministracionMedicamentoId"] = this.viaAdministracionMedicamentoId;
        data["viaAdministracionMedicamentoDesc"] = this.viaAdministracionMedicamentoDesc;
        data["tipoMedicamentoId"] = this.tipoMedicamentoId;
        data["tipoMedicamentoDesc"] = this.tipoMedicamentoDesc;
        data["presentacionMedicamentoId"] = this.presentacionMedicamentoId;
        data["presentacionMedicamentoDesc"] = this.presentacionMedicamentoDesc;
        data["codigoMedicamento"] = this.codigoMedicamento;
        data["descripcion"] = this.descripcion;
        data["claveCuadroBasico"] = this.claveCuadroBasico;
        data["presentacion"] = this.presentacion;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IMedicamentoResponse {
    id: number;
    subGruposMedicamentosId?: number | undefined;
    subGruposMedicamentosDesc?: string | undefined;
    unidadContenidoMedicamentoId?: number | undefined;
    unidadContenidoMedicamentoDesc?: string | undefined;
    unidadMedidaMedicamentoId?: number | undefined;
    unidadMedidaMedicamentoDesc?: string | undefined;
    viaAdministracionMedicamentoId?: number | undefined;
    viaAdministracionMedicamentoDesc?: string | undefined;
    tipoMedicamentoId?: number | undefined;
    tipoMedicamentoDesc?: string | undefined;
    presentacionMedicamentoId?: number | undefined;
    presentacionMedicamentoDesc?: string | undefined;
    codigoMedicamento?: string | undefined;
    descripcion?: string | undefined;
    claveCuadroBasico?: string | undefined;
    presentacion?: string | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
}

export class MedicamentoGetListQuery extends PageListByDto implements IMedicamentoGetListQuery {

    constructor(data?: IMedicamentoGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MedicamentoGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MedicamentoGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMedicamentoGetListQuery extends IPageListByDto {
}

export class TipoFiltroDializadorDto implements ITipoFiltroDializadorDto {
    id!: number;
    tipoMembranaId!: number;
    tiposMembranasDescripcion?: string | undefined;
    codigoDializador?: string | undefined;
    descripcion?: string | undefined;
    superficie?: number | undefined;
    factorKuf?: number | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;

    constructor(data?: ITipoFiltroDializadorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tipoMembranaId = _data["tipoMembranaId"];
            this.tiposMembranasDescripcion = _data["tiposMembranasDescripcion"];
            this.codigoDializador = _data["codigoDializador"];
            this.descripcion = _data["descripcion"];
            this.superficie = _data["superficie"];
            this.factorKuf = _data["factorKuf"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TipoFiltroDializadorDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipoFiltroDializadorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tipoMembranaId"] = this.tipoMembranaId;
        data["tiposMembranasDescripcion"] = this.tiposMembranasDescripcion;
        data["codigoDializador"] = this.codigoDializador;
        data["descripcion"] = this.descripcion;
        data["superficie"] = this.superficie;
        data["factorKuf"] = this.factorKuf;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITipoFiltroDializadorDto {
    id: number;
    tipoMembranaId: number;
    tiposMembranasDescripcion?: string | undefined;
    codigoDializador?: string | undefined;
    descripcion?: string | undefined;
    superficie?: number | undefined;
    factorKuf?: number | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
}

export class TipoConcentradoDto implements ITipoConcentradoDto {
    id!: number;
    descripcion?: string | undefined;
    porcentajePotasio?: number | undefined;
    porcentajeCalcio?: number | undefined;
    contieneBicarbonato!: boolean;
    contieneGlucosa!: boolean;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;

    constructor(data?: ITipoConcentradoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descripcion = _data["descripcion"];
            this.porcentajePotasio = _data["porcentajePotasio"];
            this.porcentajeCalcio = _data["porcentajeCalcio"];
            this.contieneBicarbonato = _data["contieneBicarbonato"];
            this.contieneGlucosa = _data["contieneGlucosa"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TipoConcentradoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipoConcentradoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descripcion"] = this.descripcion;
        data["porcentajePotasio"] = this.porcentajePotasio;
        data["porcentajeCalcio"] = this.porcentajeCalcio;
        data["contieneBicarbonato"] = this.contieneBicarbonato;
        data["contieneGlucosa"] = this.contieneGlucosa;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITipoConcentradoDto {
    id: number;
    descripcion?: string | undefined;
    porcentajePotasio?: number | undefined;
    porcentajeCalcio?: number | undefined;
    contieneBicarbonato: boolean;
    contieneGlucosa: boolean;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
}

export class AlimentoDto implements IAlimentoDto {
    id!: number;
    alimentoGrupoId!: number;
    alimentosGruposDescripcion?: string | undefined;
    codigoOficial?: string | undefined;
    descripcion?: string | undefined;
    cantidadEnergia?: number | undefined;
    cantidadFosforo?: number | undefined;
    cantidadCalcio?: number | undefined;
    cantidadSodio?: number | undefined;
    cantidadProteinas?: number | undefined;
    cantidadPotasio?: number | undefined;
    unidadPorcion?: string | undefined;
    cantidadSugerida?: string | undefined;
    pesoBruto?: number | undefined;
    pesoNeto?: number | undefined;

    constructor(data?: IAlimentoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.alimentoGrupoId = _data["alimentoGrupoId"];
            this.alimentosGruposDescripcion = _data["alimentosGruposDescripcion"];
            this.codigoOficial = _data["codigoOficial"];
            this.descripcion = _data["descripcion"];
            this.cantidadEnergia = _data["cantidadEnergia"];
            this.cantidadFosforo = _data["cantidadFosforo"];
            this.cantidadCalcio = _data["cantidadCalcio"];
            this.cantidadSodio = _data["cantidadSodio"];
            this.cantidadProteinas = _data["cantidadProteinas"];
            this.cantidadPotasio = _data["cantidadPotasio"];
            this.unidadPorcion = _data["unidadPorcion"];
            this.cantidadSugerida = _data["cantidadSugerida"];
            this.pesoBruto = _data["pesoBruto"];
            this.pesoNeto = _data["pesoNeto"];
        }
    }

    static fromJS(data: any): AlimentoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlimentoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["alimentoGrupoId"] = this.alimentoGrupoId;
        data["alimentosGruposDescripcion"] = this.alimentosGruposDescripcion;
        data["codigoOficial"] = this.codigoOficial;
        data["descripcion"] = this.descripcion;
        data["cantidadEnergia"] = this.cantidadEnergia;
        data["cantidadFosforo"] = this.cantidadFosforo;
        data["cantidadCalcio"] = this.cantidadCalcio;
        data["cantidadSodio"] = this.cantidadSodio;
        data["cantidadProteinas"] = this.cantidadProteinas;
        data["cantidadPotasio"] = this.cantidadPotasio;
        data["unidadPorcion"] = this.unidadPorcion;
        data["cantidadSugerida"] = this.cantidadSugerida;
        data["pesoBruto"] = this.pesoBruto;
        data["pesoNeto"] = this.pesoNeto;
        return data;
    }
}

export interface IAlimentoDto {
    id: number;
    alimentoGrupoId: number;
    alimentosGruposDescripcion?: string | undefined;
    codigoOficial?: string | undefined;
    descripcion?: string | undefined;
    cantidadEnergia?: number | undefined;
    cantidadFosforo?: number | undefined;
    cantidadCalcio?: number | undefined;
    cantidadSodio?: number | undefined;
    cantidadProteinas?: number | undefined;
    cantidadPotasio?: number | undefined;
    unidadPorcion?: string | undefined;
    cantidadSugerida?: string | undefined;
    pesoBruto?: number | undefined;
    pesoNeto?: number | undefined;
}

export class TipoConstanteMaquinaHDDto implements ITipoConstanteMaquinaHDDto {
    id!: number;
    tipoConstanteId?: number | undefined;
    tiposConstantesDescripcion?: string | undefined;
    clave?: string | undefined;
    conversionMedicion?: string | undefined;
    conversionUnidad?: string | undefined;
    descripcion?: string | undefined;
    enviaHL7?: boolean | undefined;
    fechaAlta?: moment.Moment | undefined;
    fechaModificacion?: moment.Moment | undefined;
    isActive?: boolean | undefined;
    orden?: number | undefined;
    unidadMedicion?: string | undefined;

    constructor(data?: ITipoConstanteMaquinaHDDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tipoConstanteId = _data["tipoConstanteId"];
            this.tiposConstantesDescripcion = _data["tiposConstantesDescripcion"];
            this.clave = _data["clave"];
            this.conversionMedicion = _data["conversionMedicion"];
            this.conversionUnidad = _data["conversionUnidad"];
            this.descripcion = _data["descripcion"];
            this.enviaHL7 = _data["enviaHL7"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.orden = _data["orden"];
            this.unidadMedicion = _data["unidadMedicion"];
        }
    }

    static fromJS(data: any): TipoConstanteMaquinaHDDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipoConstanteMaquinaHDDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tipoConstanteId"] = this.tipoConstanteId;
        data["tiposConstantesDescripcion"] = this.tiposConstantesDescripcion;
        data["clave"] = this.clave;
        data["conversionMedicion"] = this.conversionMedicion;
        data["conversionUnidad"] = this.conversionUnidad;
        data["descripcion"] = this.descripcion;
        data["enviaHL7"] = this.enviaHL7;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["orden"] = this.orden;
        data["unidadMedicion"] = this.unidadMedicion;
        return data;
    }
}

export interface ITipoConstanteMaquinaHDDto {
    id: number;
    tipoConstanteId?: number | undefined;
    tiposConstantesDescripcion?: string | undefined;
    clave?: string | undefined;
    conversionMedicion?: string | undefined;
    conversionUnidad?: string | undefined;
    descripcion?: string | undefined;
    enviaHL7?: boolean | undefined;
    fechaAlta?: moment.Moment | undefined;
    fechaModificacion?: moment.Moment | undefined;
    isActive?: boolean | undefined;
    orden?: number | undefined;
    unidadMedicion?: string | undefined;
}

export class ComboboxItemDtoOfString implements IComboboxItemDtoOfString {
    value?: string | undefined;
    label?: string | undefined;

    constructor(data?: IComboboxItemDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): ComboboxItemDtoOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IComboboxItemDtoOfString {
    value?: string | undefined;
    label?: string | undefined;
}

export class ComboboxItemDto extends ComboboxItemDtoOfString implements IComboboxItemDto {

    constructor(data?: IComboboxItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IComboboxItemDto extends IComboboxItemDtoOfString {
}

export class DynamicCatalogGetComboboxQuery implements IDynamicCatalogGetComboboxQuery {
    tipoCatalogos!: number;

    constructor(data?: IDynamicCatalogGetComboboxQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoCatalogos = _data["tipoCatalogos"];
        }
    }

    static fromJS(data: any): DynamicCatalogGetComboboxQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicCatalogGetComboboxQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoCatalogos"] = this.tipoCatalogos;
        return data;
    }
}

export interface IDynamicCatalogGetComboboxQuery {
    tipoCatalogos: number;
}

export class DynamicCatalogViewInfoResponse implements IDynamicCatalogViewInfoResponse {
    camposVistaList?: string[] | undefined;
    definitionsList?: DynamicCatalogDefinitionResponse[] | undefined;
    relationsList?: DynamicCatalogRelationResponse[] | undefined;
    campoLlavePrimaria?: string | undefined;

    constructor(data?: IDynamicCatalogViewInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["camposVistaList"])) {
                this.camposVistaList = [] as any;
                for (let item of _data["camposVistaList"])
                    this.camposVistaList!.push(item);
            }
            if (Array.isArray(_data["definitionsList"])) {
                this.definitionsList = [] as any;
                for (let item of _data["definitionsList"])
                    this.definitionsList!.push(DynamicCatalogDefinitionResponse.fromJS(item));
            }
            if (Array.isArray(_data["relationsList"])) {
                this.relationsList = [] as any;
                for (let item of _data["relationsList"])
                    this.relationsList!.push(DynamicCatalogRelationResponse.fromJS(item));
            }
            this.campoLlavePrimaria = _data["campoLlavePrimaria"];
        }
    }

    static fromJS(data: any): DynamicCatalogViewInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicCatalogViewInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.camposVistaList)) {
            data["camposVistaList"] = [];
            for (let item of this.camposVistaList)
                data["camposVistaList"].push(item);
        }
        if (Array.isArray(this.definitionsList)) {
            data["definitionsList"] = [];
            for (let item of this.definitionsList)
                data["definitionsList"].push(item.toJSON());
        }
        if (Array.isArray(this.relationsList)) {
            data["relationsList"] = [];
            for (let item of this.relationsList)
                data["relationsList"].push(item.toJSON());
        }
        data["campoLlavePrimaria"] = this.campoLlavePrimaria;
        return data;
    }
}

export interface IDynamicCatalogViewInfoResponse {
    camposVistaList?: string[] | undefined;
    definitionsList?: DynamicCatalogDefinitionResponse[] | undefined;
    relationsList?: DynamicCatalogRelationResponse[] | undefined;
    campoLlavePrimaria?: string | undefined;
}

export class DynamicCatalogDefinitionResponse implements IDynamicCatalogDefinitionResponse {
    id!: number;
    campo?: string | undefined;
    tipo?: string | undefined;
    longitud?: number | undefined;
    decimales?: number | undefined;
    mostrarEnVista!: boolean;
    mostrarEnCaptura!: boolean;
    editableEnCaptura!: boolean;
    posicion!: number;

    constructor(data?: IDynamicCatalogDefinitionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.campo = _data["campo"];
            this.tipo = _data["tipo"];
            this.longitud = _data["longitud"];
            this.decimales = _data["decimales"];
            this.mostrarEnVista = _data["mostrarEnVista"];
            this.mostrarEnCaptura = _data["mostrarEnCaptura"];
            this.editableEnCaptura = _data["editableEnCaptura"];
            this.posicion = _data["posicion"];
        }
    }

    static fromJS(data: any): DynamicCatalogDefinitionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicCatalogDefinitionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["campo"] = this.campo;
        data["tipo"] = this.tipo;
        data["longitud"] = this.longitud;
        data["decimales"] = this.decimales;
        data["mostrarEnVista"] = this.mostrarEnVista;
        data["mostrarEnCaptura"] = this.mostrarEnCaptura;
        data["editableEnCaptura"] = this.editableEnCaptura;
        data["posicion"] = this.posicion;
        return data;
    }
}

export interface IDynamicCatalogDefinitionResponse {
    id: number;
    campo?: string | undefined;
    tipo?: string | undefined;
    longitud?: number | undefined;
    decimales?: number | undefined;
    mostrarEnVista: boolean;
    mostrarEnCaptura: boolean;
    editableEnCaptura: boolean;
    posicion: number;
}

export class DynamicCatalogRelationResponse implements IDynamicCatalogRelationResponse {
    id!: number;
    campoRelacion?: string | undefined;
    tablaRelacionada?: string | undefined;
    campoReferenciado?: string | undefined;
    campoDescReferenciado?: string | undefined;

    constructor(data?: IDynamicCatalogRelationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.campoRelacion = _data["campoRelacion"];
            this.tablaRelacionada = _data["tablaRelacionada"];
            this.campoReferenciado = _data["campoReferenciado"];
            this.campoDescReferenciado = _data["campoDescReferenciado"];
        }
    }

    static fromJS(data: any): DynamicCatalogRelationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicCatalogRelationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["campoRelacion"] = this.campoRelacion;
        data["tablaRelacionada"] = this.tablaRelacionada;
        data["campoReferenciado"] = this.campoReferenciado;
        data["campoDescReferenciado"] = this.campoDescReferenciado;
        return data;
    }
}

export interface IDynamicCatalogRelationResponse {
    id: number;
    campoRelacion?: string | undefined;
    tablaRelacionada?: string | undefined;
    campoReferenciado?: string | undefined;
    campoDescReferenciado?: string | undefined;
}

export class DynamicCatalogGetVistaInfoQuery implements IDynamicCatalogGetVistaInfoQuery {
    tabla?: string | undefined;

    constructor(data?: IDynamicCatalogGetVistaInfoQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabla = _data["tabla"];
        }
    }

    static fromJS(data: any): DynamicCatalogGetVistaInfoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicCatalogGetVistaInfoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabla"] = this.tabla;
        return data;
    }
}

export interface IDynamicCatalogGetVistaInfoQuery {
    tabla?: string | undefined;
}

export class DynamicCatalogFormInfoResponse implements IDynamicCatalogFormInfoResponse {
    definitionsList?: DynamicCatalogDefinitionResponse[] | undefined;
    validationsList?: DynamicCatalogValidationResponse[] | undefined;
    relationsList?: DynamicCatalogRelationResponse[] | undefined;
    campoLlavePrimaria?: string | undefined;

    constructor(data?: IDynamicCatalogFormInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["definitionsList"])) {
                this.definitionsList = [] as any;
                for (let item of _data["definitionsList"])
                    this.definitionsList!.push(DynamicCatalogDefinitionResponse.fromJS(item));
            }
            if (Array.isArray(_data["validationsList"])) {
                this.validationsList = [] as any;
                for (let item of _data["validationsList"])
                    this.validationsList!.push(DynamicCatalogValidationResponse.fromJS(item));
            }
            if (Array.isArray(_data["relationsList"])) {
                this.relationsList = [] as any;
                for (let item of _data["relationsList"])
                    this.relationsList!.push(DynamicCatalogRelationResponse.fromJS(item));
            }
            this.campoLlavePrimaria = _data["campoLlavePrimaria"];
        }
    }

    static fromJS(data: any): DynamicCatalogFormInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicCatalogFormInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.definitionsList)) {
            data["definitionsList"] = [];
            for (let item of this.definitionsList)
                data["definitionsList"].push(item.toJSON());
        }
        if (Array.isArray(this.validationsList)) {
            data["validationsList"] = [];
            for (let item of this.validationsList)
                data["validationsList"].push(item.toJSON());
        }
        if (Array.isArray(this.relationsList)) {
            data["relationsList"] = [];
            for (let item of this.relationsList)
                data["relationsList"].push(item.toJSON());
        }
        data["campoLlavePrimaria"] = this.campoLlavePrimaria;
        return data;
    }
}

export interface IDynamicCatalogFormInfoResponse {
    definitionsList?: DynamicCatalogDefinitionResponse[] | undefined;
    validationsList?: DynamicCatalogValidationResponse[] | undefined;
    relationsList?: DynamicCatalogRelationResponse[] | undefined;
    campoLlavePrimaria?: string | undefined;
}

export class DynamicCatalogValidationResponse implements IDynamicCatalogValidationResponse {
    id!: number;
    campo?: string | undefined;
    regla!: number;
    valorReferencia?: string | undefined;

    constructor(data?: IDynamicCatalogValidationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.campo = _data["campo"];
            this.regla = _data["regla"];
            this.valorReferencia = _data["valorReferencia"];
        }
    }

    static fromJS(data: any): DynamicCatalogValidationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicCatalogValidationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["campo"] = this.campo;
        data["regla"] = this.regla;
        data["valorReferencia"] = this.valorReferencia;
        return data;
    }
}

export interface IDynamicCatalogValidationResponse {
    id: number;
    campo?: string | undefined;
    regla: number;
    valorReferencia?: string | undefined;
}

export class DynamicCatalogGetFormInfoQuery implements IDynamicCatalogGetFormInfoQuery {
    tabla?: string | undefined;

    constructor(data?: IDynamicCatalogGetFormInfoQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabla = _data["tabla"];
        }
    }

    static fromJS(data: any): DynamicCatalogGetFormInfoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicCatalogGetFormInfoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabla"] = this.tabla;
        return data;
    }
}

export interface IDynamicCatalogGetFormInfoQuery {
    tabla?: string | undefined;
}

export class DataListQuery implements IDataListQuery {
    tabla?: string | undefined;
    sorting?: string | undefined;
    filter?: string | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
    isPaged!: boolean;

    constructor(data?: IDataListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabla = _data["tabla"];
            this.sorting = _data["sorting"];
            this.filter = _data["filter"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.isPaged = _data["isPaged"];
        }
    }

    static fromJS(data: any): DataListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DataListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabla"] = this.tabla;
        data["sorting"] = this.sorting;
        data["filter"] = this.filter;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["isPaged"] = this.isPaged;
        return data;
    }
}

export interface IDataListQuery {
    tabla?: string | undefined;
    sorting?: string | undefined;
    filter?: string | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
    isPaged: boolean;
}

export class DataByIdQuery implements IDataByIdQuery {
    tabla?: string | undefined;
    id?: string | undefined;

    constructor(data?: IDataByIdQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabla = _data["tabla"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DataByIdQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DataByIdQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabla"] = this.tabla;
        data["id"] = this.id;
        return data;
    }
}

export interface IDataByIdQuery {
    tabla?: string | undefined;
    id?: string | undefined;
}

export class DynamicCatalogCreateCommand implements IDynamicCatalogCreateCommand {
    tabla?: string | undefined;
    data?: { [key: string]: any; } | undefined;

    constructor(data?: IDynamicCatalogCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabla = _data["tabla"];
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
        }
    }

    static fromJS(data: any): DynamicCatalogCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicCatalogCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabla"] = this.tabla;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        return data;
    }
}

export interface IDynamicCatalogCreateCommand {
    tabla?: string | undefined;
    data?: { [key: string]: any; } | undefined;
}

export class DynamicCatalogUpdateCommand implements IDynamicCatalogUpdateCommand {
    tabla?: string | undefined;
    data?: { [key: string]: any; } | undefined;

    constructor(data?: IDynamicCatalogUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabla = _data["tabla"];
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
        }
    }

    static fromJS(data: any): DynamicCatalogUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicCatalogUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabla"] = this.tabla;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        return data;
    }
}

export interface IDynamicCatalogUpdateCommand {
    tabla?: string | undefined;
    data?: { [key: string]: any; } | undefined;
}

export class DynamicCatalogDeleteCommand implements IDynamicCatalogDeleteCommand {
    tabla?: string | undefined;
    id?: string | undefined;

    constructor(data?: IDynamicCatalogDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabla = _data["tabla"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DynamicCatalogDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicCatalogDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabla"] = this.tabla;
        data["id"] = this.id;
        return data;
    }
}

export interface IDynamicCatalogDeleteCommand {
    tabla?: string | undefined;
    id?: string | undefined;
}

export class GetReferencedComboboxQuery implements IGetReferencedComboboxQuery {
    table?: string | undefined;
    field?: string | undefined;

    constructor(data?: IGetReferencedComboboxQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.table = _data["table"];
            this.field = _data["field"];
        }
    }

    static fromJS(data: any): GetReferencedComboboxQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetReferencedComboboxQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["table"] = this.table;
        data["field"] = this.field;
        return data;
    }
}

export interface IGetReferencedComboboxQuery {
    table?: string | undefined;
    field?: string | undefined;
}

export class PagedResultDtoOfHospitalForListResponse implements IPagedResultDtoOfHospitalForListResponse {
    totalCount!: number;
    items?: HospitalForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfHospitalForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HospitalForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfHospitalForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfHospitalForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfHospitalForListResponse {
    totalCount: number;
    items?: HospitalForListResponse[] | undefined;
}

export class HospitalForListResponse implements IHospitalForListResponse {
    id!: number;
    delegacionId?: number | undefined;
    delegacionDesc?: string | undefined;
    municipioId!: number;
    municipioDesc?: string | undefined;
    institucionesAseguradasId!: number;
    institucionesAseguradasDesc?: string | undefined;
    codigoHospital?: string | undefined;
    nombre?: string | undefined;
    rfc?: string | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;

    constructor(data?: IHospitalForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.delegacionId = _data["delegacionId"];
            this.delegacionDesc = _data["delegacionDesc"];
            this.municipioId = _data["municipioId"];
            this.municipioDesc = _data["municipioDesc"];
            this.institucionesAseguradasId = _data["institucionesAseguradasId"];
            this.institucionesAseguradasDesc = _data["institucionesAseguradasDesc"];
            this.codigoHospital = _data["codigoHospital"];
            this.nombre = _data["nombre"];
            this.rfc = _data["rfc"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): HospitalForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HospitalForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["delegacionId"] = this.delegacionId;
        data["delegacionDesc"] = this.delegacionDesc;
        data["municipioId"] = this.municipioId;
        data["municipioDesc"] = this.municipioDesc;
        data["institucionesAseguradasId"] = this.institucionesAseguradasId;
        data["institucionesAseguradasDesc"] = this.institucionesAseguradasDesc;
        data["codigoHospital"] = this.codigoHospital;
        data["nombre"] = this.nombre;
        data["rfc"] = this.rfc;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IHospitalForListResponse {
    id: number;
    delegacionId?: number | undefined;
    delegacionDesc?: string | undefined;
    municipioId: number;
    municipioDesc?: string | undefined;
    institucionesAseguradasId: number;
    institucionesAseguradasDesc?: string | undefined;
    codigoHospital?: string | undefined;
    nombre?: string | undefined;
    rfc?: string | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
}

export class HospitalGetListQuery extends PageListByDto implements IHospitalGetListQuery {

    constructor(data?: IHospitalGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): HospitalGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new HospitalGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IHospitalGetListQuery extends IPageListByDto {
}

export class HospitalForEditResponse implements IHospitalForEditResponse {
    id!: number;
    delegacionId?: number | undefined;
    paisId!: number;
    estadoId!: number;
    municipioId!: number;
    institucionesAseguradasId!: number;
    codigoHospital?: string | undefined;
    nombre?: string | undefined;
    direccion?: string | undefined;
    telefono1?: string | undefined;
    numExt1?: string | undefined;
    telefono2?: string | undefined;
    numExt2?: string | undefined;
    telefono3?: string | undefined;
    numExt3?: string | undefined;
    fax?: string | undefined;
    numeroRegistro?: string | undefined;
    responsable?: string | undefined;
    umf?: string | undefined;
    tratamientoDp!: boolean;
    tratamientoHd!: boolean;
    clavePresupuestal?: string | undefined;
    enviaMensajesHL7?: boolean | undefined;
    contrato?: string | undefined;
    rfc?: string | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;
    delegacionDesc?: string | undefined;
    municipioDesc?: string | undefined;
    institucionesAseguradasDesc?: string | undefined;

    constructor(data?: IHospitalForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.delegacionId = _data["delegacionId"];
            this.paisId = _data["paisId"];
            this.estadoId = _data["estadoId"];
            this.municipioId = _data["municipioId"];
            this.institucionesAseguradasId = _data["institucionesAseguradasId"];
            this.codigoHospital = _data["codigoHospital"];
            this.nombre = _data["nombre"];
            this.direccion = _data["direccion"];
            this.telefono1 = _data["telefono1"];
            this.numExt1 = _data["numExt1"];
            this.telefono2 = _data["telefono2"];
            this.numExt2 = _data["numExt2"];
            this.telefono3 = _data["telefono3"];
            this.numExt3 = _data["numExt3"];
            this.fax = _data["fax"];
            this.numeroRegistro = _data["numeroRegistro"];
            this.responsable = _data["responsable"];
            this.umf = _data["umf"];
            this.tratamientoDp = _data["tratamientoDp"];
            this.tratamientoHd = _data["tratamientoHd"];
            this.clavePresupuestal = _data["clavePresupuestal"];
            this.enviaMensajesHL7 = _data["enviaMensajesHL7"];
            this.contrato = _data["contrato"];
            this.rfc = _data["rfc"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.delegacionDesc = _data["delegacionDesc"];
            this.municipioDesc = _data["municipioDesc"];
            this.institucionesAseguradasDesc = _data["institucionesAseguradasDesc"];
        }
    }

    static fromJS(data: any): HospitalForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HospitalForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["delegacionId"] = this.delegacionId;
        data["paisId"] = this.paisId;
        data["estadoId"] = this.estadoId;
        data["municipioId"] = this.municipioId;
        data["institucionesAseguradasId"] = this.institucionesAseguradasId;
        data["codigoHospital"] = this.codigoHospital;
        data["nombre"] = this.nombre;
        data["direccion"] = this.direccion;
        data["telefono1"] = this.telefono1;
        data["numExt1"] = this.numExt1;
        data["telefono2"] = this.telefono2;
        data["numExt2"] = this.numExt2;
        data["telefono3"] = this.telefono3;
        data["numExt3"] = this.numExt3;
        data["fax"] = this.fax;
        data["numeroRegistro"] = this.numeroRegistro;
        data["responsable"] = this.responsable;
        data["umf"] = this.umf;
        data["tratamientoDp"] = this.tratamientoDp;
        data["tratamientoHd"] = this.tratamientoHd;
        data["clavePresupuestal"] = this.clavePresupuestal;
        data["enviaMensajesHL7"] = this.enviaMensajesHL7;
        data["contrato"] = this.contrato;
        data["rfc"] = this.rfc;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["delegacionDesc"] = this.delegacionDesc;
        data["municipioDesc"] = this.municipioDesc;
        data["institucionesAseguradasDesc"] = this.institucionesAseguradasDesc;
        return data;
    }
}

export interface IHospitalForEditResponse {
    id: number;
    delegacionId?: number | undefined;
    paisId: number;
    estadoId: number;
    municipioId: number;
    institucionesAseguradasId: number;
    codigoHospital?: string | undefined;
    nombre?: string | undefined;
    direccion?: string | undefined;
    telefono1?: string | undefined;
    numExt1?: string | undefined;
    telefono2?: string | undefined;
    numExt2?: string | undefined;
    telefono3?: string | undefined;
    numExt3?: string | undefined;
    fax?: string | undefined;
    numeroRegistro?: string | undefined;
    responsable?: string | undefined;
    umf?: string | undefined;
    tratamientoDp: boolean;
    tratamientoHd: boolean;
    clavePresupuestal?: string | undefined;
    enviaMensajesHL7?: boolean | undefined;
    contrato?: string | undefined;
    rfc?: string | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
    delegacionDesc?: string | undefined;
    municipioDesc?: string | undefined;
    institucionesAseguradasDesc?: string | undefined;
}

export class HospitalGetForEditQuery implements IHospitalGetForEditQuery {
    id?: number | undefined;

    constructor(data?: IHospitalGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HospitalGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new HospitalGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IHospitalGetForEditQuery {
    id?: number | undefined;
}

export class HospitalGetForComboboxQuery implements IHospitalGetForComboboxQuery {
    filter?: string | undefined;
    includeInactives!: boolean;
    delegacion?: number | undefined;
    hasTenant?: boolean | undefined;

    constructor(data?: IHospitalGetForComboboxQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.includeInactives = _data["includeInactives"];
            this.delegacion = _data["delegacion"];
            this.hasTenant = _data["hasTenant"];
        }
    }

    static fromJS(data: any): HospitalGetForComboboxQuery {
        data = typeof data === 'object' ? data : {};
        let result = new HospitalGetForComboboxQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["includeInactives"] = this.includeInactives;
        data["delegacion"] = this.delegacion;
        data["hasTenant"] = this.hasTenant;
        return data;
    }
}

export interface IHospitalGetForComboboxQuery {
    filter?: string | undefined;
    includeInactives: boolean;
    delegacion?: number | undefined;
    hasTenant?: boolean | undefined;
}

export class HospitalResponse implements IHospitalResponse {
    id!: number;
    delegacionId?: number | undefined;
    paisId!: number;
    estadoId!: number;
    municipioId!: number;
    institucionesAseguradasId!: number;
    codigoHospital?: string | undefined;
    nombre?: string | undefined;
    direccion?: string | undefined;
    telefono1?: string | undefined;
    numExt1?: string | undefined;
    telefono2?: string | undefined;
    numExt2?: string | undefined;
    telefono3?: string | undefined;
    numExt3?: string | undefined;
    fax?: string | undefined;
    numeroRegistro?: string | undefined;
    responsable?: string | undefined;
    umf?: string | undefined;
    tratamientoDp!: boolean;
    tratamientoHd!: boolean;
    clavePresupuestal?: string | undefined;
    enviaMensajesHL7?: boolean | undefined;
    contrato?: string | undefined;
    rfc?: string | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;
    delegacionDesc?: string | undefined;
    municipioDesc?: string | undefined;
    institucionesAseguradasDesc?: string | undefined;

    constructor(data?: IHospitalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.delegacionId = _data["delegacionId"];
            this.paisId = _data["paisId"];
            this.estadoId = _data["estadoId"];
            this.municipioId = _data["municipioId"];
            this.institucionesAseguradasId = _data["institucionesAseguradasId"];
            this.codigoHospital = _data["codigoHospital"];
            this.nombre = _data["nombre"];
            this.direccion = _data["direccion"];
            this.telefono1 = _data["telefono1"];
            this.numExt1 = _data["numExt1"];
            this.telefono2 = _data["telefono2"];
            this.numExt2 = _data["numExt2"];
            this.telefono3 = _data["telefono3"];
            this.numExt3 = _data["numExt3"];
            this.fax = _data["fax"];
            this.numeroRegistro = _data["numeroRegistro"];
            this.responsable = _data["responsable"];
            this.umf = _data["umf"];
            this.tratamientoDp = _data["tratamientoDp"];
            this.tratamientoHd = _data["tratamientoHd"];
            this.clavePresupuestal = _data["clavePresupuestal"];
            this.enviaMensajesHL7 = _data["enviaMensajesHL7"];
            this.contrato = _data["contrato"];
            this.rfc = _data["rfc"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.delegacionDesc = _data["delegacionDesc"];
            this.municipioDesc = _data["municipioDesc"];
            this.institucionesAseguradasDesc = _data["institucionesAseguradasDesc"];
        }
    }

    static fromJS(data: any): HospitalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HospitalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["delegacionId"] = this.delegacionId;
        data["paisId"] = this.paisId;
        data["estadoId"] = this.estadoId;
        data["municipioId"] = this.municipioId;
        data["institucionesAseguradasId"] = this.institucionesAseguradasId;
        data["codigoHospital"] = this.codigoHospital;
        data["nombre"] = this.nombre;
        data["direccion"] = this.direccion;
        data["telefono1"] = this.telefono1;
        data["numExt1"] = this.numExt1;
        data["telefono2"] = this.telefono2;
        data["numExt2"] = this.numExt2;
        data["telefono3"] = this.telefono3;
        data["numExt3"] = this.numExt3;
        data["fax"] = this.fax;
        data["numeroRegistro"] = this.numeroRegistro;
        data["responsable"] = this.responsable;
        data["umf"] = this.umf;
        data["tratamientoDp"] = this.tratamientoDp;
        data["tratamientoHd"] = this.tratamientoHd;
        data["clavePresupuestal"] = this.clavePresupuestal;
        data["enviaMensajesHL7"] = this.enviaMensajesHL7;
        data["contrato"] = this.contrato;
        data["rfc"] = this.rfc;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["delegacionDesc"] = this.delegacionDesc;
        data["municipioDesc"] = this.municipioDesc;
        data["institucionesAseguradasDesc"] = this.institucionesAseguradasDesc;
        return data;
    }
}

export interface IHospitalResponse {
    id: number;
    delegacionId?: number | undefined;
    paisId: number;
    estadoId: number;
    municipioId: number;
    institucionesAseguradasId: number;
    codigoHospital?: string | undefined;
    nombre?: string | undefined;
    direccion?: string | undefined;
    telefono1?: string | undefined;
    numExt1?: string | undefined;
    telefono2?: string | undefined;
    numExt2?: string | undefined;
    telefono3?: string | undefined;
    numExt3?: string | undefined;
    fax?: string | undefined;
    numeroRegistro?: string | undefined;
    responsable?: string | undefined;
    umf?: string | undefined;
    tratamientoDp: boolean;
    tratamientoHd: boolean;
    clavePresupuestal?: string | undefined;
    enviaMensajesHL7?: boolean | undefined;
    contrato?: string | undefined;
    rfc?: string | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
    delegacionDesc?: string | undefined;
    municipioDesc?: string | undefined;
    institucionesAseguradasDesc?: string | undefined;
}

export class HospitalGetByIdQuery implements IHospitalGetByIdQuery {
    id?: number | undefined;

    constructor(data?: IHospitalGetByIdQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HospitalGetByIdQuery {
        data = typeof data === 'object' ? data : {};
        let result = new HospitalGetByIdQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IHospitalGetByIdQuery {
    id?: number | undefined;
}

export class HospitalCreateCommand implements IHospitalCreateCommand {
    delegacionId?: number | undefined;
    municipioId?: number | undefined;
    institucionesAseguradasId?: number | undefined;
    codigoHospital?: string | undefined;
    nombre?: string | undefined;
    direccion?: string | undefined;
    telefono1?: string | undefined;
    numExt1?: string | undefined;
    telefono2?: string | undefined;
    numExt2?: string | undefined;
    telefono3?: string | undefined;
    numExt3?: string | undefined;
    fax?: string | undefined;
    numeroRegistro?: string | undefined;
    responsable?: string | undefined;
    umf?: string | undefined;
    tratamientoDp?: boolean | undefined;
    tratamientoHd?: boolean | undefined;
    clavePresupuestal?: string | undefined;
    enviaMensajesHL7?: boolean | undefined;
    contrato?: string | undefined;
    rfc?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IHospitalCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.delegacionId = _data["delegacionId"];
            this.municipioId = _data["municipioId"];
            this.institucionesAseguradasId = _data["institucionesAseguradasId"];
            this.codigoHospital = _data["codigoHospital"];
            this.nombre = _data["nombre"];
            this.direccion = _data["direccion"];
            this.telefono1 = _data["telefono1"];
            this.numExt1 = _data["numExt1"];
            this.telefono2 = _data["telefono2"];
            this.numExt2 = _data["numExt2"];
            this.telefono3 = _data["telefono3"];
            this.numExt3 = _data["numExt3"];
            this.fax = _data["fax"];
            this.numeroRegistro = _data["numeroRegistro"];
            this.responsable = _data["responsable"];
            this.umf = _data["umf"];
            this.tratamientoDp = _data["tratamientoDp"];
            this.tratamientoHd = _data["tratamientoHd"];
            this.clavePresupuestal = _data["clavePresupuestal"];
            this.enviaMensajesHL7 = _data["enviaMensajesHL7"];
            this.contrato = _data["contrato"];
            this.rfc = _data["rfc"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): HospitalCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new HospitalCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delegacionId"] = this.delegacionId;
        data["municipioId"] = this.municipioId;
        data["institucionesAseguradasId"] = this.institucionesAseguradasId;
        data["codigoHospital"] = this.codigoHospital;
        data["nombre"] = this.nombre;
        data["direccion"] = this.direccion;
        data["telefono1"] = this.telefono1;
        data["numExt1"] = this.numExt1;
        data["telefono2"] = this.telefono2;
        data["numExt2"] = this.numExt2;
        data["telefono3"] = this.telefono3;
        data["numExt3"] = this.numExt3;
        data["fax"] = this.fax;
        data["numeroRegistro"] = this.numeroRegistro;
        data["responsable"] = this.responsable;
        data["umf"] = this.umf;
        data["tratamientoDp"] = this.tratamientoDp;
        data["tratamientoHd"] = this.tratamientoHd;
        data["clavePresupuestal"] = this.clavePresupuestal;
        data["enviaMensajesHL7"] = this.enviaMensajesHL7;
        data["contrato"] = this.contrato;
        data["rfc"] = this.rfc;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IHospitalCreateCommand {
    delegacionId?: number | undefined;
    municipioId?: number | undefined;
    institucionesAseguradasId?: number | undefined;
    codigoHospital?: string | undefined;
    nombre?: string | undefined;
    direccion?: string | undefined;
    telefono1?: string | undefined;
    numExt1?: string | undefined;
    telefono2?: string | undefined;
    numExt2?: string | undefined;
    telefono3?: string | undefined;
    numExt3?: string | undefined;
    fax?: string | undefined;
    numeroRegistro?: string | undefined;
    responsable?: string | undefined;
    umf?: string | undefined;
    tratamientoDp?: boolean | undefined;
    tratamientoHd?: boolean | undefined;
    clavePresupuestal?: string | undefined;
    enviaMensajesHL7?: boolean | undefined;
    contrato?: string | undefined;
    rfc?: string | undefined;
    isActive?: boolean | undefined;
}

export class HospitalUpdateCommand implements IHospitalUpdateCommand {
    id?: number | undefined;
    delegacionId?: number | undefined;
    municipioId?: number | undefined;
    institucionesAseguradasId?: number | undefined;
    codigoHospital?: string | undefined;
    nombre?: string | undefined;
    direccion?: string | undefined;
    telefono1?: string | undefined;
    numExt1?: string | undefined;
    telefono2?: string | undefined;
    numExt2?: string | undefined;
    telefono3?: string | undefined;
    numExt3?: string | undefined;
    fax?: string | undefined;
    numeroRegistro?: string | undefined;
    responsable?: string | undefined;
    umf?: string | undefined;
    tratamientoDp?: boolean | undefined;
    tratamientoHd?: boolean | undefined;
    clavePresupuestal?: string | undefined;
    enviaMensajesHL7?: boolean | undefined;
    contrato?: string | undefined;
    rfc?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IHospitalUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.delegacionId = _data["delegacionId"];
            this.municipioId = _data["municipioId"];
            this.institucionesAseguradasId = _data["institucionesAseguradasId"];
            this.codigoHospital = _data["codigoHospital"];
            this.nombre = _data["nombre"];
            this.direccion = _data["direccion"];
            this.telefono1 = _data["telefono1"];
            this.numExt1 = _data["numExt1"];
            this.telefono2 = _data["telefono2"];
            this.numExt2 = _data["numExt2"];
            this.telefono3 = _data["telefono3"];
            this.numExt3 = _data["numExt3"];
            this.fax = _data["fax"];
            this.numeroRegistro = _data["numeroRegistro"];
            this.responsable = _data["responsable"];
            this.umf = _data["umf"];
            this.tratamientoDp = _data["tratamientoDp"];
            this.tratamientoHd = _data["tratamientoHd"];
            this.clavePresupuestal = _data["clavePresupuestal"];
            this.enviaMensajesHL7 = _data["enviaMensajesHL7"];
            this.contrato = _data["contrato"];
            this.rfc = _data["rfc"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): HospitalUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new HospitalUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["delegacionId"] = this.delegacionId;
        data["municipioId"] = this.municipioId;
        data["institucionesAseguradasId"] = this.institucionesAseguradasId;
        data["codigoHospital"] = this.codigoHospital;
        data["nombre"] = this.nombre;
        data["direccion"] = this.direccion;
        data["telefono1"] = this.telefono1;
        data["numExt1"] = this.numExt1;
        data["telefono2"] = this.telefono2;
        data["numExt2"] = this.numExt2;
        data["telefono3"] = this.telefono3;
        data["numExt3"] = this.numExt3;
        data["fax"] = this.fax;
        data["numeroRegistro"] = this.numeroRegistro;
        data["responsable"] = this.responsable;
        data["umf"] = this.umf;
        data["tratamientoDp"] = this.tratamientoDp;
        data["tratamientoHd"] = this.tratamientoHd;
        data["clavePresupuestal"] = this.clavePresupuestal;
        data["enviaMensajesHL7"] = this.enviaMensajesHL7;
        data["contrato"] = this.contrato;
        data["rfc"] = this.rfc;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IHospitalUpdateCommand {
    id?: number | undefined;
    delegacionId?: number | undefined;
    municipioId?: number | undefined;
    institucionesAseguradasId?: number | undefined;
    codigoHospital?: string | undefined;
    nombre?: string | undefined;
    direccion?: string | undefined;
    telefono1?: string | undefined;
    numExt1?: string | undefined;
    telefono2?: string | undefined;
    numExt2?: string | undefined;
    telefono3?: string | undefined;
    numExt3?: string | undefined;
    fax?: string | undefined;
    numeroRegistro?: string | undefined;
    responsable?: string | undefined;
    umf?: string | undefined;
    tratamientoDp?: boolean | undefined;
    tratamientoHd?: boolean | undefined;
    clavePresupuestal?: string | undefined;
    enviaMensajesHL7?: boolean | undefined;
    contrato?: string | undefined;
    rfc?: string | undefined;
    isActive?: boolean | undefined;
}

export class PagedResultDtoOfMedicoForListResponse implements IPagedResultDtoOfMedicoForListResponse {
    totalCount!: number;
    items?: MedicoForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfMedicoForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MedicoForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMedicoForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMedicoForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfMedicoForListResponse {
    totalCount: number;
    items?: MedicoForListResponse[] | undefined;
}

export class MedicoForListResponse implements IMedicoForListResponse {
    id!: number;
    puestoId?: number | undefined;
    especialidadId?: number | undefined;
    institucionesAseguradasId?: number | undefined;
    moduloId?: number | undefined;
    nombre?: string | undefined;
    apellidoPaterno?: string | undefined;
    apellidoMaterno?: string | undefined;
    nombreCompleto?: string | undefined;
    curp?: string | undefined;
    matricula?: string | undefined;
    cedula?: string | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;
    puestoDesc?: string | undefined;
    especialdadDesc?: string | undefined;
    institucionesAseguradasDesc?: string | undefined;
    moduloDesc?: string | undefined;

    constructor(data?: IMedicoForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.puestoId = _data["puestoId"];
            this.especialidadId = _data["especialidadId"];
            this.institucionesAseguradasId = _data["institucionesAseguradasId"];
            this.moduloId = _data["moduloId"];
            this.nombre = _data["nombre"];
            this.apellidoPaterno = _data["apellidoPaterno"];
            this.apellidoMaterno = _data["apellidoMaterno"];
            this.nombreCompleto = _data["nombreCompleto"];
            this.curp = _data["curp"];
            this.matricula = _data["matricula"];
            this.cedula = _data["cedula"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.puestoDesc = _data["puestoDesc"];
            this.especialdadDesc = _data["especialdadDesc"];
            this.institucionesAseguradasDesc = _data["institucionesAseguradasDesc"];
            this.moduloDesc = _data["moduloDesc"];
        }
    }

    static fromJS(data: any): MedicoForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MedicoForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["puestoId"] = this.puestoId;
        data["especialidadId"] = this.especialidadId;
        data["institucionesAseguradasId"] = this.institucionesAseguradasId;
        data["moduloId"] = this.moduloId;
        data["nombre"] = this.nombre;
        data["apellidoPaterno"] = this.apellidoPaterno;
        data["apellidoMaterno"] = this.apellidoMaterno;
        data["nombreCompleto"] = this.nombreCompleto;
        data["curp"] = this.curp;
        data["matricula"] = this.matricula;
        data["cedula"] = this.cedula;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["puestoDesc"] = this.puestoDesc;
        data["especialdadDesc"] = this.especialdadDesc;
        data["institucionesAseguradasDesc"] = this.institucionesAseguradasDesc;
        data["moduloDesc"] = this.moduloDesc;
        return data;
    }
}

export interface IMedicoForListResponse {
    id: number;
    puestoId?: number | undefined;
    especialidadId?: number | undefined;
    institucionesAseguradasId?: number | undefined;
    moduloId?: number | undefined;
    nombre?: string | undefined;
    apellidoPaterno?: string | undefined;
    apellidoMaterno?: string | undefined;
    nombreCompleto?: string | undefined;
    curp?: string | undefined;
    matricula?: string | undefined;
    cedula?: string | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
    puestoDesc?: string | undefined;
    especialdadDesc?: string | undefined;
    institucionesAseguradasDesc?: string | undefined;
    moduloDesc?: string | undefined;
}

export class MedicoGetListQuery extends PageListByDto implements IMedicoGetListQuery {

    constructor(data?: IMedicoGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MedicoGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MedicoGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMedicoGetListQuery extends IPageListByDto {
}

export class MedicoGetAutocompleteListQuery implements IMedicoGetAutocompleteListQuery {
    criterio?: string | undefined;

    constructor(data?: IMedicoGetAutocompleteListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.criterio = _data["criterio"];
        }
    }

    static fromJS(data: any): MedicoGetAutocompleteListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MedicoGetAutocompleteListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criterio"] = this.criterio;
        return data;
    }
}

export interface IMedicoGetAutocompleteListQuery {
    criterio?: string | undefined;
}

export class MedicoForEditResponse implements IMedicoForEditResponse {
    id!: number;
    puestoId?: number | undefined;
    especialidadId?: number | undefined;
    institucionesAseguradasId?: number | undefined;
    moduloId?: number | undefined;
    nombre?: string | undefined;
    apellidoPaterno?: string | undefined;
    apellidoMaterno?: string | undefined;
    nombreCompleto?: string | undefined;
    curp?: string | undefined;
    matricula?: string | undefined;
    cedula?: string | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;
    puestoDesc?: string | undefined;
    especialdadDesc?: string | undefined;
    institucionesAseguradasDesc?: string | undefined;
    moduloDesc?: string | undefined;

    constructor(data?: IMedicoForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.puestoId = _data["puestoId"];
            this.especialidadId = _data["especialidadId"];
            this.institucionesAseguradasId = _data["institucionesAseguradasId"];
            this.moduloId = _data["moduloId"];
            this.nombre = _data["nombre"];
            this.apellidoPaterno = _data["apellidoPaterno"];
            this.apellidoMaterno = _data["apellidoMaterno"];
            this.nombreCompleto = _data["nombreCompleto"];
            this.curp = _data["curp"];
            this.matricula = _data["matricula"];
            this.cedula = _data["cedula"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.puestoDesc = _data["puestoDesc"];
            this.especialdadDesc = _data["especialdadDesc"];
            this.institucionesAseguradasDesc = _data["institucionesAseguradasDesc"];
            this.moduloDesc = _data["moduloDesc"];
        }
    }

    static fromJS(data: any): MedicoForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MedicoForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["puestoId"] = this.puestoId;
        data["especialidadId"] = this.especialidadId;
        data["institucionesAseguradasId"] = this.institucionesAseguradasId;
        data["moduloId"] = this.moduloId;
        data["nombre"] = this.nombre;
        data["apellidoPaterno"] = this.apellidoPaterno;
        data["apellidoMaterno"] = this.apellidoMaterno;
        data["nombreCompleto"] = this.nombreCompleto;
        data["curp"] = this.curp;
        data["matricula"] = this.matricula;
        data["cedula"] = this.cedula;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["puestoDesc"] = this.puestoDesc;
        data["especialdadDesc"] = this.especialdadDesc;
        data["institucionesAseguradasDesc"] = this.institucionesAseguradasDesc;
        data["moduloDesc"] = this.moduloDesc;
        return data;
    }
}

export interface IMedicoForEditResponse {
    id: number;
    puestoId?: number | undefined;
    especialidadId?: number | undefined;
    institucionesAseguradasId?: number | undefined;
    moduloId?: number | undefined;
    nombre?: string | undefined;
    apellidoPaterno?: string | undefined;
    apellidoMaterno?: string | undefined;
    nombreCompleto?: string | undefined;
    curp?: string | undefined;
    matricula?: string | undefined;
    cedula?: string | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
    puestoDesc?: string | undefined;
    especialdadDesc?: string | undefined;
    institucionesAseguradasDesc?: string | undefined;
    moduloDesc?: string | undefined;
}

export class MedicoGetForEditQuery implements IMedicoGetForEditQuery {
    id?: number | undefined;

    constructor(data?: IMedicoGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicoGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MedicoGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IMedicoGetForEditQuery {
    id?: number | undefined;
}

export class MedicoGetForComboboxQuery implements IMedicoGetForComboboxQuery {
    id?: number | undefined;

    constructor(data?: IMedicoGetForComboboxQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicoGetForComboboxQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MedicoGetForComboboxQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IMedicoGetForComboboxQuery {
    id?: number | undefined;
}

export class MedicoResponse implements IMedicoResponse {
    id!: number;
    puestoId?: number | undefined;
    especialidadId?: number | undefined;
    institucionesAseguradasId?: number | undefined;
    moduloId?: number | undefined;
    nombre?: string | undefined;
    apellidoPaterno?: string | undefined;
    apellidoMaterno?: string | undefined;
    nombreCompleto?: string | undefined;
    curp?: string | undefined;
    matricula?: string | undefined;
    cedula?: string | undefined;
    fechaAlta!: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;
    puestoDesc?: string | undefined;
    especialdadDesc?: string | undefined;
    institucionesAseguradasDesc?: string | undefined;
    moduloDesc?: string | undefined;

    constructor(data?: IMedicoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.puestoId = _data["puestoId"];
            this.especialidadId = _data["especialidadId"];
            this.institucionesAseguradasId = _data["institucionesAseguradasId"];
            this.moduloId = _data["moduloId"];
            this.nombre = _data["nombre"];
            this.apellidoPaterno = _data["apellidoPaterno"];
            this.apellidoMaterno = _data["apellidoMaterno"];
            this.nombreCompleto = _data["nombreCompleto"];
            this.curp = _data["curp"];
            this.matricula = _data["matricula"];
            this.cedula = _data["cedula"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.puestoDesc = _data["puestoDesc"];
            this.especialdadDesc = _data["especialdadDesc"];
            this.institucionesAseguradasDesc = _data["institucionesAseguradasDesc"];
            this.moduloDesc = _data["moduloDesc"];
        }
    }

    static fromJS(data: any): MedicoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MedicoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["puestoId"] = this.puestoId;
        data["especialidadId"] = this.especialidadId;
        data["institucionesAseguradasId"] = this.institucionesAseguradasId;
        data["moduloId"] = this.moduloId;
        data["nombre"] = this.nombre;
        data["apellidoPaterno"] = this.apellidoPaterno;
        data["apellidoMaterno"] = this.apellidoMaterno;
        data["nombreCompleto"] = this.nombreCompleto;
        data["curp"] = this.curp;
        data["matricula"] = this.matricula;
        data["cedula"] = this.cedula;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["puestoDesc"] = this.puestoDesc;
        data["especialdadDesc"] = this.especialdadDesc;
        data["institucionesAseguradasDesc"] = this.institucionesAseguradasDesc;
        data["moduloDesc"] = this.moduloDesc;
        return data;
    }
}

export interface IMedicoResponse {
    id: number;
    puestoId?: number | undefined;
    especialidadId?: number | undefined;
    institucionesAseguradasId?: number | undefined;
    moduloId?: number | undefined;
    nombre?: string | undefined;
    apellidoPaterno?: string | undefined;
    apellidoMaterno?: string | undefined;
    nombreCompleto?: string | undefined;
    curp?: string | undefined;
    matricula?: string | undefined;
    cedula?: string | undefined;
    fechaAlta: moment.Moment;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
    puestoDesc?: string | undefined;
    especialdadDesc?: string | undefined;
    institucionesAseguradasDesc?: string | undefined;
    moduloDesc?: string | undefined;
}

export class MedicoGetByIdQuery implements IMedicoGetByIdQuery {
    id?: number | undefined;

    constructor(data?: IMedicoGetByIdQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicoGetByIdQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MedicoGetByIdQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IMedicoGetByIdQuery {
    id?: number | undefined;
}

export class ParametroResponse implements IParametroResponse {
    id!: number;
    nombre?: string | undefined;
    valor?: string | undefined;
    descripcion?: string | undefined;

    constructor(data?: IParametroResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nombre = _data["nombre"];
            this.valor = _data["valor"];
            this.descripcion = _data["descripcion"];
        }
    }

    static fromJS(data: any): ParametroResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ParametroResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nombre"] = this.nombre;
        data["valor"] = this.valor;
        data["descripcion"] = this.descripcion;
        return data;
    }
}

export interface IParametroResponse {
    id: number;
    nombre?: string | undefined;
    valor?: string | undefined;
    descripcion?: string | undefined;
}

export class ParametroGetByNameQuery implements IParametroGetByNameQuery {
    nombreParametro?: string | undefined;
    buscarEnHost!: boolean;

    constructor(data?: IParametroGetByNameQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nombreParametro = _data["nombreParametro"];
            this.buscarEnHost = _data["buscarEnHost"];
        }
    }

    static fromJS(data: any): ParametroGetByNameQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ParametroGetByNameQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nombreParametro"] = this.nombreParametro;
        data["buscarEnHost"] = this.buscarEnHost;
        return data;
    }
}

export interface IParametroGetByNameQuery {
    nombreParametro?: string | undefined;
    buscarEnHost: boolean;
}

export class PagedResultDtoOfPatientForListResponse implements IPagedResultDtoOfPatientForListResponse {
    totalCount!: number;
    items?: PatientForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfPatientForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPatientForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPatientForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfPatientForListResponse {
    totalCount: number;
    items?: PatientForListResponse[] | undefined;
}

export class PatientForListResponse implements IPatientForListResponse {
    id!: number;
    fullName?: string | undefined;
    nss?: string | undefined;
    sexDesc?: string | undefined;
    patientTypeImssDesc?: string | undefined;
    medicalAttache?: string | undefined;
    idee?: string | undefined;
    isActive!: boolean;
    isActiveDesc?: string | undefined;
    umf?: number | undefined;
    umfDesc?: string | undefined;
    umfBudgetAccountCode?: string | undefined;

    constructor(data?: IPatientForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.nss = _data["nss"];
            this.sexDesc = _data["sexDesc"];
            this.patientTypeImssDesc = _data["patientTypeImssDesc"];
            this.medicalAttache = _data["medicalAttache"];
            this.idee = _data["idee"];
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
            this.umf = _data["umf"];
            this.umfDesc = _data["umfDesc"];
            this.umfBudgetAccountCode = _data["umfBudgetAccountCode"];
        }
    }

    static fromJS(data: any): PatientForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PatientForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["nss"] = this.nss;
        data["sexDesc"] = this.sexDesc;
        data["patientTypeImssDesc"] = this.patientTypeImssDesc;
        data["medicalAttache"] = this.medicalAttache;
        data["idee"] = this.idee;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        data["umf"] = this.umf;
        data["umfDesc"] = this.umfDesc;
        data["umfBudgetAccountCode"] = this.umfBudgetAccountCode;
        return data;
    }
}

export interface IPatientForListResponse {
    id: number;
    fullName?: string | undefined;
    nss?: string | undefined;
    sexDesc?: string | undefined;
    patientTypeImssDesc?: string | undefined;
    medicalAttache?: string | undefined;
    idee?: string | undefined;
    isActive: boolean;
    isActiveDesc?: string | undefined;
    umf?: number | undefined;
    umfDesc?: string | undefined;
    umfBudgetAccountCode?: string | undefined;
}

export class PatientGetListQuery extends PageListByDto implements IPatientGetListQuery {

    constructor(data?: IPatientGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PatientGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PatientGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPatientGetListQuery extends IPageListByDto {
}

export class GetPatientLocalSearchListQuery extends PageListByDto implements IGetPatientLocalSearchListQuery {
    name?: string | undefined;
    nss?: string | undefined;
    sex?: number | undefined;
    statusId?: number | undefined;
    patientType?: number | undefined;
    medicalAttache?: string | undefined;
    idee?: string | undefined;
    hospitalId?: number | undefined;

    constructor(data?: IGetPatientLocalSearchListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.nss = _data["nss"];
            this.sex = _data["sex"];
            this.statusId = _data["statusId"];
            this.patientType = _data["patientType"];
            this.medicalAttache = _data["medicalAttache"];
            this.idee = _data["idee"];
            this.hospitalId = _data["hospitalId"];
        }
    }

    static override fromJS(data: any): GetPatientLocalSearchListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientLocalSearchListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nss"] = this.nss;
        data["sex"] = this.sex;
        data["statusId"] = this.statusId;
        data["patientType"] = this.patientType;
        data["medicalAttache"] = this.medicalAttache;
        data["idee"] = this.idee;
        data["hospitalId"] = this.hospitalId;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPatientLocalSearchListQuery extends IPageListByDto {
    name?: string | undefined;
    nss?: string | undefined;
    sex?: number | undefined;
    statusId?: number | undefined;
    patientType?: number | undefined;
    medicalAttache?: string | undefined;
    idee?: string | undefined;
    hospitalId?: number | undefined;
}

export class PatientForEditResponse implements IPatientForEditResponse {
    id?: number | undefined;
    idee?: string | undefined;
    patientTypeImss?: number | undefined;
    patientTypeImssDesc?: string | undefined;
    institution?: number | undefined;
    institutionDesc?: string | undefined;
    delegation?: number | undefined;
    delegationDesc?: string | undefined;
    umf?: number | undefined;
    umfDesc?: string | undefined;
    umfBudgetAccountCode?: string | undefined;
    sex?: number | undefined;
    sexDesc?: string | undefined;
    patientQuality?: number | undefined;
    patientQualityDesc?: string | undefined;
    maritalStatus?: number | undefined;
    maritalStatusDesc?: string | undefined;
    educationLevel?: number | undefined;
    educationLevelDesc?: string | undefined;
    religion?: number | undefined;
    religionDesc?: string | undefined;
    occupation?: number | undefined;
    occupationDesc?: string | undefined;
    country?: number | undefined;
    countryDesc?: string | undefined;
    state?: number | undefined;
    stateDesc?: string | undefined;
    municipality?: number | undefined;
    municipalityDesc?: string | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    nss?: string | undefined;
    medicalAttache?: string | undefined;
    curp?: string | undefined;
    birthDate?: moment.Moment | undefined;
    yearsStudy?: number | undefined;
    street?: string | undefined;
    internalNumber?: string | undefined;
    externalNumber?: string | undefined;
    postalCode?: number | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    betweenStreets?: string | undefined;
    pointsReference?: string | undefined;
    suburb?: string | undefined;
    isActive?: boolean | undefined;
    birthCountry?: number | undefined;
    birthCountryDesc?: string | undefined;
    birthState?: number | undefined;
    birthStateDesc?: string | undefined;
    rfc?: string | undefined;
    deathDate?: moment.Moment | undefined;
    age?: number | undefined;
    generalUnit?: PatientGeneralUnitDto | undefined;
    referenceUnitList?: PatientReferenceUnitDto[] | undefined;
    pathological?: PatientPathologicalDto | undefined;
    interrogationSystem?: PatientInterrogationSystemDto | undefined;
    physicalExplorationUnit?: PatientPhysicalExplorationUnitDto | undefined;
    initialStudy?: PatientInitialStudyDto | undefined;
    ginecoObstetrics?: PatientGinecoObstetricsDto | undefined;
    patientTypeImssCombo?: ComboboxItemDtoOfTipoPacienteIMSSDto[] | undefined;
    sexCombo?: ComboboxItemDtoOfSexoDto[] | undefined;
    institutionCombo?: ComboboxItemDtoOfInstitucionAseguradaDto[] | undefined;
    delegationCombo?: ComboboxItemDtoOfLong[] | undefined;
    umfCombo?: ComboboxItemDtoOfLong[] | undefined;
    patientQualityCombo?: ComboboxItemDtoOfLong[] | undefined;
    maritalStatusCombo?: ComboboxItemDtoOfLong[] | undefined;
    educationLevelCombo?: ComboboxItemDtoOfLong[] | undefined;
    religionCombo?: ComboboxItemDtoOfLong[] | undefined;
    occupationCombo?: ComboboxItemDtoOfLong[] | undefined;
    countryCombo?: ComboboxItemDtoOfLong[] | undefined;
    stateCombo?: ComboboxItemDtoOfLong[] | undefined;
    municipalityCombo?: ComboboxItemDtoOfLong[] | undefined;
    birthStateCombo?: ComboboxItemDtoOfLong[] | undefined;
    hospitalServiceCombo?: ComboboxItemDtoOfLong[] | undefined;
    patientOriginCombo?: ComboboxItemDtoOfLong[] | undefined;
    originCombo?: ComboboxItemDtoOfLong[] | undefined;
    attentionTypeCombo?: ComboboxItemDtoOfLong[] | undefined;
    shiftCombo?: ComboboxItemDtoOfLong[] | undefined;
    agreementTypeCombo?: ComboboxItemDtoOfLong[] | undefined;
    relationshipCombo?: ComboboxItemDtoOfLong[] | undefined;
    bloodTypeCombo?: ComboboxItemDtoOfLong[] | undefined;
    rhFactorCombo?: ComboboxItemDtoOfLong[] | undefined;
    etiologyCombo?: ComboboxItemDtoOfLong[] | undefined;
    housingTypeCombo?: ComboboxItemDtoOfLong[] | undefined;
    vaccinationScheduleCombo?: ComboboxItemDtoOfByte[] | undefined;
    alcoholismLevelCombo?: ComboboxItemDtoOfByte[] | undefined;
    faunaTypeCombo?: ComboboxItemDtoOfLong[] | undefined;
    allergieCombo?: ComboboxItemDtoOfLong[] | undefined;
    familiarPlanningMethodsCombo?: ComboboxItemDtoOfLong[] | undefined;

    constructor(data?: IPatientForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idee = _data["idee"];
            this.patientTypeImss = _data["patientTypeImss"];
            this.patientTypeImssDesc = _data["patientTypeImssDesc"];
            this.institution = _data["institution"];
            this.institutionDesc = _data["institutionDesc"];
            this.delegation = _data["delegation"];
            this.delegationDesc = _data["delegationDesc"];
            this.umf = _data["umf"];
            this.umfDesc = _data["umfDesc"];
            this.umfBudgetAccountCode = _data["umfBudgetAccountCode"];
            this.sex = _data["sex"];
            this.sexDesc = _data["sexDesc"];
            this.patientQuality = _data["patientQuality"];
            this.patientQualityDesc = _data["patientQualityDesc"];
            this.maritalStatus = _data["maritalStatus"];
            this.maritalStatusDesc = _data["maritalStatusDesc"];
            this.educationLevel = _data["educationLevel"];
            this.educationLevelDesc = _data["educationLevelDesc"];
            this.religion = _data["religion"];
            this.religionDesc = _data["religionDesc"];
            this.occupation = _data["occupation"];
            this.occupationDesc = _data["occupationDesc"];
            this.country = _data["country"];
            this.countryDesc = _data["countryDesc"];
            this.state = _data["state"];
            this.stateDesc = _data["stateDesc"];
            this.municipality = _data["municipality"];
            this.municipalityDesc = _data["municipalityDesc"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.nss = _data["nss"];
            this.medicalAttache = _data["medicalAttache"];
            this.curp = _data["curp"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.yearsStudy = _data["yearsStudy"];
            this.street = _data["street"];
            this.internalNumber = _data["internalNumber"];
            this.externalNumber = _data["externalNumber"];
            this.postalCode = _data["postalCode"];
            this.phone = _data["phone"];
            this.cellPhone = _data["cellPhone"];
            this.betweenStreets = _data["betweenStreets"];
            this.pointsReference = _data["pointsReference"];
            this.suburb = _data["suburb"];
            this.isActive = _data["isActive"];
            this.birthCountry = _data["birthCountry"];
            this.birthCountryDesc = _data["birthCountryDesc"];
            this.birthState = _data["birthState"];
            this.birthStateDesc = _data["birthStateDesc"];
            this.rfc = _data["rfc"];
            this.deathDate = _data["deathDate"] ? moment(_data["deathDate"].toString()) : <any>undefined;
            this.age = _data["age"];
            this.generalUnit = _data["generalUnit"] ? PatientGeneralUnitDto.fromJS(_data["generalUnit"]) : <any>undefined;
            if (Array.isArray(_data["referenceUnitList"])) {
                this.referenceUnitList = [] as any;
                for (let item of _data["referenceUnitList"])
                    this.referenceUnitList!.push(PatientReferenceUnitDto.fromJS(item));
            }
            this.pathological = _data["pathological"] ? PatientPathologicalDto.fromJS(_data["pathological"]) : <any>undefined;
            this.interrogationSystem = _data["interrogationSystem"] ? PatientInterrogationSystemDto.fromJS(_data["interrogationSystem"]) : <any>undefined;
            this.physicalExplorationUnit = _data["physicalExplorationUnit"] ? PatientPhysicalExplorationUnitDto.fromJS(_data["physicalExplorationUnit"]) : <any>undefined;
            this.initialStudy = _data["initialStudy"] ? PatientInitialStudyDto.fromJS(_data["initialStudy"]) : <any>undefined;
            this.ginecoObstetrics = _data["ginecoObstetrics"] ? PatientGinecoObstetricsDto.fromJS(_data["ginecoObstetrics"]) : <any>undefined;
            if (Array.isArray(_data["patientTypeImssCombo"])) {
                this.patientTypeImssCombo = [] as any;
                for (let item of _data["patientTypeImssCombo"])
                    this.patientTypeImssCombo!.push(ComboboxItemDtoOfTipoPacienteIMSSDto.fromJS(item));
            }
            if (Array.isArray(_data["sexCombo"])) {
                this.sexCombo = [] as any;
                for (let item of _data["sexCombo"])
                    this.sexCombo!.push(ComboboxItemDtoOfSexoDto.fromJS(item));
            }
            if (Array.isArray(_data["institutionCombo"])) {
                this.institutionCombo = [] as any;
                for (let item of _data["institutionCombo"])
                    this.institutionCombo!.push(ComboboxItemDtoOfInstitucionAseguradaDto.fromJS(item));
            }
            if (Array.isArray(_data["delegationCombo"])) {
                this.delegationCombo = [] as any;
                for (let item of _data["delegationCombo"])
                    this.delegationCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["umfCombo"])) {
                this.umfCombo = [] as any;
                for (let item of _data["umfCombo"])
                    this.umfCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["patientQualityCombo"])) {
                this.patientQualityCombo = [] as any;
                for (let item of _data["patientQualityCombo"])
                    this.patientQualityCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["maritalStatusCombo"])) {
                this.maritalStatusCombo = [] as any;
                for (let item of _data["maritalStatusCombo"])
                    this.maritalStatusCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["educationLevelCombo"])) {
                this.educationLevelCombo = [] as any;
                for (let item of _data["educationLevelCombo"])
                    this.educationLevelCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["religionCombo"])) {
                this.religionCombo = [] as any;
                for (let item of _data["religionCombo"])
                    this.religionCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["occupationCombo"])) {
                this.occupationCombo = [] as any;
                for (let item of _data["occupationCombo"])
                    this.occupationCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["countryCombo"])) {
                this.countryCombo = [] as any;
                for (let item of _data["countryCombo"])
                    this.countryCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["stateCombo"])) {
                this.stateCombo = [] as any;
                for (let item of _data["stateCombo"])
                    this.stateCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["municipalityCombo"])) {
                this.municipalityCombo = [] as any;
                for (let item of _data["municipalityCombo"])
                    this.municipalityCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["birthStateCombo"])) {
                this.birthStateCombo = [] as any;
                for (let item of _data["birthStateCombo"])
                    this.birthStateCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["hospitalServiceCombo"])) {
                this.hospitalServiceCombo = [] as any;
                for (let item of _data["hospitalServiceCombo"])
                    this.hospitalServiceCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["patientOriginCombo"])) {
                this.patientOriginCombo = [] as any;
                for (let item of _data["patientOriginCombo"])
                    this.patientOriginCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["originCombo"])) {
                this.originCombo = [] as any;
                for (let item of _data["originCombo"])
                    this.originCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["attentionTypeCombo"])) {
                this.attentionTypeCombo = [] as any;
                for (let item of _data["attentionTypeCombo"])
                    this.attentionTypeCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["shiftCombo"])) {
                this.shiftCombo = [] as any;
                for (let item of _data["shiftCombo"])
                    this.shiftCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["agreementTypeCombo"])) {
                this.agreementTypeCombo = [] as any;
                for (let item of _data["agreementTypeCombo"])
                    this.agreementTypeCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["relationshipCombo"])) {
                this.relationshipCombo = [] as any;
                for (let item of _data["relationshipCombo"])
                    this.relationshipCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["bloodTypeCombo"])) {
                this.bloodTypeCombo = [] as any;
                for (let item of _data["bloodTypeCombo"])
                    this.bloodTypeCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["rhFactorCombo"])) {
                this.rhFactorCombo = [] as any;
                for (let item of _data["rhFactorCombo"])
                    this.rhFactorCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["etiologyCombo"])) {
                this.etiologyCombo = [] as any;
                for (let item of _data["etiologyCombo"])
                    this.etiologyCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["housingTypeCombo"])) {
                this.housingTypeCombo = [] as any;
                for (let item of _data["housingTypeCombo"])
                    this.housingTypeCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["vaccinationScheduleCombo"])) {
                this.vaccinationScheduleCombo = [] as any;
                for (let item of _data["vaccinationScheduleCombo"])
                    this.vaccinationScheduleCombo!.push(ComboboxItemDtoOfByte.fromJS(item));
            }
            if (Array.isArray(_data["alcoholismLevelCombo"])) {
                this.alcoholismLevelCombo = [] as any;
                for (let item of _data["alcoholismLevelCombo"])
                    this.alcoholismLevelCombo!.push(ComboboxItemDtoOfByte.fromJS(item));
            }
            if (Array.isArray(_data["faunaTypeCombo"])) {
                this.faunaTypeCombo = [] as any;
                for (let item of _data["faunaTypeCombo"])
                    this.faunaTypeCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["allergieCombo"])) {
                this.allergieCombo = [] as any;
                for (let item of _data["allergieCombo"])
                    this.allergieCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["familiarPlanningMethodsCombo"])) {
                this.familiarPlanningMethodsCombo = [] as any;
                for (let item of _data["familiarPlanningMethodsCombo"])
                    this.familiarPlanningMethodsCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PatientForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idee"] = this.idee;
        data["patientTypeImss"] = this.patientTypeImss;
        data["patientTypeImssDesc"] = this.patientTypeImssDesc;
        data["institution"] = this.institution;
        data["institutionDesc"] = this.institutionDesc;
        data["delegation"] = this.delegation;
        data["delegationDesc"] = this.delegationDesc;
        data["umf"] = this.umf;
        data["umfDesc"] = this.umfDesc;
        data["umfBudgetAccountCode"] = this.umfBudgetAccountCode;
        data["sex"] = this.sex;
        data["sexDesc"] = this.sexDesc;
        data["patientQuality"] = this.patientQuality;
        data["patientQualityDesc"] = this.patientQualityDesc;
        data["maritalStatus"] = this.maritalStatus;
        data["maritalStatusDesc"] = this.maritalStatusDesc;
        data["educationLevel"] = this.educationLevel;
        data["educationLevelDesc"] = this.educationLevelDesc;
        data["religion"] = this.religion;
        data["religionDesc"] = this.religionDesc;
        data["occupation"] = this.occupation;
        data["occupationDesc"] = this.occupationDesc;
        data["country"] = this.country;
        data["countryDesc"] = this.countryDesc;
        data["state"] = this.state;
        data["stateDesc"] = this.stateDesc;
        data["municipality"] = this.municipality;
        data["municipalityDesc"] = this.municipalityDesc;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["nss"] = this.nss;
        data["medicalAttache"] = this.medicalAttache;
        data["curp"] = this.curp;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["yearsStudy"] = this.yearsStudy;
        data["street"] = this.street;
        data["internalNumber"] = this.internalNumber;
        data["externalNumber"] = this.externalNumber;
        data["postalCode"] = this.postalCode;
        data["phone"] = this.phone;
        data["cellPhone"] = this.cellPhone;
        data["betweenStreets"] = this.betweenStreets;
        data["pointsReference"] = this.pointsReference;
        data["suburb"] = this.suburb;
        data["isActive"] = this.isActive;
        data["birthCountry"] = this.birthCountry;
        data["birthCountryDesc"] = this.birthCountryDesc;
        data["birthState"] = this.birthState;
        data["birthStateDesc"] = this.birthStateDesc;
        data["rfc"] = this.rfc;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        data["age"] = this.age;
        data["generalUnit"] = this.generalUnit ? this.generalUnit.toJSON() : <any>undefined;
        if (Array.isArray(this.referenceUnitList)) {
            data["referenceUnitList"] = [];
            for (let item of this.referenceUnitList)
                data["referenceUnitList"].push(item.toJSON());
        }
        data["pathological"] = this.pathological ? this.pathological.toJSON() : <any>undefined;
        data["interrogationSystem"] = this.interrogationSystem ? this.interrogationSystem.toJSON() : <any>undefined;
        data["physicalExplorationUnit"] = this.physicalExplorationUnit ? this.physicalExplorationUnit.toJSON() : <any>undefined;
        data["initialStudy"] = this.initialStudy ? this.initialStudy.toJSON() : <any>undefined;
        data["ginecoObstetrics"] = this.ginecoObstetrics ? this.ginecoObstetrics.toJSON() : <any>undefined;
        if (Array.isArray(this.patientTypeImssCombo)) {
            data["patientTypeImssCombo"] = [];
            for (let item of this.patientTypeImssCombo)
                data["patientTypeImssCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.sexCombo)) {
            data["sexCombo"] = [];
            for (let item of this.sexCombo)
                data["sexCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.institutionCombo)) {
            data["institutionCombo"] = [];
            for (let item of this.institutionCombo)
                data["institutionCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.delegationCombo)) {
            data["delegationCombo"] = [];
            for (let item of this.delegationCombo)
                data["delegationCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.umfCombo)) {
            data["umfCombo"] = [];
            for (let item of this.umfCombo)
                data["umfCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.patientQualityCombo)) {
            data["patientQualityCombo"] = [];
            for (let item of this.patientQualityCombo)
                data["patientQualityCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.maritalStatusCombo)) {
            data["maritalStatusCombo"] = [];
            for (let item of this.maritalStatusCombo)
                data["maritalStatusCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.educationLevelCombo)) {
            data["educationLevelCombo"] = [];
            for (let item of this.educationLevelCombo)
                data["educationLevelCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.religionCombo)) {
            data["religionCombo"] = [];
            for (let item of this.religionCombo)
                data["religionCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.occupationCombo)) {
            data["occupationCombo"] = [];
            for (let item of this.occupationCombo)
                data["occupationCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.countryCombo)) {
            data["countryCombo"] = [];
            for (let item of this.countryCombo)
                data["countryCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.stateCombo)) {
            data["stateCombo"] = [];
            for (let item of this.stateCombo)
                data["stateCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.municipalityCombo)) {
            data["municipalityCombo"] = [];
            for (let item of this.municipalityCombo)
                data["municipalityCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.birthStateCombo)) {
            data["birthStateCombo"] = [];
            for (let item of this.birthStateCombo)
                data["birthStateCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.hospitalServiceCombo)) {
            data["hospitalServiceCombo"] = [];
            for (let item of this.hospitalServiceCombo)
                data["hospitalServiceCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.patientOriginCombo)) {
            data["patientOriginCombo"] = [];
            for (let item of this.patientOriginCombo)
                data["patientOriginCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.originCombo)) {
            data["originCombo"] = [];
            for (let item of this.originCombo)
                data["originCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.attentionTypeCombo)) {
            data["attentionTypeCombo"] = [];
            for (let item of this.attentionTypeCombo)
                data["attentionTypeCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.shiftCombo)) {
            data["shiftCombo"] = [];
            for (let item of this.shiftCombo)
                data["shiftCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.agreementTypeCombo)) {
            data["agreementTypeCombo"] = [];
            for (let item of this.agreementTypeCombo)
                data["agreementTypeCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.relationshipCombo)) {
            data["relationshipCombo"] = [];
            for (let item of this.relationshipCombo)
                data["relationshipCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.bloodTypeCombo)) {
            data["bloodTypeCombo"] = [];
            for (let item of this.bloodTypeCombo)
                data["bloodTypeCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.rhFactorCombo)) {
            data["rhFactorCombo"] = [];
            for (let item of this.rhFactorCombo)
                data["rhFactorCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.etiologyCombo)) {
            data["etiologyCombo"] = [];
            for (let item of this.etiologyCombo)
                data["etiologyCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.housingTypeCombo)) {
            data["housingTypeCombo"] = [];
            for (let item of this.housingTypeCombo)
                data["housingTypeCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.vaccinationScheduleCombo)) {
            data["vaccinationScheduleCombo"] = [];
            for (let item of this.vaccinationScheduleCombo)
                data["vaccinationScheduleCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.alcoholismLevelCombo)) {
            data["alcoholismLevelCombo"] = [];
            for (let item of this.alcoholismLevelCombo)
                data["alcoholismLevelCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.faunaTypeCombo)) {
            data["faunaTypeCombo"] = [];
            for (let item of this.faunaTypeCombo)
                data["faunaTypeCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.allergieCombo)) {
            data["allergieCombo"] = [];
            for (let item of this.allergieCombo)
                data["allergieCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.familiarPlanningMethodsCombo)) {
            data["familiarPlanningMethodsCombo"] = [];
            for (let item of this.familiarPlanningMethodsCombo)
                data["familiarPlanningMethodsCombo"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPatientForEditResponse {
    id?: number | undefined;
    idee?: string | undefined;
    patientTypeImss?: number | undefined;
    patientTypeImssDesc?: string | undefined;
    institution?: number | undefined;
    institutionDesc?: string | undefined;
    delegation?: number | undefined;
    delegationDesc?: string | undefined;
    umf?: number | undefined;
    umfDesc?: string | undefined;
    umfBudgetAccountCode?: string | undefined;
    sex?: number | undefined;
    sexDesc?: string | undefined;
    patientQuality?: number | undefined;
    patientQualityDesc?: string | undefined;
    maritalStatus?: number | undefined;
    maritalStatusDesc?: string | undefined;
    educationLevel?: number | undefined;
    educationLevelDesc?: string | undefined;
    religion?: number | undefined;
    religionDesc?: string | undefined;
    occupation?: number | undefined;
    occupationDesc?: string | undefined;
    country?: number | undefined;
    countryDesc?: string | undefined;
    state?: number | undefined;
    stateDesc?: string | undefined;
    municipality?: number | undefined;
    municipalityDesc?: string | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    nss?: string | undefined;
    medicalAttache?: string | undefined;
    curp?: string | undefined;
    birthDate?: moment.Moment | undefined;
    yearsStudy?: number | undefined;
    street?: string | undefined;
    internalNumber?: string | undefined;
    externalNumber?: string | undefined;
    postalCode?: number | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    betweenStreets?: string | undefined;
    pointsReference?: string | undefined;
    suburb?: string | undefined;
    isActive?: boolean | undefined;
    birthCountry?: number | undefined;
    birthCountryDesc?: string | undefined;
    birthState?: number | undefined;
    birthStateDesc?: string | undefined;
    rfc?: string | undefined;
    deathDate?: moment.Moment | undefined;
    age?: number | undefined;
    generalUnit?: PatientGeneralUnitDto | undefined;
    referenceUnitList?: PatientReferenceUnitDto[] | undefined;
    pathological?: PatientPathologicalDto | undefined;
    interrogationSystem?: PatientInterrogationSystemDto | undefined;
    physicalExplorationUnit?: PatientPhysicalExplorationUnitDto | undefined;
    initialStudy?: PatientInitialStudyDto | undefined;
    ginecoObstetrics?: PatientGinecoObstetricsDto | undefined;
    patientTypeImssCombo?: ComboboxItemDtoOfTipoPacienteIMSSDto[] | undefined;
    sexCombo?: ComboboxItemDtoOfSexoDto[] | undefined;
    institutionCombo?: ComboboxItemDtoOfInstitucionAseguradaDto[] | undefined;
    delegationCombo?: ComboboxItemDtoOfLong[] | undefined;
    umfCombo?: ComboboxItemDtoOfLong[] | undefined;
    patientQualityCombo?: ComboboxItemDtoOfLong[] | undefined;
    maritalStatusCombo?: ComboboxItemDtoOfLong[] | undefined;
    educationLevelCombo?: ComboboxItemDtoOfLong[] | undefined;
    religionCombo?: ComboboxItemDtoOfLong[] | undefined;
    occupationCombo?: ComboboxItemDtoOfLong[] | undefined;
    countryCombo?: ComboboxItemDtoOfLong[] | undefined;
    stateCombo?: ComboboxItemDtoOfLong[] | undefined;
    municipalityCombo?: ComboboxItemDtoOfLong[] | undefined;
    birthStateCombo?: ComboboxItemDtoOfLong[] | undefined;
    hospitalServiceCombo?: ComboboxItemDtoOfLong[] | undefined;
    patientOriginCombo?: ComboboxItemDtoOfLong[] | undefined;
    originCombo?: ComboboxItemDtoOfLong[] | undefined;
    attentionTypeCombo?: ComboboxItemDtoOfLong[] | undefined;
    shiftCombo?: ComboboxItemDtoOfLong[] | undefined;
    agreementTypeCombo?: ComboboxItemDtoOfLong[] | undefined;
    relationshipCombo?: ComboboxItemDtoOfLong[] | undefined;
    bloodTypeCombo?: ComboboxItemDtoOfLong[] | undefined;
    rhFactorCombo?: ComboboxItemDtoOfLong[] | undefined;
    etiologyCombo?: ComboboxItemDtoOfLong[] | undefined;
    housingTypeCombo?: ComboboxItemDtoOfLong[] | undefined;
    vaccinationScheduleCombo?: ComboboxItemDtoOfByte[] | undefined;
    alcoholismLevelCombo?: ComboboxItemDtoOfByte[] | undefined;
    faunaTypeCombo?: ComboboxItemDtoOfLong[] | undefined;
    allergieCombo?: ComboboxItemDtoOfLong[] | undefined;
    familiarPlanningMethodsCombo?: ComboboxItemDtoOfLong[] | undefined;
}

export class PatientGeneralUnitDto implements IPatientGeneralUnitDto {
    id?: number | undefined;
    patient?: number | undefined;
    delegationImssRequest?: number | undefined;
    delegationImssRequestDesc?: string | undefined;
    medicalCareUnit?: number | undefined;
    medicalCareUnitDesc?: string | undefined;
    hospitalService?: number | undefined;
    hospitalServiceDesc?: string | undefined;
    patientOrigin?: number | undefined;
    patientOriginDesc?: string | undefined;
    origin?: number | undefined;
    originDesc?: string | undefined;
    attentionType?: number | undefined;
    attentionTypeDesc?: string | undefined;
    attentionPlace?: string | undefined;
    shift?: number | undefined;
    shiftDesc?: string | undefined;
    doctorOffice?: string | undefined;
    validUntil?: moment.Moment | undefined;
    membershipAggregate?: string | undefined;
    agreementType?: number | undefined;
    agreementTypeDesc?: string | undefined;
    observations?: string | undefined;

    constructor(data?: IPatientGeneralUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.patient = _data["patient"];
            this.delegationImssRequest = _data["delegationImssRequest"];
            this.delegationImssRequestDesc = _data["delegationImssRequestDesc"];
            this.medicalCareUnit = _data["medicalCareUnit"];
            this.medicalCareUnitDesc = _data["medicalCareUnitDesc"];
            this.hospitalService = _data["hospitalService"];
            this.hospitalServiceDesc = _data["hospitalServiceDesc"];
            this.patientOrigin = _data["patientOrigin"];
            this.patientOriginDesc = _data["patientOriginDesc"];
            this.origin = _data["origin"];
            this.originDesc = _data["originDesc"];
            this.attentionType = _data["attentionType"];
            this.attentionTypeDesc = _data["attentionTypeDesc"];
            this.attentionPlace = _data["attentionPlace"];
            this.shift = _data["shift"];
            this.shiftDesc = _data["shiftDesc"];
            this.doctorOffice = _data["doctorOffice"];
            this.validUntil = _data["validUntil"] ? moment(_data["validUntil"].toString()) : <any>undefined;
            this.membershipAggregate = _data["membershipAggregate"];
            this.agreementType = _data["agreementType"];
            this.agreementTypeDesc = _data["agreementTypeDesc"];
            this.observations = _data["observations"];
        }
    }

    static fromJS(data: any): PatientGeneralUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientGeneralUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["patient"] = this.patient;
        data["delegationImssRequest"] = this.delegationImssRequest;
        data["delegationImssRequestDesc"] = this.delegationImssRequestDesc;
        data["medicalCareUnit"] = this.medicalCareUnit;
        data["medicalCareUnitDesc"] = this.medicalCareUnitDesc;
        data["hospitalService"] = this.hospitalService;
        data["hospitalServiceDesc"] = this.hospitalServiceDesc;
        data["patientOrigin"] = this.patientOrigin;
        data["patientOriginDesc"] = this.patientOriginDesc;
        data["origin"] = this.origin;
        data["originDesc"] = this.originDesc;
        data["attentionType"] = this.attentionType;
        data["attentionTypeDesc"] = this.attentionTypeDesc;
        data["attentionPlace"] = this.attentionPlace;
        data["shift"] = this.shift;
        data["shiftDesc"] = this.shiftDesc;
        data["doctorOffice"] = this.doctorOffice;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>undefined;
        data["membershipAggregate"] = this.membershipAggregate;
        data["agreementType"] = this.agreementType;
        data["agreementTypeDesc"] = this.agreementTypeDesc;
        data["observations"] = this.observations;
        return data;
    }
}

export interface IPatientGeneralUnitDto {
    id?: number | undefined;
    patient?: number | undefined;
    delegationImssRequest?: number | undefined;
    delegationImssRequestDesc?: string | undefined;
    medicalCareUnit?: number | undefined;
    medicalCareUnitDesc?: string | undefined;
    hospitalService?: number | undefined;
    hospitalServiceDesc?: string | undefined;
    patientOrigin?: number | undefined;
    patientOriginDesc?: string | undefined;
    origin?: number | undefined;
    originDesc?: string | undefined;
    attentionType?: number | undefined;
    attentionTypeDesc?: string | undefined;
    attentionPlace?: string | undefined;
    shift?: number | undefined;
    shiftDesc?: string | undefined;
    doctorOffice?: string | undefined;
    validUntil?: moment.Moment | undefined;
    membershipAggregate?: string | undefined;
    agreementType?: number | undefined;
    agreementTypeDesc?: string | undefined;
    observations?: string | undefined;
}

export class PatientReferenceUnitDto implements IPatientReferenceUnitDto {
    id?: number | undefined;
    patient?: number | undefined;
    relationship?: number | undefined;
    relationshipDesc?: string | undefined;
    country?: number | undefined;
    state?: number | undefined;
    municipality?: number | undefined;
    municipalityDesc?: string | undefined;
    reference?: PatientReferenceUnit | undefined;
    referenceDesc?: string | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    street?: string | undefined;
    internalNumber?: string | undefined;
    externalNumber?: string | undefined;
    suburb?: string | undefined;
    phone?: string | undefined;
    postalCode?: number | undefined;
    betweenStreets?: string | undefined;
    pointsReference?: string | undefined;
    creationTime?: moment.Moment | undefined;
    updateTime?: moment.Moment | undefined;
    isActive?: boolean | undefined;
    isChecked!: boolean;
    stateCombo?: ComboboxItemDtoOfLong[] | undefined;
    municipalityCombo?: ComboboxItemDtoOfLong[] | undefined;

    constructor(data?: IPatientReferenceUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.patient = _data["patient"];
            this.relationship = _data["relationship"];
            this.relationshipDesc = _data["relationshipDesc"];
            this.country = _data["country"];
            this.state = _data["state"];
            this.municipality = _data["municipality"];
            this.municipalityDesc = _data["municipalityDesc"];
            this.reference = _data["reference"];
            this.referenceDesc = _data["referenceDesc"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.street = _data["street"];
            this.internalNumber = _data["internalNumber"];
            this.externalNumber = _data["externalNumber"];
            this.suburb = _data["suburb"];
            this.phone = _data["phone"];
            this.postalCode = _data["postalCode"];
            this.betweenStreets = _data["betweenStreets"];
            this.pointsReference = _data["pointsReference"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.updateTime = _data["updateTime"] ? moment(_data["updateTime"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isChecked = _data["isChecked"];
            if (Array.isArray(_data["stateCombo"])) {
                this.stateCombo = [] as any;
                for (let item of _data["stateCombo"])
                    this.stateCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["municipalityCombo"])) {
                this.municipalityCombo = [] as any;
                for (let item of _data["municipalityCombo"])
                    this.municipalityCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientReferenceUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientReferenceUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["patient"] = this.patient;
        data["relationship"] = this.relationship;
        data["relationshipDesc"] = this.relationshipDesc;
        data["country"] = this.country;
        data["state"] = this.state;
        data["municipality"] = this.municipality;
        data["municipalityDesc"] = this.municipalityDesc;
        data["reference"] = this.reference;
        data["referenceDesc"] = this.referenceDesc;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["street"] = this.street;
        data["internalNumber"] = this.internalNumber;
        data["externalNumber"] = this.externalNumber;
        data["suburb"] = this.suburb;
        data["phone"] = this.phone;
        data["postalCode"] = this.postalCode;
        data["betweenStreets"] = this.betweenStreets;
        data["pointsReference"] = this.pointsReference;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isChecked"] = this.isChecked;
        if (Array.isArray(this.stateCombo)) {
            data["stateCombo"] = [];
            for (let item of this.stateCombo)
                data["stateCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.municipalityCombo)) {
            data["municipalityCombo"] = [];
            for (let item of this.municipalityCombo)
                data["municipalityCombo"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPatientReferenceUnitDto {
    id?: number | undefined;
    patient?: number | undefined;
    relationship?: number | undefined;
    relationshipDesc?: string | undefined;
    country?: number | undefined;
    state?: number | undefined;
    municipality?: number | undefined;
    municipalityDesc?: string | undefined;
    reference?: PatientReferenceUnit | undefined;
    referenceDesc?: string | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    street?: string | undefined;
    internalNumber?: string | undefined;
    externalNumber?: string | undefined;
    suburb?: string | undefined;
    phone?: string | undefined;
    postalCode?: number | undefined;
    betweenStreets?: string | undefined;
    pointsReference?: string | undefined;
    creationTime?: moment.Moment | undefined;
    updateTime?: moment.Moment | undefined;
    isActive?: boolean | undefined;
    isChecked: boolean;
    stateCombo?: ComboboxItemDtoOfLong[] | undefined;
    municipalityCombo?: ComboboxItemDtoOfLong[] | undefined;
}

export enum PatientReferenceUnit {
    FamilyContact = 1,
    Reference1 = 2,
    Reference2 = 3,
}

export class PatientPathologicalDto implements IPatientPathologicalDto {
    id?: number | undefined;
    patient?: number | undefined;
    bloodType?: number | undefined;
    bloodTypeDesc?: string | undefined;
    etiology?: number | undefined;
    etiologyDesc?: string | undefined;
    housingType?: number | undefined;
    housingTypeDesc?: string | undefined;
    rhFactor?: number | undefined;
    rhFactorDesc?: string | undefined;
    isVHB!: boolean;
    isVHC!: boolean;
    isVIH!: boolean;
    albumina?: number | undefined;
    basalBloodGlucose?: number | undefined;
    hbA1c?: number | undefined;
    isDiabetes!: boolean;
    cholesterol?: number | undefined;
    cholesterolHDL?: number | undefined;
    cholesterolLDL?: number | undefined;
    triglycerides?: number | undefined;
    sanefroDate?: moment.Moment | undefined;
    vaccinationSchedule!: boolean;
    vaccinationScheduleDesc?: string | undefined;
    vaccinationScheduleMissing?: string | undefined;
    foodPredominance?: string | undefined;
    isSmoking!: boolean;
    smokingYears?: number | undefined;
    smokingMonths?: number | undefined;
    cigars?: number | undefined;
    isAlcoholism!: boolean;
    alcoholismLevel?: number | undefined;
    alcoholismLevelDesc?: string | undefined;
    others?: string | undefined;
    isBasicServices!: boolean;
    isWater!: boolean;
    isElectricity!: boolean;
    isSewerSystem!: boolean;
    ivsa?: number | undefined;
    sexualPartners?: number | undefined;

    constructor(data?: IPatientPathologicalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.patient = _data["patient"];
            this.bloodType = _data["bloodType"];
            this.bloodTypeDesc = _data["bloodTypeDesc"];
            this.etiology = _data["etiology"];
            this.etiologyDesc = _data["etiologyDesc"];
            this.housingType = _data["housingType"];
            this.housingTypeDesc = _data["housingTypeDesc"];
            this.rhFactor = _data["rhFactor"];
            this.rhFactorDesc = _data["rhFactorDesc"];
            this.isVHB = _data["isVHB"];
            this.isVHC = _data["isVHC"];
            this.isVIH = _data["isVIH"];
            this.albumina = _data["albumina"];
            this.basalBloodGlucose = _data["basalBloodGlucose"];
            this.hbA1c = _data["hbA1c"];
            this.isDiabetes = _data["isDiabetes"];
            this.cholesterol = _data["cholesterol"];
            this.cholesterolHDL = _data["cholesterolHDL"];
            this.cholesterolLDL = _data["cholesterolLDL"];
            this.triglycerides = _data["triglycerides"];
            this.sanefroDate = _data["sanefroDate"] ? moment(_data["sanefroDate"].toString()) : <any>undefined;
            this.vaccinationSchedule = _data["vaccinationSchedule"];
            this.vaccinationScheduleDesc = _data["vaccinationScheduleDesc"];
            this.vaccinationScheduleMissing = _data["vaccinationScheduleMissing"];
            this.foodPredominance = _data["foodPredominance"];
            this.isSmoking = _data["isSmoking"];
            this.smokingYears = _data["smokingYears"];
            this.smokingMonths = _data["smokingMonths"];
            this.cigars = _data["cigars"];
            this.isAlcoholism = _data["isAlcoholism"];
            this.alcoholismLevel = _data["alcoholismLevel"];
            this.alcoholismLevelDesc = _data["alcoholismLevelDesc"];
            this.others = _data["others"];
            this.isBasicServices = _data["isBasicServices"];
            this.isWater = _data["isWater"];
            this.isElectricity = _data["isElectricity"];
            this.isSewerSystem = _data["isSewerSystem"];
            this.ivsa = _data["ivsa"];
            this.sexualPartners = _data["sexualPartners"];
        }
    }

    static fromJS(data: any): PatientPathologicalDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPathologicalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["patient"] = this.patient;
        data["bloodType"] = this.bloodType;
        data["bloodTypeDesc"] = this.bloodTypeDesc;
        data["etiology"] = this.etiology;
        data["etiologyDesc"] = this.etiologyDesc;
        data["housingType"] = this.housingType;
        data["housingTypeDesc"] = this.housingTypeDesc;
        data["rhFactor"] = this.rhFactor;
        data["rhFactorDesc"] = this.rhFactorDesc;
        data["isVHB"] = this.isVHB;
        data["isVHC"] = this.isVHC;
        data["isVIH"] = this.isVIH;
        data["albumina"] = this.albumina;
        data["basalBloodGlucose"] = this.basalBloodGlucose;
        data["hbA1c"] = this.hbA1c;
        data["isDiabetes"] = this.isDiabetes;
        data["cholesterol"] = this.cholesterol;
        data["cholesterolHDL"] = this.cholesterolHDL;
        data["cholesterolLDL"] = this.cholesterolLDL;
        data["triglycerides"] = this.triglycerides;
        data["sanefroDate"] = this.sanefroDate ? this.sanefroDate.toISOString() : <any>undefined;
        data["vaccinationSchedule"] = this.vaccinationSchedule;
        data["vaccinationScheduleDesc"] = this.vaccinationScheduleDesc;
        data["vaccinationScheduleMissing"] = this.vaccinationScheduleMissing;
        data["foodPredominance"] = this.foodPredominance;
        data["isSmoking"] = this.isSmoking;
        data["smokingYears"] = this.smokingYears;
        data["smokingMonths"] = this.smokingMonths;
        data["cigars"] = this.cigars;
        data["isAlcoholism"] = this.isAlcoholism;
        data["alcoholismLevel"] = this.alcoholismLevel;
        data["alcoholismLevelDesc"] = this.alcoholismLevelDesc;
        data["others"] = this.others;
        data["isBasicServices"] = this.isBasicServices;
        data["isWater"] = this.isWater;
        data["isElectricity"] = this.isElectricity;
        data["isSewerSystem"] = this.isSewerSystem;
        data["ivsa"] = this.ivsa;
        data["sexualPartners"] = this.sexualPartners;
        return data;
    }
}

export interface IPatientPathologicalDto {
    id?: number | undefined;
    patient?: number | undefined;
    bloodType?: number | undefined;
    bloodTypeDesc?: string | undefined;
    etiology?: number | undefined;
    etiologyDesc?: string | undefined;
    housingType?: number | undefined;
    housingTypeDesc?: string | undefined;
    rhFactor?: number | undefined;
    rhFactorDesc?: string | undefined;
    isVHB: boolean;
    isVHC: boolean;
    isVIH: boolean;
    albumina?: number | undefined;
    basalBloodGlucose?: number | undefined;
    hbA1c?: number | undefined;
    isDiabetes: boolean;
    cholesterol?: number | undefined;
    cholesterolHDL?: number | undefined;
    cholesterolLDL?: number | undefined;
    triglycerides?: number | undefined;
    sanefroDate?: moment.Moment | undefined;
    vaccinationSchedule: boolean;
    vaccinationScheduleDesc?: string | undefined;
    vaccinationScheduleMissing?: string | undefined;
    foodPredominance?: string | undefined;
    isSmoking: boolean;
    smokingYears?: number | undefined;
    smokingMonths?: number | undefined;
    cigars?: number | undefined;
    isAlcoholism: boolean;
    alcoholismLevel?: number | undefined;
    alcoholismLevelDesc?: string | undefined;
    others?: string | undefined;
    isBasicServices: boolean;
    isWater: boolean;
    isElectricity: boolean;
    isSewerSystem: boolean;
    ivsa?: number | undefined;
    sexualPartners?: number | undefined;
}

export class PatientInterrogationSystemDto implements IPatientInterrogationSystemDto {
    id?: number | undefined;
    patient?: number | undefined;
    isRespiratory!: boolean;
    respiratoryComments?: string | undefined;
    isCardiovascular!: boolean;
    cardiovascularComments?: string | undefined;
    isDigestive!: boolean;
    digestiveComments?: string | undefined;
    isGenitourinary!: boolean;
    genitourinaryComments?: string | undefined;
    isMusculoskeletal!: boolean;
    musculoskeletaComments?: string | undefined;
    isEndocrine!: boolean;
    endocrineComments?: string | undefined;
    isNeuropsychiatric!: boolean;
    neuropsychiatricComments?: string | undefined;
    hematopoietic?: string | undefined;
    skinIntegument?: string | undefined;

    constructor(data?: IPatientInterrogationSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.patient = _data["patient"];
            this.isRespiratory = _data["isRespiratory"];
            this.respiratoryComments = _data["respiratoryComments"];
            this.isCardiovascular = _data["isCardiovascular"];
            this.cardiovascularComments = _data["cardiovascularComments"];
            this.isDigestive = _data["isDigestive"];
            this.digestiveComments = _data["digestiveComments"];
            this.isGenitourinary = _data["isGenitourinary"];
            this.genitourinaryComments = _data["genitourinaryComments"];
            this.isMusculoskeletal = _data["isMusculoskeletal"];
            this.musculoskeletaComments = _data["musculoskeletaComments"];
            this.isEndocrine = _data["isEndocrine"];
            this.endocrineComments = _data["endocrineComments"];
            this.isNeuropsychiatric = _data["isNeuropsychiatric"];
            this.neuropsychiatricComments = _data["neuropsychiatricComments"];
            this.hematopoietic = _data["hematopoietic"];
            this.skinIntegument = _data["skinIntegument"];
        }
    }

    static fromJS(data: any): PatientInterrogationSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientInterrogationSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["patient"] = this.patient;
        data["isRespiratory"] = this.isRespiratory;
        data["respiratoryComments"] = this.respiratoryComments;
        data["isCardiovascular"] = this.isCardiovascular;
        data["cardiovascularComments"] = this.cardiovascularComments;
        data["isDigestive"] = this.isDigestive;
        data["digestiveComments"] = this.digestiveComments;
        data["isGenitourinary"] = this.isGenitourinary;
        data["genitourinaryComments"] = this.genitourinaryComments;
        data["isMusculoskeletal"] = this.isMusculoskeletal;
        data["musculoskeletaComments"] = this.musculoskeletaComments;
        data["isEndocrine"] = this.isEndocrine;
        data["endocrineComments"] = this.endocrineComments;
        data["isNeuropsychiatric"] = this.isNeuropsychiatric;
        data["neuropsychiatricComments"] = this.neuropsychiatricComments;
        data["hematopoietic"] = this.hematopoietic;
        data["skinIntegument"] = this.skinIntegument;
        return data;
    }
}

export interface IPatientInterrogationSystemDto {
    id?: number | undefined;
    patient?: number | undefined;
    isRespiratory: boolean;
    respiratoryComments?: string | undefined;
    isCardiovascular: boolean;
    cardiovascularComments?: string | undefined;
    isDigestive: boolean;
    digestiveComments?: string | undefined;
    isGenitourinary: boolean;
    genitourinaryComments?: string | undefined;
    isMusculoskeletal: boolean;
    musculoskeletaComments?: string | undefined;
    isEndocrine: boolean;
    endocrineComments?: string | undefined;
    isNeuropsychiatric: boolean;
    neuropsychiatricComments?: string | undefined;
    hematopoietic?: string | undefined;
    skinIntegument?: string | undefined;
}

export class PatientPhysicalExplorationUnitDto implements IPatientPhysicalExplorationUnitDto {
    id?: number | undefined;
    patient?: number | undefined;
    imc?: string | undefined;
    ta?: string | undefined;
    heartRate?: number | undefined;
    breathingFrequency?: number | undefined;
    temperature?: string | undefined;
    actualWeight?: number | undefined;
    dryWeight?: number | undefined;
    satO2?: number | undefined;
    observations?: string | undefined;

    constructor(data?: IPatientPhysicalExplorationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.patient = _data["patient"];
            this.imc = _data["imc"];
            this.ta = _data["ta"];
            this.heartRate = _data["heartRate"];
            this.breathingFrequency = _data["breathingFrequency"];
            this.temperature = _data["temperature"];
            this.actualWeight = _data["actualWeight"];
            this.dryWeight = _data["dryWeight"];
            this.satO2 = _data["satO2"];
            this.observations = _data["observations"];
        }
    }

    static fromJS(data: any): PatientPhysicalExplorationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPhysicalExplorationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["patient"] = this.patient;
        data["imc"] = this.imc;
        data["ta"] = this.ta;
        data["heartRate"] = this.heartRate;
        data["breathingFrequency"] = this.breathingFrequency;
        data["temperature"] = this.temperature;
        data["actualWeight"] = this.actualWeight;
        data["dryWeight"] = this.dryWeight;
        data["satO2"] = this.satO2;
        data["observations"] = this.observations;
        return data;
    }
}

export interface IPatientPhysicalExplorationUnitDto {
    id?: number | undefined;
    patient?: number | undefined;
    imc?: string | undefined;
    ta?: string | undefined;
    heartRate?: number | undefined;
    breathingFrequency?: number | undefined;
    temperature?: string | undefined;
    actualWeight?: number | undefined;
    dryWeight?: number | undefined;
    satO2?: number | undefined;
    observations?: string | undefined;
}

export class PatientInitialStudyDto implements IPatientInitialStudyDto {
    id?: number | undefined;
    patient?: number | undefined;
    leukocytes?: string | undefined;
    erythrocytes?: string | undefined;
    hematrocitos?: string | undefined;
    hemoglobin?: string | undefined;
    volCorMiddle?: string | undefined;
    hcm?: string | undefined;
    platelets?: string | undefined;
    volPlatMiddle?: string | undefined;
    neutrophils?: string | undefined;
    lymphocytes?: string | undefined;
    monocytes?: string | undefined;
    eosinophils?: string | undefined;
    basophils?: string | undefined;
    urea?: string | undefined;
    creatinine?: string | undefined;
    glucose?: string | undefined;
    uricAC?: string | undefined;
    tfg?: string | undefined;
    ast?: string | undefined;
    alt?: string | undefined;
    albumin?: string | undefined;
    tp?: string | undefined;
    tpt?: string | undefined;
    inr?: string | undefined;
    radiographyComments?: string | undefined;
    electrocardiogramComments?: string | undefined;

    constructor(data?: IPatientInitialStudyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.patient = _data["patient"];
            this.leukocytes = _data["leukocytes"];
            this.erythrocytes = _data["erythrocytes"];
            this.hematrocitos = _data["hematrocitos"];
            this.hemoglobin = _data["hemoglobin"];
            this.volCorMiddle = _data["volCorMiddle"];
            this.hcm = _data["hcm"];
            this.platelets = _data["platelets"];
            this.volPlatMiddle = _data["volPlatMiddle"];
            this.neutrophils = _data["neutrophils"];
            this.lymphocytes = _data["lymphocytes"];
            this.monocytes = _data["monocytes"];
            this.eosinophils = _data["eosinophils"];
            this.basophils = _data["basophils"];
            this.urea = _data["urea"];
            this.creatinine = _data["creatinine"];
            this.glucose = _data["glucose"];
            this.uricAC = _data["uricAC"];
            this.tfg = _data["tfg"];
            this.ast = _data["ast"];
            this.alt = _data["alt"];
            this.albumin = _data["albumin"];
            this.tp = _data["tp"];
            this.tpt = _data["tpt"];
            this.inr = _data["inr"];
            this.radiographyComments = _data["radiographyComments"];
            this.electrocardiogramComments = _data["electrocardiogramComments"];
        }
    }

    static fromJS(data: any): PatientInitialStudyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientInitialStudyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["patient"] = this.patient;
        data["leukocytes"] = this.leukocytes;
        data["erythrocytes"] = this.erythrocytes;
        data["hematrocitos"] = this.hematrocitos;
        data["hemoglobin"] = this.hemoglobin;
        data["volCorMiddle"] = this.volCorMiddle;
        data["hcm"] = this.hcm;
        data["platelets"] = this.platelets;
        data["volPlatMiddle"] = this.volPlatMiddle;
        data["neutrophils"] = this.neutrophils;
        data["lymphocytes"] = this.lymphocytes;
        data["monocytes"] = this.monocytes;
        data["eosinophils"] = this.eosinophils;
        data["basophils"] = this.basophils;
        data["urea"] = this.urea;
        data["creatinine"] = this.creatinine;
        data["glucose"] = this.glucose;
        data["uricAC"] = this.uricAC;
        data["tfg"] = this.tfg;
        data["ast"] = this.ast;
        data["alt"] = this.alt;
        data["albumin"] = this.albumin;
        data["tp"] = this.tp;
        data["tpt"] = this.tpt;
        data["inr"] = this.inr;
        data["radiographyComments"] = this.radiographyComments;
        data["electrocardiogramComments"] = this.electrocardiogramComments;
        return data;
    }
}

export interface IPatientInitialStudyDto {
    id?: number | undefined;
    patient?: number | undefined;
    leukocytes?: string | undefined;
    erythrocytes?: string | undefined;
    hematrocitos?: string | undefined;
    hemoglobin?: string | undefined;
    volCorMiddle?: string | undefined;
    hcm?: string | undefined;
    platelets?: string | undefined;
    volPlatMiddle?: string | undefined;
    neutrophils?: string | undefined;
    lymphocytes?: string | undefined;
    monocytes?: string | undefined;
    eosinophils?: string | undefined;
    basophils?: string | undefined;
    urea?: string | undefined;
    creatinine?: string | undefined;
    glucose?: string | undefined;
    uricAC?: string | undefined;
    tfg?: string | undefined;
    ast?: string | undefined;
    alt?: string | undefined;
    albumin?: string | undefined;
    tp?: string | undefined;
    tpt?: string | undefined;
    inr?: string | undefined;
    radiographyComments?: string | undefined;
    electrocardiogramComments?: string | undefined;
}

export class PatientGinecoObstetricsDto implements IPatientGinecoObstetricsDto {
    id?: number | undefined;
    pacienteId!: number;
    metodoPlanificacionFamiliarId?: number | undefined;
    metodoPlanificacionFamiliarDesc?: string | undefined;
    menarca?: number | undefined;
    ciclo?: number | undefined;
    alteracionMenstrual?: string | undefined;
    fechaUltimoPapiloma?: moment.Moment | undefined;
    resultado?: string | undefined;
    gestas?: number | undefined;
    partos?: number | undefined;
    cesareas?: number | undefined;
    abortos?: number | undefined;

    constructor(data?: IPatientGinecoObstetricsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pacienteId = _data["pacienteId"];
            this.metodoPlanificacionFamiliarId = _data["metodoPlanificacionFamiliarId"];
            this.metodoPlanificacionFamiliarDesc = _data["metodoPlanificacionFamiliarDesc"];
            this.menarca = _data["menarca"];
            this.ciclo = _data["ciclo"];
            this.alteracionMenstrual = _data["alteracionMenstrual"];
            this.fechaUltimoPapiloma = _data["fechaUltimoPapiloma"] ? moment(_data["fechaUltimoPapiloma"].toString()) : <any>undefined;
            this.resultado = _data["resultado"];
            this.gestas = _data["gestas"];
            this.partos = _data["partos"];
            this.cesareas = _data["cesareas"];
            this.abortos = _data["abortos"];
        }
    }

    static fromJS(data: any): PatientGinecoObstetricsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientGinecoObstetricsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pacienteId"] = this.pacienteId;
        data["metodoPlanificacionFamiliarId"] = this.metodoPlanificacionFamiliarId;
        data["metodoPlanificacionFamiliarDesc"] = this.metodoPlanificacionFamiliarDesc;
        data["menarca"] = this.menarca;
        data["ciclo"] = this.ciclo;
        data["alteracionMenstrual"] = this.alteracionMenstrual;
        data["fechaUltimoPapiloma"] = this.fechaUltimoPapiloma ? this.fechaUltimoPapiloma.toISOString() : <any>undefined;
        data["resultado"] = this.resultado;
        data["gestas"] = this.gestas;
        data["partos"] = this.partos;
        data["cesareas"] = this.cesareas;
        data["abortos"] = this.abortos;
        return data;
    }
}

export interface IPatientGinecoObstetricsDto {
    id?: number | undefined;
    pacienteId: number;
    metodoPlanificacionFamiliarId?: number | undefined;
    metodoPlanificacionFamiliarDesc?: string | undefined;
    menarca?: number | undefined;
    ciclo?: number | undefined;
    alteracionMenstrual?: string | undefined;
    fechaUltimoPapiloma?: moment.Moment | undefined;
    resultado?: string | undefined;
    gestas?: number | undefined;
    partos?: number | undefined;
    cesareas?: number | undefined;
    abortos?: number | undefined;
}

export class ComboboxItemDtoOfTipoPacienteIMSSDto implements IComboboxItemDtoOfTipoPacienteIMSSDto {
    value?: TipoPacienteIMSSDto | undefined;
    label?: string | undefined;

    constructor(data?: IComboboxItemDtoOfTipoPacienteIMSSDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? TipoPacienteIMSSDto.fromJS(_data["value"]) : <any>undefined;
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): ComboboxItemDtoOfTipoPacienteIMSSDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDtoOfTipoPacienteIMSSDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["label"] = this.label;
        return data;
    }
}

export interface IComboboxItemDtoOfTipoPacienteIMSSDto {
    value?: TipoPacienteIMSSDto | undefined;
    label?: string | undefined;
}

export class TipoPacienteIMSSDto implements ITipoPacienteIMSSDto {
    id!: number;
    claveTipoPacienteIMSS?: string | undefined;
    descripcion?: string | undefined;
    fechaAlta?: moment.Moment | undefined;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;

    constructor(data?: ITipoPacienteIMSSDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claveTipoPacienteIMSS = _data["claveTipoPacienteIMSS"];
            this.descripcion = _data["descripcion"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TipoPacienteIMSSDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipoPacienteIMSSDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claveTipoPacienteIMSS"] = this.claveTipoPacienteIMSS;
        data["descripcion"] = this.descripcion;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITipoPacienteIMSSDto {
    id: number;
    claveTipoPacienteIMSS?: string | undefined;
    descripcion?: string | undefined;
    fechaAlta?: moment.Moment | undefined;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
}

export class ComboboxItemDtoOfSexoDto implements IComboboxItemDtoOfSexoDto {
    value?: SexoDto | undefined;
    label?: string | undefined;

    constructor(data?: IComboboxItemDtoOfSexoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? SexoDto.fromJS(_data["value"]) : <any>undefined;
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): ComboboxItemDtoOfSexoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDtoOfSexoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["label"] = this.label;
        return data;
    }
}

export interface IComboboxItemDtoOfSexoDto {
    value?: SexoDto | undefined;
    label?: string | undefined;
}

export class SexoDto implements ISexoDto {
    id!: number;
    claveSexo?: string | undefined;
    descripcion?: string | undefined;
    fechaAlta?: moment.Moment | undefined;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;

    constructor(data?: ISexoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claveSexo = _data["claveSexo"];
            this.descripcion = _data["descripcion"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SexoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SexoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claveSexo"] = this.claveSexo;
        data["descripcion"] = this.descripcion;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISexoDto {
    id: number;
    claveSexo?: string | undefined;
    descripcion?: string | undefined;
    fechaAlta?: moment.Moment | undefined;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
}

export class ComboboxItemDtoOfInstitucionAseguradaDto implements IComboboxItemDtoOfInstitucionAseguradaDto {
    value?: InstitucionAseguradaDto | undefined;
    label?: string | undefined;

    constructor(data?: IComboboxItemDtoOfInstitucionAseguradaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? InstitucionAseguradaDto.fromJS(_data["value"]) : <any>undefined;
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): ComboboxItemDtoOfInstitucionAseguradaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDtoOfInstitucionAseguradaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["label"] = this.label;
        return data;
    }
}

export interface IComboboxItemDtoOfInstitucionAseguradaDto {
    value?: InstitucionAseguradaDto | undefined;
    label?: string | undefined;
}

export class InstitucionAseguradaDto implements IInstitucionAseguradaDto {
    id!: number;
    codigoInstitucion?: string | undefined;
    descripcion?: string | undefined;
    isPublico!: boolean;
    isPrivado!: boolean;
    fechaAlta?: moment.Moment | undefined;
    fechaModificacion?: moment.Moment | undefined;
    isActive!: boolean;

    constructor(data?: IInstitucionAseguradaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.codigoInstitucion = _data["codigoInstitucion"];
            this.descripcion = _data["descripcion"];
            this.isPublico = _data["isPublico"];
            this.isPrivado = _data["isPrivado"];
            this.fechaAlta = _data["fechaAlta"] ? moment(_data["fechaAlta"].toString()) : <any>undefined;
            this.fechaModificacion = _data["fechaModificacion"] ? moment(_data["fechaModificacion"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): InstitucionAseguradaDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstitucionAseguradaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["codigoInstitucion"] = this.codigoInstitucion;
        data["descripcion"] = this.descripcion;
        data["isPublico"] = this.isPublico;
        data["isPrivado"] = this.isPrivado;
        data["fechaAlta"] = this.fechaAlta ? this.fechaAlta.toISOString() : <any>undefined;
        data["fechaModificacion"] = this.fechaModificacion ? this.fechaModificacion.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IInstitucionAseguradaDto {
    id: number;
    codigoInstitucion?: string | undefined;
    descripcion?: string | undefined;
    isPublico: boolean;
    isPrivado: boolean;
    fechaAlta?: moment.Moment | undefined;
    fechaModificacion?: moment.Moment | undefined;
    isActive: boolean;
}

export class ComboboxItemDtoOfByte implements IComboboxItemDtoOfByte {
    value!: number;
    label?: string | undefined;

    constructor(data?: IComboboxItemDtoOfByte) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): ComboboxItemDtoOfByte {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDtoOfByte();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IComboboxItemDtoOfByte {
    value: number;
    label?: string | undefined;
}

export class PatientGetForEditQuery implements IPatientGetForEditQuery {
    id?: number | undefined;

    constructor(data?: IPatientGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PatientGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PatientGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IPatientGetForEditQuery {
    id?: number | undefined;
}

export class PatientResponse implements IPatientResponse {
    id!: number;
    idee?: string | undefined;
    clinicHistory?: number | undefined;
    patientTypeImss?: number | undefined;
    patientTypeImssDesc?: string | undefined;
    institution?: number | undefined;
    institutionDesc?: string | undefined;
    delegation?: number | undefined;
    delegationDesc?: string | undefined;
    umf?: number | undefined;
    umfDesc?: string | undefined;
    sex?: number | undefined;
    sexDesc?: string | undefined;
    patientQuality?: number | undefined;
    patientQualityDesc?: string | undefined;
    maritalStatus?: number | undefined;
    maritalStatusDesc?: string | undefined;
    educationLevel?: number | undefined;
    educationLevelDesc?: string | undefined;
    religion?: number | undefined;
    religionDesc?: string | undefined;
    occupation?: number | undefined;
    occupationDesc?: string | undefined;
    municipality?: number | undefined;
    municipalityDesc?: string | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    nss?: string | undefined;
    medicalAttache?: string | undefined;
    curp?: string | undefined;
    birthDate?: moment.Moment | undefined;
    yearsStudy?: number | undefined;
    street?: string | undefined;
    internalNumber?: string | undefined;
    externalNumber?: string | undefined;
    postalCode?: number | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    betweenStreets?: string | undefined;
    pointsReference?: string | undefined;
    suburb?: string | undefined;
    creationTime?: moment.Moment | undefined;
    updateTime?: moment.Moment | undefined;
    isActive?: boolean | undefined;
    isActiveDesc?: string | undefined;
    birthState?: number | undefined;
    rfc?: string | undefined;
    deathDate?: moment.Moment | undefined;
    generalUnit?: PatientGeneralUnitDto | undefined;
    referenceUnitList?: PatientReferenceUnitDto[] | undefined;
    pathological?: PatientPathologicalDto | undefined;
    ginecoObstetrics?: PatientGinecoObstetricsDto | undefined;
    age?: number | undefined;
    umfBudgetAccountCode?: string | undefined;

    constructor(data?: IPatientResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idee = _data["idee"];
            this.clinicHistory = _data["clinicHistory"];
            this.patientTypeImss = _data["patientTypeImss"];
            this.patientTypeImssDesc = _data["patientTypeImssDesc"];
            this.institution = _data["institution"];
            this.institutionDesc = _data["institutionDesc"];
            this.delegation = _data["delegation"];
            this.delegationDesc = _data["delegationDesc"];
            this.umf = _data["umf"];
            this.umfDesc = _data["umfDesc"];
            this.sex = _data["sex"];
            this.sexDesc = _data["sexDesc"];
            this.patientQuality = _data["patientQuality"];
            this.patientQualityDesc = _data["patientQualityDesc"];
            this.maritalStatus = _data["maritalStatus"];
            this.maritalStatusDesc = _data["maritalStatusDesc"];
            this.educationLevel = _data["educationLevel"];
            this.educationLevelDesc = _data["educationLevelDesc"];
            this.religion = _data["religion"];
            this.religionDesc = _data["religionDesc"];
            this.occupation = _data["occupation"];
            this.occupationDesc = _data["occupationDesc"];
            this.municipality = _data["municipality"];
            this.municipalityDesc = _data["municipalityDesc"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.nss = _data["nss"];
            this.medicalAttache = _data["medicalAttache"];
            this.curp = _data["curp"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.yearsStudy = _data["yearsStudy"];
            this.street = _data["street"];
            this.internalNumber = _data["internalNumber"];
            this.externalNumber = _data["externalNumber"];
            this.postalCode = _data["postalCode"];
            this.phone = _data["phone"];
            this.cellPhone = _data["cellPhone"];
            this.betweenStreets = _data["betweenStreets"];
            this.pointsReference = _data["pointsReference"];
            this.suburb = _data["suburb"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.updateTime = _data["updateTime"] ? moment(_data["updateTime"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
            this.birthState = _data["birthState"];
            this.rfc = _data["rfc"];
            this.deathDate = _data["deathDate"] ? moment(_data["deathDate"].toString()) : <any>undefined;
            this.generalUnit = _data["generalUnit"] ? PatientGeneralUnitDto.fromJS(_data["generalUnit"]) : <any>undefined;
            if (Array.isArray(_data["referenceUnitList"])) {
                this.referenceUnitList = [] as any;
                for (let item of _data["referenceUnitList"])
                    this.referenceUnitList!.push(PatientReferenceUnitDto.fromJS(item));
            }
            this.pathological = _data["pathological"] ? PatientPathologicalDto.fromJS(_data["pathological"]) : <any>undefined;
            this.ginecoObstetrics = _data["ginecoObstetrics"] ? PatientGinecoObstetricsDto.fromJS(_data["ginecoObstetrics"]) : <any>undefined;
            this.age = _data["age"];
            this.umfBudgetAccountCode = _data["umfBudgetAccountCode"];
        }
    }

    static fromJS(data: any): PatientResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PatientResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idee"] = this.idee;
        data["clinicHistory"] = this.clinicHistory;
        data["patientTypeImss"] = this.patientTypeImss;
        data["patientTypeImssDesc"] = this.patientTypeImssDesc;
        data["institution"] = this.institution;
        data["institutionDesc"] = this.institutionDesc;
        data["delegation"] = this.delegation;
        data["delegationDesc"] = this.delegationDesc;
        data["umf"] = this.umf;
        data["umfDesc"] = this.umfDesc;
        data["sex"] = this.sex;
        data["sexDesc"] = this.sexDesc;
        data["patientQuality"] = this.patientQuality;
        data["patientQualityDesc"] = this.patientQualityDesc;
        data["maritalStatus"] = this.maritalStatus;
        data["maritalStatusDesc"] = this.maritalStatusDesc;
        data["educationLevel"] = this.educationLevel;
        data["educationLevelDesc"] = this.educationLevelDesc;
        data["religion"] = this.religion;
        data["religionDesc"] = this.religionDesc;
        data["occupation"] = this.occupation;
        data["occupationDesc"] = this.occupationDesc;
        data["municipality"] = this.municipality;
        data["municipalityDesc"] = this.municipalityDesc;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["nss"] = this.nss;
        data["medicalAttache"] = this.medicalAttache;
        data["curp"] = this.curp;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["yearsStudy"] = this.yearsStudy;
        data["street"] = this.street;
        data["internalNumber"] = this.internalNumber;
        data["externalNumber"] = this.externalNumber;
        data["postalCode"] = this.postalCode;
        data["phone"] = this.phone;
        data["cellPhone"] = this.cellPhone;
        data["betweenStreets"] = this.betweenStreets;
        data["pointsReference"] = this.pointsReference;
        data["suburb"] = this.suburb;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        data["birthState"] = this.birthState;
        data["rfc"] = this.rfc;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        data["generalUnit"] = this.generalUnit ? this.generalUnit.toJSON() : <any>undefined;
        if (Array.isArray(this.referenceUnitList)) {
            data["referenceUnitList"] = [];
            for (let item of this.referenceUnitList)
                data["referenceUnitList"].push(item.toJSON());
        }
        data["pathological"] = this.pathological ? this.pathological.toJSON() : <any>undefined;
        data["ginecoObstetrics"] = this.ginecoObstetrics ? this.ginecoObstetrics.toJSON() : <any>undefined;
        data["age"] = this.age;
        data["umfBudgetAccountCode"] = this.umfBudgetAccountCode;
        return data;
    }
}

export interface IPatientResponse {
    id: number;
    idee?: string | undefined;
    clinicHistory?: number | undefined;
    patientTypeImss?: number | undefined;
    patientTypeImssDesc?: string | undefined;
    institution?: number | undefined;
    institutionDesc?: string | undefined;
    delegation?: number | undefined;
    delegationDesc?: string | undefined;
    umf?: number | undefined;
    umfDesc?: string | undefined;
    sex?: number | undefined;
    sexDesc?: string | undefined;
    patientQuality?: number | undefined;
    patientQualityDesc?: string | undefined;
    maritalStatus?: number | undefined;
    maritalStatusDesc?: string | undefined;
    educationLevel?: number | undefined;
    educationLevelDesc?: string | undefined;
    religion?: number | undefined;
    religionDesc?: string | undefined;
    occupation?: number | undefined;
    occupationDesc?: string | undefined;
    municipality?: number | undefined;
    municipalityDesc?: string | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    nss?: string | undefined;
    medicalAttache?: string | undefined;
    curp?: string | undefined;
    birthDate?: moment.Moment | undefined;
    yearsStudy?: number | undefined;
    street?: string | undefined;
    internalNumber?: string | undefined;
    externalNumber?: string | undefined;
    postalCode?: number | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    betweenStreets?: string | undefined;
    pointsReference?: string | undefined;
    suburb?: string | undefined;
    creationTime?: moment.Moment | undefined;
    updateTime?: moment.Moment | undefined;
    isActive?: boolean | undefined;
    isActiveDesc?: string | undefined;
    birthState?: number | undefined;
    rfc?: string | undefined;
    deathDate?: moment.Moment | undefined;
    generalUnit?: PatientGeneralUnitDto | undefined;
    referenceUnitList?: PatientReferenceUnitDto[] | undefined;
    pathological?: PatientPathologicalDto | undefined;
    ginecoObstetrics?: PatientGinecoObstetricsDto | undefined;
    age?: number | undefined;
    umfBudgetAccountCode?: string | undefined;
}

export class PatientGetByIdQuery implements IPatientGetByIdQuery {
    id?: number | undefined;

    constructor(data?: IPatientGetByIdQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PatientGetByIdQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PatientGetByIdQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IPatientGetByIdQuery {
    id?: number | undefined;
}

export class PatientGetByCURPQuery implements IPatientGetByCURPQuery {
    curp?: string | undefined;

    constructor(data?: IPatientGetByCURPQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.curp = _data["curp"];
        }
    }

    static fromJS(data: any): PatientGetByCURPQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PatientGetByCURPQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["curp"] = this.curp;
        return data;
    }
}

export interface IPatientGetByCURPQuery {
    curp?: string | undefined;
}

export class PatientCreateCommand implements IPatientCreateCommand {
    idee?: string | undefined;
    patientTypeImss?: number | undefined;
    institution?: number | undefined;
    delegation?: number | undefined;
    umf?: number | undefined;
    sex?: number | undefined;
    patientQuality?: number | undefined;
    maritalStatus?: number | undefined;
    educationLevel?: number | undefined;
    religion?: number | undefined;
    occupation?: number | undefined;
    municipality?: number | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nss?: string | undefined;
    medicalAttache?: string | undefined;
    curp?: string | undefined;
    birthDate?: moment.Moment | undefined;
    yearsStudy?: number | undefined;
    street?: string | undefined;
    internalNumber?: string | undefined;
    externalNumber?: string | undefined;
    postalCode?: number | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    betweenStreets?: string | undefined;
    pointsReference?: string | undefined;
    suburb?: string | undefined;
    isActive?: boolean | undefined;
    birthState?: number | undefined;
    rfc?: string | undefined;
    deathDate?: moment.Moment | undefined;
    generalUnit?: PatientGeneralUnitDto | undefined;
    referenceUnit?: PatientReferenceUnitDto | undefined;
    ginecoObstetrics?: PatientGinecoObstetricsDto | undefined;
    bloodType?: number | undefined;
    rhFactor?: number | undefined;

    constructor(data?: IPatientCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idee = _data["idee"];
            this.patientTypeImss = _data["patientTypeImss"];
            this.institution = _data["institution"];
            this.delegation = _data["delegation"];
            this.umf = _data["umf"];
            this.sex = _data["sex"];
            this.patientQuality = _data["patientQuality"];
            this.maritalStatus = _data["maritalStatus"];
            this.educationLevel = _data["educationLevel"];
            this.religion = _data["religion"];
            this.occupation = _data["occupation"];
            this.municipality = _data["municipality"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.nss = _data["nss"];
            this.medicalAttache = _data["medicalAttache"];
            this.curp = _data["curp"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.yearsStudy = _data["yearsStudy"];
            this.street = _data["street"];
            this.internalNumber = _data["internalNumber"];
            this.externalNumber = _data["externalNumber"];
            this.postalCode = _data["postalCode"];
            this.phone = _data["phone"];
            this.cellPhone = _data["cellPhone"];
            this.betweenStreets = _data["betweenStreets"];
            this.pointsReference = _data["pointsReference"];
            this.suburb = _data["suburb"];
            this.isActive = _data["isActive"];
            this.birthState = _data["birthState"];
            this.rfc = _data["rfc"];
            this.deathDate = _data["deathDate"] ? moment(_data["deathDate"].toString()) : <any>undefined;
            this.generalUnit = _data["generalUnit"] ? PatientGeneralUnitDto.fromJS(_data["generalUnit"]) : <any>undefined;
            this.referenceUnit = _data["referenceUnit"] ? PatientReferenceUnitDto.fromJS(_data["referenceUnit"]) : <any>undefined;
            this.ginecoObstetrics = _data["ginecoObstetrics"] ? PatientGinecoObstetricsDto.fromJS(_data["ginecoObstetrics"]) : <any>undefined;
            this.bloodType = _data["bloodType"];
            this.rhFactor = _data["rhFactor"];
        }
    }

    static fromJS(data: any): PatientCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PatientCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idee"] = this.idee;
        data["patientTypeImss"] = this.patientTypeImss;
        data["institution"] = this.institution;
        data["delegation"] = this.delegation;
        data["umf"] = this.umf;
        data["sex"] = this.sex;
        data["patientQuality"] = this.patientQuality;
        data["maritalStatus"] = this.maritalStatus;
        data["educationLevel"] = this.educationLevel;
        data["religion"] = this.religion;
        data["occupation"] = this.occupation;
        data["municipality"] = this.municipality;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["nss"] = this.nss;
        data["medicalAttache"] = this.medicalAttache;
        data["curp"] = this.curp;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["yearsStudy"] = this.yearsStudy;
        data["street"] = this.street;
        data["internalNumber"] = this.internalNumber;
        data["externalNumber"] = this.externalNumber;
        data["postalCode"] = this.postalCode;
        data["phone"] = this.phone;
        data["cellPhone"] = this.cellPhone;
        data["betweenStreets"] = this.betweenStreets;
        data["pointsReference"] = this.pointsReference;
        data["suburb"] = this.suburb;
        data["isActive"] = this.isActive;
        data["birthState"] = this.birthState;
        data["rfc"] = this.rfc;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        data["generalUnit"] = this.generalUnit ? this.generalUnit.toJSON() : <any>undefined;
        data["referenceUnit"] = this.referenceUnit ? this.referenceUnit.toJSON() : <any>undefined;
        data["ginecoObstetrics"] = this.ginecoObstetrics ? this.ginecoObstetrics.toJSON() : <any>undefined;
        data["bloodType"] = this.bloodType;
        data["rhFactor"] = this.rhFactor;
        return data;
    }
}

export interface IPatientCreateCommand {
    idee?: string | undefined;
    patientTypeImss?: number | undefined;
    institution?: number | undefined;
    delegation?: number | undefined;
    umf?: number | undefined;
    sex?: number | undefined;
    patientQuality?: number | undefined;
    maritalStatus?: number | undefined;
    educationLevel?: number | undefined;
    religion?: number | undefined;
    occupation?: number | undefined;
    municipality?: number | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nss?: string | undefined;
    medicalAttache?: string | undefined;
    curp?: string | undefined;
    birthDate?: moment.Moment | undefined;
    yearsStudy?: number | undefined;
    street?: string | undefined;
    internalNumber?: string | undefined;
    externalNumber?: string | undefined;
    postalCode?: number | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    betweenStreets?: string | undefined;
    pointsReference?: string | undefined;
    suburb?: string | undefined;
    isActive?: boolean | undefined;
    birthState?: number | undefined;
    rfc?: string | undefined;
    deathDate?: moment.Moment | undefined;
    generalUnit?: PatientGeneralUnitDto | undefined;
    referenceUnit?: PatientReferenceUnitDto | undefined;
    ginecoObstetrics?: PatientGinecoObstetricsDto | undefined;
    bloodType?: number | undefined;
    rhFactor?: number | undefined;
}

export class PatientUpdateCommand implements IPatientUpdateCommand {
    id?: number | undefined;
    idee?: string | undefined;
    patientTypeImss?: number | undefined;
    institution?: number | undefined;
    delegation?: number | undefined;
    umf?: number | undefined;
    sex?: number | undefined;
    patientQuality?: number | undefined;
    maritalStatus?: number | undefined;
    educationLevel?: number | undefined;
    religion?: number | undefined;
    occupation?: number | undefined;
    municipality?: number | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nss?: string | undefined;
    medicalAttache?: string | undefined;
    curp?: string | undefined;
    birthDate?: moment.Moment | undefined;
    yearsStudy?: number | undefined;
    street?: string | undefined;
    internalNumber?: string | undefined;
    externalNumber?: string | undefined;
    postalCode?: number | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    betweenStreets?: string | undefined;
    pointsReference?: string | undefined;
    suburb?: string | undefined;
    isActive?: boolean | undefined;
    birthState?: number | undefined;
    rfc?: string | undefined;
    deathDate?: moment.Moment | undefined;
    generalUnit?: PatientGeneralUnitDto | undefined;
    referenceUnitList?: PatientReferenceUnitDto[] | undefined;
    pathological?: PatientPathologicalDto | undefined;
    interrogationSystem?: PatientInterrogationSystemDto | undefined;
    physicalExplorationUnit?: PatientPhysicalExplorationUnitDto | undefined;
    initialStudy?: PatientInitialStudyDto | undefined;
    ginecoObstetrics?: PatientGinecoObstetricsDto | undefined;

    constructor(data?: IPatientUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idee = _data["idee"];
            this.patientTypeImss = _data["patientTypeImss"];
            this.institution = _data["institution"];
            this.delegation = _data["delegation"];
            this.umf = _data["umf"];
            this.sex = _data["sex"];
            this.patientQuality = _data["patientQuality"];
            this.maritalStatus = _data["maritalStatus"];
            this.educationLevel = _data["educationLevel"];
            this.religion = _data["religion"];
            this.occupation = _data["occupation"];
            this.municipality = _data["municipality"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.nss = _data["nss"];
            this.medicalAttache = _data["medicalAttache"];
            this.curp = _data["curp"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.yearsStudy = _data["yearsStudy"];
            this.street = _data["street"];
            this.internalNumber = _data["internalNumber"];
            this.externalNumber = _data["externalNumber"];
            this.postalCode = _data["postalCode"];
            this.phone = _data["phone"];
            this.cellPhone = _data["cellPhone"];
            this.betweenStreets = _data["betweenStreets"];
            this.pointsReference = _data["pointsReference"];
            this.suburb = _data["suburb"];
            this.isActive = _data["isActive"];
            this.birthState = _data["birthState"];
            this.rfc = _data["rfc"];
            this.deathDate = _data["deathDate"] ? moment(_data["deathDate"].toString()) : <any>undefined;
            this.generalUnit = _data["generalUnit"] ? PatientGeneralUnitDto.fromJS(_data["generalUnit"]) : <any>undefined;
            if (Array.isArray(_data["referenceUnitList"])) {
                this.referenceUnitList = [] as any;
                for (let item of _data["referenceUnitList"])
                    this.referenceUnitList!.push(PatientReferenceUnitDto.fromJS(item));
            }
            this.pathological = _data["pathological"] ? PatientPathologicalDto.fromJS(_data["pathological"]) : <any>undefined;
            this.interrogationSystem = _data["interrogationSystem"] ? PatientInterrogationSystemDto.fromJS(_data["interrogationSystem"]) : <any>undefined;
            this.physicalExplorationUnit = _data["physicalExplorationUnit"] ? PatientPhysicalExplorationUnitDto.fromJS(_data["physicalExplorationUnit"]) : <any>undefined;
            this.initialStudy = _data["initialStudy"] ? PatientInitialStudyDto.fromJS(_data["initialStudy"]) : <any>undefined;
            this.ginecoObstetrics = _data["ginecoObstetrics"] ? PatientGinecoObstetricsDto.fromJS(_data["ginecoObstetrics"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PatientUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idee"] = this.idee;
        data["patientTypeImss"] = this.patientTypeImss;
        data["institution"] = this.institution;
        data["delegation"] = this.delegation;
        data["umf"] = this.umf;
        data["sex"] = this.sex;
        data["patientQuality"] = this.patientQuality;
        data["maritalStatus"] = this.maritalStatus;
        data["educationLevel"] = this.educationLevel;
        data["religion"] = this.religion;
        data["occupation"] = this.occupation;
        data["municipality"] = this.municipality;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["nss"] = this.nss;
        data["medicalAttache"] = this.medicalAttache;
        data["curp"] = this.curp;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["yearsStudy"] = this.yearsStudy;
        data["street"] = this.street;
        data["internalNumber"] = this.internalNumber;
        data["externalNumber"] = this.externalNumber;
        data["postalCode"] = this.postalCode;
        data["phone"] = this.phone;
        data["cellPhone"] = this.cellPhone;
        data["betweenStreets"] = this.betweenStreets;
        data["pointsReference"] = this.pointsReference;
        data["suburb"] = this.suburb;
        data["isActive"] = this.isActive;
        data["birthState"] = this.birthState;
        data["rfc"] = this.rfc;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        data["generalUnit"] = this.generalUnit ? this.generalUnit.toJSON() : <any>undefined;
        if (Array.isArray(this.referenceUnitList)) {
            data["referenceUnitList"] = [];
            for (let item of this.referenceUnitList)
                data["referenceUnitList"].push(item.toJSON());
        }
        data["pathological"] = this.pathological ? this.pathological.toJSON() : <any>undefined;
        data["interrogationSystem"] = this.interrogationSystem ? this.interrogationSystem.toJSON() : <any>undefined;
        data["physicalExplorationUnit"] = this.physicalExplorationUnit ? this.physicalExplorationUnit.toJSON() : <any>undefined;
        data["initialStudy"] = this.initialStudy ? this.initialStudy.toJSON() : <any>undefined;
        data["ginecoObstetrics"] = this.ginecoObstetrics ? this.ginecoObstetrics.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPatientUpdateCommand {
    id?: number | undefined;
    idee?: string | undefined;
    patientTypeImss?: number | undefined;
    institution?: number | undefined;
    delegation?: number | undefined;
    umf?: number | undefined;
    sex?: number | undefined;
    patientQuality?: number | undefined;
    maritalStatus?: number | undefined;
    educationLevel?: number | undefined;
    religion?: number | undefined;
    occupation?: number | undefined;
    municipality?: number | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nss?: string | undefined;
    medicalAttache?: string | undefined;
    curp?: string | undefined;
    birthDate?: moment.Moment | undefined;
    yearsStudy?: number | undefined;
    street?: string | undefined;
    internalNumber?: string | undefined;
    externalNumber?: string | undefined;
    postalCode?: number | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    betweenStreets?: string | undefined;
    pointsReference?: string | undefined;
    suburb?: string | undefined;
    isActive?: boolean | undefined;
    birthState?: number | undefined;
    rfc?: string | undefined;
    deathDate?: moment.Moment | undefined;
    generalUnit?: PatientGeneralUnitDto | undefined;
    referenceUnitList?: PatientReferenceUnitDto[] | undefined;
    pathological?: PatientPathologicalDto | undefined;
    interrogationSystem?: PatientInterrogationSystemDto | undefined;
    physicalExplorationUnit?: PatientPhysicalExplorationUnitDto | undefined;
    initialStudy?: PatientInitialStudyDto | undefined;
    ginecoObstetrics?: PatientGinecoObstetricsDto | undefined;
}

export class PagedResultDtoOfPatientFaunaForListResponse implements IPagedResultDtoOfPatientFaunaForListResponse {
    totalCount!: number;
    items?: PatientFaunaForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfPatientFaunaForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientFaunaForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPatientFaunaForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPatientFaunaForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfPatientFaunaForListResponse {
    totalCount: number;
    items?: PatientFaunaForListResponse[] | undefined;
}

export class PatientFaunaForListResponse implements IPatientFaunaForListResponse {
    id!: number;
    quantity?: number | undefined;
    faunaDesc?: string | undefined;
    faunaTypeDesc?: string | undefined;

    constructor(data?: IPatientFaunaForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quantity = _data["quantity"];
            this.faunaDesc = _data["faunaDesc"];
            this.faunaTypeDesc = _data["faunaTypeDesc"];
        }
    }

    static fromJS(data: any): PatientFaunaForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PatientFaunaForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quantity"] = this.quantity;
        data["faunaDesc"] = this.faunaDesc;
        data["faunaTypeDesc"] = this.faunaTypeDesc;
        return data;
    }
}

export interface IPatientFaunaForListResponse {
    id: number;
    quantity?: number | undefined;
    faunaDesc?: string | undefined;
    faunaTypeDesc?: string | undefined;
}

export class PatientFaunaGetListQuery extends PageListByDto implements IPatientFaunaGetListQuery {
    patient?: number | undefined;

    constructor(data?: IPatientFaunaGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patient = _data["patient"];
        }
    }

    static override fromJS(data: any): PatientFaunaGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PatientFaunaGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patient"] = this.patient;
        super.toJSON(data);
        return data;
    }
}

export interface IPatientFaunaGetListQuery extends IPageListByDto {
    patient?: number | undefined;
}

export class PatientFaunaCreateCommand implements IPatientFaunaCreateCommand {
    patient?: number | undefined;
    quantity?: number | undefined;
    fauna?: number | undefined;

    constructor(data?: IPatientFaunaCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patient = _data["patient"];
            this.quantity = _data["quantity"];
            this.fauna = _data["fauna"];
        }
    }

    static fromJS(data: any): PatientFaunaCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PatientFaunaCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patient"] = this.patient;
        data["quantity"] = this.quantity;
        data["fauna"] = this.fauna;
        return data;
    }
}

export interface IPatientFaunaCreateCommand {
    patient?: number | undefined;
    quantity?: number | undefined;
    fauna?: number | undefined;
}

export class PatientFaunaDeleteCommand implements IPatientFaunaDeleteCommand {
    id?: number | undefined;

    constructor(data?: IPatientFaunaDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PatientFaunaDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PatientFaunaDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IPatientFaunaDeleteCommand {
    id?: number | undefined;
}

export class PagedResultDtoOfPatientAllergieForListResponse implements IPagedResultDtoOfPatientAllergieForListResponse {
    totalCount!: number;
    items?: PatientAllergieForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfPatientAllergieForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientAllergieForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPatientAllergieForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPatientAllergieForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfPatientAllergieForListResponse {
    totalCount: number;
    items?: PatientAllergieForListResponse[] | undefined;
}

export class PatientAllergieForListResponse implements IPatientAllergieForListResponse {
    id!: number;
    allergieDesc?: string | undefined;
    allergieDate!: moment.Moment;

    constructor(data?: IPatientAllergieForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.allergieDesc = _data["allergieDesc"];
            this.allergieDate = _data["allergieDate"] ? moment(_data["allergieDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientAllergieForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PatientAllergieForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["allergieDesc"] = this.allergieDesc;
        data["allergieDate"] = this.allergieDate ? this.allergieDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPatientAllergieForListResponse {
    id: number;
    allergieDesc?: string | undefined;
    allergieDate: moment.Moment;
}

export class PatientAllergieGetListQuery extends PageListByDto implements IPatientAllergieGetListQuery {
    patient?: number | undefined;

    constructor(data?: IPatientAllergieGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patient = _data["patient"];
        }
    }

    static override fromJS(data: any): PatientAllergieGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PatientAllergieGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patient"] = this.patient;
        super.toJSON(data);
        return data;
    }
}

export interface IPatientAllergieGetListQuery extends IPageListByDto {
    patient?: number | undefined;
}

export class PatientAllergieCreateCommand implements IPatientAllergieCreateCommand {
    patient?: number | undefined;
    allergie?: number | undefined;
    allergieDate?: moment.Moment | undefined;

    constructor(data?: IPatientAllergieCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patient = _data["patient"];
            this.allergie = _data["allergie"];
            this.allergieDate = _data["allergieDate"] ? moment(_data["allergieDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientAllergieCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PatientAllergieCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patient"] = this.patient;
        data["allergie"] = this.allergie;
        data["allergieDate"] = this.allergieDate ? this.allergieDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPatientAllergieCreateCommand {
    patient?: number | undefined;
    allergie?: number | undefined;
    allergieDate?: moment.Moment | undefined;
}

export class PatientAllergieDeleteCommand implements IPatientAllergieDeleteCommand {
    id?: number | undefined;

    constructor(data?: IPatientAllergieDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PatientAllergieDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PatientAllergieDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IPatientAllergieDeleteCommand {
    id?: number | undefined;
}

export class PagedResultDtoOfPatientMedicalHistoryForListResponse implements IPagedResultDtoOfPatientMedicalHistoryForListResponse {
    totalCount!: number;
    items?: PatientMedicalHistoryForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfPatientMedicalHistoryForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientMedicalHistoryForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPatientMedicalHistoryForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPatientMedicalHistoryForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfPatientMedicalHistoryForListResponse {
    totalCount: number;
    items?: PatientMedicalHistoryForListResponse[] | undefined;
}

export class PatientMedicalHistoryForListResponse implements IPatientMedicalHistoryForListResponse {
    id!: number;
    eventDesc?: string | undefined;
    eventCode?: string | undefined;
    eventTypeDesc?: string | undefined;
    catalogTypeDesc?: string | undefined;
    eventDate!: moment.Moment;
    age?: number | undefined;
    isHereditary!: boolean;
    isHereditaryDesc?: string | undefined;

    constructor(data?: IPatientMedicalHistoryForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventDesc = _data["eventDesc"];
            this.eventCode = _data["eventCode"];
            this.eventTypeDesc = _data["eventTypeDesc"];
            this.catalogTypeDesc = _data["catalogTypeDesc"];
            this.eventDate = _data["eventDate"] ? moment(_data["eventDate"].toString()) : <any>undefined;
            this.age = _data["age"];
            this.isHereditary = _data["isHereditary"];
            this.isHereditaryDesc = _data["isHereditaryDesc"];
        }
    }

    static fromJS(data: any): PatientMedicalHistoryForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicalHistoryForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventDesc"] = this.eventDesc;
        data["eventCode"] = this.eventCode;
        data["eventTypeDesc"] = this.eventTypeDesc;
        data["catalogTypeDesc"] = this.catalogTypeDesc;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["age"] = this.age;
        data["isHereditary"] = this.isHereditary;
        data["isHereditaryDesc"] = this.isHereditaryDesc;
        return data;
    }
}

export interface IPatientMedicalHistoryForListResponse {
    id: number;
    eventDesc?: string | undefined;
    eventCode?: string | undefined;
    eventTypeDesc?: string | undefined;
    catalogTypeDesc?: string | undefined;
    eventDate: moment.Moment;
    age?: number | undefined;
    isHereditary: boolean;
    isHereditaryDesc?: string | undefined;
}

export class PatientMedicalHistoryGetListQuery extends PageListByDto implements IPatientMedicalHistoryGetListQuery {
    patient?: number | undefined;

    constructor(data?: IPatientMedicalHistoryGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patient = _data["patient"];
        }
    }

    static override fromJS(data: any): PatientMedicalHistoryGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicalHistoryGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patient"] = this.patient;
        super.toJSON(data);
        return data;
    }
}

export interface IPatientMedicalHistoryGetListQuery extends IPageListByDto {
    patient?: number | undefined;
}

export class PatientMedicalHistoryResponse implements IPatientMedicalHistoryResponse {
    id!: number;
    patient?: number | undefined;
    event?: number | undefined;
    eventDesc?: string | undefined;
    eventCode?: string | undefined;
    eventLargeDesc?: string | undefined;
    eventType?: number | undefined;
    eventTypeDesc?: string | undefined;
    catalogType?: number | undefined;
    catalogTypeDesc?: string | undefined;
    relationship?: number | undefined;
    relationshipDesc?: string | undefined;
    eventDate?: moment.Moment | undefined;
    age?: number | undefined;
    isHereditary!: boolean;
    observations?: string | undefined;

    constructor(data?: IPatientMedicalHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.patient = _data["patient"];
            this.event = _data["event"];
            this.eventDesc = _data["eventDesc"];
            this.eventCode = _data["eventCode"];
            this.eventLargeDesc = _data["eventLargeDesc"];
            this.eventType = _data["eventType"];
            this.eventTypeDesc = _data["eventTypeDesc"];
            this.catalogType = _data["catalogType"];
            this.catalogTypeDesc = _data["catalogTypeDesc"];
            this.relationship = _data["relationship"];
            this.relationshipDesc = _data["relationshipDesc"];
            this.eventDate = _data["eventDate"] ? moment(_data["eventDate"].toString()) : <any>undefined;
            this.age = _data["age"];
            this.isHereditary = _data["isHereditary"];
            this.observations = _data["observations"];
        }
    }

    static fromJS(data: any): PatientMedicalHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicalHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["patient"] = this.patient;
        data["event"] = this.event;
        data["eventDesc"] = this.eventDesc;
        data["eventCode"] = this.eventCode;
        data["eventLargeDesc"] = this.eventLargeDesc;
        data["eventType"] = this.eventType;
        data["eventTypeDesc"] = this.eventTypeDesc;
        data["catalogType"] = this.catalogType;
        data["catalogTypeDesc"] = this.catalogTypeDesc;
        data["relationship"] = this.relationship;
        data["relationshipDesc"] = this.relationshipDesc;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["age"] = this.age;
        data["isHereditary"] = this.isHereditary;
        data["observations"] = this.observations;
        return data;
    }
}

export interface IPatientMedicalHistoryResponse {
    id: number;
    patient?: number | undefined;
    event?: number | undefined;
    eventDesc?: string | undefined;
    eventCode?: string | undefined;
    eventLargeDesc?: string | undefined;
    eventType?: number | undefined;
    eventTypeDesc?: string | undefined;
    catalogType?: number | undefined;
    catalogTypeDesc?: string | undefined;
    relationship?: number | undefined;
    relationshipDesc?: string | undefined;
    eventDate?: moment.Moment | undefined;
    age?: number | undefined;
    isHereditary: boolean;
    observations?: string | undefined;
}

export class PatientMedicalHistoryGetByIdQuery implements IPatientMedicalHistoryGetByIdQuery {
    id?: number | undefined;

    constructor(data?: IPatientMedicalHistoryGetByIdQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PatientMedicalHistoryGetByIdQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicalHistoryGetByIdQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IPatientMedicalHistoryGetByIdQuery {
    id?: number | undefined;
}

export class PatientMedicalHistoryCreateCommand implements IPatientMedicalHistoryCreateCommand {
    patient?: number | undefined;
    event?: number | undefined;
    relationship?: number | undefined;
    eventDate?: moment.Moment | undefined;
    age?: number | undefined;
    isHereditary!: boolean;
    observations?: string | undefined;
    catalogType?: number | undefined;

    constructor(data?: IPatientMedicalHistoryCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patient = _data["patient"];
            this.event = _data["event"];
            this.relationship = _data["relationship"];
            this.eventDate = _data["eventDate"] ? moment(_data["eventDate"].toString()) : <any>undefined;
            this.age = _data["age"];
            this.isHereditary = _data["isHereditary"];
            this.observations = _data["observations"];
            this.catalogType = _data["catalogType"];
        }
    }

    static fromJS(data: any): PatientMedicalHistoryCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicalHistoryCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patient"] = this.patient;
        data["event"] = this.event;
        data["relationship"] = this.relationship;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["age"] = this.age;
        data["isHereditary"] = this.isHereditary;
        data["observations"] = this.observations;
        data["catalogType"] = this.catalogType;
        return data;
    }
}

export interface IPatientMedicalHistoryCreateCommand {
    patient?: number | undefined;
    event?: number | undefined;
    relationship?: number | undefined;
    eventDate?: moment.Moment | undefined;
    age?: number | undefined;
    isHereditary: boolean;
    observations?: string | undefined;
    catalogType?: number | undefined;
}

export class PatientMedicalHistoryDeleteCommand implements IPatientMedicalHistoryDeleteCommand {
    id?: number | undefined;

    constructor(data?: IPatientMedicalHistoryDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PatientMedicalHistoryDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicalHistoryDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IPatientMedicalHistoryDeleteCommand {
    id?: number | undefined;
}

export class PagedResultDtoOfPatientMedicationForListResponse implements IPagedResultDtoOfPatientMedicationForListResponse {
    totalCount!: number;
    items?: PatientMedicationForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfPatientMedicationForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientMedicationForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPatientMedicationForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPatientMedicationForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfPatientMedicationForListResponse {
    totalCount: number;
    items?: PatientMedicationForListResponse[] | undefined;
}

export class PatientMedicationForListResponse implements IPatientMedicationForListResponse {
    id!: number;
    pacienteId!: number;
    medicamentoId!: number;
    codigoMedicamento?: string | undefined;
    medicamentoDesc?: string | undefined;
    periodo?: string | undefined;
    fechaInicio!: moment.Moment;
    fechaFin?: moment.Moment | undefined;
    observaciones?: string | undefined;

    constructor(data?: IPatientMedicationForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pacienteId = _data["pacienteId"];
            this.medicamentoId = _data["medicamentoId"];
            this.codigoMedicamento = _data["codigoMedicamento"];
            this.medicamentoDesc = _data["medicamentoDesc"];
            this.periodo = _data["periodo"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.observaciones = _data["observaciones"];
        }
    }

    static fromJS(data: any): PatientMedicationForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicationForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pacienteId"] = this.pacienteId;
        data["medicamentoId"] = this.medicamentoId;
        data["codigoMedicamento"] = this.codigoMedicamento;
        data["medicamentoDesc"] = this.medicamentoDesc;
        data["periodo"] = this.periodo;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["observaciones"] = this.observaciones;
        return data;
    }
}

export interface IPatientMedicationForListResponse {
    id: number;
    pacienteId: number;
    medicamentoId: number;
    codigoMedicamento?: string | undefined;
    medicamentoDesc?: string | undefined;
    periodo?: string | undefined;
    fechaInicio: moment.Moment;
    fechaFin?: moment.Moment | undefined;
    observaciones?: string | undefined;
}

export class PatientMedicationGetListQuery extends PageListByDto implements IPatientMedicationGetListQuery {
    pacienteId?: number | undefined;

    constructor(data?: IPatientMedicationGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pacienteId = _data["pacienteId"];
        }
    }

    static override fromJS(data: any): PatientMedicationGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicationGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        super.toJSON(data);
        return data;
    }
}

export interface IPatientMedicationGetListQuery extends IPageListByDto {
    pacienteId?: number | undefined;
}

export class PatientMedicationResponse implements IPatientMedicationResponse {
    id!: number;
    pacienteId!: number;
    medicamentoId!: number;
    codigoMedicamento?: string | undefined;
    medicamentoDesc?: string | undefined;
    periodo?: string | undefined;
    fechaInicio!: moment.Moment;
    fechaFin?: moment.Moment | undefined;
    observaciones?: string | undefined;

    constructor(data?: IPatientMedicationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pacienteId = _data["pacienteId"];
            this.medicamentoId = _data["medicamentoId"];
            this.codigoMedicamento = _data["codigoMedicamento"];
            this.medicamentoDesc = _data["medicamentoDesc"];
            this.periodo = _data["periodo"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.observaciones = _data["observaciones"];
        }
    }

    static fromJS(data: any): PatientMedicationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pacienteId"] = this.pacienteId;
        data["medicamentoId"] = this.medicamentoId;
        data["codigoMedicamento"] = this.codigoMedicamento;
        data["medicamentoDesc"] = this.medicamentoDesc;
        data["periodo"] = this.periodo;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["observaciones"] = this.observaciones;
        return data;
    }
}

export interface IPatientMedicationResponse {
    id: number;
    pacienteId: number;
    medicamentoId: number;
    codigoMedicamento?: string | undefined;
    medicamentoDesc?: string | undefined;
    periodo?: string | undefined;
    fechaInicio: moment.Moment;
    fechaFin?: moment.Moment | undefined;
    observaciones?: string | undefined;
}

export class PatientMedicationGetByIdQuery implements IPatientMedicationGetByIdQuery {
    id?: number | undefined;

    constructor(data?: IPatientMedicationGetByIdQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PatientMedicationGetByIdQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicationGetByIdQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IPatientMedicationGetByIdQuery {
    id?: number | undefined;
}

export class PatientMedicationCreateCommand implements IPatientMedicationCreateCommand {
    pacienteId?: number | undefined;
    medicamentoId?: number | undefined;
    periodo?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    observaciones?: string | undefined;

    constructor(data?: IPatientMedicationCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
            this.medicamentoId = _data["medicamentoId"];
            this.periodo = _data["periodo"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.observaciones = _data["observaciones"];
        }
    }

    static fromJS(data: any): PatientMedicationCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicationCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        data["medicamentoId"] = this.medicamentoId;
        data["periodo"] = this.periodo;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["observaciones"] = this.observaciones;
        return data;
    }
}

export interface IPatientMedicationCreateCommand {
    pacienteId?: number | undefined;
    medicamentoId?: number | undefined;
    periodo?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    observaciones?: string | undefined;
}

export class PatientMedicationDeleteCommand implements IPatientMedicationDeleteCommand {
    id?: number | undefined;

    constructor(data?: IPatientMedicationDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PatientMedicationDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicationDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IPatientMedicationDeleteCommand {
    id?: number | undefined;
}

export class PatientIsValidCIRCResponse implements IPatientIsValidCIRCResponse {
    isValid!: boolean;
    message?: string | undefined;

    constructor(data?: IPatientIsValidCIRCResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): PatientIsValidCIRCResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PatientIsValidCIRCResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["message"] = this.message;
        return data;
    }
}

export interface IPatientIsValidCIRCResponse {
    isValid: boolean;
    message?: string | undefined;
}

export class PatientGetIsCIRCValidQuery implements IPatientGetIsCIRCValidQuery {
    pacienteId!: number;

    constructor(data?: IPatientGetIsCIRCValidQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
        }
    }

    static fromJS(data: any): PatientGetIsCIRCValidQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PatientGetIsCIRCValidQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        return data;
    }
}

export interface IPatientGetIsCIRCValidQuery {
    pacienteId: number;
}

export class PagedResultDtoOfAuditLogListResponse implements IPagedResultDtoOfAuditLogListResponse {
    totalCount!: number;
    items?: AuditLogListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfAuditLogListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuditLogListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditLogListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditLogListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfAuditLogListResponse {
    totalCount: number;
    items?: AuditLogListResponse[] | undefined;
}

export class AuditLogListResponse implements IAuditLogListResponse {
    id?: number | undefined;
    tenantName?: string | undefined;
    userId?: number | undefined;
    userName?: string | undefined;
    impersonalizerUserId?: number | undefined;
    impersonalizerUserName?: string | undefined;
    serviceName?: string | undefined;
    methodName?: string | undefined;
    parameters?: string | undefined;
    executionTime?: moment.Moment | undefined;
    executionDuration?: number | undefined;
    clientIpAddress?: string | undefined;
    clientName?: string | undefined;
    browserInfo?: string | undefined;
    exception?: string | undefined;
    customData?: string | undefined;
    severity?: number | undefined;

    constructor(data?: IAuditLogListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantName = _data["tenantName"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.impersonalizerUserId = _data["impersonalizerUserId"];
            this.impersonalizerUserName = _data["impersonalizerUserName"];
            this.serviceName = _data["serviceName"];
            this.methodName = _data["methodName"];
            this.parameters = _data["parameters"];
            this.executionTime = _data["executionTime"] ? moment(_data["executionTime"].toString()) : <any>undefined;
            this.executionDuration = _data["executionDuration"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.exception = _data["exception"];
            this.customData = _data["customData"];
            this.severity = _data["severity"];
        }
    }

    static fromJS(data: any): AuditLogListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantName"] = this.tenantName;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonalizerUserId"] = this.impersonalizerUserId;
        data["impersonalizerUserName"] = this.impersonalizerUserName;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        data["severity"] = this.severity;
        return data;
    }
}

export interface IAuditLogListResponse {
    id?: number | undefined;
    tenantName?: string | undefined;
    userId?: number | undefined;
    userName?: string | undefined;
    impersonalizerUserId?: number | undefined;
    impersonalizerUserName?: string | undefined;
    serviceName?: string | undefined;
    methodName?: string | undefined;
    parameters?: string | undefined;
    executionTime?: moment.Moment | undefined;
    executionDuration?: number | undefined;
    clientIpAddress?: string | undefined;
    clientName?: string | undefined;
    browserInfo?: string | undefined;
    exception?: string | undefined;
    customData?: string | undefined;
    severity?: number | undefined;
}

export class AuditLogGetListQuery extends PageListByDto implements IAuditLogGetListQuery {
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    userName?: string | undefined;
    serviceName?: string | undefined;
    methodName?: string | undefined;
    browserInfo?: string | undefined;
    tenantId?: number | undefined;
    hasException?: boolean | undefined;
    minExecutionDuration?: number | undefined;
    maxExecutionDuration?: number | undefined;
    severity?: number | undefined;
    onlyHost?: boolean | undefined;

    constructor(data?: IAuditLogGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.userName = _data["userName"];
            this.serviceName = _data["serviceName"];
            this.methodName = _data["methodName"];
            this.browserInfo = _data["browserInfo"];
            this.tenantId = _data["tenantId"];
            this.hasException = _data["hasException"];
            this.minExecutionDuration = _data["minExecutionDuration"];
            this.maxExecutionDuration = _data["maxExecutionDuration"];
            this.severity = _data["severity"];
            this.onlyHost = _data["onlyHost"];
        }
    }

    static override fromJS(data: any): AuditLogGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["userName"] = this.userName;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["browserInfo"] = this.browserInfo;
        data["tenantId"] = this.tenantId;
        data["hasException"] = this.hasException;
        data["minExecutionDuration"] = this.minExecutionDuration;
        data["maxExecutionDuration"] = this.maxExecutionDuration;
        data["severity"] = this.severity;
        data["onlyHost"] = this.onlyHost;
        super.toJSON(data);
        return data;
    }
}

export interface IAuditLogGetListQuery extends IPageListByDto {
    startDate: moment.Moment;
    endDate: moment.Moment;
    userName?: string | undefined;
    serviceName?: string | undefined;
    methodName?: string | undefined;
    browserInfo?: string | undefined;
    tenantId?: number | undefined;
    hasException?: boolean | undefined;
    minExecutionDuration?: number | undefined;
    maxExecutionDuration?: number | undefined;
    severity?: number | undefined;
    onlyHost?: boolean | undefined;
}

export class AuditLogExcelResponse implements IAuditLogExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;

    constructor(data?: IAuditLogExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): AuditLogExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IAuditLogExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
}

export class AuditLogGetExcelQuery extends PageListByDto implements IAuditLogGetExcelQuery {
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    userName?: string | undefined;
    serviceName?: string | undefined;
    methodName?: string | undefined;
    browserInfo?: string | undefined;
    tenantId?: number | undefined;
    hasException?: boolean | undefined;
    minExecutionDuration?: number | undefined;
    maxExecutionDuration?: number | undefined;
    severity?: number | undefined;
    onlyHost?: boolean | undefined;

    constructor(data?: IAuditLogGetExcelQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.userName = _data["userName"];
            this.serviceName = _data["serviceName"];
            this.methodName = _data["methodName"];
            this.browserInfo = _data["browserInfo"];
            this.tenantId = _data["tenantId"];
            this.hasException = _data["hasException"];
            this.minExecutionDuration = _data["minExecutionDuration"];
            this.maxExecutionDuration = _data["maxExecutionDuration"];
            this.severity = _data["severity"];
            this.onlyHost = _data["onlyHost"];
        }
    }

    static override fromJS(data: any): AuditLogGetExcelQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogGetExcelQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["userName"] = this.userName;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["browserInfo"] = this.browserInfo;
        data["tenantId"] = this.tenantId;
        data["hasException"] = this.hasException;
        data["minExecutionDuration"] = this.minExecutionDuration;
        data["maxExecutionDuration"] = this.maxExecutionDuration;
        data["severity"] = this.severity;
        data["onlyHost"] = this.onlyHost;
        super.toJSON(data);
        return data;
    }
}

export interface IAuditLogGetExcelQuery extends IPageListByDto {
    startDate: moment.Moment;
    endDate: moment.Moment;
    userName?: string | undefined;
    serviceName?: string | undefined;
    methodName?: string | undefined;
    browserInfo?: string | undefined;
    tenantId?: number | undefined;
    hasException?: boolean | undefined;
    minExecutionDuration?: number | undefined;
    maxExecutionDuration?: number | undefined;
    severity?: number | undefined;
    onlyHost?: boolean | undefined;
}

export class FileDto implements IFileDto {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
    fileArray?: string | undefined;
    fileBase64?: string | undefined;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
            this.fileArray = _data["fileArray"];
            this.fileBase64 = _data["fileBase64"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        data["fileArray"] = this.fileArray;
        data["fileBase64"] = this.fileBase64;
        return data;
    }
}

export interface IFileDto {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
    fileArray?: string | undefined;
    fileBase64?: string | undefined;
}

export class AuditLogExportQuery extends PageListByDto implements IAuditLogExportQuery {
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    userName?: string | undefined;
    serviceName?: string | undefined;
    methodName?: string | undefined;
    browserInfo?: string | undefined;
    tenantId?: number | undefined;
    hasException?: boolean | undefined;
    minExecutionDuration?: number | undefined;
    maxExecutionDuration?: number | undefined;
    severity?: number | undefined;
    onlyHost?: boolean | undefined;
    viewColumnsConfigJSON?: string | undefined;

    constructor(data?: IAuditLogExportQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.userName = _data["userName"];
            this.serviceName = _data["serviceName"];
            this.methodName = _data["methodName"];
            this.browserInfo = _data["browserInfo"];
            this.tenantId = _data["tenantId"];
            this.hasException = _data["hasException"];
            this.minExecutionDuration = _data["minExecutionDuration"];
            this.maxExecutionDuration = _data["maxExecutionDuration"];
            this.severity = _data["severity"];
            this.onlyHost = _data["onlyHost"];
            this.viewColumnsConfigJSON = _data["viewColumnsConfigJSON"];
        }
    }

    static override fromJS(data: any): AuditLogExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogExportQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["userName"] = this.userName;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["browserInfo"] = this.browserInfo;
        data["tenantId"] = this.tenantId;
        data["hasException"] = this.hasException;
        data["minExecutionDuration"] = this.minExecutionDuration;
        data["maxExecutionDuration"] = this.maxExecutionDuration;
        data["severity"] = this.severity;
        data["onlyHost"] = this.onlyHost;
        data["viewColumnsConfigJSON"] = this.viewColumnsConfigJSON;
        super.toJSON(data);
        return data;
    }
}

export interface IAuditLogExportQuery extends IPageListByDto {
    startDate: moment.Moment;
    endDate: moment.Moment;
    userName?: string | undefined;
    serviceName?: string | undefined;
    methodName?: string | undefined;
    browserInfo?: string | undefined;
    tenantId?: number | undefined;
    hasException?: boolean | undefined;
    minExecutionDuration?: number | undefined;
    maxExecutionDuration?: number | undefined;
    severity?: number | undefined;
    onlyHost?: boolean | undefined;
    viewColumnsConfigJSON?: string | undefined;
}

export class AuditLogExportCSVQuery extends PageListByDto implements IAuditLogExportCSVQuery {
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    userName?: string | undefined;
    serviceName?: string | undefined;
    methodName?: string | undefined;
    browserInfo?: string | undefined;
    tenantId?: number | undefined;
    hasException?: boolean | undefined;
    minExecutionDuration?: number | undefined;
    maxExecutionDuration?: number | undefined;
    severity?: number | undefined;
    onlyHost?: boolean | undefined;
    viewColumnsConfigJSON?: string | undefined;

    constructor(data?: IAuditLogExportCSVQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.userName = _data["userName"];
            this.serviceName = _data["serviceName"];
            this.methodName = _data["methodName"];
            this.browserInfo = _data["browserInfo"];
            this.tenantId = _data["tenantId"];
            this.hasException = _data["hasException"];
            this.minExecutionDuration = _data["minExecutionDuration"];
            this.maxExecutionDuration = _data["maxExecutionDuration"];
            this.severity = _data["severity"];
            this.onlyHost = _data["onlyHost"];
            this.viewColumnsConfigJSON = _data["viewColumnsConfigJSON"];
        }
    }

    static override fromJS(data: any): AuditLogExportCSVQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogExportCSVQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["userName"] = this.userName;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["browserInfo"] = this.browserInfo;
        data["tenantId"] = this.tenantId;
        data["hasException"] = this.hasException;
        data["minExecutionDuration"] = this.minExecutionDuration;
        data["maxExecutionDuration"] = this.maxExecutionDuration;
        data["severity"] = this.severity;
        data["onlyHost"] = this.onlyHost;
        data["viewColumnsConfigJSON"] = this.viewColumnsConfigJSON;
        super.toJSON(data);
        return data;
    }
}

export interface IAuditLogExportCSVQuery extends IPageListByDto {
    startDate: moment.Moment;
    endDate: moment.Moment;
    userName?: string | undefined;
    serviceName?: string | undefined;
    methodName?: string | undefined;
    browserInfo?: string | undefined;
    tenantId?: number | undefined;
    hasException?: boolean | undefined;
    minExecutionDuration?: number | undefined;
    maxExecutionDuration?: number | undefined;
    severity?: number | undefined;
    onlyHost?: boolean | undefined;
    viewColumnsConfigJSON?: string | undefined;
}

export class AuditLogExportPDFQuery extends PageListByDto implements IAuditLogExportPDFQuery {
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    userName?: string | undefined;
    serviceName?: string | undefined;
    methodName?: string | undefined;
    browserInfo?: string | undefined;
    tenantId?: number | undefined;
    hasException?: boolean | undefined;
    minExecutionDuration?: number | undefined;
    maxExecutionDuration?: number | undefined;
    severity?: number | undefined;
    onlyHost?: boolean | undefined;
    viewColumnsConfigJSON?: string | undefined;

    constructor(data?: IAuditLogExportPDFQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.userName = _data["userName"];
            this.serviceName = _data["serviceName"];
            this.methodName = _data["methodName"];
            this.browserInfo = _data["browserInfo"];
            this.tenantId = _data["tenantId"];
            this.hasException = _data["hasException"];
            this.minExecutionDuration = _data["minExecutionDuration"];
            this.maxExecutionDuration = _data["maxExecutionDuration"];
            this.severity = _data["severity"];
            this.onlyHost = _data["onlyHost"];
            this.viewColumnsConfigJSON = _data["viewColumnsConfigJSON"];
        }
    }

    static override fromJS(data: any): AuditLogExportPDFQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogExportPDFQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["userName"] = this.userName;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["browserInfo"] = this.browserInfo;
        data["tenantId"] = this.tenantId;
        data["hasException"] = this.hasException;
        data["minExecutionDuration"] = this.minExecutionDuration;
        data["maxExecutionDuration"] = this.maxExecutionDuration;
        data["severity"] = this.severity;
        data["onlyHost"] = this.onlyHost;
        data["viewColumnsConfigJSON"] = this.viewColumnsConfigJSON;
        super.toJSON(data);
        return data;
    }
}

export interface IAuditLogExportPDFQuery extends IPageListByDto {
    startDate: moment.Moment;
    endDate: moment.Moment;
    userName?: string | undefined;
    serviceName?: string | undefined;
    methodName?: string | undefined;
    browserInfo?: string | undefined;
    tenantId?: number | undefined;
    hasException?: boolean | undefined;
    minExecutionDuration?: number | undefined;
    maxExecutionDuration?: number | undefined;
    severity?: number | undefined;
    onlyHost?: boolean | undefined;
    viewColumnsConfigJSON?: string | undefined;
}

export class SessionLoginResponse implements ISessionLoginResponse {
    tenantId?: number | undefined;
    tenancyName?: string | undefined;
    userId!: number;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    eMail?: string | undefined;
    isImpersonalized!: boolean;
    impersonalizerUserId?: number | undefined;
    sessionToken?: string | undefined;

    constructor(data?: ISessionLoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenancyName = _data["tenancyName"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.secondLastName = _data["secondLastName"];
            this.eMail = _data["eMail"];
            this.isImpersonalized = _data["isImpersonalized"];
            this.impersonalizerUserId = _data["impersonalizerUserId"];
            this.sessionToken = _data["sessionToken"];
        }
    }

    static fromJS(data: any): SessionLoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SessionLoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["secondLastName"] = this.secondLastName;
        data["eMail"] = this.eMail;
        data["isImpersonalized"] = this.isImpersonalized;
        data["impersonalizerUserId"] = this.impersonalizerUserId;
        data["sessionToken"] = this.sessionToken;
        return data;
    }
}

export interface ISessionLoginResponse {
    tenantId?: number | undefined;
    tenancyName?: string | undefined;
    userId: number;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    eMail?: string | undefined;
    isImpersonalized: boolean;
    impersonalizerUserId?: number | undefined;
    sessionToken?: string | undefined;
}

export class SessionLoginResponseController extends SessionLoginResponse implements ISessionLoginResponseController {
    token?: string | undefined;

    constructor(data?: ISessionLoginResponseController) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.token = _data["token"];
        }
    }

    static override fromJS(data: any): SessionLoginResponseController {
        data = typeof data === 'object' ? data : {};
        let result = new SessionLoginResponseController();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        super.toJSON(data);
        return data;
    }
}

export interface ISessionLoginResponseController extends ISessionLoginResponse {
    token?: string | undefined;
}

export class UserLoginQuery implements IUserLoginQuery {
    userName?: string | undefined;
    password?: string | undefined;
    tenancyName?: string | undefined;

    constructor(data?: IUserLoginQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): UserLoginQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IUserLoginQuery {
    userName?: string | undefined;
    password?: string | undefined;
    tenancyName?: string | undefined;
}

export class UserLoginMicrosoftQuery implements IUserLoginMicrosoftQuery {
    token?: string | undefined;
    userName?: string | undefined;
    tenancyName?: string | undefined;

    constructor(data?: IUserLoginMicrosoftQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.userName = _data["userName"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): UserLoginMicrosoftQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginMicrosoftQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["userName"] = this.userName;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IUserLoginMicrosoftQuery {
    token?: string | undefined;
    userName?: string | undefined;
    tenancyName?: string | undefined;
}

export class UserImpersonalizeQuery implements IUserImpersonalizeQuery {
    tenant?: number | undefined;
    user!: number;

    constructor(data?: IUserImpersonalizeQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenant = _data["tenant"];
            this.user = _data["user"];
        }
    }

    static fromJS(data: any): UserImpersonalizeQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserImpersonalizeQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenant"] = this.tenant;
        data["user"] = this.user;
        return data;
    }
}

export interface IUserImpersonalizeQuery {
    tenant?: number | undefined;
    user: number;
}

export class UserChangePasswordCommand implements IUserChangePasswordCommand {
    tenancyName?: string | undefined;
    userName?: string | undefined;
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
    confirmPassword?: string | undefined;

    constructor(data?: IUserChangePasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userName = _data["userName"];
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): UserChangePasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserChangePasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IUserChangePasswordCommand {
    tenancyName?: string | undefined;
    userName?: string | undefined;
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
    confirmPassword?: string | undefined;
}

export class UserResetPasswordCommand implements IUserResetPasswordCommand {
    userName?: string | undefined;
    tenancyName?: string | undefined;

    constructor(data?: IUserResetPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): UserResetPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserResetPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IUserResetPasswordCommand {
    userName?: string | undefined;
    tenancyName?: string | undefined;
}

export class ConfirmPasswordCommandReset implements IConfirmPasswordCommandReset {
    confirmationCode?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;

    constructor(data?: IConfirmPasswordCommandReset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.confirmationCode = _data["confirmationCode"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): ConfirmPasswordCommandReset {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmPasswordCommandReset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confirmationCode"] = this.confirmationCode;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IConfirmPasswordCommandReset {
    confirmationCode?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
}

export class PagedResultDtoOfChangeLogForListResponse implements IPagedResultDtoOfChangeLogForListResponse {
    totalCount!: number;
    items?: ChangeLogForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfChangeLogForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChangeLogForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfChangeLogForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfChangeLogForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfChangeLogForListResponse {
    totalCount: number;
    items?: ChangeLogForListResponse[] | undefined;
}

export class ChangeLogForListResponse implements IChangeLogForListResponse {
    id?: number | undefined;
    user?: number | undefined;
    userDesc?: string | undefined;
    datetime?: moment.Moment | undefined;
    detail?: string | undefined;

    constructor(data?: IChangeLogForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"];
            this.userDesc = _data["userDesc"];
            this.datetime = _data["datetime"] ? moment(_data["datetime"].toString()) : <any>undefined;
            this.detail = _data["detail"];
        }
    }

    static fromJS(data: any): ChangeLogForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeLogForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user;
        data["userDesc"] = this.userDesc;
        data["datetime"] = this.datetime ? this.datetime.toISOString() : <any>undefined;
        data["detail"] = this.detail;
        return data;
    }
}

export interface IChangeLogForListResponse {
    id?: number | undefined;
    user?: number | undefined;
    userDesc?: string | undefined;
    datetime?: moment.Moment | undefined;
    detail?: string | undefined;
}

export class ChangeLogGetListQuery extends PageListByDto implements IChangeLogGetListQuery {
    table?: string | undefined;
    key?: string | undefined;

    constructor(data?: IChangeLogGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.table = _data["table"];
            this.key = _data["key"];
        }
    }

    static override fromJS(data: any): ChangeLogGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeLogGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["table"] = this.table;
        data["key"] = this.key;
        super.toJSON(data);
        return data;
    }
}

export interface IChangeLogGetListQuery extends IPageListByDto {
    table?: string | undefined;
    key?: string | undefined;
}

export class PagedResultDtoOfChatMessageListResponse implements IPagedResultDtoOfChatMessageListResponse {
    totalCount!: number;
    items?: ChatMessageListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfChatMessageListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChatMessageListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfChatMessageListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfChatMessageListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfChatMessageListResponse {
    totalCount: number;
    items?: ChatMessageListResponse[] | undefined;
}

export class ChatMessageListResponse implements IChatMessageListResponse {
    id!: number;
    targetUserId!: number;
    targetTenantId?: number | undefined;
    message?: string | undefined;
    creationTime!: moment.Moment;
    side!: ChatSide;
    readState!: ChatMessageReadState;

    constructor(data?: IChatMessageListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.targetUserId = _data["targetUserId"];
            this.targetTenantId = _data["targetTenantId"];
            this.message = _data["message"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.side = _data["side"];
            this.readState = _data["readState"];
        }
    }

    static fromJS(data: any): ChatMessageListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["targetUserId"] = this.targetUserId;
        data["targetTenantId"] = this.targetTenantId;
        data["message"] = this.message;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["side"] = this.side;
        data["readState"] = this.readState;
        return data;
    }
}

export interface IChatMessageListResponse {
    id: number;
    targetUserId: number;
    targetTenantId?: number | undefined;
    message?: string | undefined;
    creationTime: moment.Moment;
    side: ChatSide;
    readState: ChatMessageReadState;
}

export enum ChatSide {
    Sender = 1,
    Receiver = 2,
}

export enum ChatMessageReadState {
    Unread = 1,
    Read = 2,
}

export class ChatMessageGetListQuery implements IChatMessageGetListQuery {
    tenantId?: number | undefined;
    userId!: number;
    minMessageId?: number | undefined;

    constructor(data?: IChatMessageGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.minMessageId = _data["minMessageId"];
        }
    }

    static fromJS(data: any): ChatMessageGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["minMessageId"] = this.minMessageId;
        return data;
    }
}

export interface IChatMessageGetListQuery {
    tenantId?: number | undefined;
    userId: number;
    minMessageId?: number | undefined;
}

export class ChatMessageMarkReadCommand implements IChatMessageMarkReadCommand {
    friendTenantId?: number | undefined;
    friendUserId!: number;

    constructor(data?: IChatMessageMarkReadCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.friendTenantId = _data["friendTenantId"];
            this.friendUserId = _data["friendUserId"];
        }
    }

    static fromJS(data: any): ChatMessageMarkReadCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageMarkReadCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendTenantId"] = this.friendTenantId;
        data["friendUserId"] = this.friendUserId;
        return data;
    }
}

export interface IChatMessageMarkReadCommand {
    friendTenantId?: number | undefined;
    friendUserId: number;
}

export class PagedResultDtoOfChatRoomForListResponse implements IPagedResultDtoOfChatRoomForListResponse {
    totalCount!: number;
    items?: ChatRoomForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfChatRoomForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChatRoomForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfChatRoomForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfChatRoomForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfChatRoomForListResponse {
    totalCount: number;
    items?: ChatRoomForListResponse[] | undefined;
}

export class ChatRoomForListResponse implements IChatRoomForListResponse {
    id!: number;
    chatRoomId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    userCreatorDesc?: string | undefined;
    creationTime?: moment.Moment | undefined;

    constructor(data?: IChatRoomForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.chatRoomId = _data["chatRoomId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.userCreatorDesc = _data["userCreatorDesc"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatRoomForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChatRoomForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["chatRoomId"] = this.chatRoomId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["userCreatorDesc"] = this.userCreatorDesc;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IChatRoomForListResponse {
    id: number;
    chatRoomId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    userCreatorDesc?: string | undefined;
    creationTime?: moment.Moment | undefined;
}

export class ChatRoomGetListQuery extends PageListByDto implements IChatRoomGetListQuery {

    constructor(data?: IChatRoomGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ChatRoomGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ChatRoomGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IChatRoomGetListQuery extends IPageListByDto {
}

export class ChatRoomResponse implements IChatRoomResponse {
    id!: number;
    userCreator?: number | undefined;
    userCreatorDesc?: string | undefined;
    chatRoomId?: string | undefined;
    name?: string | undefined;
    creationTime?: moment.Moment | undefined;
    description?: string | undefined;

    constructor(data?: IChatRoomResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userCreator = _data["userCreator"];
            this.userCreatorDesc = _data["userCreatorDesc"];
            this.chatRoomId = _data["chatRoomId"];
            this.name = _data["name"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ChatRoomResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChatRoomResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userCreator"] = this.userCreator;
        data["userCreatorDesc"] = this.userCreatorDesc;
        data["chatRoomId"] = this.chatRoomId;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        return data;
    }
}

export interface IChatRoomResponse {
    id: number;
    userCreator?: number | undefined;
    userCreatorDesc?: string | undefined;
    chatRoomId?: string | undefined;
    name?: string | undefined;
    creationTime?: moment.Moment | undefined;
    description?: string | undefined;
}

export class ChatRoomForEditResponse implements IChatRoomForEditResponse {
    id?: number | undefined;
    chatRoomId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    userCreator?: number | undefined;
    userCreatorDesc?: string | undefined;
    creationTime?: moment.Moment | undefined;

    constructor(data?: IChatRoomForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.chatRoomId = _data["chatRoomId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.userCreator = _data["userCreator"];
            this.userCreatorDesc = _data["userCreatorDesc"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatRoomForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChatRoomForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["chatRoomId"] = this.chatRoomId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["userCreator"] = this.userCreator;
        data["userCreatorDesc"] = this.userCreatorDesc;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IChatRoomForEditResponse {
    id?: number | undefined;
    chatRoomId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    userCreator?: number | undefined;
    userCreatorDesc?: string | undefined;
    creationTime?: moment.Moment | undefined;
}

export class ChatRoomGetForEditQuery implements IChatRoomGetForEditQuery {
    id?: number | undefined;

    constructor(data?: IChatRoomGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ChatRoomGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ChatRoomGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IChatRoomGetForEditQuery {
    id?: number | undefined;
}

export class ChatRoomGetOrCreateCommand implements IChatRoomGetOrCreateCommand {
    chatRoomId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IChatRoomGetOrCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chatRoomId = _data["chatRoomId"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ChatRoomGetOrCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChatRoomGetOrCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatRoomId"] = this.chatRoomId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IChatRoomGetOrCreateCommand {
    chatRoomId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export class ChatRoomCreateCommand implements IChatRoomCreateCommand {
    chatRoomId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IChatRoomCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chatRoomId = _data["chatRoomId"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ChatRoomCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChatRoomCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatRoomId"] = this.chatRoomId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IChatRoomCreateCommand {
    chatRoomId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export class ChatRoomUpdateCommand implements IChatRoomUpdateCommand {
    id!: number;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IChatRoomUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ChatRoomUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChatRoomUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IChatRoomUpdateCommand {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
}

export class PagedResultDtoOfChatRoomChatForListResponse implements IPagedResultDtoOfChatRoomChatForListResponse {
    totalCount!: number;
    items?: ChatRoomChatForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfChatRoomChatForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChatRoomChatForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfChatRoomChatForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfChatRoomChatForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfChatRoomChatForListResponse {
    totalCount: number;
    items?: ChatRoomChatForListResponse[] | undefined;
}

export class ChatRoomChatForListResponse implements IChatRoomChatForListResponse {
    id!: number;
    chatRoom!: number;
    user?: number | undefined;
    userDesc?: string | undefined;
    creationTime?: moment.Moment | undefined;
    comment?: string | undefined;
    files?: ChatRoomChatFileResponse[] | undefined;
    userLogin?: string | undefined;

    constructor(data?: IChatRoomChatForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.chatRoom = _data["chatRoom"];
            this.user = _data["user"];
            this.userDesc = _data["userDesc"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(ChatRoomChatFileResponse.fromJS(item));
            }
            this.userLogin = _data["userLogin"];
        }
    }

    static fromJS(data: any): ChatRoomChatForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChatRoomChatForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["chatRoom"] = this.chatRoom;
        data["user"] = this.user;
        data["userDesc"] = this.userDesc;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["userLogin"] = this.userLogin;
        return data;
    }
}

export interface IChatRoomChatForListResponse {
    id: number;
    chatRoom: number;
    user?: number | undefined;
    userDesc?: string | undefined;
    creationTime?: moment.Moment | undefined;
    comment?: string | undefined;
    files?: ChatRoomChatFileResponse[] | undefined;
    userLogin?: string | undefined;
}

export class ChatRoomChatFileResponse implements IChatRoomChatFileResponse {
    fileName?: string | undefined;
    fileExtension?: string | undefined;
    file?: string | undefined;

    constructor(data?: IChatRoomChatFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileExtension = _data["fileExtension"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): ChatRoomChatFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChatRoomChatFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileExtension"] = this.fileExtension;
        data["file"] = this.file;
        return data;
    }
}

export interface IChatRoomChatFileResponse {
    fileName?: string | undefined;
    fileExtension?: string | undefined;
    file?: string | undefined;
}

export class ChatRoomChatGetListQuery extends PageListByDto implements IChatRoomChatGetListQuery {
    chatRoom?: number | undefined;
    chatRoomId?: string | undefined;
    skip!: number;
    onlyFiles!: boolean;

    constructor(data?: IChatRoomChatGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.chatRoom = _data["chatRoom"];
            this.chatRoomId = _data["chatRoomId"];
            this.skip = _data["skip"];
            this.onlyFiles = _data["onlyFiles"];
        }
    }

    static override fromJS(data: any): ChatRoomChatGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ChatRoomChatGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatRoom"] = this.chatRoom;
        data["chatRoomId"] = this.chatRoomId;
        data["skip"] = this.skip;
        data["onlyFiles"] = this.onlyFiles;
        super.toJSON(data);
        return data;
    }
}

export interface IChatRoomChatGetListQuery extends IPageListByDto {
    chatRoom?: number | undefined;
    chatRoomId?: string | undefined;
    skip: number;
    onlyFiles: boolean;
}

export class ChatRoomChatGetForLogListQuery implements IChatRoomChatGetForLogListQuery {
    chatRoomId?: string | undefined;
    lastId?: number | undefined;

    constructor(data?: IChatRoomChatGetForLogListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chatRoomId = _data["chatRoomId"];
            this.lastId = _data["lastId"];
        }
    }

    static fromJS(data: any): ChatRoomChatGetForLogListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ChatRoomChatGetForLogListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatRoomId"] = this.chatRoomId;
        data["lastId"] = this.lastId;
        return data;
    }
}

export interface IChatRoomChatGetForLogListQuery {
    chatRoomId?: string | undefined;
    lastId?: number | undefined;
}

export class ChatRoomChatResponse implements IChatRoomChatResponse {
    id!: number;
    chatRoom!: number;
    user?: number | undefined;
    userDesc?: string | undefined;
    creationTime?: moment.Moment | undefined;
    comment?: string | undefined;
    files?: ChatRoomChatFileResponse[] | undefined;
    userLogin?: string | undefined;

    constructor(data?: IChatRoomChatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.chatRoom = _data["chatRoom"];
            this.user = _data["user"];
            this.userDesc = _data["userDesc"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(ChatRoomChatFileResponse.fromJS(item));
            }
            this.userLogin = _data["userLogin"];
        }
    }

    static fromJS(data: any): ChatRoomChatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChatRoomChatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["chatRoom"] = this.chatRoom;
        data["user"] = this.user;
        data["userDesc"] = this.userDesc;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["userLogin"] = this.userLogin;
        return data;
    }
}

export interface IChatRoomChatResponse {
    id: number;
    chatRoom: number;
    user?: number | undefined;
    userDesc?: string | undefined;
    creationTime?: moment.Moment | undefined;
    comment?: string | undefined;
    files?: ChatRoomChatFileResponse[] | undefined;
    userLogin?: string | undefined;
}

export class ChatRoomChatCreateCommand implements IChatRoomChatCreateCommand {
    chatRoom!: number;
    comment?: string | undefined;
    taggedUsers?: number[] | undefined;
    files?: ChatRoomChatFileCreateCommand[] | undefined;

    constructor(data?: IChatRoomChatCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chatRoom = _data["chatRoom"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["taggedUsers"])) {
                this.taggedUsers = [] as any;
                for (let item of _data["taggedUsers"])
                    this.taggedUsers!.push(item);
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(ChatRoomChatFileCreateCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChatRoomChatCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChatRoomChatCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatRoom"] = this.chatRoom;
        data["comment"] = this.comment;
        if (Array.isArray(this.taggedUsers)) {
            data["taggedUsers"] = [];
            for (let item of this.taggedUsers)
                data["taggedUsers"].push(item);
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChatRoomChatCreateCommand {
    chatRoom: number;
    comment?: string | undefined;
    taggedUsers?: number[] | undefined;
    files?: ChatRoomChatFileCreateCommand[] | undefined;
}

export class ChatRoomChatFileCreateCommand implements IChatRoomChatFileCreateCommand {
    fileName?: string | undefined;
    fileExtension?: string | undefined;
    base64?: string | undefined;

    constructor(data?: IChatRoomChatFileCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileExtension = _data["fileExtension"];
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): ChatRoomChatFileCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChatRoomChatFileCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileExtension"] = this.fileExtension;
        data["base64"] = this.base64;
        return data;
    }
}

export interface IChatRoomChatFileCreateCommand {
    fileName?: string | undefined;
    fileExtension?: string | undefined;
    base64?: string | undefined;
}

export class FileUploadResponse implements IFileUploadResponse {
    fileName?: string | undefined;
    fileSize!: number;
    tempFileName?: string | undefined;

    constructor(data?: IFileUploadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.tempFileName = _data["tempFileName"];
        }
    }

    static fromJS(data: any): FileUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["tempFileName"] = this.tempFileName;
        return data;
    }
}

export interface IFileUploadResponse {
    fileName?: string | undefined;
    fileSize: number;
    tempFileName?: string | undefined;
}

export class PagedResultDtoOfFriendshipListResponse implements IPagedResultDtoOfFriendshipListResponse {
    totalCount!: number;
    items?: FriendshipListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfFriendshipListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FriendshipListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFriendshipListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFriendshipListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfFriendshipListResponse {
    totalCount: number;
    items?: FriendshipListResponse[] | undefined;
}

export class FriendshipListResponse implements IFriendshipListResponse {
    id!: number;
    friendUserId!: number;
    friendTenantId?: number | undefined;
    friendUserName?: string | undefined;
    friendTenancyName?: string | undefined;
    friendProfilePictureUrl?: string | undefined;
    unreadMessageCount!: number;
    isOnline!: boolean;
    state!: FriendshipState;

    constructor(data?: IFriendshipListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.friendUserId = _data["friendUserId"];
            this.friendTenantId = _data["friendTenantId"];
            this.friendUserName = _data["friendUserName"];
            this.friendTenancyName = _data["friendTenancyName"];
            this.friendProfilePictureUrl = _data["friendProfilePictureUrl"];
            this.unreadMessageCount = _data["unreadMessageCount"];
            this.isOnline = _data["isOnline"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): FriendshipListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FriendshipListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["friendUserId"] = this.friendUserId;
        data["friendTenantId"] = this.friendTenantId;
        data["friendUserName"] = this.friendUserName;
        data["friendTenancyName"] = this.friendTenancyName;
        data["friendProfilePictureUrl"] = this.friendProfilePictureUrl;
        data["unreadMessageCount"] = this.unreadMessageCount;
        data["isOnline"] = this.isOnline;
        data["state"] = this.state;
        return data;
    }
}

export interface IFriendshipListResponse {
    id: number;
    friendUserId: number;
    friendTenantId?: number | undefined;
    friendUserName?: string | undefined;
    friendTenancyName?: string | undefined;
    friendProfilePictureUrl?: string | undefined;
    unreadMessageCount: number;
    isOnline: boolean;
    state: FriendshipState;
}

export enum FriendshipState {
    Pending = 1,
    Accepted = 2,
    Reject = 3,
    Blocked = 9,
}

export class FriendshipGetListQuery implements IFriendshipGetListQuery {

    constructor(data?: IFriendshipGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FriendshipGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FriendshipGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IFriendshipGetListQuery {
}

export class FriendshipCreateCommand implements IFriendshipCreateCommand {
    friendTenantId?: number | undefined;
    friendUserId!: number;

    constructor(data?: IFriendshipCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.friendTenantId = _data["friendTenantId"];
            this.friendUserId = _data["friendUserId"];
        }
    }

    static fromJS(data: any): FriendshipCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FriendshipCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendTenantId"] = this.friendTenantId;
        data["friendUserId"] = this.friendUserId;
        return data;
    }
}

export interface IFriendshipCreateCommand {
    friendTenantId?: number | undefined;
    friendUserId: number;
}

export class FriendshipBlockCommand implements IFriendshipBlockCommand {
    friendTenantId?: number | undefined;
    friendUserId!: number;

    constructor(data?: IFriendshipBlockCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.friendTenantId = _data["friendTenantId"];
            this.friendUserId = _data["friendUserId"];
        }
    }

    static fromJS(data: any): FriendshipBlockCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FriendshipBlockCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendTenantId"] = this.friendTenantId;
        data["friendUserId"] = this.friendUserId;
        return data;
    }
}

export interface IFriendshipBlockCommand {
    friendTenantId?: number | undefined;
    friendUserId: number;
}

export class FriendshipUnblockCommand implements IFriendshipUnblockCommand {
    friendTenantId?: number | undefined;
    friendUserId!: number;

    constructor(data?: IFriendshipUnblockCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.friendTenantId = _data["friendTenantId"];
            this.friendUserId = _data["friendUserId"];
        }
    }

    static fromJS(data: any): FriendshipUnblockCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FriendshipUnblockCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendTenantId"] = this.friendTenantId;
        data["friendUserId"] = this.friendUserId;
        return data;
    }
}

export interface IFriendshipUnblockCommand {
    friendTenantId?: number | undefined;
    friendUserId: number;
}

export class PagedResultDtoOfHelpForListResponse implements IPagedResultDtoOfHelpForListResponse {
    totalCount!: number;
    items?: HelpForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfHelpForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HelpForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfHelpForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfHelpForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfHelpForListResponse {
    totalCount: number;
    items?: HelpForListResponse[] | undefined;
}

export class HelpForListResponse implements IHelpForListResponse {
    id!: number;
    languageDesc?: string | undefined;
    key?: string | undefined;
    displayName?: string | undefined;
    isActive!: boolean;
    isActiveDesc?: string | undefined;

    constructor(data?: IHelpForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.languageDesc = _data["languageDesc"];
            this.key = _data["key"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
        }
    }

    static fromJS(data: any): HelpForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HelpForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["languageDesc"] = this.languageDesc;
        data["key"] = this.key;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        return data;
    }
}

export interface IHelpForListResponse {
    id: number;
    languageDesc?: string | undefined;
    key?: string | undefined;
    displayName?: string | undefined;
    isActive: boolean;
    isActiveDesc?: string | undefined;
}

export class HelpGetListQuery extends PageListByDto implements IHelpGetListQuery {

    constructor(data?: IHelpGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): HelpGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new HelpGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IHelpGetListQuery extends IPageListByDto {
}

export class HelpExportQuery extends PageListByDto implements IHelpExportQuery {
    viewColumnsConfigJSON?: string | undefined;

    constructor(data?: IHelpExportQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.viewColumnsConfigJSON = _data["viewColumnsConfigJSON"];
        }
    }

    static override fromJS(data: any): HelpExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new HelpExportQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viewColumnsConfigJSON"] = this.viewColumnsConfigJSON;
        super.toJSON(data);
        return data;
    }
}

export interface IHelpExportQuery extends IPageListByDto {
    viewColumnsConfigJSON?: string | undefined;
}

export class HelpExportCSVQuery extends PageListByDto implements IHelpExportCSVQuery {
    viewColumnsConfigJSON?: string | undefined;

    constructor(data?: IHelpExportCSVQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.viewColumnsConfigJSON = _data["viewColumnsConfigJSON"];
        }
    }

    static override fromJS(data: any): HelpExportCSVQuery {
        data = typeof data === 'object' ? data : {};
        let result = new HelpExportCSVQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viewColumnsConfigJSON"] = this.viewColumnsConfigJSON;
        super.toJSON(data);
        return data;
    }
}

export interface IHelpExportCSVQuery extends IPageListByDto {
    viewColumnsConfigJSON?: string | undefined;
}

export class HelpExportPDFQuery extends PageListByDto implements IHelpExportPDFQuery {
    viewColumnsConfigJSON?: string | undefined;

    constructor(data?: IHelpExportPDFQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.viewColumnsConfigJSON = _data["viewColumnsConfigJSON"];
        }
    }

    static override fromJS(data: any): HelpExportPDFQuery {
        data = typeof data === 'object' ? data : {};
        let result = new HelpExportPDFQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viewColumnsConfigJSON"] = this.viewColumnsConfigJSON;
        super.toJSON(data);
        return data;
    }
}

export interface IHelpExportPDFQuery extends IPageListByDto {
    viewColumnsConfigJSON?: string | undefined;
}

export class HelpResponse implements IHelpResponse {
    id?: number | undefined;
    language!: number;
    languageDesc?: string | undefined;
    key?: string | undefined;
    displayName?: string | undefined;
    body?: string | undefined;
    isActive!: boolean;

    constructor(data?: IHelpResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.language = _data["language"];
            this.languageDesc = _data["languageDesc"];
            this.key = _data["key"];
            this.displayName = _data["displayName"];
            this.body = _data["body"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): HelpResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HelpResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["language"] = this.language;
        data["languageDesc"] = this.languageDesc;
        data["key"] = this.key;
        data["displayName"] = this.displayName;
        data["body"] = this.body;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IHelpResponse {
    id?: number | undefined;
    language: number;
    languageDesc?: string | undefined;
    key?: string | undefined;
    displayName?: string | undefined;
    body?: string | undefined;
    isActive: boolean;
}

export class HelpForEditResponse implements IHelpForEditResponse {
    id?: number | undefined;
    language?: number | undefined;
    languageDesc?: string | undefined;
    key?: string | undefined;
    displayName?: string | undefined;
    body?: string | undefined;
    isActive!: boolean;
    languageCombo?: ComboboxItemDto[] | undefined;
    keyCombo?: ComboboxItemDto[] | undefined;

    constructor(data?: IHelpForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.language = _data["language"];
            this.languageDesc = _data["languageDesc"];
            this.key = _data["key"];
            this.displayName = _data["displayName"];
            this.body = _data["body"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["languageCombo"])) {
                this.languageCombo = [] as any;
                for (let item of _data["languageCombo"])
                    this.languageCombo!.push(ComboboxItemDto.fromJS(item));
            }
            if (Array.isArray(_data["keyCombo"])) {
                this.keyCombo = [] as any;
                for (let item of _data["keyCombo"])
                    this.keyCombo!.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HelpForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HelpForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["language"] = this.language;
        data["languageDesc"] = this.languageDesc;
        data["key"] = this.key;
        data["displayName"] = this.displayName;
        data["body"] = this.body;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.languageCombo)) {
            data["languageCombo"] = [];
            for (let item of this.languageCombo)
                data["languageCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.keyCombo)) {
            data["keyCombo"] = [];
            for (let item of this.keyCombo)
                data["keyCombo"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHelpForEditResponse {
    id?: number | undefined;
    language?: number | undefined;
    languageDesc?: string | undefined;
    key?: string | undefined;
    displayName?: string | undefined;
    body?: string | undefined;
    isActive: boolean;
    languageCombo?: ComboboxItemDto[] | undefined;
    keyCombo?: ComboboxItemDto[] | undefined;
}

export class HelpGetForEditQuery implements IHelpGetForEditQuery {
    id?: number | undefined;

    constructor(data?: IHelpGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HelpGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new HelpGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IHelpGetForEditQuery {
    id?: number | undefined;
}

export class HelpCreateCommand implements IHelpCreateCommand {
    language!: number;
    key?: string | undefined;
    displayName?: string | undefined;
    body?: string | undefined;
    isActive!: boolean;

    constructor(data?: IHelpCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.key = _data["key"];
            this.displayName = _data["displayName"];
            this.body = _data["body"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): HelpCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new HelpCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["key"] = this.key;
        data["displayName"] = this.displayName;
        data["body"] = this.body;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IHelpCreateCommand {
    language: number;
    key?: string | undefined;
    displayName?: string | undefined;
    body?: string | undefined;
    isActive: boolean;
}

export class HelpUpdateCommand implements IHelpUpdateCommand {
    id!: number;
    language!: number;
    key?: string | undefined;
    displayName?: string | undefined;
    body?: string | undefined;
    isActive!: boolean;

    constructor(data?: IHelpUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.language = _data["language"];
            this.key = _data["key"];
            this.displayName = _data["displayName"];
            this.body = _data["body"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): HelpUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new HelpUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["language"] = this.language;
        data["key"] = this.key;
        data["displayName"] = this.displayName;
        data["body"] = this.body;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IHelpUpdateCommand {
    id: number;
    language: number;
    key?: string | undefined;
    displayName?: string | undefined;
    body?: string | undefined;
    isActive: boolean;
}

export class HostSettingsForEditResponse implements IHostSettingsForEditResponse {
    webSiteRootAddress?: string | undefined;
    passwordUseDefaultConfiguration!: boolean;
    passwordComplexity?: HostSettingsPasswordComplexityResponse | undefined;
    passwordComplexityDefault?: HostSettingsPasswordComplexityResponse | undefined;
    enableUserBlocking!: boolean;
    failedAttemptsToBlockUser!: number;
    userBlockingDuration!: number;
    enableTwoFactorLogin!: boolean;
    enableMailVerification!: boolean;
    enableSMSVerification!: boolean;
    enableBrowserRemenberMe!: boolean;
    mailSMTPSenderDefault?: string | undefined;
    mailSMTPSenderDefaultDisplayName?: string | undefined;
    mailSMTPHost?: string | undefined;
    mailSMTPPort?: number | undefined;
    mailEnableSSL!: boolean;
    mailUseDefaultCredentials!: boolean;
    mailDomainName?: string | undefined;
    mailUserName?: string | undefined;
    mailUserPassword?: string | undefined;
    emailSendMethod!: EmailSendMethod;
    grpcEmail?: HostGrpcEmailResponse | undefined;
    enviarSesionHDAutomatico!: boolean;

    constructor(data?: IHostSettingsForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webSiteRootAddress = _data["webSiteRootAddress"];
            this.passwordUseDefaultConfiguration = _data["passwordUseDefaultConfiguration"];
            this.passwordComplexity = _data["passwordComplexity"] ? HostSettingsPasswordComplexityResponse.fromJS(_data["passwordComplexity"]) : <any>undefined;
            this.passwordComplexityDefault = _data["passwordComplexityDefault"] ? HostSettingsPasswordComplexityResponse.fromJS(_data["passwordComplexityDefault"]) : <any>undefined;
            this.enableUserBlocking = _data["enableUserBlocking"];
            this.failedAttemptsToBlockUser = _data["failedAttemptsToBlockUser"];
            this.userBlockingDuration = _data["userBlockingDuration"];
            this.enableTwoFactorLogin = _data["enableTwoFactorLogin"];
            this.enableMailVerification = _data["enableMailVerification"];
            this.enableSMSVerification = _data["enableSMSVerification"];
            this.enableBrowserRemenberMe = _data["enableBrowserRemenberMe"];
            this.mailSMTPSenderDefault = _data["mailSMTPSenderDefault"];
            this.mailSMTPSenderDefaultDisplayName = _data["mailSMTPSenderDefaultDisplayName"];
            this.mailSMTPHost = _data["mailSMTPHost"];
            this.mailSMTPPort = _data["mailSMTPPort"];
            this.mailEnableSSL = _data["mailEnableSSL"];
            this.mailUseDefaultCredentials = _data["mailUseDefaultCredentials"];
            this.mailDomainName = _data["mailDomainName"];
            this.mailUserName = _data["mailUserName"];
            this.mailUserPassword = _data["mailUserPassword"];
            this.emailSendMethod = _data["emailSendMethod"];
            this.grpcEmail = _data["grpcEmail"] ? HostGrpcEmailResponse.fromJS(_data["grpcEmail"]) : <any>undefined;
            this.enviarSesionHDAutomatico = _data["enviarSesionHDAutomatico"];
        }
    }

    static fromJS(data: any): HostSettingsForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webSiteRootAddress"] = this.webSiteRootAddress;
        data["passwordUseDefaultConfiguration"] = this.passwordUseDefaultConfiguration;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["passwordComplexityDefault"] = this.passwordComplexityDefault ? this.passwordComplexityDefault.toJSON() : <any>undefined;
        data["enableUserBlocking"] = this.enableUserBlocking;
        data["failedAttemptsToBlockUser"] = this.failedAttemptsToBlockUser;
        data["userBlockingDuration"] = this.userBlockingDuration;
        data["enableTwoFactorLogin"] = this.enableTwoFactorLogin;
        data["enableMailVerification"] = this.enableMailVerification;
        data["enableSMSVerification"] = this.enableSMSVerification;
        data["enableBrowserRemenberMe"] = this.enableBrowserRemenberMe;
        data["mailSMTPSenderDefault"] = this.mailSMTPSenderDefault;
        data["mailSMTPSenderDefaultDisplayName"] = this.mailSMTPSenderDefaultDisplayName;
        data["mailSMTPHost"] = this.mailSMTPHost;
        data["mailSMTPPort"] = this.mailSMTPPort;
        data["mailEnableSSL"] = this.mailEnableSSL;
        data["mailUseDefaultCredentials"] = this.mailUseDefaultCredentials;
        data["mailDomainName"] = this.mailDomainName;
        data["mailUserName"] = this.mailUserName;
        data["mailUserPassword"] = this.mailUserPassword;
        data["emailSendMethod"] = this.emailSendMethod;
        data["grpcEmail"] = this.grpcEmail ? this.grpcEmail.toJSON() : <any>undefined;
        data["enviarSesionHDAutomatico"] = this.enviarSesionHDAutomatico;
        return data;
    }
}

export interface IHostSettingsForEditResponse {
    webSiteRootAddress?: string | undefined;
    passwordUseDefaultConfiguration: boolean;
    passwordComplexity?: HostSettingsPasswordComplexityResponse | undefined;
    passwordComplexityDefault?: HostSettingsPasswordComplexityResponse | undefined;
    enableUserBlocking: boolean;
    failedAttemptsToBlockUser: number;
    userBlockingDuration: number;
    enableTwoFactorLogin: boolean;
    enableMailVerification: boolean;
    enableSMSVerification: boolean;
    enableBrowserRemenberMe: boolean;
    mailSMTPSenderDefault?: string | undefined;
    mailSMTPSenderDefaultDisplayName?: string | undefined;
    mailSMTPHost?: string | undefined;
    mailSMTPPort?: number | undefined;
    mailEnableSSL: boolean;
    mailUseDefaultCredentials: boolean;
    mailDomainName?: string | undefined;
    mailUserName?: string | undefined;
    mailUserPassword?: string | undefined;
    emailSendMethod: EmailSendMethod;
    grpcEmail?: HostGrpcEmailResponse | undefined;
    enviarSesionHDAutomatico: boolean;
}

export class HostSettingsPasswordComplexityResponse implements IHostSettingsPasswordComplexityResponse {
    minimumLength!: number;
    maximumLength!: number;
    useNumbers!: boolean;
    useUppercase!: boolean;
    useLowercase!: boolean;
    usePunctuationSymbols!: boolean;

    constructor(data?: IHostSettingsPasswordComplexityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minimumLength = _data["minimumLength"];
            this.maximumLength = _data["maximumLength"];
            this.useNumbers = _data["useNumbers"];
            this.useUppercase = _data["useUppercase"];
            this.useLowercase = _data["useLowercase"];
            this.usePunctuationSymbols = _data["usePunctuationSymbols"];
        }
    }

    static fromJS(data: any): HostSettingsPasswordComplexityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsPasswordComplexityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumLength"] = this.minimumLength;
        data["maximumLength"] = this.maximumLength;
        data["useNumbers"] = this.useNumbers;
        data["useUppercase"] = this.useUppercase;
        data["useLowercase"] = this.useLowercase;
        data["usePunctuationSymbols"] = this.usePunctuationSymbols;
        return data;
    }
}

export interface IHostSettingsPasswordComplexityResponse {
    minimumLength: number;
    maximumLength: number;
    useNumbers: boolean;
    useUppercase: boolean;
    useLowercase: boolean;
    usePunctuationSymbols: boolean;
}

export enum EmailSendMethod {
    Normal = 0,
    Grpc = 1,
}

export class HostGrpcEmailResponse implements IHostGrpcEmailResponse {
    sendConfiguration!: boolean;
    tenancyName?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;

    constructor(data?: IHostGrpcEmailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sendConfiguration = _data["sendConfiguration"];
            this.tenancyName = _data["tenancyName"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): HostGrpcEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HostGrpcEmailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sendConfiguration"] = this.sendConfiguration;
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface IHostGrpcEmailResponse {
    sendConfiguration: boolean;
    tenancyName?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
}

export class HostSettingsGetForEditQuery implements IHostSettingsGetForEditQuery {

    constructor(data?: IHostSettingsGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): HostSettingsGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IHostSettingsGetForEditQuery {
}

export class HostSettingsUpdateCommand implements IHostSettingsUpdateCommand {
    webSiteRootAddress?: string | undefined;
    passwordUseDefaultConfiguration!: boolean;
    passwordComplexity?: HostSettingsPasswordComplexityCommand | undefined;
    enableUserBlocking!: boolean;
    failedAttemptsToBlockUser!: number;
    userBlockingDuration!: number;
    enableTwoFactorLogin!: boolean;
    enableMailVerification!: boolean;
    enableSMSVerification!: boolean;
    enableBrowserRemenberMe!: boolean;
    mailSMTPSenderDefault?: string | undefined;
    mailSMTPSenderDefaultDisplayName?: string | undefined;
    mailSMTPHost?: string | undefined;
    mailSMTPPort?: number | undefined;
    mailEnableSSL!: boolean;
    mailUseDefaultCredentials!: boolean;
    mailDomainName?: string | undefined;
    mailUserName?: string | undefined;
    mailUserPassword?: string | undefined;
    grpcEmail?: HostGrpcEmailCommand | undefined;
    enviarSesionHDAutomatico?: boolean | undefined;

    constructor(data?: IHostSettingsUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webSiteRootAddress = _data["webSiteRootAddress"];
            this.passwordUseDefaultConfiguration = _data["passwordUseDefaultConfiguration"];
            this.passwordComplexity = _data["passwordComplexity"] ? HostSettingsPasswordComplexityCommand.fromJS(_data["passwordComplexity"]) : <any>undefined;
            this.enableUserBlocking = _data["enableUserBlocking"];
            this.failedAttemptsToBlockUser = _data["failedAttemptsToBlockUser"];
            this.userBlockingDuration = _data["userBlockingDuration"];
            this.enableTwoFactorLogin = _data["enableTwoFactorLogin"];
            this.enableMailVerification = _data["enableMailVerification"];
            this.enableSMSVerification = _data["enableSMSVerification"];
            this.enableBrowserRemenberMe = _data["enableBrowserRemenberMe"];
            this.mailSMTPSenderDefault = _data["mailSMTPSenderDefault"];
            this.mailSMTPSenderDefaultDisplayName = _data["mailSMTPSenderDefaultDisplayName"];
            this.mailSMTPHost = _data["mailSMTPHost"];
            this.mailSMTPPort = _data["mailSMTPPort"];
            this.mailEnableSSL = _data["mailEnableSSL"];
            this.mailUseDefaultCredentials = _data["mailUseDefaultCredentials"];
            this.mailDomainName = _data["mailDomainName"];
            this.mailUserName = _data["mailUserName"];
            this.mailUserPassword = _data["mailUserPassword"];
            this.grpcEmail = _data["grpcEmail"] ? HostGrpcEmailCommand.fromJS(_data["grpcEmail"]) : <any>undefined;
            this.enviarSesionHDAutomatico = _data["enviarSesionHDAutomatico"];
        }
    }

    static fromJS(data: any): HostSettingsUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webSiteRootAddress"] = this.webSiteRootAddress;
        data["passwordUseDefaultConfiguration"] = this.passwordUseDefaultConfiguration;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["enableUserBlocking"] = this.enableUserBlocking;
        data["failedAttemptsToBlockUser"] = this.failedAttemptsToBlockUser;
        data["userBlockingDuration"] = this.userBlockingDuration;
        data["enableTwoFactorLogin"] = this.enableTwoFactorLogin;
        data["enableMailVerification"] = this.enableMailVerification;
        data["enableSMSVerification"] = this.enableSMSVerification;
        data["enableBrowserRemenberMe"] = this.enableBrowserRemenberMe;
        data["mailSMTPSenderDefault"] = this.mailSMTPSenderDefault;
        data["mailSMTPSenderDefaultDisplayName"] = this.mailSMTPSenderDefaultDisplayName;
        data["mailSMTPHost"] = this.mailSMTPHost;
        data["mailSMTPPort"] = this.mailSMTPPort;
        data["mailEnableSSL"] = this.mailEnableSSL;
        data["mailUseDefaultCredentials"] = this.mailUseDefaultCredentials;
        data["mailDomainName"] = this.mailDomainName;
        data["mailUserName"] = this.mailUserName;
        data["mailUserPassword"] = this.mailUserPassword;
        data["grpcEmail"] = this.grpcEmail ? this.grpcEmail.toJSON() : <any>undefined;
        data["enviarSesionHDAutomatico"] = this.enviarSesionHDAutomatico;
        return data;
    }
}

export interface IHostSettingsUpdateCommand {
    webSiteRootAddress?: string | undefined;
    passwordUseDefaultConfiguration: boolean;
    passwordComplexity?: HostSettingsPasswordComplexityCommand | undefined;
    enableUserBlocking: boolean;
    failedAttemptsToBlockUser: number;
    userBlockingDuration: number;
    enableTwoFactorLogin: boolean;
    enableMailVerification: boolean;
    enableSMSVerification: boolean;
    enableBrowserRemenberMe: boolean;
    mailSMTPSenderDefault?: string | undefined;
    mailSMTPSenderDefaultDisplayName?: string | undefined;
    mailSMTPHost?: string | undefined;
    mailSMTPPort?: number | undefined;
    mailEnableSSL: boolean;
    mailUseDefaultCredentials: boolean;
    mailDomainName?: string | undefined;
    mailUserName?: string | undefined;
    mailUserPassword?: string | undefined;
    grpcEmail?: HostGrpcEmailCommand | undefined;
    enviarSesionHDAutomatico?: boolean | undefined;
}

export class HostSettingsPasswordComplexityCommand implements IHostSettingsPasswordComplexityCommand {
    minimumLength!: number;
    maximumLength!: number;
    useNumbers!: boolean;
    useUppercase!: boolean;
    useLowercase!: boolean;
    usePunctuationSymbols!: boolean;

    constructor(data?: IHostSettingsPasswordComplexityCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minimumLength = _data["minimumLength"];
            this.maximumLength = _data["maximumLength"];
            this.useNumbers = _data["useNumbers"];
            this.useUppercase = _data["useUppercase"];
            this.useLowercase = _data["useLowercase"];
            this.usePunctuationSymbols = _data["usePunctuationSymbols"];
        }
    }

    static fromJS(data: any): HostSettingsPasswordComplexityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsPasswordComplexityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumLength"] = this.minimumLength;
        data["maximumLength"] = this.maximumLength;
        data["useNumbers"] = this.useNumbers;
        data["useUppercase"] = this.useUppercase;
        data["useLowercase"] = this.useLowercase;
        data["usePunctuationSymbols"] = this.usePunctuationSymbols;
        return data;
    }
}

export interface IHostSettingsPasswordComplexityCommand {
    minimumLength: number;
    maximumLength: number;
    useNumbers: boolean;
    useUppercase: boolean;
    useLowercase: boolean;
    usePunctuationSymbols: boolean;
}

export class HostGrpcEmailCommand implements IHostGrpcEmailCommand {
    tenancyName?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;

    constructor(data?: IHostGrpcEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): HostGrpcEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new HostGrpcEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface IHostGrpcEmailCommand {
    tenancyName?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
}

export class HostSettingsSendTestEmailCommand implements IHostSettingsSendTestEmailCommand {
    emailAddress?: string | undefined;

    constructor(data?: IHostSettingsSendTestEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): HostSettingsSendTestEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsSendTestEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IHostSettingsSendTestEmailCommand {
    emailAddress?: string | undefined;
}

export class PagedResultDtoOfLanguageForListResponse implements IPagedResultDtoOfLanguageForListResponse {
    totalCount!: number;
    items?: LanguageForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfLanguageForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LanguageForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLanguageForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLanguageForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLanguageForListResponse {
    totalCount: number;
    items?: LanguageForListResponse[] | undefined;
}

export class LanguageForListResponse implements ILanguageForListResponse {
    id?: number | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive!: boolean;
    isActiveDesc?: string | undefined;

    constructor(data?: ILanguageForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
        }
    }

    static fromJS(data: any): LanguageForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        return data;
    }
}

export interface ILanguageForListResponse {
    id?: number | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive: boolean;
    isActiveDesc?: string | undefined;
}

export class LanguageGetListQuery extends PageListByDto implements ILanguageGetListQuery {

    constructor(data?: ILanguageGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): LanguageGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ILanguageGetListQuery extends IPageListByDto {
}

export class LanguageExportQuery extends PageListByDto implements ILanguageExportQuery {
    viewColumnsConfigJSON?: string | undefined;

    constructor(data?: ILanguageExportQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.viewColumnsConfigJSON = _data["viewColumnsConfigJSON"];
        }
    }

    static override fromJS(data: any): LanguageExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageExportQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viewColumnsConfigJSON"] = this.viewColumnsConfigJSON;
        super.toJSON(data);
        return data;
    }
}

export interface ILanguageExportQuery extends IPageListByDto {
    viewColumnsConfigJSON?: string | undefined;
}

export class LanguageExportCSVQuery extends PageListByDto implements ILanguageExportCSVQuery {
    viewColumnsConfigJSON?: string | undefined;

    constructor(data?: ILanguageExportCSVQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.viewColumnsConfigJSON = _data["viewColumnsConfigJSON"];
        }
    }

    static override fromJS(data: any): LanguageExportCSVQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageExportCSVQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viewColumnsConfigJSON"] = this.viewColumnsConfigJSON;
        super.toJSON(data);
        return data;
    }
}

export interface ILanguageExportCSVQuery extends IPageListByDto {
    viewColumnsConfigJSON?: string | undefined;
}

export class LanguageExportPDFQuery extends PageListByDto implements ILanguageExportPDFQuery {
    viewColumnsConfigJSON?: string | undefined;

    constructor(data?: ILanguageExportPDFQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.viewColumnsConfigJSON = _data["viewColumnsConfigJSON"];
        }
    }

    static override fromJS(data: any): LanguageExportPDFQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageExportPDFQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viewColumnsConfigJSON"] = this.viewColumnsConfigJSON;
        super.toJSON(data);
        return data;
    }
}

export interface ILanguageExportPDFQuery extends IPageListByDto {
    viewColumnsConfigJSON?: string | undefined;
}

export class LanguageResponse implements ILanguageResponse {
    id?: number | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive!: boolean;

    constructor(data?: ILanguageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LanguageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ILanguageResponse {
    id?: number | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive: boolean;
}

export class LanguageForEditResponse implements ILanguageForEditResponse {
    id?: number | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive!: boolean;
    languageCombo?: ComboboxItemDto[] | undefined;

    constructor(data?: ILanguageForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["languageCombo"])) {
                this.languageCombo = [] as any;
                for (let item of _data["languageCombo"])
                    this.languageCombo!.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LanguageForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.languageCombo)) {
            data["languageCombo"] = [];
            for (let item of this.languageCombo)
                data["languageCombo"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILanguageForEditResponse {
    id?: number | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive: boolean;
    languageCombo?: ComboboxItemDto[] | undefined;
}

export class LanguageGetForEditQuery implements ILanguageGetForEditQuery {
    id?: number | undefined;

    constructor(data?: ILanguageGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LanguageGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ILanguageGetForEditQuery {
    id?: number | undefined;
}

export class LanguageCreateCommand implements ILanguageCreateCommand {
    name?: string | undefined;
    displayName?: string | undefined;
    isActive!: boolean;

    constructor(data?: ILanguageCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LanguageCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ILanguageCreateCommand {
    name?: string | undefined;
    displayName?: string | undefined;
    isActive: boolean;
}

export class LanguageUpdateCommand implements ILanguageUpdateCommand {
    id!: number;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive!: boolean;

    constructor(data?: ILanguageUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LanguageUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ILanguageUpdateCommand {
    id: number;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive: boolean;
}

export class PagedResultDtoOfLanguageTextForListResponse implements IPagedResultDtoOfLanguageTextForListResponse {
    totalCount!: number;
    items?: LanguageTextForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfLanguageTextForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LanguageTextForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLanguageTextForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLanguageTextForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLanguageTextForListResponse {
    totalCount: number;
    items?: LanguageTextForListResponse[] | undefined;
}

export class LanguageTextForListResponse implements ILanguageTextForListResponse {
    id?: number | undefined;
    languageId?: number | undefined;
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: ILanguageTextForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.languageId = _data["languageId"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): LanguageTextForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["languageId"] = this.languageId;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface ILanguageTextForListResponse {
    id?: number | undefined;
    languageId?: number | undefined;
    key?: string | undefined;
    value?: string | undefined;
}

export class LanguageTextGetListQuery extends PageListByDto implements ILanguageTextGetListQuery {
    languageId?: number | undefined;

    constructor(data?: ILanguageTextGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
        }
    }

    static override fromJS(data: any): LanguageTextGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        super.toJSON(data);
        return data;
    }
}

export interface ILanguageTextGetListQuery extends IPageListByDto {
    languageId?: number | undefined;
}

export class LanguageTextResponse implements ILanguageTextResponse {
    id?: number | undefined;
    languageId?: number | undefined;
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: ILanguageTextResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.languageId = _data["languageId"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): LanguageTextResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["languageId"] = this.languageId;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface ILanguageTextResponse {
    id?: number | undefined;
    languageId?: number | undefined;
    key?: string | undefined;
    value?: string | undefined;
}

export class LanguageTextForEditResponse implements ILanguageTextForEditResponse {
    id?: number | undefined;
    languageId?: number | undefined;
    languageDesc?: string | undefined;
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: ILanguageTextForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.languageId = _data["languageId"];
            this.languageDesc = _data["languageDesc"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): LanguageTextForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["languageId"] = this.languageId;
        data["languageDesc"] = this.languageDesc;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface ILanguageTextForEditResponse {
    id?: number | undefined;
    languageId?: number | undefined;
    languageDesc?: string | undefined;
    key?: string | undefined;
    value?: string | undefined;
}

export class LanguageTextGetForEditQuery implements ILanguageTextGetForEditQuery {
    id?: number | undefined;

    constructor(data?: ILanguageTextGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LanguageTextGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ILanguageTextGetForEditQuery {
    id?: number | undefined;
}

export class LanguageTextUpdateCommand implements ILanguageTextUpdateCommand {
    id?: number | undefined;
    languageId!: number;
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: ILanguageTextUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.languageId = _data["languageId"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): LanguageTextUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["languageId"] = this.languageId;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface ILanguageTextUpdateCommand {
    id?: number | undefined;
    languageId: number;
    key?: string | undefined;
    value?: string | undefined;
}

export class PagedResultDtoOfMailGroupListResponse implements IPagedResultDtoOfMailGroupListResponse {
    totalCount!: number;
    items?: MailGroupListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfMailGroupListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MailGroupListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMailGroupListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMailGroupListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfMailGroupListResponse {
    totalCount: number;
    items?: MailGroupListResponse[] | undefined;
}

export class MailGroupListResponse implements IMailGroupListResponse {
    id!: number;
    displayName?: string | undefined;
    isSelected?: boolean | undefined;

    constructor(data?: IMailGroupListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): MailGroupListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MailGroupListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IMailGroupListResponse {
    id: number;
    displayName?: string | undefined;
    isSelected?: boolean | undefined;
}

export class MailGroupGetListQuery extends PageListByDto implements IMailGroupGetListQuery {

    constructor(data?: IMailGroupGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MailGroupGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MailGroupGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMailGroupGetListQuery extends IPageListByDto {
}

export class MailGroupCreateCommand implements IMailGroupCreateCommand {
    displayName?: string | undefined;
    header?: string | undefined;
    footer?: string | undefined;

    constructor(data?: IMailGroupCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.header = _data["header"];
            this.footer = _data["footer"];
        }
    }

    static fromJS(data: any): MailGroupCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailGroupCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["header"] = this.header;
        data["footer"] = this.footer;
        return data;
    }
}

export interface IMailGroupCreateCommand {
    displayName?: string | undefined;
    header?: string | undefined;
    footer?: string | undefined;
}

export class MailGroupUpdateCommand implements IMailGroupUpdateCommand {
    id!: number;
    displayName?: string | undefined;
    header?: string | undefined;
    footer?: string | undefined;

    constructor(data?: IMailGroupUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.header = _data["header"];
            this.footer = _data["footer"];
        }
    }

    static fromJS(data: any): MailGroupUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailGroupUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["header"] = this.header;
        data["footer"] = this.footer;
        return data;
    }
}

export interface IMailGroupUpdateCommand {
    id: number;
    displayName?: string | undefined;
    header?: string | undefined;
    footer?: string | undefined;
}

export class MailGroupForEditResponse implements IMailGroupForEditResponse {
    id!: number;
    displayName?: string | undefined;
    header?: string | undefined;
    footer?: string | undefined;

    constructor(data?: IMailGroupForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.header = _data["header"];
            this.footer = _data["footer"];
        }
    }

    static fromJS(data: any): MailGroupForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MailGroupForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["header"] = this.header;
        data["footer"] = this.footer;
        return data;
    }
}

export interface IMailGroupForEditResponse {
    id: number;
    displayName?: string | undefined;
    header?: string | undefined;
    footer?: string | undefined;
}

export class MailGroupGetForEditQuery implements IMailGroupGetForEditQuery {
    id!: number;

    constructor(data?: IMailGroupGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MailGroupGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MailGroupGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IMailGroupGetForEditQuery {
    id: number;
}

export class MailGroupCopyCommand implements IMailGroupCopyCommand {
    id!: number;
    displayName?: string | undefined;

    constructor(data?: IMailGroupCopyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MailGroupCopyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailGroupCopyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMailGroupCopyCommand {
    id: number;
    displayName?: string | undefined;
}

export class MailGroupCheckCommand implements IMailGroupCheckCommand {
    id!: number;

    constructor(data?: IMailGroupCheckCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MailGroupCheckCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailGroupCheckCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IMailGroupCheckCommand {
    id: number;
}

export class MailGroupUnCheckCommand implements IMailGroupUnCheckCommand {
    id!: number;

    constructor(data?: IMailGroupUnCheckCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MailGroupUnCheckCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailGroupUnCheckCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IMailGroupUnCheckCommand {
    id: number;
}

export class PagedResultDtoOfMailTemplateListResponse implements IPagedResultDtoOfMailTemplateListResponse {
    totalCount!: number;
    items?: MailTemplateListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfMailTemplateListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MailTemplateListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMailTemplateListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMailTemplateListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfMailTemplateListResponse {
    totalCount: number;
    items?: MailTemplateListResponse[] | undefined;
}

export class MailTemplateListResponse implements IMailTemplateListResponse {
    id!: number;
    mailKeyDesc?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: IMailTemplateListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mailKeyDesc = _data["mailKeyDesc"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MailTemplateListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mailKeyDesc"] = this.mailKeyDesc;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMailTemplateListResponse {
    id: number;
    mailKeyDesc?: string | undefined;
    displayName?: string | undefined;
}

export class MailTemplateGetListQuery extends PageListByDto implements IMailTemplateGetListQuery {
    mailGroup!: number;

    constructor(data?: IMailTemplateGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mailGroup = _data["mailGroup"];
        }
    }

    static override fromJS(data: any): MailTemplateGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailGroup"] = this.mailGroup;
        super.toJSON(data);
        return data;
    }
}

export interface IMailTemplateGetListQuery extends IPageListByDto {
    mailGroup: number;
}

export class MailTemplateCreateCommand implements IMailTemplateCreateCommand {
    mailGroup?: number | undefined;
    mailKey?: string | undefined;
    displayName?: string | undefined;
    sendTo?: string | undefined;
    copyTo?: string | undefined;
    blindCopyTo?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    isActive!: boolean;

    constructor(data?: IMailTemplateCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailGroup = _data["mailGroup"];
            this.mailKey = _data["mailKey"];
            this.displayName = _data["displayName"];
            this.sendTo = _data["sendTo"];
            this.copyTo = _data["copyTo"];
            this.blindCopyTo = _data["blindCopyTo"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): MailTemplateCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailGroup"] = this.mailGroup;
        data["mailKey"] = this.mailKey;
        data["displayName"] = this.displayName;
        data["sendTo"] = this.sendTo;
        data["copyTo"] = this.copyTo;
        data["blindCopyTo"] = this.blindCopyTo;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IMailTemplateCreateCommand {
    mailGroup?: number | undefined;
    mailKey?: string | undefined;
    displayName?: string | undefined;
    sendTo?: string | undefined;
    copyTo?: string | undefined;
    blindCopyTo?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    isActive: boolean;
}

export class MailTemplateUpdateCommand implements IMailTemplateUpdateCommand {
    id!: number;
    mailGroup?: number | undefined;
    mailKey?: string | undefined;
    displayName?: string | undefined;
    sendTo?: string | undefined;
    copyTo?: string | undefined;
    blindCopyTo?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    isActive!: boolean;

    constructor(data?: IMailTemplateUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mailGroup = _data["mailGroup"];
            this.mailKey = _data["mailKey"];
            this.displayName = _data["displayName"];
            this.sendTo = _data["sendTo"];
            this.copyTo = _data["copyTo"];
            this.blindCopyTo = _data["blindCopyTo"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): MailTemplateUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mailGroup"] = this.mailGroup;
        data["mailKey"] = this.mailKey;
        data["displayName"] = this.displayName;
        data["sendTo"] = this.sendTo;
        data["copyTo"] = this.copyTo;
        data["blindCopyTo"] = this.blindCopyTo;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IMailTemplateUpdateCommand {
    id: number;
    mailGroup?: number | undefined;
    mailKey?: string | undefined;
    displayName?: string | undefined;
    sendTo?: string | undefined;
    copyTo?: string | undefined;
    blindCopyTo?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    isActive: boolean;
}

export class MailTemplateForEditResponse implements IMailTemplateForEditResponse {
    id!: number;
    mailGroup?: number | undefined;
    mailKey?: string | undefined;
    displayName?: string | undefined;
    sendTo?: string | undefined;
    copyTo?: string | undefined;
    blindCopyTo?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    isActive?: boolean | undefined;
    mailKeyList?: ComboboxItemDto[] | undefined;

    constructor(data?: IMailTemplateForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mailGroup = _data["mailGroup"];
            this.mailKey = _data["mailKey"];
            this.displayName = _data["displayName"];
            this.sendTo = _data["sendTo"];
            this.copyTo = _data["copyTo"];
            this.blindCopyTo = _data["blindCopyTo"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["mailKeyList"])) {
                this.mailKeyList = [] as any;
                for (let item of _data["mailKeyList"])
                    this.mailKeyList!.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MailTemplateForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mailGroup"] = this.mailGroup;
        data["mailKey"] = this.mailKey;
        data["displayName"] = this.displayName;
        data["sendTo"] = this.sendTo;
        data["copyTo"] = this.copyTo;
        data["blindCopyTo"] = this.blindCopyTo;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.mailKeyList)) {
            data["mailKeyList"] = [];
            for (let item of this.mailKeyList)
                data["mailKeyList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMailTemplateForEditResponse {
    id: number;
    mailGroup?: number | undefined;
    mailKey?: string | undefined;
    displayName?: string | undefined;
    sendTo?: string | undefined;
    copyTo?: string | undefined;
    blindCopyTo?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    isActive?: boolean | undefined;
    mailKeyList?: ComboboxItemDto[] | undefined;
}

export class MailTemplateGetForEditQuery implements IMailTemplateGetForEditQuery {
    id!: number;

    constructor(data?: IMailTemplateGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MailTemplateGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IMailTemplateGetForEditQuery {
    id: number;
}

export class MailTemplateSendTestCommand implements IMailTemplateSendTestCommand {
    mailGroup!: number;
    email?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;

    constructor(data?: IMailTemplateSendTestCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailGroup = _data["mailGroup"];
            this.email = _data["email"];
            this.subject = _data["subject"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): MailTemplateSendTestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateSendTestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailGroup"] = this.mailGroup;
        data["email"] = this.email;
        data["subject"] = this.subject;
        data["body"] = this.body;
        return data;
    }
}

export interface IMailTemplateSendTestCommand {
    mailGroup: number;
    email?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
}

export class MailTemplateGetBodyParamListQuery implements IMailTemplateGetBodyParamListQuery {
    mailKey?: string | undefined;

    constructor(data?: IMailTemplateGetBodyParamListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailKey = _data["mailKey"];
        }
    }

    static fromJS(data: any): MailTemplateGetBodyParamListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateGetBodyParamListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailKey"] = this.mailKey;
        return data;
    }
}

export interface IMailTemplateGetBodyParamListQuery {
    mailKey?: string | undefined;
}

export class MailTemplateGetMailKeyAvailableListQuery implements IMailTemplateGetMailKeyAvailableListQuery {
    mailGroup!: number;

    constructor(data?: IMailTemplateGetMailKeyAvailableListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailGroup = _data["mailGroup"];
        }
    }

    static fromJS(data: any): MailTemplateGetMailKeyAvailableListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateGetMailKeyAvailableListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailGroup"] = this.mailGroup;
        return data;
    }
}

export interface IMailTemplateGetMailKeyAvailableListQuery {
    mailGroup: number;
}

export class PagedResultDtoOfOrgUnitForListResponse implements IPagedResultDtoOfOrgUnitForListResponse {
    totalCount!: number;
    items?: OrgUnitForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfOrgUnitForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrgUnitForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrgUnitForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrgUnitForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrgUnitForListResponse {
    totalCount: number;
    items?: OrgUnitForListResponse[] | undefined;
}

export class OrgUnitForListResponse implements IOrgUnitForListResponse {
    id!: number;
    parentOU?: number | undefined;
    parentOUDesc?: string | undefined;
    name?: string | undefined;
    level!: number;
    hasChildren!: boolean;
    size!: number;

    constructor(data?: IOrgUnitForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentOU = _data["parentOU"];
            this.parentOUDesc = _data["parentOUDesc"];
            this.name = _data["name"];
            this.level = _data["level"];
            this.hasChildren = _data["hasChildren"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): OrgUnitForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentOU"] = this.parentOU;
        data["parentOUDesc"] = this.parentOUDesc;
        data["name"] = this.name;
        data["level"] = this.level;
        data["hasChildren"] = this.hasChildren;
        data["size"] = this.size;
        return data;
    }
}

export interface IOrgUnitForListResponse {
    id: number;
    parentOU?: number | undefined;
    parentOUDesc?: string | undefined;
    name?: string | undefined;
    level: number;
    hasChildren: boolean;
    size: number;
}

export class OrgUnitGetListQuery extends PageListByDto implements IOrgUnitGetListQuery {
    parentOU?: number | undefined;
    level?: number | undefined;

    constructor(data?: IOrgUnitGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.parentOU = _data["parentOU"];
            this.level = _data["level"];
        }
    }

    static override fromJS(data: any): OrgUnitGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentOU"] = this.parentOU;
        data["level"] = this.level;
        super.toJSON(data);
        return data;
    }
}

export interface IOrgUnitGetListQuery extends IPageListByDto {
    parentOU?: number | undefined;
    level?: number | undefined;
}

export class OrgUnitResponse implements IOrgUnitResponse {
    id!: number;
    parentOU?: number | undefined;
    parentOUDesc?: string | undefined;
    name?: string | undefined;
    level!: number;
    hasChildren!: boolean;
    size!: number;

    constructor(data?: IOrgUnitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentOU = _data["parentOU"];
            this.parentOUDesc = _data["parentOUDesc"];
            this.name = _data["name"];
            this.level = _data["level"];
            this.hasChildren = _data["hasChildren"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): OrgUnitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentOU"] = this.parentOU;
        data["parentOUDesc"] = this.parentOUDesc;
        data["name"] = this.name;
        data["level"] = this.level;
        data["hasChildren"] = this.hasChildren;
        data["size"] = this.size;
        return data;
    }
}

export interface IOrgUnitResponse {
    id: number;
    parentOU?: number | undefined;
    parentOUDesc?: string | undefined;
    name?: string | undefined;
    level: number;
    hasChildren: boolean;
    size: number;
}

export class OrgUnitGetComboQuery implements IOrgUnitGetComboQuery {
    filter?: string | undefined;

    constructor(data?: IOrgUnitGetComboQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): OrgUnitGetComboQuery {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitGetComboQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data;
    }
}

export interface IOrgUnitGetComboQuery {
    filter?: string | undefined;
}

export class OrgUnitForEditResponse implements IOrgUnitForEditResponse {
    id!: number;
    parentOU?: number | undefined;
    parentOUDesc?: string | undefined;
    name?: string | undefined;
    level!: number;
    hasChildren!: boolean;
    size!: number;

    constructor(data?: IOrgUnitForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentOU = _data["parentOU"];
            this.parentOUDesc = _data["parentOUDesc"];
            this.name = _data["name"];
            this.level = _data["level"];
            this.hasChildren = _data["hasChildren"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): OrgUnitForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentOU"] = this.parentOU;
        data["parentOUDesc"] = this.parentOUDesc;
        data["name"] = this.name;
        data["level"] = this.level;
        data["hasChildren"] = this.hasChildren;
        data["size"] = this.size;
        return data;
    }
}

export interface IOrgUnitForEditResponse {
    id: number;
    parentOU?: number | undefined;
    parentOUDesc?: string | undefined;
    name?: string | undefined;
    level: number;
    hasChildren: boolean;
    size: number;
}

export class OrgUnitGetForEditQuery implements IOrgUnitGetForEditQuery {
    id?: number | undefined;

    constructor(data?: IOrgUnitGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrgUnitGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IOrgUnitGetForEditQuery {
    id?: number | undefined;
}

export class OrgUnitCreateCommand implements IOrgUnitCreateCommand {
    parentOU?: number | undefined;
    name?: string | undefined;
    level!: number;

    constructor(data?: IOrgUnitCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentOU = _data["parentOU"];
            this.name = _data["name"];
            this.level = _data["level"];
        }
    }

    static fromJS(data: any): OrgUnitCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentOU"] = this.parentOU;
        data["name"] = this.name;
        data["level"] = this.level;
        return data;
    }
}

export interface IOrgUnitCreateCommand {
    parentOU?: number | undefined;
    name?: string | undefined;
    level: number;
}

export class OrgUnitUpdateCommand implements IOrgUnitUpdateCommand {
    id!: number;
    name?: string | undefined;

    constructor(data?: IOrgUnitUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): OrgUnitUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IOrgUnitUpdateCommand {
    id: number;
    name?: string | undefined;
}

export class PagedResultDtoOfOrgUnitUserForListResponse implements IPagedResultDtoOfOrgUnitUserForListResponse {
    totalCount!: number;
    items?: OrgUnitUserForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfOrgUnitUserForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrgUnitUserForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrgUnitUserForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrgUnitUserForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrgUnitUserForListResponse {
    totalCount: number;
    items?: OrgUnitUserForListResponse[] | undefined;
}

export class OrgUnitUserForListResponse implements IOrgUnitUserForListResponse {
    id!: number;
    orgUnit!: number;
    orgUnitDesc?: string | undefined;
    user!: number;
    userDesc?: string | undefined;

    constructor(data?: IOrgUnitUserForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orgUnit = _data["orgUnit"];
            this.orgUnitDesc = _data["orgUnitDesc"];
            this.user = _data["user"];
            this.userDesc = _data["userDesc"];
        }
    }

    static fromJS(data: any): OrgUnitUserForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitUserForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orgUnit"] = this.orgUnit;
        data["orgUnitDesc"] = this.orgUnitDesc;
        data["user"] = this.user;
        data["userDesc"] = this.userDesc;
        return data;
    }
}

export interface IOrgUnitUserForListResponse {
    id: number;
    orgUnit: number;
    orgUnitDesc?: string | undefined;
    user: number;
    userDesc?: string | undefined;
}

export class OrgUnitUserGetListQuery extends PageListByDto implements IOrgUnitUserGetListQuery {
    orgUnit?: number | undefined;

    constructor(data?: IOrgUnitUserGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.orgUnit = _data["orgUnit"];
        }
    }

    static override fromJS(data: any): OrgUnitUserGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitUserGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgUnit"] = this.orgUnit;
        super.toJSON(data);
        return data;
    }
}

export interface IOrgUnitUserGetListQuery extends IPageListByDto {
    orgUnit?: number | undefined;
}

export class OrgUnitUserCreateCommand implements IOrgUnitUserCreateCommand {
    orgUnit!: number;
    user!: number;

    constructor(data?: IOrgUnitUserCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgUnit = _data["orgUnit"];
            this.user = _data["user"];
        }
    }

    static fromJS(data: any): OrgUnitUserCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitUserCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgUnit"] = this.orgUnit;
        data["user"] = this.user;
        return data;
    }
}

export interface IOrgUnitUserCreateCommand {
    orgUnit: number;
    user: number;
}

export class Permission implements IPermission {
    parent?: Permission | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    multiTenancySides!: MultiTenancySides;
    children?: Permission[] | undefined;

    constructor(data?: IPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parent = _data["parent"] ? Permission.fromJS(_data["parent"]) : <any>undefined;
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.multiTenancySides = _data["multiTenancySides"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(Permission.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Permission {
        data = typeof data === 'object' ? data : {};
        let result = new Permission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["multiTenancySides"] = this.multiTenancySides;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPermission {
    parent?: Permission | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    multiTenancySides: MultiTenancySides;
    children?: Permission[] | undefined;
}

export enum MultiTenancySides {
    Tenant = 1,
    Host = 2,
}

export class PermissionGetTreeQuery implements IPermissionGetTreeQuery {
    isTenant?: boolean | undefined;

    constructor(data?: IPermissionGetTreeQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isTenant = _data["isTenant"];
        }
    }

    static fromJS(data: any): PermissionGetTreeQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionGetTreeQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isTenant"] = this.isTenant;
        return data;
    }
}

export interface IPermissionGetTreeQuery {
    isTenant?: boolean | undefined;
}

export class TenantCreateRegistrationCommand implements ITenantCreateRegistrationCommand {
    tenancyName?: string | undefined;
    tenantName?: string | undefined;
    password?: string | undefined;
    passwordConfirm?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;

    constructor(data?: ITenantCreateRegistrationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.tenantName = _data["tenantName"];
            this.password = _data["password"];
            this.passwordConfirm = _data["passwordConfirm"];
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            this.secondLastName = _data["secondLastName"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): TenantCreateRegistrationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TenantCreateRegistrationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["tenantName"] = this.tenantName;
        data["password"] = this.password;
        data["passwordConfirm"] = this.passwordConfirm;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["secondLastName"] = this.secondLastName;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ITenantCreateRegistrationCommand {
    tenancyName?: string | undefined;
    tenantName?: string | undefined;
    password?: string | undefined;
    passwordConfirm?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
}

export class TenantConfirmRegistrationCommand implements ITenantConfirmRegistrationCommand {
    code?: string | undefined;

    constructor(data?: ITenantConfirmRegistrationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): TenantConfirmRegistrationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TenantConfirmRegistrationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }
}

export interface ITenantConfirmRegistrationCommand {
    code?: string | undefined;
}

export class PagedResultDtoOfRoleForListResponse implements IPagedResultDtoOfRoleForListResponse {
    totalCount!: number;
    items?: RoleForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfRoleForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRoleForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRoleForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfRoleForListResponse {
    totalCount: number;
    items?: RoleForListResponse[] | undefined;
}

export class RoleForListResponse implements IRoleForListResponse {
    id!: number;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean | undefined;
    isActiveDesc?: string | undefined;

    constructor(data?: IRoleForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
        }
    }

    static fromJS(data: any): RoleForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RoleForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        return data;
    }
}

export interface IRoleForListResponse {
    id: number;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean | undefined;
    isActiveDesc?: string | undefined;
}

export class RoleGetListQuery extends PageListByDto implements IRoleGetListQuery {
    isTenant?: boolean | undefined;

    constructor(data?: IRoleGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isTenant = _data["isTenant"];
        }
    }

    static override fromJS(data: any): RoleGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new RoleGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isTenant"] = this.isTenant;
        super.toJSON(data);
        return data;
    }
}

export interface IRoleGetListQuery extends IPageListByDto {
    isTenant?: boolean | undefined;
}

export class RoleExportQuery extends PageListByDto implements IRoleExportQuery {
    viewColumnsConfigJSON?: string | undefined;
    isTenant?: boolean | undefined;

    constructor(data?: IRoleExportQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.viewColumnsConfigJSON = _data["viewColumnsConfigJSON"];
            this.isTenant = _data["isTenant"];
        }
    }

    static override fromJS(data: any): RoleExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new RoleExportQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viewColumnsConfigJSON"] = this.viewColumnsConfigJSON;
        data["isTenant"] = this.isTenant;
        super.toJSON(data);
        return data;
    }
}

export interface IRoleExportQuery extends IPageListByDto {
    viewColumnsConfigJSON?: string | undefined;
    isTenant?: boolean | undefined;
}

export class RoleExportCSVQuery extends PageListByDto implements IRoleExportCSVQuery {
    viewColumnsConfigJSON?: string | undefined;
    isTenant?: boolean | undefined;

    constructor(data?: IRoleExportCSVQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.viewColumnsConfigJSON = _data["viewColumnsConfigJSON"];
            this.isTenant = _data["isTenant"];
        }
    }

    static override fromJS(data: any): RoleExportCSVQuery {
        data = typeof data === 'object' ? data : {};
        let result = new RoleExportCSVQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viewColumnsConfigJSON"] = this.viewColumnsConfigJSON;
        data["isTenant"] = this.isTenant;
        super.toJSON(data);
        return data;
    }
}

export interface IRoleExportCSVQuery extends IPageListByDto {
    viewColumnsConfigJSON?: string | undefined;
    isTenant?: boolean | undefined;
}

export class RoleExportPDFQuery extends PageListByDto implements IRoleExportPDFQuery {
    viewColumnsConfigJSON?: string | undefined;
    isTenant?: boolean | undefined;

    constructor(data?: IRoleExportPDFQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.viewColumnsConfigJSON = _data["viewColumnsConfigJSON"];
            this.isTenant = _data["isTenant"];
        }
    }

    static override fromJS(data: any): RoleExportPDFQuery {
        data = typeof data === 'object' ? data : {};
        let result = new RoleExportPDFQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viewColumnsConfigJSON"] = this.viewColumnsConfigJSON;
        data["isTenant"] = this.isTenant;
        super.toJSON(data);
        return data;
    }
}

export interface IRoleExportPDFQuery extends IPageListByDto {
    viewColumnsConfigJSON?: string | undefined;
    isTenant?: boolean | undefined;
}

export class RoleResponse implements IRoleResponse {
    id!: number;
    tenantId?: number | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean | undefined;
    isDeleted?: boolean | undefined;

    constructor(data?: IRoleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): RoleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RoleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IRoleResponse {
    id: number;
    tenantId?: number | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean | undefined;
    isDeleted?: boolean | undefined;
}

export class RoleGetByIdQuery implements IRoleGetByIdQuery {
    id!: number;

    constructor(data?: IRoleGetByIdQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleGetByIdQuery {
        data = typeof data === 'object' ? data : {};
        let result = new RoleGetByIdQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IRoleGetByIdQuery {
    id: number;
}

export class RoleCreateCommand implements IRoleCreateCommand {
    id!: number;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive!: boolean;
    grantedPermissionNames?: string[] | undefined;
    isTenant!: boolean;

    constructor(data?: IRoleCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
            this.isTenant = _data["isTenant"];
        }
    }

    static fromJS(data: any): RoleCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RoleCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        data["isTenant"] = this.isTenant;
        return data;
    }
}

export interface IRoleCreateCommand {
    id: number;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive: boolean;
    grantedPermissionNames?: string[] | undefined;
    isTenant: boolean;
}

export class RoleUpdateCommand implements IRoleUpdateCommand {
    id!: number;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive!: boolean;
    isDeleted!: boolean;
    grantedPermissionNames?: string[] | undefined;
    isTenant!: boolean;

    constructor(data?: IRoleUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
            this.isTenant = _data["isTenant"];
        }
    }

    static fromJS(data: any): RoleUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RoleUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        data["isTenant"] = this.isTenant;
        return data;
    }
}

export interface IRoleUpdateCommand {
    id: number;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
    grantedPermissionNames?: string[] | undefined;
    isTenant: boolean;
}

export class RoleDeleteCommand implements IRoleDeleteCommand {
    id!: number;

    constructor(data?: IRoleDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IRoleDeleteCommand {
    id: number;
}

export class RoleForEditReponse implements IRoleForEditReponse {
    id!: number;
    tenantId?: number | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean | undefined;
    permissionList?: RolePermisoResponse[] | undefined;
    isTenant!: boolean;

    constructor(data?: IRoleForEditReponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["permissionList"])) {
                this.permissionList = [] as any;
                for (let item of _data["permissionList"])
                    this.permissionList!.push(RolePermisoResponse.fromJS(item));
            }
            this.isTenant = _data["isTenant"];
        }
    }

    static fromJS(data: any): RoleForEditReponse {
        data = typeof data === 'object' ? data : {};
        let result = new RoleForEditReponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.permissionList)) {
            data["permissionList"] = [];
            for (let item of this.permissionList)
                data["permissionList"].push(item.toJSON());
        }
        data["isTenant"] = this.isTenant;
        return data;
    }
}

export interface IRoleForEditReponse {
    id: number;
    tenantId?: number | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean | undefined;
    permissionList?: RolePermisoResponse[] | undefined;
    isTenant: boolean;
}

export class RolePermisoResponse implements IRolePermisoResponse {
    id!: number;
    name?: string | undefined;

    constructor(data?: IRolePermisoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RolePermisoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RolePermisoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IRolePermisoResponse {
    id: number;
    name?: string | undefined;
}

export class RoleGetForEditQuery implements IRoleGetForEditQuery {
    id!: number;

    constructor(data?: IRoleGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new RoleGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IRoleGetForEditQuery {
    id: number;
}

export class RoleForListActiveResponse implements IRoleForListActiveResponse {
    id!: number;
    name?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: IRoleForListActiveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): RoleForListActiveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RoleForListActiveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IRoleForListActiveResponse {
    id: number;
    name?: string | undefined;
    displayName?: string | undefined;
}

export class RoleGetForListActiveQuery implements IRoleGetForListActiveQuery {
    isTenant!: boolean;

    constructor(data?: IRoleGetForListActiveQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isTenant = _data["isTenant"];
        }
    }

    static fromJS(data: any): RoleGetForListActiveQuery {
        data = typeof data === 'object' ? data : {};
        let result = new RoleGetForListActiveQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isTenant"] = this.isTenant;
        return data;
    }
}

export interface IRoleGetForListActiveQuery {
    isTenant: boolean;
}

export class PagedResultDtoOfSessionForListResponse implements IPagedResultDtoOfSessionForListResponse {
    totalCount!: number;
    items?: SessionForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfSessionForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SessionForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSessionForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSessionForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfSessionForListResponse {
    totalCount: number;
    items?: SessionForListResponse[] | undefined;
}

export class SessionForListResponse implements ISessionForListResponse {
    id!: number;
    user!: number;
    userDesc?: string | undefined;
    userLogin?: string | undefined;
    creationDateTime?: moment.Moment | undefined;
    isActive!: boolean;
    isActiveDesc?: string | undefined;

    constructor(data?: ISessionForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"];
            this.userDesc = _data["userDesc"];
            this.userLogin = _data["userLogin"];
            this.creationDateTime = _data["creationDateTime"] ? moment(_data["creationDateTime"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
        }
    }

    static fromJS(data: any): SessionForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SessionForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user;
        data["userDesc"] = this.userDesc;
        data["userLogin"] = this.userLogin;
        data["creationDateTime"] = this.creationDateTime ? this.creationDateTime.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        return data;
    }
}

export interface ISessionForListResponse {
    id: number;
    user: number;
    userDesc?: string | undefined;
    userLogin?: string | undefined;
    creationDateTime?: moment.Moment | undefined;
    isActive: boolean;
    isActiveDesc?: string | undefined;
}

export class SessionGetListQuery extends PageListByDto implements ISessionGetListQuery {
    isActive?: boolean | undefined;

    constructor(data?: ISessionGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isActive = _data["isActive"];
        }
    }

    static override fromJS(data: any): SessionGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SessionGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        super.toJSON(data);
        return data;
    }
}

export interface ISessionGetListQuery extends IPageListByDto {
    isActive?: boolean | undefined;
}

export class SettingClientChangeCommand implements ISettingClientChangeCommand {
    id!: number;
    clientType?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: ISettingClientChangeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientType = _data["clientType"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SettingClientChangeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SettingClientChangeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientType"] = this.clientType;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface ISettingClientChangeCommand {
    id: number;
    clientType?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
}

export class TenantExportQuery extends PageListByDto implements ITenantExportQuery {
    viewColumnsConfigJSON?: string | undefined;

    constructor(data?: ITenantExportQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.viewColumnsConfigJSON = _data["viewColumnsConfigJSON"];
        }
    }

    static override fromJS(data: any): TenantExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TenantExportQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viewColumnsConfigJSON"] = this.viewColumnsConfigJSON;
        super.toJSON(data);
        return data;
    }
}

export interface ITenantExportQuery extends IPageListByDto {
    viewColumnsConfigJSON?: string | undefined;
}

export class TenantExportCSVQuery extends PageListByDto implements ITenantExportCSVQuery {
    viewColumnsConfigJSON?: string | undefined;

    constructor(data?: ITenantExportCSVQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.viewColumnsConfigJSON = _data["viewColumnsConfigJSON"];
        }
    }

    static override fromJS(data: any): TenantExportCSVQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TenantExportCSVQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viewColumnsConfigJSON"] = this.viewColumnsConfigJSON;
        super.toJSON(data);
        return data;
    }
}

export interface ITenantExportCSVQuery extends IPageListByDto {
    viewColumnsConfigJSON?: string | undefined;
}

export class TenantExportPDFQuery extends PageListByDto implements ITenantExportPDFQuery {
    viewColumnsConfigJSON?: string | undefined;

    constructor(data?: ITenantExportPDFQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.viewColumnsConfigJSON = _data["viewColumnsConfigJSON"];
        }
    }

    static override fromJS(data: any): TenantExportPDFQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TenantExportPDFQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viewColumnsConfigJSON"] = this.viewColumnsConfigJSON;
        super.toJSON(data);
        return data;
    }
}

export interface ITenantExportPDFQuery extends IPageListByDto {
    viewColumnsConfigJSON?: string | undefined;
}

export class TenantResponse implements ITenantResponse {
    id!: number;
    tenancyName?: string | undefined;
    name?: string | undefined;
    creationTime?: moment.Moment | undefined;
    isActive!: boolean;
    isDeleted!: boolean;

    constructor(data?: ITenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): TenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ITenantResponse {
    id: number;
    tenancyName?: string | undefined;
    name?: string | undefined;
    creationTime?: moment.Moment | undefined;
    isActive: boolean;
    isDeleted: boolean;
}

export class TenantCreateCommand implements ITenantCreateCommand {
    tenancyName?: string | undefined;
    tenantName?: string | undefined;
    password?: string | undefined;
    passwordConfirm?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;

    constructor(data?: ITenantCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.tenantName = _data["tenantName"];
            this.password = _data["password"];
            this.passwordConfirm = _data["passwordConfirm"];
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            this.secondLastName = _data["secondLastName"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): TenantCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TenantCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["tenantName"] = this.tenantName;
        data["password"] = this.password;
        data["passwordConfirm"] = this.passwordConfirm;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["secondLastName"] = this.secondLastName;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ITenantCreateCommand {
    tenancyName?: string | undefined;
    tenantName?: string | undefined;
    password?: string | undefined;
    passwordConfirm?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
}

export class UpdateTenantCommand implements IUpdateTenantCommand {
    id!: number;
    tenancyName?: string | undefined;
    name?: string | undefined;
    isActive!: boolean;

    constructor(data?: IUpdateTenantCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateTenantCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateTenantCommand {
    id: number;
    tenancyName?: string | undefined;
    name?: string | undefined;
    isActive: boolean;
}

export class PagedResultDtoOfTenantListResponse implements IPagedResultDtoOfTenantListResponse {
    totalCount!: number;
    items?: TenantListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfTenantListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTenantListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfTenantListResponse {
    totalCount: number;
    items?: TenantListResponse[] | undefined;
}

export class TenantListResponse implements ITenantListResponse {
    id!: number;
    tenancyName?: string | undefined;
    name?: string | undefined;
    largeName?: string | undefined;
    creationTime?: moment.Moment | undefined;
    isActive!: boolean;
    isActiveDesc?: string | undefined;

    constructor(data?: ITenantListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.largeName = _data["largeName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
        }
    }

    static fromJS(data: any): TenantListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["largeName"] = this.largeName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        return data;
    }
}

export interface ITenantListResponse {
    id: number;
    tenancyName?: string | undefined;
    name?: string | undefined;
    largeName?: string | undefined;
    creationTime?: moment.Moment | undefined;
    isActive: boolean;
    isActiveDesc?: string | undefined;
}

export class TenantGetListQuery extends PageListByDto implements ITenantGetListQuery {

    constructor(data?: ITenantGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TenantGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TenantGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITenantGetListQuery extends IPageListByDto {
}

export class TenantGetListCompleterQuery implements ITenantGetListCompleterQuery {
    filter?: string | undefined;

    constructor(data?: ITenantGetListCompleterQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): TenantGetListCompleterQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TenantGetListCompleterQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data;
    }
}

export interface ITenantGetListCompleterQuery {
    filter?: string | undefined;
}

export class TenantDeleteCommand implements ITenantDeleteCommand {
    id!: number;

    constructor(data?: ITenantDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantDeleteCommand {
    id: number;
}

export class TenantSettingsForEditResponse implements ITenantSettingsForEditResponse {
    passwordUseDefaultConfiguration!: boolean;
    passwordComplexity?: TenantSettingsPasswordComplexityResponse | undefined;
    passwordComplexityDefault?: TenantSettingsPasswordComplexityResponse | undefined;
    enablePasswordReuseValidation!: boolean;
    enablePasswordPeriod!: boolean;
    passwordValidDays!: number;
    enableUserBlocking!: boolean;
    failedAttemptsToBlockUser!: number;
    preventConcurrentSesions!: boolean;
    userBlockingDuration!: number;
    sessionTime!: number;
    mailSMTPSenderDefault?: string | undefined;
    mailSMTPSenderDefaultDisplayName?: string | undefined;
    mailSMTPHost?: string | undefined;
    mailSMTPPort?: number | undefined;
    mailEnableSSL!: boolean;
    mailUseDefaultCredentials!: boolean;
    mailDomainName?: string | undefined;
    mailUserName?: string | undefined;
    mailUserPassword?: string | undefined;
    emailSendMethod!: EmailSendMethod;
    grpcEmail?: GrpcEmailResponse | undefined;

    constructor(data?: ITenantSettingsForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.passwordUseDefaultConfiguration = _data["passwordUseDefaultConfiguration"];
            this.passwordComplexity = _data["passwordComplexity"] ? TenantSettingsPasswordComplexityResponse.fromJS(_data["passwordComplexity"]) : <any>undefined;
            this.passwordComplexityDefault = _data["passwordComplexityDefault"] ? TenantSettingsPasswordComplexityResponse.fromJS(_data["passwordComplexityDefault"]) : <any>undefined;
            this.enablePasswordReuseValidation = _data["enablePasswordReuseValidation"];
            this.enablePasswordPeriod = _data["enablePasswordPeriod"];
            this.passwordValidDays = _data["passwordValidDays"];
            this.enableUserBlocking = _data["enableUserBlocking"];
            this.failedAttemptsToBlockUser = _data["failedAttemptsToBlockUser"];
            this.preventConcurrentSesions = _data["preventConcurrentSesions"];
            this.userBlockingDuration = _data["userBlockingDuration"];
            this.sessionTime = _data["sessionTime"];
            this.mailSMTPSenderDefault = _data["mailSMTPSenderDefault"];
            this.mailSMTPSenderDefaultDisplayName = _data["mailSMTPSenderDefaultDisplayName"];
            this.mailSMTPHost = _data["mailSMTPHost"];
            this.mailSMTPPort = _data["mailSMTPPort"];
            this.mailEnableSSL = _data["mailEnableSSL"];
            this.mailUseDefaultCredentials = _data["mailUseDefaultCredentials"];
            this.mailDomainName = _data["mailDomainName"];
            this.mailUserName = _data["mailUserName"];
            this.mailUserPassword = _data["mailUserPassword"];
            this.emailSendMethod = _data["emailSendMethod"];
            this.grpcEmail = _data["grpcEmail"] ? GrpcEmailResponse.fromJS(_data["grpcEmail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantSettingsForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passwordUseDefaultConfiguration"] = this.passwordUseDefaultConfiguration;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["passwordComplexityDefault"] = this.passwordComplexityDefault ? this.passwordComplexityDefault.toJSON() : <any>undefined;
        data["enablePasswordReuseValidation"] = this.enablePasswordReuseValidation;
        data["enablePasswordPeriod"] = this.enablePasswordPeriod;
        data["passwordValidDays"] = this.passwordValidDays;
        data["enableUserBlocking"] = this.enableUserBlocking;
        data["failedAttemptsToBlockUser"] = this.failedAttemptsToBlockUser;
        data["preventConcurrentSesions"] = this.preventConcurrentSesions;
        data["userBlockingDuration"] = this.userBlockingDuration;
        data["sessionTime"] = this.sessionTime;
        data["mailSMTPSenderDefault"] = this.mailSMTPSenderDefault;
        data["mailSMTPSenderDefaultDisplayName"] = this.mailSMTPSenderDefaultDisplayName;
        data["mailSMTPHost"] = this.mailSMTPHost;
        data["mailSMTPPort"] = this.mailSMTPPort;
        data["mailEnableSSL"] = this.mailEnableSSL;
        data["mailUseDefaultCredentials"] = this.mailUseDefaultCredentials;
        data["mailDomainName"] = this.mailDomainName;
        data["mailUserName"] = this.mailUserName;
        data["mailUserPassword"] = this.mailUserPassword;
        data["emailSendMethod"] = this.emailSendMethod;
        data["grpcEmail"] = this.grpcEmail ? this.grpcEmail.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITenantSettingsForEditResponse {
    passwordUseDefaultConfiguration: boolean;
    passwordComplexity?: TenantSettingsPasswordComplexityResponse | undefined;
    passwordComplexityDefault?: TenantSettingsPasswordComplexityResponse | undefined;
    enablePasswordReuseValidation: boolean;
    enablePasswordPeriod: boolean;
    passwordValidDays: number;
    enableUserBlocking: boolean;
    failedAttemptsToBlockUser: number;
    preventConcurrentSesions: boolean;
    userBlockingDuration: number;
    sessionTime: number;
    mailSMTPSenderDefault?: string | undefined;
    mailSMTPSenderDefaultDisplayName?: string | undefined;
    mailSMTPHost?: string | undefined;
    mailSMTPPort?: number | undefined;
    mailEnableSSL: boolean;
    mailUseDefaultCredentials: boolean;
    mailDomainName?: string | undefined;
    mailUserName?: string | undefined;
    mailUserPassword?: string | undefined;
    emailSendMethod: EmailSendMethod;
    grpcEmail?: GrpcEmailResponse | undefined;
}

export class TenantSettingsPasswordComplexityResponse implements ITenantSettingsPasswordComplexityResponse {
    minimumLength!: number;
    maximumLength!: number;
    useNumbers!: boolean;
    useUppercase!: boolean;
    useLowercase!: boolean;
    usePunctuationSymbols!: boolean;

    constructor(data?: ITenantSettingsPasswordComplexityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minimumLength = _data["minimumLength"];
            this.maximumLength = _data["maximumLength"];
            this.useNumbers = _data["useNumbers"];
            this.useUppercase = _data["useUppercase"];
            this.useLowercase = _data["useLowercase"];
            this.usePunctuationSymbols = _data["usePunctuationSymbols"];
        }
    }

    static fromJS(data: any): TenantSettingsPasswordComplexityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsPasswordComplexityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumLength"] = this.minimumLength;
        data["maximumLength"] = this.maximumLength;
        data["useNumbers"] = this.useNumbers;
        data["useUppercase"] = this.useUppercase;
        data["useLowercase"] = this.useLowercase;
        data["usePunctuationSymbols"] = this.usePunctuationSymbols;
        return data;
    }
}

export interface ITenantSettingsPasswordComplexityResponse {
    minimumLength: number;
    maximumLength: number;
    useNumbers: boolean;
    useUppercase: boolean;
    useLowercase: boolean;
    usePunctuationSymbols: boolean;
}

export class GrpcEmailResponse implements IGrpcEmailResponse {
    sendConfiguration!: boolean;
    tenancyName?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;

    constructor(data?: IGrpcEmailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sendConfiguration = _data["sendConfiguration"];
            this.tenancyName = _data["tenancyName"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): GrpcEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GrpcEmailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sendConfiguration"] = this.sendConfiguration;
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface IGrpcEmailResponse {
    sendConfiguration: boolean;
    tenancyName?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
}

export class TenantSettingsGetForEditQuery implements ITenantSettingsGetForEditQuery {

    constructor(data?: ITenantSettingsGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): TenantSettingsGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ITenantSettingsGetForEditQuery {
}

export class TenantSettingsUpdateCommand implements ITenantSettingsUpdateCommand {
    passwordUseDefaultConfiguration!: boolean;
    passwordComplexity?: TenantSettingsPasswordComplexityCommand | undefined;
    enablePasswordReuseValidation!: boolean;
    enablePasswordPeriod!: boolean;
    passwordValidDays!: number;
    enableUserBlocking!: boolean;
    failedAttemptsToBlockUser!: number;
    userBlockingDuration!: number;
    sessionTime!: number;
    preventConcurrentSesions!: boolean;
    mailSMTPSenderDefault?: string | undefined;
    mailSMTPSenderDefaultDisplayName?: string | undefined;
    mailSMTPHost?: string | undefined;
    mailSMTPPort?: number | undefined;
    mailEnableSSL!: boolean;
    mailUseDefaultCredentials!: boolean;
    mailDomainName?: string | undefined;
    mailUserName?: string | undefined;
    mailUserPassword?: string | undefined;
    grpcEmail?: GrpcEmailCommand | undefined;

    constructor(data?: ITenantSettingsUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.passwordUseDefaultConfiguration = _data["passwordUseDefaultConfiguration"];
            this.passwordComplexity = _data["passwordComplexity"] ? TenantSettingsPasswordComplexityCommand.fromJS(_data["passwordComplexity"]) : <any>undefined;
            this.enablePasswordReuseValidation = _data["enablePasswordReuseValidation"];
            this.enablePasswordPeriod = _data["enablePasswordPeriod"];
            this.passwordValidDays = _data["passwordValidDays"];
            this.enableUserBlocking = _data["enableUserBlocking"];
            this.failedAttemptsToBlockUser = _data["failedAttemptsToBlockUser"];
            this.userBlockingDuration = _data["userBlockingDuration"];
            this.sessionTime = _data["sessionTime"];
            this.preventConcurrentSesions = _data["preventConcurrentSesions"];
            this.mailSMTPSenderDefault = _data["mailSMTPSenderDefault"];
            this.mailSMTPSenderDefaultDisplayName = _data["mailSMTPSenderDefaultDisplayName"];
            this.mailSMTPHost = _data["mailSMTPHost"];
            this.mailSMTPPort = _data["mailSMTPPort"];
            this.mailEnableSSL = _data["mailEnableSSL"];
            this.mailUseDefaultCredentials = _data["mailUseDefaultCredentials"];
            this.mailDomainName = _data["mailDomainName"];
            this.mailUserName = _data["mailUserName"];
            this.mailUserPassword = _data["mailUserPassword"];
            this.grpcEmail = _data["grpcEmail"] ? GrpcEmailCommand.fromJS(_data["grpcEmail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantSettingsUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passwordUseDefaultConfiguration"] = this.passwordUseDefaultConfiguration;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["enablePasswordReuseValidation"] = this.enablePasswordReuseValidation;
        data["enablePasswordPeriod"] = this.enablePasswordPeriod;
        data["passwordValidDays"] = this.passwordValidDays;
        data["enableUserBlocking"] = this.enableUserBlocking;
        data["failedAttemptsToBlockUser"] = this.failedAttemptsToBlockUser;
        data["userBlockingDuration"] = this.userBlockingDuration;
        data["sessionTime"] = this.sessionTime;
        data["preventConcurrentSesions"] = this.preventConcurrentSesions;
        data["mailSMTPSenderDefault"] = this.mailSMTPSenderDefault;
        data["mailSMTPSenderDefaultDisplayName"] = this.mailSMTPSenderDefaultDisplayName;
        data["mailSMTPHost"] = this.mailSMTPHost;
        data["mailSMTPPort"] = this.mailSMTPPort;
        data["mailEnableSSL"] = this.mailEnableSSL;
        data["mailUseDefaultCredentials"] = this.mailUseDefaultCredentials;
        data["mailDomainName"] = this.mailDomainName;
        data["mailUserName"] = this.mailUserName;
        data["mailUserPassword"] = this.mailUserPassword;
        data["grpcEmail"] = this.grpcEmail ? this.grpcEmail.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITenantSettingsUpdateCommand {
    passwordUseDefaultConfiguration: boolean;
    passwordComplexity?: TenantSettingsPasswordComplexityCommand | undefined;
    enablePasswordReuseValidation: boolean;
    enablePasswordPeriod: boolean;
    passwordValidDays: number;
    enableUserBlocking: boolean;
    failedAttemptsToBlockUser: number;
    userBlockingDuration: number;
    sessionTime: number;
    preventConcurrentSesions: boolean;
    mailSMTPSenderDefault?: string | undefined;
    mailSMTPSenderDefaultDisplayName?: string | undefined;
    mailSMTPHost?: string | undefined;
    mailSMTPPort?: number | undefined;
    mailEnableSSL: boolean;
    mailUseDefaultCredentials: boolean;
    mailDomainName?: string | undefined;
    mailUserName?: string | undefined;
    mailUserPassword?: string | undefined;
    grpcEmail?: GrpcEmailCommand | undefined;
}

export class TenantSettingsPasswordComplexityCommand implements ITenantSettingsPasswordComplexityCommand {
    minimumLength!: number;
    maximumLength!: number;
    useNumbers!: boolean;
    useUppercase!: boolean;
    useLowercase!: boolean;
    usePunctuationSymbols!: boolean;

    constructor(data?: ITenantSettingsPasswordComplexityCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minimumLength = _data["minimumLength"];
            this.maximumLength = _data["maximumLength"];
            this.useNumbers = _data["useNumbers"];
            this.useUppercase = _data["useUppercase"];
            this.useLowercase = _data["useLowercase"];
            this.usePunctuationSymbols = _data["usePunctuationSymbols"];
        }
    }

    static fromJS(data: any): TenantSettingsPasswordComplexityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsPasswordComplexityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumLength"] = this.minimumLength;
        data["maximumLength"] = this.maximumLength;
        data["useNumbers"] = this.useNumbers;
        data["useUppercase"] = this.useUppercase;
        data["useLowercase"] = this.useLowercase;
        data["usePunctuationSymbols"] = this.usePunctuationSymbols;
        return data;
    }
}

export interface ITenantSettingsPasswordComplexityCommand {
    minimumLength: number;
    maximumLength: number;
    useNumbers: boolean;
    useUppercase: boolean;
    useLowercase: boolean;
    usePunctuationSymbols: boolean;
}

export class GrpcEmailCommand implements IGrpcEmailCommand {
    tenancyName?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;

    constructor(data?: IGrpcEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): GrpcEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GrpcEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface IGrpcEmailCommand {
    tenancyName?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
}

export class TenantSettingsSendTestEmailCommand implements ITenantSettingsSendTestEmailCommand {
    emailAddress?: string | undefined;

    constructor(data?: ITenantSettingsSendTestEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): TenantSettingsSendTestEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsSendTestEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ITenantSettingsSendTestEmailCommand {
    emailAddress?: string | undefined;
}

export class UserConfigurationResponse implements IUserConfigurationResponse {
    localization?: UserLocalizationConfigResponse | undefined;
    permission?: UserPermissionConfigResponse | undefined;
    settingsClient?: { [key: string]: string; } | undefined;
    multiTenancyConfig?: MultiTenancyConfigResponse | undefined;
    passwordComplexity?: PasswordComplexityDto | undefined;
    sessionTime!: number;

    constructor(data?: IUserConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localization = _data["localization"] ? UserLocalizationConfigResponse.fromJS(_data["localization"]) : <any>undefined;
            this.permission = _data["permission"] ? UserPermissionConfigResponse.fromJS(_data["permission"]) : <any>undefined;
            if (_data["settingsClient"]) {
                this.settingsClient = {} as any;
                for (let key in _data["settingsClient"]) {
                    if (_data["settingsClient"].hasOwnProperty(key))
                        (<any>this.settingsClient)![key] = _data["settingsClient"][key];
                }
            }
            this.multiTenancyConfig = _data["multiTenancyConfig"] ? MultiTenancyConfigResponse.fromJS(_data["multiTenancyConfig"]) : <any>undefined;
            this.passwordComplexity = _data["passwordComplexity"] ? PasswordComplexityDto.fromJS(_data["passwordComplexity"]) : <any>undefined;
            this.sessionTime = _data["sessionTime"];
        }
    }

    static fromJS(data: any): UserConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localization"] = this.localization ? this.localization.toJSON() : <any>undefined;
        data["permission"] = this.permission ? this.permission.toJSON() : <any>undefined;
        if (this.settingsClient) {
            data["settingsClient"] = {};
            for (let key in this.settingsClient) {
                if (this.settingsClient.hasOwnProperty(key))
                    (<any>data["settingsClient"])[key] = (<any>this.settingsClient)[key];
            }
        }
        data["multiTenancyConfig"] = this.multiTenancyConfig ? this.multiTenancyConfig.toJSON() : <any>undefined;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["sessionTime"] = this.sessionTime;
        return data;
    }
}

export interface IUserConfigurationResponse {
    localization?: UserLocalizationConfigResponse | undefined;
    permission?: UserPermissionConfigResponse | undefined;
    settingsClient?: { [key: string]: string; } | undefined;
    multiTenancyConfig?: MultiTenancyConfigResponse | undefined;
    passwordComplexity?: PasswordComplexityDto | undefined;
    sessionTime: number;
}

export class UserLocalizationConfigResponse implements IUserLocalizationConfigResponse {
    defaultLanguage?: LanguageInfoResponse | undefined;
    currentLanguage?: LanguageInfoResponse | undefined;
    values?: { [key: string]: string; } | undefined;

    constructor(data?: IUserLocalizationConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultLanguage = _data["defaultLanguage"] ? LanguageInfoResponse.fromJS(_data["defaultLanguage"]) : <any>undefined;
            this.currentLanguage = _data["currentLanguage"] ? LanguageInfoResponse.fromJS(_data["currentLanguage"]) : <any>undefined;
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)![key] = _data["values"][key];
                }
            }
        }
    }

    static fromJS(data: any): UserLocalizationConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserLocalizationConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguage"] = this.defaultLanguage ? this.defaultLanguage.toJSON() : <any>undefined;
        data["currentLanguage"] = this.currentLanguage ? this.currentLanguage.toJSON() : <any>undefined;
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = (<any>this.values)[key];
            }
        }
        return data;
    }
}

export interface IUserLocalizationConfigResponse {
    defaultLanguage?: LanguageInfoResponse | undefined;
    currentLanguage?: LanguageInfoResponse | undefined;
    values?: { [key: string]: string; } | undefined;
}

export class LanguageInfoResponse implements ILanguageInfoResponse {
    name?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: ILanguageInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): LanguageInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ILanguageInfoResponse {
    name?: string | undefined;
    displayName?: string | undefined;
}

export class UserPermissionConfigResponse implements IUserPermissionConfigResponse {
    values?: { [key: string]: boolean; } | undefined;

    constructor(data?: IUserPermissionConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)![key] = _data["values"][key];
                }
            }
        }
    }

    static fromJS(data: any): UserPermissionConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = (<any>this.values)[key];
            }
        }
        return data;
    }
}

export interface IUserPermissionConfigResponse {
    values?: { [key: string]: boolean; } | undefined;
}

export class MultiTenancyConfigResponse implements IMultiTenancyConfigResponse {
    enabled!: boolean;
    tenancyNameDefault?: string | undefined;

    constructor(data?: IMultiTenancyConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.tenancyNameDefault = _data["tenancyNameDefault"];
        }
    }

    static fromJS(data: any): MultiTenancyConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MultiTenancyConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["tenancyNameDefault"] = this.tenancyNameDefault;
        return data;
    }
}

export interface IMultiTenancyConfigResponse {
    enabled: boolean;
    tenancyNameDefault?: string | undefined;
}

export class PasswordComplexityDto implements IPasswordComplexityDto {
    minimumLength!: number;
    maximumLength!: number;
    useNumbers!: boolean;
    useUppercase!: boolean;
    useLowercase!: boolean;
    usePunctuationSymbols!: boolean;

    constructor(data?: IPasswordComplexityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minimumLength = _data["minimumLength"];
            this.maximumLength = _data["maximumLength"];
            this.useNumbers = _data["useNumbers"];
            this.useUppercase = _data["useUppercase"];
            this.useLowercase = _data["useLowercase"];
            this.usePunctuationSymbols = _data["usePunctuationSymbols"];
        }
    }

    static fromJS(data: any): PasswordComplexityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordComplexityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumLength"] = this.minimumLength;
        data["maximumLength"] = this.maximumLength;
        data["useNumbers"] = this.useNumbers;
        data["useUppercase"] = this.useUppercase;
        data["useLowercase"] = this.useLowercase;
        data["usePunctuationSymbols"] = this.usePunctuationSymbols;
        return data;
    }
}

export interface IPasswordComplexityDto {
    minimumLength: number;
    maximumLength: number;
    useNumbers: boolean;
    useUppercase: boolean;
    useLowercase: boolean;
    usePunctuationSymbols: boolean;
}

export class UserConfigurationGetAllQuery implements IUserConfigurationGetAllQuery {
    clientType?: string | undefined;

    constructor(data?: IUserConfigurationGetAllQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientType = _data["clientType"];
        }
    }

    static fromJS(data: any): UserConfigurationGetAllQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserConfigurationGetAllQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientType"] = this.clientType;
        return data;
    }
}

export interface IUserConfigurationGetAllQuery {
    clientType?: string | undefined;
}

export class PagedResultDtoOfUserListResponse implements IPagedResultDtoOfUserListResponse {
    totalCount!: number;
    items?: UserListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfUserListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserListResponse {
    totalCount: number;
    items?: UserListResponse[] | undefined;
}

export class UserListResponse implements IUserListResponse {
    id!: number;
    login?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
    isEmailConfirmed?: boolean | undefined;
    userLocked?: boolean | undefined;
    userLockedDesc?: string | undefined;
    isActive?: boolean | undefined;
    isActiveDesc?: string | undefined;
    creationTime?: moment.Moment | undefined;
    fullName?: string | undefined;

    constructor(data?: IUserListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.login = _data["login"];
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            this.secondLastName = _data["secondLastName"];
            this.emailAddress = _data["emailAddress"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.userLocked = _data["userLocked"];
            this.userLockedDesc = _data["userLockedDesc"];
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): UserListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["login"] = this.login;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["secondLastName"] = this.secondLastName;
        data["emailAddress"] = this.emailAddress;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["userLocked"] = this.userLocked;
        data["userLockedDesc"] = this.userLockedDesc;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IUserListResponse {
    id: number;
    login?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
    isEmailConfirmed?: boolean | undefined;
    userLocked?: boolean | undefined;
    userLockedDesc?: string | undefined;
    isActive?: boolean | undefined;
    isActiveDesc?: string | undefined;
    creationTime?: moment.Moment | undefined;
    fullName?: string | undefined;
}

export class UserGetListQuery extends PageListByDto implements IUserGetListQuery {
    tenant?: number | undefined;
    isTenant?: boolean | undefined;

    constructor(data?: IUserGetListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tenant = _data["tenant"];
            this.isTenant = _data["isTenant"];
        }
    }

    static override fromJS(data: any): UserGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserGetListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenant"] = this.tenant;
        data["isTenant"] = this.isTenant;
        super.toJSON(data);
        return data;
    }
}

export interface IUserGetListQuery extends IPageListByDto {
    tenant?: number | undefined;
    isTenant?: boolean | undefined;
}

export class UserExportQuery extends PageListByDto implements IUserExportQuery {
    tenant?: number | undefined;
    viewColumnsConfigJSON?: string | undefined;
    isTenant?: boolean | undefined;

    constructor(data?: IUserExportQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tenant = _data["tenant"];
            this.viewColumnsConfigJSON = _data["viewColumnsConfigJSON"];
            this.isTenant = _data["isTenant"];
        }
    }

    static override fromJS(data: any): UserExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserExportQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenant"] = this.tenant;
        data["viewColumnsConfigJSON"] = this.viewColumnsConfigJSON;
        data["isTenant"] = this.isTenant;
        super.toJSON(data);
        return data;
    }
}

export interface IUserExportQuery extends IPageListByDto {
    tenant?: number | undefined;
    viewColumnsConfigJSON?: string | undefined;
    isTenant?: boolean | undefined;
}

export class UserExportCSVQuery extends PageListByDto implements IUserExportCSVQuery {
    tenant?: number | undefined;
    viewColumnsConfigJSON?: string | undefined;
    isTenant?: boolean | undefined;

    constructor(data?: IUserExportCSVQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tenant = _data["tenant"];
            this.viewColumnsConfigJSON = _data["viewColumnsConfigJSON"];
            this.isTenant = _data["isTenant"];
        }
    }

    static override fromJS(data: any): UserExportCSVQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserExportCSVQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenant"] = this.tenant;
        data["viewColumnsConfigJSON"] = this.viewColumnsConfigJSON;
        data["isTenant"] = this.isTenant;
        super.toJSON(data);
        return data;
    }
}

export interface IUserExportCSVQuery extends IPageListByDto {
    tenant?: number | undefined;
    viewColumnsConfigJSON?: string | undefined;
    isTenant?: boolean | undefined;
}

export class UserExportPDFQuery extends PageListByDto implements IUserExportPDFQuery {
    tenant?: number | undefined;
    viewColumnsConfigJSON?: string | undefined;
    isTenant?: boolean | undefined;

    constructor(data?: IUserExportPDFQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tenant = _data["tenant"];
            this.viewColumnsConfigJSON = _data["viewColumnsConfigJSON"];
            this.isTenant = _data["isTenant"];
        }
    }

    static override fromJS(data: any): UserExportPDFQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserExportPDFQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenant"] = this.tenant;
        data["viewColumnsConfigJSON"] = this.viewColumnsConfigJSON;
        data["isTenant"] = this.isTenant;
        super.toJSON(data);
        return data;
    }
}

export interface IUserExportPDFQuery extends IPageListByDto {
    tenant?: number | undefined;
    viewColumnsConfigJSON?: string | undefined;
    isTenant?: boolean | undefined;
}

export class UserCreateCommand implements IUserCreateCommand {
    userName?: string | undefined;
    password?: string | undefined;
    passwordRepeat?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    isActive?: boolean | undefined;
    setRandomPassword?: boolean | undefined;
    shouldChangePasswordOnNextLogin?: boolean | undefined;
    assignedRoleNames?: string[] | undefined;
    isTenant!: boolean;
    tenantsList?: TenantDto[] | undefined;
    medicoId?: number | undefined;
    delegationsInfo?: UserDelegacionDto | undefined;

    constructor(data?: IUserCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.passwordRepeat = _data["passwordRepeat"];
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            this.secondLastName = _data["secondLastName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isActive = _data["isActive"];
            this.setRandomPassword = _data["setRandomPassword"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            if (Array.isArray(_data["assignedRoleNames"])) {
                this.assignedRoleNames = [] as any;
                for (let item of _data["assignedRoleNames"])
                    this.assignedRoleNames!.push(item);
            }
            this.isTenant = _data["isTenant"];
            if (Array.isArray(_data["tenantsList"])) {
                this.tenantsList = [] as any;
                for (let item of _data["tenantsList"])
                    this.tenantsList!.push(TenantDto.fromJS(item));
            }
            this.medicoId = _data["medicoId"];
            this.delegationsInfo = _data["delegationsInfo"] ? UserDelegacionDto.fromJS(_data["delegationsInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["passwordRepeat"] = this.passwordRepeat;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["secondLastName"] = this.secondLastName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isActive"] = this.isActive;
        data["setRandomPassword"] = this.setRandomPassword;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        if (Array.isArray(this.assignedRoleNames)) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        data["isTenant"] = this.isTenant;
        if (Array.isArray(this.tenantsList)) {
            data["tenantsList"] = [];
            for (let item of this.tenantsList)
                data["tenantsList"].push(item.toJSON());
        }
        data["medicoId"] = this.medicoId;
        data["delegationsInfo"] = this.delegationsInfo ? this.delegationsInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserCreateCommand {
    userName?: string | undefined;
    password?: string | undefined;
    passwordRepeat?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    isActive?: boolean | undefined;
    setRandomPassword?: boolean | undefined;
    shouldChangePasswordOnNextLogin?: boolean | undefined;
    assignedRoleNames?: string[] | undefined;
    isTenant: boolean;
    tenantsList?: TenantDto[] | undefined;
    medicoId?: number | undefined;
    delegationsInfo?: UserDelegacionDto | undefined;
}

export class TenantDto implements ITenantDto {
    id!: number;
    tenancyName?: string | undefined;
    name?: string | undefined;
    largeName?: string | undefined;
    creationTime?: moment.Moment | undefined;
    isActive!: boolean;
    isActiveDesc?: string | undefined;
    isDeleted!: boolean;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.largeName = _data["largeName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["largeName"] = this.largeName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ITenantDto {
    id: number;
    tenancyName?: string | undefined;
    name?: string | undefined;
    largeName?: string | undefined;
    creationTime?: moment.Moment | undefined;
    isActive: boolean;
    isActiveDesc?: string | undefined;
    isDeleted: boolean;
}

export class UserDelegacionDto implements IUserDelegacionDto {
    id!: number;
    userId!: number;
    restringirDelegaciones!: boolean;
    delegacionesPermitidasList?: UserDelegacionDetalleDto[] | undefined;

    constructor(data?: IUserDelegacionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.restringirDelegaciones = _data["restringirDelegaciones"];
            if (Array.isArray(_data["delegacionesPermitidasList"])) {
                this.delegacionesPermitidasList = [] as any;
                for (let item of _data["delegacionesPermitidasList"])
                    this.delegacionesPermitidasList!.push(UserDelegacionDetalleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDelegacionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDelegacionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["restringirDelegaciones"] = this.restringirDelegaciones;
        if (Array.isArray(this.delegacionesPermitidasList)) {
            data["delegacionesPermitidasList"] = [];
            for (let item of this.delegacionesPermitidasList)
                data["delegacionesPermitidasList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserDelegacionDto {
    id: number;
    userId: number;
    restringirDelegaciones: boolean;
    delegacionesPermitidasList?: UserDelegacionDetalleDto[] | undefined;
}

export class UserDelegacionDetalleDto implements IUserDelegacionDetalleDto {
    id!: number;
    userDelegacionId!: number;
    delegacionId!: number;
    delegacionDesc?: string | undefined;

    constructor(data?: IUserDelegacionDetalleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userDelegacionId = _data["userDelegacionId"];
            this.delegacionId = _data["delegacionId"];
            this.delegacionDesc = _data["delegacionDesc"];
        }
    }

    static fromJS(data: any): UserDelegacionDetalleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDelegacionDetalleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userDelegacionId"] = this.userDelegacionId;
        data["delegacionId"] = this.delegacionId;
        data["delegacionDesc"] = this.delegacionDesc;
        return data;
    }
}

export interface IUserDelegacionDetalleDto {
    id: number;
    userDelegacionId: number;
    delegacionId: number;
    delegacionDesc?: string | undefined;
}

export class UserUpdateCommand implements IUserUpdateCommand {
    id!: number;
    userName?: string | undefined;
    password?: string | undefined;
    passwordRepeat?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    isActive?: boolean | undefined;
    setRandomPassword?: boolean | undefined;
    shouldChangePasswordOnNextLogin?: boolean | undefined;
    assignedRoleNames?: string[] | undefined;
    isTenant!: boolean;
    tenantsList?: TenantDto[] | undefined;
    medicoId?: number | undefined;
    delegationsInfo?: UserDelegacionDto | undefined;

    constructor(data?: IUserUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.passwordRepeat = _data["passwordRepeat"];
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            this.secondLastName = _data["secondLastName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isActive = _data["isActive"];
            this.setRandomPassword = _data["setRandomPassword"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            if (Array.isArray(_data["assignedRoleNames"])) {
                this.assignedRoleNames = [] as any;
                for (let item of _data["assignedRoleNames"])
                    this.assignedRoleNames!.push(item);
            }
            this.isTenant = _data["isTenant"];
            if (Array.isArray(_data["tenantsList"])) {
                this.tenantsList = [] as any;
                for (let item of _data["tenantsList"])
                    this.tenantsList!.push(TenantDto.fromJS(item));
            }
            this.medicoId = _data["medicoId"];
            this.delegationsInfo = _data["delegationsInfo"] ? UserDelegacionDto.fromJS(_data["delegationsInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["passwordRepeat"] = this.passwordRepeat;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["secondLastName"] = this.secondLastName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isActive"] = this.isActive;
        data["setRandomPassword"] = this.setRandomPassword;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        if (Array.isArray(this.assignedRoleNames)) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        data["isTenant"] = this.isTenant;
        if (Array.isArray(this.tenantsList)) {
            data["tenantsList"] = [];
            for (let item of this.tenantsList)
                data["tenantsList"].push(item.toJSON());
        }
        data["medicoId"] = this.medicoId;
        data["delegationsInfo"] = this.delegationsInfo ? this.delegationsInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserUpdateCommand {
    id: number;
    userName?: string | undefined;
    password?: string | undefined;
    passwordRepeat?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    isActive?: boolean | undefined;
    setRandomPassword?: boolean | undefined;
    shouldChangePasswordOnNextLogin?: boolean | undefined;
    assignedRoleNames?: string[] | undefined;
    isTenant: boolean;
    tenantsList?: TenantDto[] | undefined;
    medicoId?: number | undefined;
    delegationsInfo?: UserDelegacionDto | undefined;
}

export class UserForEditResponse implements IUserForEditResponse {
    id!: number;
    userName?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    medicoId?: number | undefined;
    nombreMedico?: string | undefined;
    isActive?: boolean | undefined;
    isTenant!: boolean;
    setRandomPassword?: boolean | undefined;
    shouldChangePasswordOnNextLogin?: boolean | undefined;
    sendActivationEmail?: boolean | undefined;
    language?: number | undefined;
    preferences?: { [key: string]: string; } | undefined;
    languageCombo?: ComboboxItemDto[] | undefined;
    rolList?: UserRolResponse[] | undefined;
    tenantsList?: TenantDto[] | undefined;
    delegationsInfo?: UserDelegacionDto | undefined;

    constructor(data?: IUserForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            this.secondLastName = _data["secondLastName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.medicoId = _data["medicoId"];
            this.nombreMedico = _data["nombreMedico"];
            this.isActive = _data["isActive"];
            this.isTenant = _data["isTenant"];
            this.setRandomPassword = _data["setRandomPassword"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.language = _data["language"];
            if (_data["preferences"]) {
                this.preferences = {} as any;
                for (let key in _data["preferences"]) {
                    if (_data["preferences"].hasOwnProperty(key))
                        (<any>this.preferences)![key] = _data["preferences"][key];
                }
            }
            if (Array.isArray(_data["languageCombo"])) {
                this.languageCombo = [] as any;
                for (let item of _data["languageCombo"])
                    this.languageCombo!.push(ComboboxItemDto.fromJS(item));
            }
            if (Array.isArray(_data["rolList"])) {
                this.rolList = [] as any;
                for (let item of _data["rolList"])
                    this.rolList!.push(UserRolResponse.fromJS(item));
            }
            if (Array.isArray(_data["tenantsList"])) {
                this.tenantsList = [] as any;
                for (let item of _data["tenantsList"])
                    this.tenantsList!.push(TenantDto.fromJS(item));
            }
            this.delegationsInfo = _data["delegationsInfo"] ? UserDelegacionDto.fromJS(_data["delegationsInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["secondLastName"] = this.secondLastName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["medicoId"] = this.medicoId;
        data["nombreMedico"] = this.nombreMedico;
        data["isActive"] = this.isActive;
        data["isTenant"] = this.isTenant;
        data["setRandomPassword"] = this.setRandomPassword;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["language"] = this.language;
        if (this.preferences) {
            data["preferences"] = {};
            for (let key in this.preferences) {
                if (this.preferences.hasOwnProperty(key))
                    (<any>data["preferences"])[key] = (<any>this.preferences)[key];
            }
        }
        if (Array.isArray(this.languageCombo)) {
            data["languageCombo"] = [];
            for (let item of this.languageCombo)
                data["languageCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.rolList)) {
            data["rolList"] = [];
            for (let item of this.rolList)
                data["rolList"].push(item.toJSON());
        }
        if (Array.isArray(this.tenantsList)) {
            data["tenantsList"] = [];
            for (let item of this.tenantsList)
                data["tenantsList"].push(item.toJSON());
        }
        data["delegationsInfo"] = this.delegationsInfo ? this.delegationsInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserForEditResponse {
    id: number;
    userName?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    medicoId?: number | undefined;
    nombreMedico?: string | undefined;
    isActive?: boolean | undefined;
    isTenant: boolean;
    setRandomPassword?: boolean | undefined;
    shouldChangePasswordOnNextLogin?: boolean | undefined;
    sendActivationEmail?: boolean | undefined;
    language?: number | undefined;
    preferences?: { [key: string]: string; } | undefined;
    languageCombo?: ComboboxItemDto[] | undefined;
    rolList?: UserRolResponse[] | undefined;
    tenantsList?: TenantDto[] | undefined;
    delegationsInfo?: UserDelegacionDto | undefined;
}

export class UserRolResponse implements IUserRolResponse {
    roleId?: number | undefined;
    roleName?: string | undefined;
    roleDisplayName?: string | undefined;

    constructor(data?: IUserRolResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.roleDisplayName = _data["roleDisplayName"];
        }
    }

    static fromJS(data: any): UserRolResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserRolResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        return data;
    }
}

export interface IUserRolResponse {
    roleId?: number | undefined;
    roleName?: string | undefined;
    roleDisplayName?: string | undefined;
}

export class UserGetForEditQuery implements IUserGetForEditQuery {
    id!: number;

    constructor(data?: IUserGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUserGetForEditQuery {
    id: number;
}

export class UserProfileQuery implements IUserProfileQuery {
    id!: number;
    clientType?: string | undefined;

    constructor(data?: IUserProfileQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientType = _data["clientType"];
        }
    }

    static fromJS(data: any): UserProfileQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientType"] = this.clientType;
        return data;
    }
}

export interface IUserProfileQuery {
    id: number;
    clientType?: string | undefined;
}

export class UserUpdateProfileCommand implements IUserUpdateProfileCommand {
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    pictureName?: string | undefined;
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
    newPasswordConfirm?: string | undefined;
    language?: number | undefined;
    clientType?: string | undefined;
    preferences?: { [key: string]: string; } | undefined;

    constructor(data?: IUserUpdateProfileCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            this.secondLastName = _data["secondLastName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.pictureName = _data["pictureName"];
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
            this.newPasswordConfirm = _data["newPasswordConfirm"];
            this.language = _data["language"];
            this.clientType = _data["clientType"];
            if (_data["preferences"]) {
                this.preferences = {} as any;
                for (let key in _data["preferences"]) {
                    if (_data["preferences"].hasOwnProperty(key))
                        (<any>this.preferences)![key] = _data["preferences"][key];
                }
            }
        }
    }

    static fromJS(data: any): UserUpdateProfileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserUpdateProfileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["secondLastName"] = this.secondLastName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["pictureName"] = this.pictureName;
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        data["newPasswordConfirm"] = this.newPasswordConfirm;
        data["language"] = this.language;
        data["clientType"] = this.clientType;
        if (this.preferences) {
            data["preferences"] = {};
            for (let key in this.preferences) {
                if (this.preferences.hasOwnProperty(key))
                    (<any>data["preferences"])[key] = (<any>this.preferences)[key];
            }
        }
        return data;
    }
}

export interface IUserUpdateProfileCommand {
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    pictureName?: string | undefined;
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
    newPasswordConfirm?: string | undefined;
    language?: number | undefined;
    clientType?: string | undefined;
    preferences?: { [key: string]: string; } | undefined;
}

export class UserDeleteCommand implements IUserDeleteCommand {
    id!: number;

    constructor(data?: IUserDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUserDeleteCommand {
    id: number;
}

export class WebLogGetLastestResponse implements IWebLogGetLastestResponse {
    latesWebLogLines?: string[] | undefined;

    constructor(data?: IWebLogGetLastestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["latesWebLogLines"])) {
                this.latesWebLogLines = [] as any;
                for (let item of _data["latesWebLogLines"])
                    this.latesWebLogLines!.push(item);
            }
        }
    }

    static fromJS(data: any): WebLogGetLastestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WebLogGetLastestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.latesWebLogLines)) {
            data["latesWebLogLines"] = [];
            for (let item of this.latesWebLogLines)
                data["latesWebLogLines"].push(item);
        }
        return data;
    }
}

export interface IWebLogGetLastestResponse {
    latesWebLogLines?: string[] | undefined;
}

export class WebLogGetLastestQuery implements IWebLogGetLastestQuery {

    constructor(data?: IWebLogGetLastestQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): WebLogGetLastestQuery {
        data = typeof data === 'object' ? data : {};
        let result = new WebLogGetLastestQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IWebLogGetLastestQuery {
}

export class WebLogDownloadZipResponse implements IWebLogDownloadZipResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;

    constructor(data?: IWebLogDownloadZipResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): WebLogDownloadZipResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WebLogDownloadZipResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IWebLogDownloadZipResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
}

export class WebLogDownloadZipQuery implements IWebLogDownloadZipQuery {

    constructor(data?: IWebLogDownloadZipQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): WebLogDownloadZipQuery {
        data = typeof data === 'object' ? data : {};
        let result = new WebLogDownloadZipQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IWebLogDownloadZipQuery {
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}